export const programsData = {
    "programs": {
        "programs": [
            {
              "id": 929,
              "client_id": 207,
              "hysform_id": 638,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 337,
              "entity_submit": "",
              "donor_submit": "0",
              "link_id": 0,
              "name": "Education",
              "prefix": "",
              "counter": 427,
              "lft": 20,
              "rgt": 21,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2017-02-23T01:40:22.000000Z",
              "updated_at": "2024-06-17T13:15:33.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1680004248741,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1680003822000,
              "children": []
            },
            {
              "id": 1221,
              "client_id": 207,
              "hysform_id": 638,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 337,
              "entity_submit": "",
              "donor_submit": "",
              "link_id": 0,
              "name": "Sponsored",
              "prefix": "",
              "counter": 54,
              "lft": 18,
              "rgt": 19,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2019-01-22T01:50:21.000000Z",
              "updated_at": "2024-07-09T13:54:44.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1679910350681,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1679909849000,
              "children": []
            },
            {
              "id": 3437,
              "client_id": 207,
              "hysform_id": 638,
              "donor_hysform_id": 0,
              "setting_id": 410,
              "emailset_id": 0,
              "entity_submit": "",
              "donor_submit": "",
              "link_id": 0,
              "name": "Medical",
              "prefix": "",
              "counter": 0,
              "lft": 16,
              "rgt": 17,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2022-12-14T20:13:03.000000Z",
              "updated_at": "2023-03-28T18:44:07.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1680004248746,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1680003847000,
              "children": []
            },
            {
              "id": 3438,
              "client_id": 207,
              "hysform_id": 3019,
              "donor_hysform_id": 639,
              "setting_id": 1641,
              "emailset_id": 0,
              "entity_submit": "",
              "donor_submit": "",
              "link_id": 0,
              "name": "Marathon for the disabled",
              "prefix": "",
              "counter": 0,
              "lft": 14,
              "rgt": 15,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2022-12-21T16:50:33.000000Z",
              "updated_at": "2024-06-25T06:11:37.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1679910350683,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1679909849000,
              "children": []
            },
            {
              "id": 3494,
              "client_id": 207,
              "hysform_id": 638,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 337,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": 929,
              "name": "Youth Mentorship Program",
              "prefix": "",
              "counter": 1,
              "lft": 21,
              "rgt": 22,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-03-25T09:14:29.000000Z",
              "updated_at": "2024-07-09T13:35:33.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "parent_program": "Education",
              "children": []
            },
            {
              "id": 3506,
              "client_id": 207,
              "hysform_id": 3039,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 1557,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "Kupenda",
              "prefix": "KP",
              "counter": 200,
              "lft": 12,
              "rgt": 13,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-04-29T15:08:37.000000Z",
              "updated_at": "2024-07-09T13:33:24.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            },
            {
              "id": 3507,
              "client_id": 207,
              "hysform_id": 3019,
              "donor_hysform_id": 3040,
              "setting_id": 1641,
              "emailset_id": null,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "Kupe",
              "prefix": "KUP",
              "counter": null,
              "lft": 10,
              "rgt": 11,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-05-03T06:41:45.000000Z",
              "updated_at": "2024-06-21T11:08:10.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            },
            {
              "id": 3510,
              "client_id": 207,
              "hysform_id": 3043,
              "donor_hysform_id": null,
              "setting_id": 410,
              "emailset_id": null,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "us2uganda",
              "prefix": "usa",
              "counter": null,
              "lft": 8,
              "rgt": 9,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-06-02T09:24:28.000000Z",
              "updated_at": "2023-06-02T09:36:45.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            },
            {
              "id": 3518,
              "client_id": 207,
              "hysform_id": 3048,
              "donor_hysform_id": 639,
              "setting_id": 1650,
              "emailset_id": null,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "Masaka BoreHole",
              "prefix": "MBH",
              "counter": 1,
              "lft": 4,
              "rgt": 5,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-10-17T06:26:48.000000Z",
              "updated_at": "2024-06-17T12:10:38.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            },
            {
              "id": 3521,
              "client_id": 207,
              "hysform_id": 3051,
              "donor_hysform_id": 639,
              "setting_id": 1652,
              "emailset_id": null,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "Sustainable Living Expo",
              "prefix": "DC",
              "counter": 1,
              "lft": 2,
              "rgt": 3,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2024-06-13T08:35:10.000000Z",
              "updated_at": "2024-06-13T08:40:15.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            }
          ],
          "archived": [
            {
              "id": 928,
              "client_id": 207,
              "hysform_id": 0,
              "donor_hysform_id": 0,
              "setting_id": 0,
              "emailset_id": 0,
              "entity_submit": "",
              "donor_submit": "",
              "link_id": 0,
              "name": "Mission Starfish Haiti",
              "prefix": "",
              "counter": 0,
              "lft": 1,
              "rgt": 22,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2017-02-23T01:40:21.000000Z",
              "updated_at": "2023-03-27T16:37:29.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1679910350683,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1679909849000,
              "children": []
            },
            {
              "id": 929,
              "client_id": 207,
              "hysform_id": 638,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 337,
              "entity_submit": "",
              "donor_submit": "0",
              "link_id": 0,
              "name": "Education",
              "prefix": "",
              "counter": 427,
              "lft": 20,
              "rgt": 21,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2017-02-23T01:40:22.000000Z",
              "updated_at": "2024-06-17T13:15:33.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1680004248741,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1680003822000,
              "children": []
            },
            {
              "id": 1221,
              "client_id": 207,
              "hysform_id": 638,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 337,
              "entity_submit": "",
              "donor_submit": "",
              "link_id": 0,
              "name": "Sponsored",
              "prefix": "",
              "counter": 54,
              "lft": 18,
              "rgt": 19,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2019-01-22T01:50:21.000000Z",
              "updated_at": "2024-07-09T13:54:44.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1679910350681,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1679909849000,
              "children": []
            },
            {
              "id": 3437,
              "client_id": 207,
              "hysform_id": 638,
              "donor_hysform_id": 0,
              "setting_id": 410,
              "emailset_id": 0,
              "entity_submit": "",
              "donor_submit": "",
              "link_id": 0,
              "name": "Medical",
              "prefix": "",
              "counter": 0,
              "lft": 16,
              "rgt": 17,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2022-12-14T20:13:03.000000Z",
              "updated_at": "2023-03-28T18:44:07.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1680004248746,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1680003847000,
              "children": []
            },
            {
              "id": 3438,
              "client_id": 207,
              "hysform_id": 3019,
              "donor_hysform_id": 639,
              "setting_id": 1641,
              "emailset_id": 0,
              "entity_submit": "",
              "donor_submit": "",
              "link_id": 0,
              "name": "Marathon for the disabled",
              "prefix": "",
              "counter": 0,
              "lft": 14,
              "rgt": 15,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2022-12-21T16:50:33.000000Z",
              "updated_at": "2024-06-25T06:11:37.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1679910350683,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1679909849000,
              "children": []
            },
            {
              "id": 3494,
              "client_id": 207,
              "hysform_id": 638,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 337,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": 929,
              "name": "Youth Mentorship Program",
              "prefix": "",
              "counter": 1,
              "lft": 21,
              "rgt": 22,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-03-25T09:14:29.000000Z",
              "updated_at": "2024-07-09T13:35:33.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            },
            {
              "id": 3506,
              "client_id": 207,
              "hysform_id": 3039,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 1557,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "Kupenda",
              "prefix": "KP",
              "counter": 200,
              "lft": 12,
              "rgt": 13,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-04-29T15:08:37.000000Z",
              "updated_at": "2024-07-09T13:33:24.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            },
            {
              "id": 3507,
              "client_id": 207,
              "hysform_id": 3019,
              "donor_hysform_id": 3040,
              "setting_id": 1641,
              "emailset_id": null,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "Kupe",
              "prefix": "KUP",
              "counter": null,
              "lft": 10,
              "rgt": 11,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-05-03T06:41:45.000000Z",
              "updated_at": "2024-06-21T11:08:10.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            },
            {
              "id": 3510,
              "client_id": 207,
              "hysform_id": 3043,
              "donor_hysform_id": null,
              "setting_id": 410,
              "emailset_id": null,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "us2uganda",
              "prefix": "usa",
              "counter": null,
              "lft": 8,
              "rgt": 9,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-06-02T09:24:28.000000Z",
              "updated_at": "2023-06-02T09:36:45.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            },
            {
              "id": 3518,
              "client_id": 207,
              "hysform_id": 3048,
              "donor_hysform_id": 639,
              "setting_id": 1650,
              "emailset_id": null,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "Masaka BoreHole",
              "prefix": "MBH",
              "counter": 1,
              "lft": 4,
              "rgt": 5,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-10-17T06:26:48.000000Z",
              "updated_at": "2024-06-17T12:10:38.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            },
            {
              "id": 3521,
              "client_id": 207,
              "hysform_id": 3051,
              "donor_hysform_id": 639,
              "setting_id": 1652,
              "emailset_id": null,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "Demo Campaign",
              "prefix": "DC",
              "counter": 1,
              "lft": 2,
              "rgt": 3,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2024-06-13T08:35:10.000000Z",
              "updated_at": "2024-06-13T08:40:15.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": []
            }
          ],
          "number_of_programs": 11
    }
}

export const hysforms = [
  {
    "id": 638,
    "client_id": 207,
    "default_emailset_id": 0,
    "type": "entity",
    "name": "Child Profiles",
    "prefix": "",
    "counter": 0,
    "box_folder_id": "",
    "can_donor_modify_amount": "",
    "mailchimp_list_id": "",
    "forgive_missed_payments": 0,
    "notify": null,
    "created_at": "2017-02-22T17:40:21.000000Z",
  },
  {
    "id": 639,
    "client_id": 207,
    "default_emailset_id": 337,
    "type": "donor",
    "name": "Sponsor Profiles",
    "prefix": "",
    "counter": 249,
    "box_folder_id": "",
    "can_donor_modify_amount": "",
    "mailchimp_list_id": "",
    "forgive_missed_payments": 0,
    "notify": null,
    "created_at": "2017-02-23T01:40:21.000000Z",
  },
  {
    "id": 3019,
    "client_id": 207,
    "default_emailset_id": 0,
    "type": "entity",
    "name": "test form",
    "prefix": "",
    "counter": 0,
    "box_folder_id": "",
    "can_donor_modify_amount": "",
    "mailchimp_list_id": "",
    "forgive_missed_payments": 0,
    "notify": null,
    "created_at": "2023-02-20T17:19:13.000000Z",
  },
  {
    "id": 3030,
    "client_id": 207,
    "default_emailset_id": 0,
    "type": "donor",
    "name": "new test form",
    "prefix": "",
    "counter": 0,
    "box_folder_id": "",
    "can_donor_modify_amount": "",
    "mailchimp_list_id": "",
    "forgive_missed_payments": 0,
    "notify": null,
    "created_at": "2023-04-04T08:39:19.000000Z",
  },
  {
    "id": 3039,
    "client_id": 207,
    "default_emailset_id": 0,
    "type": "entity",
    "name": "Kupenda",
    "prefix": "",
    "counter": 0,
    "box_folder_id": "",
    "can_donor_modify_amount": "",
    "mailchimp_list_id": "",
    "forgive_missed_payments": 0,
    "notify": null,
    "created_at": "2023-04-29T14:27:08.000000Z",
  },
  {
    "id": 3040,
    "client_id": 207,
    "default_emailset_id": 0,
    "type": "donor",
    "name": "Kupenda Donors",
    "prefix": "",
    "counter": 0,
    "box_folder_id": "",
    "can_donor_modify_amount": "",
    "mailchimp_list_id": "",
    "forgive_missed_payments": 0,
    "notify": null,
    "created_at": "2023-05-09T14:53:42.000000Z",
  },
  {
    "id": 3043,
    "client_id": 207,
    "default_emailset_id": 0,
    "type": "entity",
    "name": "usa2uganda",
    "prefix": "",
    "counter": 0,
    "box_folder_id": "",
    "can_donor_modify_amount": "",
    "mailchimp_list_id": "",
    "forgive_missed_payments": 0,
    "notify": null,
    "created_at": "2023-06-02T09:27:43.000000Z",
  },
  {
    "id": 3048,
    "client_id": 207,
    "default_emailset_id": 0,
    "type": "entity",
    "name": "Borehole form",
    "prefix": "",
    "counter": 0,
    "box_folder_id": "",
    "can_donor_modify_amount": "",
    "mailchimp_list_id": "",
    "forgive_missed_payments": 0,
    "notify": null,
    "created_at": "2023-10-17T06:27:19.000000Z",
  },
  {
    "id": 3051,
    "client_id": 207,
    "default_emailset_id": 0,
    "type": "entity",
    "name": "Demo campaign form",
    "prefix": "",
    "counter": 0,
    "box_folder_id": "",
    "can_donor_modify_amount": "",
    "mailchimp_list_id": "",
    "forgive_missed_payments": 0,
    "notify": null,
    "created_at": "2024-06-13T08:38:12.000000Z",
  }
]

export const settings = [
  {
    "id": 410,
    "client_id": 207,
    "name": "General Settings",
    "program_settings": "{\"program_type\":\"number\",\"sp_num\":\"\",\"labels\":\"\",\"number_spon\":\"2\",\"descending_order\":\"\",\"hide_noimage_recipients\":\"\",\"donation_target\":\"\",\"sponsorship_amount\":\"35,40,50\",\"transaction_amount\":\"\",\"currency_symbol\":\"$\",\"duration\":\"366\",\"stripe\":\"1\",\"login_box\":\"1\",\"checks\":\"1\",\"designations\":\"1\",\"sorting\":\"1\",\"display_all\":\"1\",\"wire_transfer\":\"1\",\"cash\":\"1\",\"hide_payment_method\":\"\",\"hide_frequency\":\"\",\"placeholder\":\"\",\"display_info\":\"1\",\"display_percent\":\"1\",\"processing_fee\":\"\",\"processing_percentage\":\"\"}",
    "text_front": "<p>Front End Text here for our program</p>",
    "text_profile": "<p>profile page text</p>",
    "text_checkout": "<p><strong> Order Page Texts</strong></p>",
    "text_account": "<p>donor account page</p>",
    "info": "<p>Sponsoring [en_child_name] helps provide basic needs like hot lunch, school uniform, school books and supplies.</p>",
    "allow_email": 1,
    "show_payment": 1,
    "deleted_at": null,
    "created_at": "2017-02-22T17:40:22.000000Z",
    "updated_at": "2024-06-17T12:21:18.000000Z",
    "__hevo__ingested_at": 1679725258686,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": "apphys_new",
    "programs": [
      {
        "id": 929,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 337,
        "entity_submit": "",
        "donor_submit": "0",
        "link_id": 0,
        "name": "Education",
        "prefix": "",
        "counter": 427,
        "lft": 20,
        "rgt": 21,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2017-02-23T01:40:22.000000Z",
        "updated_at": "2024-06-17T13:15:33.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1680004248741,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1680003822000,
        "children": []
      },
      {
        "id": 1221,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 337,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Sponsored",
        "prefix": "",
        "counter": 54,
        "lft": 18,
        "rgt": 19,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2019-01-22T01:50:21.000000Z",
        "updated_at": "2024-07-09T13:54:44.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679910350681,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1679909849000,
        "children": []
      },
      {
        "id": 3437,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 0,
        "setting_id": 410,
        "emailset_id": 0,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Medical",
        "prefix": "",
        "counter": 0,
        "lft": 16,
        "rgt": 17,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2022-12-14T20:13:03.000000Z",
        "updated_at": "2023-03-28T18:44:07.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1680004248746,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1680003847000,
        "children": []
      },
      {
        "id": 3494,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 337,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": 929,
        "name": "SubTest2",
        "prefix": "",
        "counter": 1,
        "lft": 21,
        "rgt": 22,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-03-25T09:14:29.000000Z",
        "updated_at": "2024-07-09T13:35:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      {
        "id": 3506,
        "client_id": 207,
        "hysform_id": 3039,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 1557,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Kupenda",
        "prefix": "KP",
        "counter": 200,
        "lft": 12,
        "rgt": 13,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-04-29T15:08:37.000000Z",
        "updated_at": "2024-07-09T13:33:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      {
        "id": 3510,
        "client_id": 207,
        "hysform_id": 3043,
        "donor_hysform_id": null,
        "setting_id": 410,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "us2uganda",
        "prefix": "usa",
        "counter": null,
        "lft": 8,
        "rgt": 9,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-06-02T09:24:28.000000Z",
        "updated_at": "2023-06-02T09:36:45.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      }
    ]
  },
  {
    "id": 1641,
    "client_id": 207,
    "name": "Test Settings",
    "program_settings": "{\"program_type\":\"contribution\",\"sp_num\":\"100\",\"labels\":\"Small\",\"number_spon\":\"\",\"descending_order\":\"\",\"hide_noimage_recipients\":\"\",\"donation_target\":\"\",\"sponsorship_amount\":\"10\",\"transaction_amount\":\"\",\"currency_symbol\":\"Yen\",\"duration\":\"365\",\"stripe\":\"\",\"login_box\":\"\",\"checks\":\"\",\"designations\":\"\",\"sorting\":\"\",\"display_all\":\"\",\"wire_transfer\":\"\",\"cash\":\"\",\"hide_payment_method\":\"\",\"hide_frequency\":\"\",\"placeholder\":\"\",\"display_info\":\"\",\"display_percent\":\"\",\"processing_fee\":\"\",\"processing_percentage\":\"\"}",
    "text_front": "<p>test text</p>",
    "text_profile": "<p>test text</p>",
    "text_checkout": "<p>test text</p>",
    "text_account": "<p>test text</p>",
    "info": "<p>test text</p>",
    "allow_email": 1,
    "show_payment": 1,
    "deleted_at": null,
    "created_at": "2023-04-03T10:14:32.000000Z",
    "updated_at": "2024-06-21T11:09:50.000000Z",
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": null,
    "programs": [
      {
        "id": 3438,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 639,
        "setting_id": 1641,
        "emailset_id": 0,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Marathon for the disabled",
        "prefix": "",
        "counter": 0,
        "lft": 14,
        "rgt": 15,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2022-12-21T16:50:33.000000Z",
        "updated_at": "2024-06-25T06:11:37.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679910350683,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1679909849000,
        "children": []
      },
      {
        "id": 3507,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 3040,
        "setting_id": 1641,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Kupe",
        "prefix": "KUP",
        "counter": null,
        "lft": 10,
        "rgt": 11,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-05-03T06:41:45.000000Z",
        "updated_at": "2024-06-21T11:08:10.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      }
    ]
  },
  {
    "id": 1646,
    "client_id": 207,
    "name": "Kupenda Setting",
    "program_settings": "{\"program_type\":\"number\",\"sp_num\":\"\",\"labels\":\"\",\"number_spon\":\"2\",\"descending_order\":\"\",\"hide_noimage_recipients\":\"\",\"donation_target\":\"\",\"sponsorship_amount\":\"32\",\"transaction_amount\":\"\",\"currency_symbol\":\"$\",\"duration\":\"365\",\"stripe\":\"\",\"login_box\":\"1\",\"checks\":\"1\",\"designations\":\"1\",\"sorting\":\"1\",\"display_all\":\"1\",\"wire_transfer\":\"1\",\"cash\":\"1\",\"hide_payment_method\":\"\",\"hide_frequency\":\"hidden\",\"placeholder\":\"\",\"display_info\":\"\",\"display_percent\":\"\",\"processing_fee\":\"\",\"processing_percentage\":\"\"}",
    "text_front": "<p>Front End Text here for our program</p>",
    "text_profile": "<p>profile page text</p>",
    "text_checkout": "<p><strong> Order Page Text</strong></p>",
    "text_account": "<p>donor account page</p>",
    "info": "<p>Sponsoring [en_child_name] helps provide basic needs like hot lunch, school uniform, school books and supplies.</p>",
    "allow_email": 1,
    "show_payment": 1,
    "deleted_at": null,
    "created_at": "2023-05-02T09:03:26.000000Z",
    "updated_at": "2024-06-20T11:50:58.000000Z",
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": null,
    "programs": []
  },
  {
    "id": 1650,
    "client_id": 207,
    "name": "General Donations",
    "program_settings": "{\"program_type\":\"campaign\",\"sp_num\":\"\",\"labels\":\"\",\"number_spon\":\"\",\"donation_target\":\"20000\",\"sponsorship_amount\":\"\",\"transaction_amount\":\"50,100,200,500\",\"currency_symbol\":\"$\",\"duration\":\"\",\"stripe\":\"1\",\"login_box\":\"1\",\"checks\":\"\",\"designations\":\"\",\"sorting\":\"\",\"display_all\":\"\",\"wire_transfer\":\"\",\"cash\":\"\",\"hide_payment_method\":\"\",\"hide_frequency\":\"\",\"placeholder\":\"data:image\\/png;base64,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\",\"disable_program_link\":\"\",\"display_info\":\"\",\"display_percent\":\"\",\"processing_fee\":\"1\",\"processing_percentage\":\"5\"}",
    "text_front": "",
    "text_profile": "",
    "text_checkout": "",
    "text_account": "",
    "info": "<p>Lorem Ipsum</p>",
    "allow_email": 0,
    "show_payment": 1,
    "deleted_at": null,
    "created_at": "2023-10-17T06:26:28.000000Z",
    "updated_at": "2023-10-17T06:26:28.000000Z",
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": null,
    "programs": [
      {
        "id": 3518,
        "client_id": 207,
        "hysform_id": 3048,
        "donor_hysform_id": 639,
        "setting_id": 1650,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Masaka BoreHole",
        "prefix": "MBH",
        "counter": 1,
        "lft": 4,
        "rgt": 5,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-10-17T06:26:48.000000Z",
        "updated_at": "2024-06-17T12:10:38.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      }
    ]
  },
  {
    "id": 1652,
    "client_id": 207,
    "name": "Demo campaign setting",
    "program_settings": "{\"program_type\":\"campaign\",\"sp_num\":\"\",\"labels\":\"\",\"number_spon\":\"\",\"donation_target\":\"\",\"sponsorship_amount\":\"\",\"transaction_amount\":\"10,20,50,100\",\"currency_symbol\":\"$\",\"duration\":\"\",\"stripe\":\"1\",\"login_box\":\"\",\"checks\":\"1\",\"designations\":\"\",\"sorting\":\"\",\"display_all\":\"\",\"wire_transfer\":\"\",\"cash\":\"\",\"hide_payment_method\":\"\",\"hide_frequency\":\"\",\"placeholder\":\"\",\"disable_program_link\":\"\",\"display_info\":\"\",\"display_percent\":\"\",\"processing_fee\":\"1\",\"processing_percentage\":\"2.9\"}",
    "text_front": "",
    "text_profile": "",
    "text_checkout": "",
    "text_account": "",
    "info": "<p>Demo campaign description</p>",
    "allow_email": 0,
    "show_payment": 1,
    "deleted_at": null,
    "created_at": "2024-06-13T08:37:26.000000Z",
    "updated_at": "2024-06-13T08:37:26.000000Z",
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": null,
    "programs": [
      {
        "id": 3521,
        "client_id": 207,
        "hysform_id": 3051,
        "donor_hysform_id": 639,
        "setting_id": 1652,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Demo Campaign",
        "prefix": "DC",
        "counter": 1,
        "lft": 2,
        "rgt": 3,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2024-06-13T08:35:10.000000Z",
        "updated_at": "2024-06-13T08:40:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      }
    ]
  }
]

export const emailsets = [
  {
    "id": 337,
    "client_id": 207,
    "name": "Child Sponsorship Program Email Templates",
    "from": "dev+10@helpyousponsor.com",
    "deleted_at": null,
    "created_at": "2017-02-22T17:40:22.000000Z",
    "updated_at": "2022-11-28T15:00:36.000000Z",
    "__hevo__ingested_at": 1679725257334,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": "apphys_new",
    "emailtemplates": [
      {
        "id": 2437,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "new_donor",
        "schedule": "",
        "to": "",
        "subject": "Welcome to our sponsorship program",
        "message": "<p>Hello [dn_donor_name],</p><p>Welcome to our sponsorship program. We are thankful you decided to sponsor [en_child_name]. Here is all the information you need to know about the program and contacting your child.</p><p>Sincerely,</p><p>Program Director</p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-02-19T04:10:09.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 2438,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "profile_update",
        "schedule": "",
        "to": "",
        "subject": "[en_child_name]'s profile has been updated!",
        "message": "<p>Hello [dn_donor_name],</p><p>We have just updated your sponsor child's information. You may log in to our website with your account to view the updated information about [en_child_name].</p><p>Thank you for your continued sponsorship. You are making a difference in the life of a child.</p><p>Sincerely,</p><p>Program Director</p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-02-19T04:10:09.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 2439,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "notify_donor",
        "schedule": "",
        "to": "",
        "subject": "Your sponsorship account has been setup with HYS Demo!",
        "message": "<h2>Donor Account for [dn_donor_name]</h2><p>You have been added to the \"sponsorship program\" for Hys Demo.</p><p>If you would like to have online access to your <span  style=\"background-color: initial;\">Hys Demo</span><span  style=\"background-color: initial;\"> Sponsorship,</span></p><p>please go to mshaiti.org, click on the sponsor tab at the top, then click login and enter your login information that is listed below. </p><p>You will now be able to set up your payments to be made automatically from a credit card. No more having to remember to send a check in the mail. Just click on the recurring option and it will be done for you.</p><p>Web access also gives you a place to send messages to your sponsor child, and throughout the year we will be posting notes and new photos right to your online account.</p><p>We are looking forward to the new opportunities that the online program has to offer and are very excited for you, our sponsors, to have more access to your sponsor children!</p><p>Thank you for your continued support!</p><p>Here is your login information:</p><ul><li>Username:  [username]</li><li>Temporary Password: [password]</li></ul>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-28T14:47:40.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 2440,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "pay_receipt",
        "schedule": "",
        "to": "",
        "subject": "Donation Receipt",
        "message": "<p>Thank you for your donation [designations] for [total_amount]. This email serves as your donation receipt.</p>\r\n\t\t\t\t\t\t\t\t<table style=\"\" border-color:#666;width:80%;margin:20px=\"\" auto;\"\"=\"\" cellpadding=\"\" 10\"\"=\"\">\r\n\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tDonor Name\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t[donor_name]\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tDesignation\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t[designation_name]\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tAmount\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t$[amount]\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tMethod\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t[method]\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tFrequency\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t[frequency]</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t\t</table><p>[date]</p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-02-19T04:10:09.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 2441,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "pay_remind",
        "schedule": "",
        "to": "",
        "subject": "HYS Demo",
        "message": "<p>Hi [donor_name],</p><p>We are updating our sponsorship database and are asking that all of our sponsors confirm if they would like to continue or discontinue their sponsorship.  </p><p>Your information:</p><p>[designation_name] sponsored for [amount] [method] [frequency]</p><p>Please respond to this email with either continue or discontinue so we can have the most accurate information and continue to provide for the children.</p><p>We sincerely thank you for your support of our ministry. It is only through people like you that we are able to do what we do.</p><p>Sincerely,</p><p>Sponsorship Team</p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-28T14:48:31.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 2442,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "pay_fail",
        "schedule": "",
        "to": "",
        "subject": "Sponsorship Payment Failed ",
        "message": "<p>Hello [dn_donor_name],</p><p>We regret to inform you that there was a problem with your recent sponsorship payment [designation_name] for [[amount] by [method] every [frequency]. Please log in to your account on our website in order to update your card number.</p><p>Thank you,</p><p>Program Director</p><p>[error]</p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-02-19T04:10:09.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 2443,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "new_donor_admin",
        "schedule": "",
        "to": "dev@helpyousponsor.com",
        "subject": "New Sponsorship",
        "message": "<p>[dn_donor_name] has just signed up to sponsor [en_child_name]. [designations] [total_amount]</p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2024-04-25T19:56:53.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 2444,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "sp_email",
        "schedule": "",
        "to": "arnoldmukisa@gmail.com",
        "subject": "New email from [dn_donor_name] for [en_child_name]",
        "message": "<p>A sponsor has just sent an email to their sponsor child:</p><p>From: [dn_donor_name]</p><p>To: [en_child_name]</p><p>[subject]</p><p>[body]</p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2024-05-17T20:20:12.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 2445,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "pay_fail_admin",
        "schedule": "",
        "to": "",
        "subject": "Sponsorhip payment failed",
        "message": "<p>This is a notification that the following donor's payment failed: [dn_donor_name].</p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-02-20T19:55:25.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 3235,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "recip_email",
        "schedule": "",
        "to": "",
        "subject": "New Message from your sponsored child.",
        "message": "<p><span  style=\"background-color: initial;\">You have received a new message from your sponsor child [en_child_name]</span></p><p><span  style=\"background-color: initial;\">[subject] [login_link]</span></p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": "2018-11-24T02:47:17.000000Z",
        "updated_at": "2019-09-04T23:02:35.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      {
        "id": 3342,
        "client_id": 207,
        "emailset_id": 337,
        "trigger": "year_end_statement",
        "schedule": "",
        "to": "",
        "subject": "Donor Year End Statement",
        "message": "<hr><p>[dn_donor_name]</p><p>This is your donor year end statement for [year] for Mission Starfish Haiti. </p><p>[year_end_total]</p><p>[donations_table]</p>",
        "disabled": 1,
        "deleted_at": null,
        "created_at": "2019-02-19T04:03:10.000000Z",
        "updated_at": "2022-12-10T14:06:15.000000Z",
        "__hevo__ingested_at": 1679725246677,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      }
    ],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 427,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T01:40:22.000000Z",
      "updated_at": "2024-06-17T13:15:33.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": [],
      "donorfields": [
        {
          "id": 1436,
          "client_id": 207,
          "hysform_id": 639,
          "field_key": "dn_donor_name",
          "field_label": "Donor Name",
          "field_data": "Enter Name",
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "field_order": 0,
          "deleted_at": null,
          "created_at": "2017-02-22T17:40:22.000000Z",
          "updated_at": "2022-12-12T15:27:35.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725249741,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 1817,
          "client_id": 207,
          "hysform_id": 639,
          "field_key": "dn_payment_type",
          "field_label": "Payment Type",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "admin",
          "admingroup_id": 0,
          "is_title": 1,
          "field_order": 1,
          "deleted_at": null,
          "created_at": "2019-01-23T01:58:32.000000Z",
          "updated_at": "2022-12-12T15:27:35.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725249741,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 1861,
          "client_id": 207,
          "hysform_id": 639,
          "field_key": "dn_child_sponsored",
          "field_label": "Child Sponsored",
          "field_data": "Enter child name",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "field_order": 2,
          "deleted_at": null,
          "created_at": "2019-03-19T21:32:33.000000Z",
          "updated_at": "2022-12-12T15:27:35.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725249741,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        }
      ]
    }
  },
  {
    "id": 1542,
    "client_id": 207,
    "name": "Test Emails",
    "from": "emailtest@gmail.com",
    "deleted_at": null,
    "created_at": "2023-02-27T07:53:03.000000Z",
    "updated_at": "2024-06-18T09:44:05.000000Z",
    "__hevo__ingested_at": 1679725257334,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": "apphys_new",
    "emailtemplates": [
      {
        "id": 12971,
        "client_id": 207,
        "emailset_id": 1542,
        "trigger": "new_donor",
        "schedule": "",
        "to": "",
        "subject": "shabanlubanga@gmail.com",
        "message": "<p>testing</p>",
        "disabled": 0,
        "deleted_at": null,
        "created_at": "2024-06-13T20:08:42.000000Z",
        "updated_at": "2024-06-13T20:09:06.000000Z",
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": null
      }
    ],
    "program": null
  },
  {
    "id": 1557,
    "client_id": 207,
    "name": "Test 2",
    "from": "Test2@gmail.com",
    "deleted_at": null,
    "created_at": "2024-07-09T13:18:10.000000Z",
    "updated_at": "2024-07-09T13:18:10.000000Z",
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": null,
    "emailtemplates": [
      {
        "id": 12990,
        "client_id": 207,
        "emailset_id": 1557,
        "trigger": "new_donor",
        "schedule": "",
        "to": "",
        "subject": "",
        "message": "",
        "disabled": 0,
        "deleted_at": null,
        "created_at": "2024-07-09T13:18:18.000000Z",
        "updated_at": "2024-07-09T13:18:18.000000Z",
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3039,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-09T13:33:24.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": [],
      "donorfields": [
        {
          "id": 1436,
          "client_id": 207,
          "hysform_id": 639,
          "field_key": "dn_donor_name",
          "field_label": "Donor Name",
          "field_data": "Enter Name",
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "field_order": 0,
          "deleted_at": null,
          "created_at": "2017-02-22T17:40:22.000000Z",
          "updated_at": "2022-12-12T15:27:35.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725249741,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 1817,
          "client_id": 207,
          "hysform_id": 639,
          "field_key": "dn_payment_type",
          "field_label": "Payment Type",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "admin",
          "admingroup_id": 0,
          "is_title": 1,
          "field_order": 1,
          "deleted_at": null,
          "created_at": "2019-01-23T01:58:32.000000Z",
          "updated_at": "2022-12-12T15:27:35.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725249741,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 1861,
          "client_id": 207,
          "hysform_id": 639,
          "field_key": "dn_child_sponsored",
          "field_label": "Child Sponsored",
          "field_data": "Enter child name",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "field_order": 2,
          "deleted_at": null,
          "created_at": "2019-03-19T21:32:33.000000Z",
          "updated_at": "2022-12-12T15:27:35.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725249741,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        }
      ]
    }
  }
]

export const designations = [
  {
    "id": 190,
    "client_id": 207,
    "emailset_id": 337,
    "hysforms": "639",
    "code": "",
    "name": "Bag of Rice",
    "info": "",
    "donation_amounts": "25",
    "deleted_at": null,
    "created_at": "2018-11-24T02:15:34.000000Z",
    "updated_at": "2018-11-24T02:26:13.000000Z",
    "__hevo__ingested_at": 1679725263466,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": "apphys_new"
  },
  {
    "id": 191,
    "client_id": 207,
    "emailset_id": 337,
    "hysforms": "639",
    "code": "",
    "name": "Bag of Beans",
    "info": "",
    "donation_amounts": "45",
    "deleted_at": null,
    "created_at": "2018-11-24T02:15:49.000000Z",
    "updated_at": "2018-11-24T02:26:21.000000Z",
    "__hevo__ingested_at": 1679725263466,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": "apphys_new"
  },
  {
    "id": 253,
    "client_id": 207,
    "emailset_id": 337,
    "hysforms": "639",
    "code": "TGT",
    "name": "Test Gift",
    "info": "",
    "donation_amounts": "5",
    "deleted_at": null,
    "created_at": "2023-03-16T09:53:26.000000Z",
    "updated_at": "2023-03-16T09:54:27.000000Z",
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": null
  }
]

export const programOptionsData = {
  forms: {
    "hysforms": [
        {
          "id": 638,
          "client_id": 207,
          "default_emailset_id": 0,
          "type": "entity",
          "name": "Child Profiles",
          "prefix": "",
          "counter": 0,
          "box_folder_id": "",
          "can_donor_modify_amount": "",
          "mailchimp_list_id": "",
          "forgive_missed_payments": 0,
          "notify": null,
          "deleted_at": null,
          "created_at": "2017-02-22T17:40:21.000000Z",
          "updated_at": "2017-02-22T17:40:21.000000Z",
          "hide_payment": "",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725248523,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 639,
          "client_id": 207,
          "default_emailset_id": 337,
          "type": "donor",
          "name": "Sponsor Profiles",
          "prefix": "",
          "counter": 249,
          "box_folder_id": "",
          "can_donor_modify_amount": "",
          "mailchimp_list_id": "",
          "forgive_missed_payments": 0,
          "notify": null,
          "deleted_at": null,
          "created_at": "2017-02-23T01:40:21.000000Z",
          "updated_at": "2024-07-09T13:55:57.000000Z",
          "hide_payment": "",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1680093778944,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": 1680093318000
        },
        {
          "id": 3019,
          "client_id": 207,
          "default_emailset_id": 0,
          "type": "entity",
          "name": "test form",
          "prefix": "",
          "counter": 0,
          "box_folder_id": "",
          "can_donor_modify_amount": "",
          "mailchimp_list_id": "",
          "forgive_missed_payments": 0,
          "notify": null,
          "deleted_at": null,
          "created_at": "2023-02-20T17:19:13.000000Z",
          "updated_at": "2023-02-20T17:19:13.000000Z",
          "hide_payment": "",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725248523,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 3030,
          "client_id": 207,
          "default_emailset_id": 0,
          "type": "donor",
          "name": "new test form",
          "prefix": "",
          "counter": 0,
          "box_folder_id": "",
          "can_donor_modify_amount": "",
          "mailchimp_list_id": "",
          "forgive_missed_payments": 0,
          "notify": null,
          "deleted_at": null,
          "created_at": "2023-04-04T08:39:19.000000Z",
          "updated_at": "2023-04-04T08:39:19.000000Z",
          "hide_payment": "",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 3039,
          "client_id": 207,
          "default_emailset_id": 0,
          "type": "entity",
          "name": "Kupenda",
          "prefix": "",
          "counter": 0,
          "box_folder_id": "",
          "can_donor_modify_amount": "",
          "mailchimp_list_id": "",
          "forgive_missed_payments": 0,
          "notify": null,
          "deleted_at": null,
          "created_at": "2023-04-29T14:27:08.000000Z",
          "updated_at": "2023-04-29T14:27:08.000000Z",
          "hide_payment": "",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 3040,
          "client_id": 207,
          "default_emailset_id": 0,
          "type": "donor",
          "name": "Kupenda Donors",
          "prefix": "",
          "counter": 0,
          "box_folder_id": "",
          "can_donor_modify_amount": "",
          "mailchimp_list_id": "",
          "forgive_missed_payments": 0,
          "notify": null,
          "deleted_at": null,
          "created_at": "2023-05-09T14:53:42.000000Z",
          "updated_at": "2023-05-09T14:53:42.000000Z",
          "hide_payment": "",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 3043,
          "client_id": 207,
          "default_emailset_id": 0,
          "type": "entity",
          "name": "usa2uganda",
          "prefix": "",
          "counter": 0,
          "box_folder_id": "",
          "can_donor_modify_amount": "",
          "mailchimp_list_id": "",
          "forgive_missed_payments": 0,
          "notify": null,
          "deleted_at": null,
          "created_at": "2023-06-02T09:27:43.000000Z",
          "updated_at": "2023-06-02T09:27:43.000000Z",
          "hide_payment": "",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 3048,
          "client_id": 207,
          "default_emailset_id": 0,
          "type": "entity",
          "name": "Borehole form",
          "prefix": "",
          "counter": 0,
          "box_folder_id": "",
          "can_donor_modify_amount": "",
          "mailchimp_list_id": "",
          "forgive_missed_payments": 0,
          "notify": null,
          "deleted_at": null,
          "created_at": "2023-10-17T06:27:19.000000Z",
          "updated_at": "2023-10-17T06:27:19.000000Z",
          "hide_payment": "",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 3051,
          "client_id": 207,
          "default_emailset_id": 0,
          "type": "entity",
          "name": "Demo campaign form",
          "prefix": "",
          "counter": 0,
          "box_folder_id": "",
          "can_donor_modify_amount": "",
          "mailchimp_list_id": "",
          "forgive_missed_payments": 0,
          "notify": null,
          "deleted_at": null,
          "created_at": "2024-06-13T08:38:12.000000Z",
          "updated_at": "2024-06-13T08:38:12.000000Z",
          "hide_payment": "",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ]
  },
  settings: {
      "settings": [
          {
            "id": 410,
            "client_id": 207,
            "name": "General Settings",
            "program_settings": "{\"program_type\":\"number\",\"sp_num\":\"\",\"labels\":\"\",\"number_spon\":\"2\",\"descending_order\":\"\",\"hide_noimage_recipients\":\"\",\"donation_target\":\"\",\"sponsorship_amount\":\"35,40,50\",\"transaction_amount\":\"\",\"currency_symbol\":\"$\",\"duration\":\"366\",\"stripe\":\"1\",\"login_box\":\"1\",\"checks\":\"1\",\"designations\":\"1\",\"sorting\":\"1\",\"display_all\":\"1\",\"wire_transfer\":\"1\",\"cash\":\"1\",\"hide_payment_method\":\"\",\"hide_frequency\":\"\",\"placeholder\":\"\",\"display_info\":\"1\",\"display_percent\":\"1\",\"processing_fee\":\"\",\"processing_percentage\":\"\"}",
            "text_front": "<p>Front End Text here for our program</p>",
            "text_profile": "<p>profile page text</p>",
            "text_checkout": "<p><strong> Order Page Texts</strong></p>",
            "text_account": "<p>donor account page</p>",
            "info": "<p>Sponsoring [en_child_name] helps provide basic needs like hot lunch, school uniform, school books and supplies.</p>",
            "allow_email": 1,
            "show_payment": 1,
            "deleted_at": null,
            "created_at": "2017-02-22T17:40:22.000000Z",
            "updated_at": "2024-06-17T12:21:18.000000Z",
            "__hevo__ingested_at": 1679725258686,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new",
            "programs": [
              {
                "id": 929,
                "client_id": 207,
                "hysform_id": 638,
                "donor_hysform_id": 639,
                "setting_id": 410,
                "emailset_id": 337,
                "entity_submit": "",
                "donor_submit": "0",
                "link_id": 0,
                "name": "Education",
                "prefix": "",
                "counter": 427,
                "lft": 20,
                "rgt": 21,
                "tree": 207,
                "box_folder_id": "",
                "deleted_at": null,
                "created_at": "2017-02-23T01:40:22.000000Z",
                "updated_at": "2024-06-17T13:15:33.000000Z",
                "__hevo__database_name": "apphys_new",
                "__hevo__ingested_at": 1680004248741,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": 1680003822000,
                "children": []
              },
              {
                "id": 1221,
                "client_id": 207,
                "hysform_id": 638,
                "donor_hysform_id": 639,
                "setting_id": 410,
                "emailset_id": 337,
                "entity_submit": "",
                "donor_submit": "",
                "link_id": 0,
                "name": "Sponsored",
                "prefix": "",
                "counter": 54,
                "lft": 18,
                "rgt": 19,
                "tree": 207,
                "box_folder_id": "",
                "deleted_at": null,
                "created_at": "2019-01-22T01:50:21.000000Z",
                "updated_at": "2024-07-09T13:54:44.000000Z",
                "__hevo__database_name": "apphys_new",
                "__hevo__ingested_at": 1679910350681,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": 1679909849000,
                "children": []
              },
              {
                "id": 3437,
                "client_id": 207,
                "hysform_id": 638,
                "donor_hysform_id": 0,
                "setting_id": 410,
                "emailset_id": 0,
                "entity_submit": "",
                "donor_submit": "",
                "link_id": 0,
                "name": "Medical",
                "prefix": "",
                "counter": 0,
                "lft": 16,
                "rgt": 17,
                "tree": 207,
                "box_folder_id": "",
                "deleted_at": null,
                "created_at": "2022-12-14T20:13:03.000000Z",
                "updated_at": "2023-03-28T18:44:07.000000Z",
                "__hevo__database_name": "apphys_new",
                "__hevo__ingested_at": 1680004248746,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": 1680003847000,
                "children": []
              },
              {
                "id": 3494,
                "client_id": 207,
                "hysform_id": 638,
                "donor_hysform_id": 639,
                "setting_id": 410,
                "emailset_id": 337,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": 929,
                "name": "SubTest2",
                "prefix": "",
                "counter": 1,
                "lft": 21,
                "rgt": 22,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-03-25T09:14:29.000000Z",
                "updated_at": "2024-07-09T13:35:33.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
              },
              {
                "id": 3506,
                "client_id": 207,
                "hysform_id": 3039,
                "donor_hysform_id": 639,
                "setting_id": 410,
                "emailset_id": 1557,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "Kupenda",
                "prefix": "KP",
                "counter": 200,
                "lft": 12,
                "rgt": 13,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-04-29T15:08:37.000000Z",
                "updated_at": "2024-07-09T13:33:24.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
              },
              {
                "id": 3510,
                "client_id": 207,
                "hysform_id": 3043,
                "donor_hysform_id": null,
                "setting_id": 410,
                "emailset_id": null,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "us2uganda",
                "prefix": "usa",
                "counter": null,
                "lft": 8,
                "rgt": 9,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-06-02T09:24:28.000000Z",
                "updated_at": "2023-06-02T09:36:45.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
              }
            ]
          },
          {
            "id": 1641,
            "client_id": 207,
            "name": "Test Settings",
            "program_settings": "{\"program_type\":\"contribution\",\"sp_num\":\"100\",\"labels\":\"Small\",\"number_spon\":\"\",\"descending_order\":\"\",\"hide_noimage_recipients\":\"\",\"donation_target\":\"\",\"sponsorship_amount\":\"10\",\"transaction_amount\":\"\",\"currency_symbol\":\"Yen\",\"duration\":\"365\",\"stripe\":\"\",\"login_box\":\"\",\"checks\":\"\",\"designations\":\"\",\"sorting\":\"\",\"display_all\":\"\",\"wire_transfer\":\"\",\"cash\":\"\",\"hide_payment_method\":\"\",\"hide_frequency\":\"\",\"placeholder\":\"\",\"display_info\":\"\",\"display_percent\":\"\",\"processing_fee\":\"\",\"processing_percentage\":\"\"}",
            "text_front": "<p>test text</p>",
            "text_profile": "<p>test text</p>",
            "text_checkout": "<p>test text</p>",
            "text_account": "<p>test text</p>",
            "info": "<p>test text</p>",
            "allow_email": 1,
            "show_payment": 1,
            "deleted_at": null,
            "created_at": "2023-04-03T10:14:32.000000Z",
            "updated_at": "2024-06-21T11:09:50.000000Z",
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": null,
            "programs": [
              {
                "id": 3438,
                "client_id": 207,
                "hysform_id": 3019,
                "donor_hysform_id": 639,
                "setting_id": 1641,
                "emailset_id": 0,
                "entity_submit": "",
                "donor_submit": "",
                "link_id": 0,
                "name": "Marathon for the disabled",
                "prefix": "",
                "counter": 0,
                "lft": 14,
                "rgt": 15,
                "tree": 207,
                "box_folder_id": "",
                "deleted_at": null,
                "created_at": "2022-12-21T16:50:33.000000Z",
                "updated_at": "2024-06-25T06:11:37.000000Z",
                "__hevo__database_name": "apphys_new",
                "__hevo__ingested_at": 1679910350683,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": 1679909849000,
                "children": []
              },
              {
                "id": 3507,
                "client_id": 207,
                "hysform_id": 3019,
                "donor_hysform_id": 3040,
                "setting_id": 1641,
                "emailset_id": null,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "Kupe",
                "prefix": "KUP",
                "counter": null,
                "lft": 10,
                "rgt": 11,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-05-03T06:41:45.000000Z",
                "updated_at": "2024-06-21T11:08:10.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
              }
            ]
          },
          {
            "id": 1646,
            "client_id": 207,
            "name": "Kupenda Setting",
            "program_settings": "{\"program_type\":\"number\",\"sp_num\":\"\",\"labels\":\"\",\"number_spon\":\"2\",\"descending_order\":\"\",\"hide_noimage_recipients\":\"\",\"donation_target\":\"\",\"sponsorship_amount\":\"32\",\"transaction_amount\":\"\",\"currency_symbol\":\"$\",\"duration\":\"365\",\"stripe\":\"\",\"login_box\":\"1\",\"checks\":\"1\",\"designations\":\"1\",\"sorting\":\"1\",\"display_all\":\"1\",\"wire_transfer\":\"1\",\"cash\":\"1\",\"hide_payment_method\":\"\",\"hide_frequency\":\"hidden\",\"placeholder\":\"\",\"display_info\":\"\",\"display_percent\":\"\",\"processing_fee\":\"\",\"processing_percentage\":\"\"}",
            "text_front": "<p>Front End Text here for our program</p>",
            "text_profile": "<p>profile page text</p>",
            "text_checkout": "<p><strong> Order Page Text</strong></p>",
            "text_account": "<p>donor account page</p>",
            "info": "<p>Sponsoring [en_child_name] helps provide basic needs like hot lunch, school uniform, school books and supplies.</p>",
            "allow_email": 1,
            "show_payment": 1,
            "deleted_at": null,
            "created_at": "2023-05-02T09:03:26.000000Z",
            "updated_at": "2024-06-20T11:50:58.000000Z",
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": null,
            "programs": []
          },
          {
            "id": 1650,
            "client_id": 207,
            "name": "General Donations",
            "program_settings": "{\"program_type\":\"campaign\",\"sp_num\":\"\",\"labels\":\"\",\"number_spon\":\"\",\"donation_target\":\"20000\",\"sponsorship_amount\":\"\",\"transaction_amount\":\"50,100,200,500\",\"currency_symbol\":\"$\",\"duration\":\"\",\"stripe\":\"1\",\"login_box\":\"1\",\"checks\":\"\",\"designations\":\"\",\"sorting\":\"\",\"display_all\":\"\",\"wire_transfer\":\"\",\"cash\":\"\",\"hide_payment_method\":\"\",\"hide_frequency\":\"\",\"placeholder\":\"data:image\\/png;base64,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\",\"disable_program_link\":\"\",\"display_info\":\"\",\"display_percent\":\"\",\"processing_fee\":\"1\",\"processing_percentage\":\"5\"}",
            "text_front": "",
            "text_profile": "",
            "text_checkout": "",
            "text_account": "",
            "info": "<p>Lorem Ipsum</p>",
            "allow_email": 0,
            "show_payment": 1,
            "deleted_at": null,
            "created_at": "2023-10-17T06:26:28.000000Z",
            "updated_at": "2023-10-17T06:26:28.000000Z",
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": null,
            "programs": [
              {
                "id": 3518,
                "client_id": 207,
                "hysform_id": 3048,
                "donor_hysform_id": 639,
                "setting_id": 1650,
                "emailset_id": null,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "Masaka BoreHole",
                "prefix": "MBH",
                "counter": 1,
                "lft": 4,
                "rgt": 5,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-10-17T06:26:48.000000Z",
                "updated_at": "2024-06-17T12:10:38.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
              }
            ]
          },
          {
            "id": 1652,
            "client_id": 207,
            "name": "Demo campaign setting",
            "program_settings": "{\"program_type\":\"campaign\",\"sp_num\":\"\",\"labels\":\"\",\"number_spon\":\"\",\"donation_target\":\"\",\"sponsorship_amount\":\"\",\"transaction_amount\":\"10,20,50,100\",\"currency_symbol\":\"$\",\"duration\":\"\",\"stripe\":\"1\",\"login_box\":\"\",\"checks\":\"1\",\"designations\":\"\",\"sorting\":\"\",\"display_all\":\"\",\"wire_transfer\":\"\",\"cash\":\"\",\"hide_payment_method\":\"\",\"hide_frequency\":\"\",\"placeholder\":\"\",\"disable_program_link\":\"\",\"display_info\":\"\",\"display_percent\":\"\",\"processing_fee\":\"1\",\"processing_percentage\":\"2.9\"}",
            "text_front": "",
            "text_profile": "",
            "text_checkout": "",
            "text_account": "",
            "info": "<p>Demo campaign description</p>",
            "allow_email": 0,
            "show_payment": 1,
            "deleted_at": null,
            "created_at": "2024-06-13T08:37:26.000000Z",
            "updated_at": "2024-06-13T08:37:26.000000Z",
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": null,
            "programs": [
              {
                "id": 3521,
                "client_id": 207,
                "hysform_id": 3051,
                "donor_hysform_id": 639,
                "setting_id": 1652,
                "emailset_id": null,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "Demo Campaign",
                "prefix": "DC",
                "counter": 1,
                "lft": 2,
                "rgt": 3,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2024-06-13T08:35:10.000000Z",
                "updated_at": "2024-06-13T08:40:15.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
              }
            ]
          }
        ]
  },
  auto_emails: {
      "emailsets": [
          {
            "id": 337,
            "client_id": 207,
            "name": "Child Sponsorship Program Email Templates",
            "from": "dev+10@helpyousponsor.com",
            "deleted_at": null,
            "created_at": "2017-02-22T17:40:22.000000Z",
            "updated_at": "2022-11-28T15:00:36.000000Z",
            "__hevo__ingested_at": 1679725257334,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new",
            "emailtemplates": [
              {
                "id": 2437,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "new_donor",
                "schedule": "",
                "to": "",
                "subject": "Welcome to our sponsorship program",
                "message": "<p>Hello [dn_donor_name],</p><p>Welcome to our sponsorship program. We are thankful you decided to sponsor [en_child_name]. Here is all the information you need to know about the program and contacting your child.</p><p>Sincerely,</p><p>Program Director</p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": null,
                "updated_at": "2019-02-19T04:10:09.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 2438,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "profile_update",
                "schedule": "",
                "to": "",
                "subject": "[en_child_name]'s profile has been updated!",
                "message": "<p>Hello [dn_donor_name],</p><p>We have just updated your sponsor child's information. You may log in to our website with your account to view the updated information about [en_child_name].</p><p>Thank you for your continued sponsorship. You are making a difference in the life of a child.</p><p>Sincerely,</p><p>Program Director</p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": null,
                "updated_at": "2019-02-19T04:10:09.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 2439,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "notify_donor",
                "schedule": "",
                "to": "",
                "subject": "Your sponsorship account has been setup with HYS Demo!",
                "message": "<h2>Donor Account for [dn_donor_name]</h2><p>You have been added to the \"sponsorship program\" for Hys Demo.</p><p>If you would like to have online access to your <span  style=\"background-color: initial;\">Hys Demo</span><span  style=\"background-color: initial;\"> Sponsorship,</span></p><p>please go to mshaiti.org, click on the sponsor tab at the top, then click login and enter your login information that is listed below. </p><p>You will now be able to set up your payments to be made automatically from a credit card. No more having to remember to send a check in the mail. Just click on the recurring option and it will be done for you.</p><p>Web access also gives you a place to send messages to your sponsor child, and throughout the year we will be posting notes and new photos right to your online account.</p><p>We are looking forward to the new opportunities that the online program has to offer and are very excited for you, our sponsors, to have more access to your sponsor children!</p><p>Thank you for your continued support!</p><p>Here is your login information:</p><ul><li>Username:  [username]</li><li>Temporary Password: [password]</li></ul>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": null,
                "updated_at": "2022-11-28T14:47:40.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 2440,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "pay_receipt",
                "schedule": "",
                "to": "",
                "subject": "Donation Receipt",
                "message": "<p>Thank you for your donation [designations] for [total_amount]. This email serves as your donation receipt.</p>\r\n\t\t\t\t\t\t\t\t<table style=\"\" border-color:#666;width:80%;margin:20px=\"\" auto;\"\"=\"\" cellpadding=\"\" 10\"\"=\"\">\r\n\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tDonor Name\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t[donor_name]\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tDesignation\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t[designation_name]\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tAmount\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t$[amount]\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tMethod\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t[method]\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\tFrequency\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t[frequency]</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t\t</table><p>[date]</p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": null,
                "updated_at": "2019-02-19T04:10:09.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 2441,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "pay_remind",
                "schedule": "",
                "to": "",
                "subject": "HYS Demo",
                "message": "<p>Hi [donor_name],</p><p>We are updating our sponsorship database and are asking that all of our sponsors confirm if they would like to continue or discontinue their sponsorship.  </p><p>Your information:</p><p>[designation_name] sponsored for [amount] [method] [frequency]</p><p>Please respond to this email with either continue or discontinue so we can have the most accurate information and continue to provide for the children.</p><p>We sincerely thank you for your support of our ministry. It is only through people like you that we are able to do what we do.</p><p>Sincerely,</p><p>Sponsorship Team</p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": null,
                "updated_at": "2022-11-28T14:48:31.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 2442,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "pay_fail",
                "schedule": "",
                "to": "",
                "subject": "Sponsorship Payment Failed ",
                "message": "<p>Hello [dn_donor_name],</p><p>We regret to inform you that there was a problem with your recent sponsorship payment [designation_name] for [[amount] by [method] every [frequency]. Please log in to your account on our website in order to update your card number.</p><p>Thank you,</p><p>Program Director</p><p>[error]</p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": null,
                "updated_at": "2019-02-19T04:10:09.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 2443,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "new_donor_admin",
                "schedule": "",
                "to": "dev@helpyousponsor.com",
                "subject": "New Sponsorship",
                "message": "<p>[dn_donor_name] has just signed up to sponsor [en_child_name]. [designations] [total_amount]</p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": null,
                "updated_at": "2024-04-25T19:56:53.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 2444,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "sp_email",
                "schedule": "",
                "to": "arnoldmukisa@gmail.com",
                "subject": "New email from [dn_donor_name] for [en_child_name]",
                "message": "<p>A sponsor has just sent an email to their sponsor child:</p><p>From: [dn_donor_name]</p><p>To: [en_child_name]</p><p>[subject]</p><p>[body]</p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": null,
                "updated_at": "2024-05-17T20:20:12.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 2445,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "pay_fail_admin",
                "schedule": "",
                "to": "",
                "subject": "Sponsorhip payment failed",
                "message": "<p>This is a notification that the following donor's payment failed: [dn_donor_name].</p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": null,
                "updated_at": "2019-02-20T19:55:25.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 3235,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "recip_email",
                "schedule": "",
                "to": "",
                "subject": "New Message from your sponsored child.",
                "message": "<p><span  style=\"background-color: initial;\">You have received a new message from your sponsor child [en_child_name]</span></p><p><span  style=\"background-color: initial;\">[subject] [login_link]</span></p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": "2018-11-24T02:47:17.000000Z",
                "updated_at": "2019-09-04T23:02:35.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              },
              {
                "id": 3342,
                "client_id": 207,
                "emailset_id": 337,
                "trigger": "year_end_statement",
                "schedule": "",
                "to": "",
                "subject": "Donor Year End Statement",
                "message": "<hr><p>[dn_donor_name]</p><p>This is your donor year end statement for [year] for Mission Starfish Haiti. </p><p>[year_end_total]</p><p>[donations_table]</p>",
                "disabled": 1,
                "deleted_at": null,
                "created_at": "2019-02-19T04:03:10.000000Z",
                "updated_at": "2022-12-10T14:06:15.000000Z",
                "__hevo__ingested_at": 1679725246677,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
              }
            ],
            "program": {
              "id": 929,
              "client_id": 207,
              "hysform_id": 638,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 337,
              "entity_submit": "",
              "donor_submit": "0",
              "link_id": 0,
              "name": "Education",
              "prefix": "",
              "counter": 427,
              "lft": 20,
              "rgt": 21,
              "tree": 207,
              "box_folder_id": "",
              "deleted_at": null,
              "created_at": "2017-02-23T01:40:22.000000Z",
              "updated_at": "2024-06-17T13:15:33.000000Z",
              "__hevo__database_name": "apphys_new",
              "__hevo__ingested_at": 1680004248741,
              "__hevo__marked_deleted": 0,
              "__hevo__source_modified_at": 1680003822000,
              "children": [],
              "donorfields": [
                {
                  "id": 1436,
                  "client_id": 207,
                  "hysform_id": 639,
                  "field_key": "dn_donor_name",
                  "field_label": "Donor Name",
                  "field_data": "Enter Name",
                  "field_type": "hysText",
                  "required": 1,
                  "permissions": "public",
                  "admingroup_id": 0,
                  "is_title": 1,
                  "field_order": 0,
                  "deleted_at": null,
                  "created_at": "2017-02-22T17:40:22.000000Z",
                  "updated_at": "2022-12-12T15:27:35.000000Z",
                  "__hevo__database_name": "apphys_new",
                  "__hevo__ingested_at": 1679725249741,
                  "__hevo__marked_deleted": 0,
                  "__hevo__source_modified_at": null
                },
                {
                  "id": 1817,
                  "client_id": 207,
                  "hysform_id": 639,
                  "field_key": "dn_payment_type",
                  "field_label": "Payment Type",
                  "field_data": "",
                  "field_type": "hysText",
                  "required": 0,
                  "permissions": "admin",
                  "admingroup_id": 0,
                  "is_title": 1,
                  "field_order": 1,
                  "deleted_at": null,
                  "created_at": "2019-01-23T01:58:32.000000Z",
                  "updated_at": "2022-12-12T15:27:35.000000Z",
                  "__hevo__database_name": "apphys_new",
                  "__hevo__ingested_at": 1679725249741,
                  "__hevo__marked_deleted": 0,
                  "__hevo__source_modified_at": null
                },
                {
                  "id": 1861,
                  "client_id": 207,
                  "hysform_id": 639,
                  "field_key": "dn_child_sponsored",
                  "field_label": "Child Sponsored",
                  "field_data": "Enter child name",
                  "field_type": "hysText",
                  "required": 0,
                  "permissions": "public",
                  "admingroup_id": 0,
                  "is_title": 0,
                  "field_order": 2,
                  "deleted_at": null,
                  "created_at": "2019-03-19T21:32:33.000000Z",
                  "updated_at": "2022-12-12T15:27:35.000000Z",
                  "__hevo__database_name": "apphys_new",
                  "__hevo__ingested_at": 1679725249741,
                  "__hevo__marked_deleted": 0,
                  "__hevo__source_modified_at": null
                }
              ]
            }
          },
          {
            "id": 1542,
            "client_id": 207,
            "name": "Test Emails",
            "from": "emailtest@gmail.com",
            "deleted_at": null,
            "created_at": "2023-02-27T07:53:03.000000Z",
            "updated_at": "2024-06-18T09:44:05.000000Z",
            "__hevo__ingested_at": 1679725257334,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new",
            "emailtemplates": [
              {
                "id": 12971,
                "client_id": 207,
                "emailset_id": 1542,
                "trigger": "new_donor",
                "schedule": "",
                "to": "",
                "subject": "shabanlubanga@gmail.com",
                "message": "<p>testing</p>",
                "disabled": 0,
                "deleted_at": null,
                "created_at": "2024-06-13T20:08:42.000000Z",
                "updated_at": "2024-06-13T20:09:06.000000Z",
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": null
              }
            ],
            "program": null
          },
          {
            "id": 1557,
            "client_id": 207,
            "name": "Test 2",
            "from": "Test2@gmail.com",
            "deleted_at": null,
            "created_at": "2024-07-09T13:18:10.000000Z",
            "updated_at": "2024-07-09T13:18:10.000000Z",
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": null,
            "emailtemplates": [
              {
                "id": 12990,
                "client_id": 207,
                "emailset_id": 1557,
                "trigger": "new_donor",
                "schedule": "",
                "to": "",
                "subject": "",
                "message": "",
                "disabled": 0,
                "deleted_at": null,
                "created_at": "2024-07-09T13:18:18.000000Z",
                "updated_at": "2024-07-09T13:18:18.000000Z",
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": null
              }
            ],
            "program": {
              "id": 3506,
              "client_id": 207,
              "hysform_id": 3039,
              "donor_hysform_id": 639,
              "setting_id": 410,
              "emailset_id": 1557,
              "entity_submit": null,
              "donor_submit": null,
              "link_id": null,
              "name": "Kupenda",
              "prefix": "KP",
              "counter": 200,
              "lft": 12,
              "rgt": 13,
              "tree": 207,
              "box_folder_id": null,
              "deleted_at": null,
              "created_at": "2023-04-29T15:08:37.000000Z",
              "updated_at": "2024-07-09T13:33:24.000000Z",
              "__hevo__database_name": null,
              "__hevo__ingested_at": null,
              "__hevo__marked_deleted": null,
              "__hevo__source_modified_at": null,
              "children": [],
              "donorfields": [
                {
                  "id": 1436,
                  "client_id": 207,
                  "hysform_id": 639,
                  "field_key": "dn_donor_name",
                  "field_label": "Donor Name",
                  "field_data": "Enter Name",
                  "field_type": "hysText",
                  "required": 1,
                  "permissions": "public",
                  "admingroup_id": 0,
                  "is_title": 1,
                  "field_order": 0,
                  "deleted_at": null,
                  "created_at": "2017-02-22T17:40:22.000000Z",
                  "updated_at": "2022-12-12T15:27:35.000000Z",
                  "__hevo__database_name": "apphys_new",
                  "__hevo__ingested_at": 1679725249741,
                  "__hevo__marked_deleted": 0,
                  "__hevo__source_modified_at": null
                },
                {
                  "id": 1817,
                  "client_id": 207,
                  "hysform_id": 639,
                  "field_key": "dn_payment_type",
                  "field_label": "Payment Type",
                  "field_data": "",
                  "field_type": "hysText",
                  "required": 0,
                  "permissions": "admin",
                  "admingroup_id": 0,
                  "is_title": 1,
                  "field_order": 1,
                  "deleted_at": null,
                  "created_at": "2019-01-23T01:58:32.000000Z",
                  "updated_at": "2022-12-12T15:27:35.000000Z",
                  "__hevo__database_name": "apphys_new",
                  "__hevo__ingested_at": 1679725249741,
                  "__hevo__marked_deleted": 0,
                  "__hevo__source_modified_at": null
                },
                {
                  "id": 1861,
                  "client_id": 207,
                  "hysform_id": 639,
                  "field_key": "dn_child_sponsored",
                  "field_label": "Child Sponsored",
                  "field_data": "Enter child name",
                  "field_type": "hysText",
                  "required": 0,
                  "permissions": "public",
                  "admingroup_id": 0,
                  "is_title": 0,
                  "field_order": 2,
                  "deleted_at": null,
                  "created_at": "2019-03-19T21:32:33.000000Z",
                  "updated_at": "2022-12-12T15:27:35.000000Z",
                  "__hevo__database_name": "apphys_new",
                  "__hevo__ingested_at": 1679725249741,
                  "__hevo__marked_deleted": 0,
                  "__hevo__source_modified_at": null
                }
              ]
            }
          }
        ],
        "template_errors": {
          "337": {
            "new_donor": [
              {
                "status": "success",
                "message": "Completed"
              }
            ],
            "profile_update": [
              {
                "status": "success",
                "message": "Completed"
              }
            ],
            "notify_donor": [
              {
                "status": "success",
                "message": "Completed"
              }
            ],
            "pay_receipt": [
              {
                "status": "warning",
                "message": "1 Warning"
              },
              {
                "status": "danger",
                "missing": "[donor_name] shortcode is missing"
              },
              {
                "status": "danger",
                "missing": "[designation_name] shortcode is missing"
              },
              {
                "status": "danger",
                "missing": "[amount] shortcode is missing"
              },
              {
                "status": "danger",
                "missing": "[frequency] shortcode is missing"
              }
            ],
            "pay_remind": [
              {
                "status": "warning",
                "message": "1 Warning"
              },
              {
                "status": "danger",
                "missing": "[donor_name] shortcode is missing"
              }
            ],
            "pay_fail": [
              {
                "status": "warning",
                "message": "1 Warning"
              },
              {
                "status": "danger",
                "missing": "[[amount] shortcode is missing"
              }
            ],
            "new_donor_admin": [
              {
                "status": "success",
                "message": "Completed"
              }
            ],
            "sp_email": [
              {
                "status": "success",
                "message": "Completed"
              }
            ],
            "pay_fail_admin": [
              {
                "status": "warning",
                "message": "1 Warning"
              },
              null,
              {
                "status": "danger",
                "missing": "[designation_name] shortcode is missing"
              },
              {
                "status": "danger",
                "missing": "[amount] shortcode is missing"
              },
              {
                "status": "danger",
                "missing": "[method] shortcode is missing"
              },
              {
                "status": "danger",
                "missing": "[frequency] shortcode is missing"
              },
              {
                "status": "danger",
                "missing": "[error] shortcode is missing"
              }
            ],
            "recip_email": [
              {
                "status": "success",
                "message": "Completed"
              }
            ],
            "year_end_statement": [
              {
                "status": "info",
                "message": "Email Disabled"
              }
            ]
          },
          "1542": {
            "new_donor": [
              {
                "status": "success",
                "message": "Completed"
              }
            ],
            "new_donor_admin": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "notify_donor": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "sp_email": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "recip_email": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "profile_update": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "pay_remind": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "pay_receipt": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "pay_fail": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "year_end_statement": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "pay_fail_admin": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ]
          },
          "1557": {
            "new_donor": [
              {
                "status": "warning",
                "message": "1 Warning"
              },
              {
                "status": "danger",
                "message": "No Subject"
              },
              {
                "status": "danger",
                "message": "No Email Message Body"
              }
            ],
            "new_donor_admin": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "notify_donor": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "sp_email": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "recip_email": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "profile_update": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "pay_remind": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "pay_receipt": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "pay_fail": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "year_end_statement": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ],
            "pay_fail_admin": [
              {
                "status": "danger",
                "message": "Email Blank"
              }
            ]
          }
        },
        "t_array": {
          "new_donor": {
            "title": "New Donor Signup",
            "to": false,
            "shortcodes": [
              "username",
              "date"
            ],
            "required": []
          },
          "new_donor_admin": {
            "title": "Notify Admin of New Sponsorship",
            "to": true,
            "shortcodes": [
              "designations",
              "total_amount",
              "method",
              "frequency",
              "date",
              "donor_email"
            ],
            "required": [
              "designations",
              "total_amount"
            ]
          },
          "notify_donor": {
            "title": "Notify Donor of Account Setup",
            "to": false,
            "shortcodes": [
              "username",
              "email",
              "password"
            ],
            "required": [
              "username",
              "password"
            ]
          },
          "sp_email": {
            "title": "Notify Admin of Message from Sponsor",
            "to": true,
            "shortcodes": [
              "subject",
              "body"
            ],
            "required": [
              "subject",
              "body"
            ]
          },
          "recip_email": {
            "title": "Notify Sponsor of Message from Recipient",
            "to": false,
            "shortcodes": [
              "subject",
              "login_link",
              "url"
            ],
            "required": [
              "subject",
              "login_link"
            ]
          },
          "profile_update": {
            "title": "Notify Sponsor of Profile Update",
            "to": false,
            "shortcodes": [],
            "required": []
          },
          "pay_remind": {
            "title": "Donor Payment Reminder",
            "to": false,
            "shortcodes": [
              "designation_name",
              "amount",
              "method",
              "frequency"
            ],
            "required": [
              "designation_name",
              "amount",
              "method",
              "frequency"
            ]
          },
          "pay_receipt": {
            "title": "Donor Payment Receipt",
            "to": false,
            "shortcodes": [
              "designations",
              "total_amount",
              "method",
              "date"
            ],
            "required": [
              "designations",
              "total_amount",
              "method",
              "date"
            ]
          },
          "pay_fail": {
            "title": "Donor Payment Failed",
            "to": false,
            "shortcodes": [
              "designation_name",
              "amount",
              "method",
              "frequency",
              "error"
            ],
            "required": [
              "designation_name",
              "amount",
              "method",
              "frequency",
              "error"
            ]
          },
          "year_end_statement": {
            "title": "Donor Year End Statement",
            "to": false,
            "shortcodes": [
              "date",
              "year",
              "year_end_total",
              "donations_table"
            ],
            "required": [
              "year",
              "year_end_total",
              "donations_table"
            ]
          },
          "pay_fail_admin": {
            "title": "Notify Admin of Failed Payment",
            "to": true,
            "shortcodes": [
              "designation_name",
              "amount",
              "method",
              "frequency",
              "error"
            ],
            "required": [
              "designation_name",
              "amount",
              "method",
              "frequency",
              "error"
            ]
          }
        }
  },
  additional_gifts: {
      "designations": [
          {
            "id": 190,
            "client_id": 207,
            "emailset_id": 337,
            "hysforms": "639",
            "code": "",
            "name": "Bag of Rice",
            "info": "",
            "donation_amounts": "25",
            "deleted_at": null,
            "created_at": "2018-11-24T02:15:34.000000Z",
            "updated_at": "2018-11-24T02:26:13.000000Z",
            "__hevo__ingested_at": 1679725263466,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new"
          },
          {
            "id": 191,
            "client_id": 207,
            "emailset_id": 337,
            "hysforms": "639",
            "code": "",
            "name": "Bag of Beans",
            "info": "",
            "donation_amounts": "45",
            "deleted_at": null,
            "created_at": "2018-11-24T02:15:49.000000Z",
            "updated_at": "2018-11-24T02:26:21.000000Z",
            "__hevo__ingested_at": 1679725263466,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new"
          },
          {
            "id": 253,
            "client_id": 207,
            "emailset_id": 337,
            "hysforms": "639",
            "code": "TGT",
            "name": "Test Gift",
            "info": "",
            "donation_amounts": "5",
            "deleted_at": null,
            "created_at": "2023-03-16T09:53:26.000000Z",
            "updated_at": "2023-03-16T09:54:27.000000Z",
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": null
          }
        ]
  },
  url_generator: {
      "programs_by_hysform_id": [],
      "exists": false
  }
}

export const programs = [
  {
    "id": 929,
    "client_id": 207,
    "hysform_id": 638,
    "donor_hysform_id": 639,
    "setting_id": 410,
    "emailset_id": 337,
    "entity_submit": "",
    "donor_submit": "0",
    "link_id": 0,
    "name": "Education",
    "prefix": "",
    "counter": 427,
    "lft": 20,
    "rgt": 21,
    "tree": 207,
    "box_folder_id": "",
    "children": []
  },
  {
    "id": 3438,
    "client_id": 207,
    "hysform_id": 3019,
    "donor_hysform_id": 639,
    "setting_id": 1641,
    "emailset_id": 0,
    "entity_submit": "",
    "donor_submit": "",
    "link_id": 0,
    "name": "Marathon for the disabled",
    "prefix": "",
    "counter": 0,
    "lft": 14,
    "rgt": 15,
    "tree": 207,
    "box_folder_id": "",
  },
  {
    "id": 3494,
    "client_id": 207,
    "hysform_id": 638,
    "donor_hysform_id": 639,
    "setting_id": 410,
    "emailset_id": 337,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": 929,
    "name": "Youth Mentorship Program",
    "prefix": "",
    "counter": 1,
    "lft": 21,
    "rgt": 22,
    "tree": 207,
    "box_folder_id": null,
    "children": []
  },
  {
    "id": 3518,
    "client_id": 207,
    "hysform_id": 3048,
    "donor_hysform_id": 639,
    "setting_id": 1650,
    "emailset_id": null,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": null,
    "name": "Masaka BoreHole",
    "prefix": "MBH",
    "counter": 1,
    "lft": 4,
    "rgt": 5,
    "tree": 207,
    "box_folder_id": null,
    "children": []
  },
  {
    "id": 3521,
    "client_id": 207,
    "hysform_id": 3051,
    "donor_hysform_id": 639,
    "setting_id": 1652,
    "emailset_id": null,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": null,
    "name": "Sustainable Living Expo",
    "prefix": "DC",
    "counter": 1,
    "lft": 2,
    "rgt": 3,
    "tree": 207,
    "box_folder_id": null,
    "children": []
  }
]

export const archived = [
  {
    "id": 928,
    "client_id": 207,
    "hysform_id": 0,
    "donor_hysform_id": 0,
    "setting_id": 0,
    "emailset_id": 0,
    "entity_submit": "",
    "donor_submit": "",
    "link_id": 0,
    "name": "Mission Starfish Haiti",
    "prefix": "",
    "counter": 0,
    "lft": 1,
    "rgt": 22,
    "tree": 207,
    "box_folder_id": "",
    "deleted_at": null,
    "created_at": "2017-02-23T01:40:21.000000Z",
    "updated_at": "2023-03-27T16:37:29.000000Z",
    "__hevo__database_name": "apphys_new",
    "__hevo__ingested_at": 1679910350683,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": 1679909849000,
    "children": []
  },
  {
    "id": 929,
    "client_id": 207,
    "hysform_id": 638,
    "donor_hysform_id": 639,
    "setting_id": 410,
    "emailset_id": 337,
    "entity_submit": "",
    "donor_submit": "0",
    "link_id": 0,
    "name": "Education",
    "prefix": "",
    "counter": 427,
    "lft": 20,
    "rgt": 21,
    "tree": 207,
    "box_folder_id": "",
    "deleted_at": null,
    "created_at": "2017-02-23T01:40:22.000000Z",
    "updated_at": "2024-06-17T13:15:33.000000Z",
    "__hevo__database_name": "apphys_new",
    "__hevo__ingested_at": 1680004248741,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": 1680003822000,
    "children": []
  },
  {
    "id": 1221,
    "client_id": 207,
    "hysform_id": 638,
    "donor_hysform_id": 639,
    "setting_id": 410,
    "emailset_id": 337,
    "entity_submit": "",
    "donor_submit": "",
    "link_id": 0,
    "name": "Sponsored",
    "prefix": "",
    "counter": 54,
    "lft": 18,
    "rgt": 19,
    "tree": 207,
    "box_folder_id": "",
    "deleted_at": null,
    "created_at": "2019-01-22T01:50:21.000000Z",
    "updated_at": "2024-07-09T13:54:44.000000Z",
    "__hevo__database_name": "apphys_new",
    "__hevo__ingested_at": 1679910350681,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": 1679909849000,
    "children": []
  },
  {
    "id": 3437,
    "client_id": 207,
    "hysform_id": 638,
    "donor_hysform_id": 0,
    "setting_id": 410,
    "emailset_id": 0,
    "entity_submit": "",
    "donor_submit": "",
    "link_id": 0,
    "name": "Medical",
    "prefix": "",
    "counter": 0,
    "lft": 16,
    "rgt": 17,
    "tree": 207,
    "box_folder_id": "",
    "deleted_at": null,
    "created_at": "2022-12-14T20:13:03.000000Z",
    "updated_at": "2023-03-28T18:44:07.000000Z",
    "__hevo__database_name": "apphys_new",
    "__hevo__ingested_at": 1680004248746,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": 1680003847000,
    "children": []
  },
  {
    "id": 3438,
    "client_id": 207,
    "hysform_id": 3019,
    "donor_hysform_id": 639,
    "setting_id": 1641,
    "emailset_id": 0,
    "entity_submit": "",
    "donor_submit": "",
    "link_id": 0,
    "name": "Marathon for the disabled",
    "prefix": "",
    "counter": 0,
    "lft": 14,
    "rgt": 15,
    "tree": 207,
    "box_folder_id": "",
    "deleted_at": null,
    "created_at": "2022-12-21T16:50:33.000000Z",
    "updated_at": "2024-06-25T06:11:37.000000Z",
    "__hevo__database_name": "apphys_new",
    "__hevo__ingested_at": 1679910350683,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": 1679909849000,
    "children": []
  },
  {
    "id": 3494,
    "client_id": 207,
    "hysform_id": 638,
    "donor_hysform_id": 639,
    "setting_id": 410,
    "emailset_id": 337,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": 929,
    "name": "SubTest2",
    "prefix": "",
    "counter": 1,
    "lft": 21,
    "rgt": 22,
    "tree": 207,
    "box_folder_id": null,
    "deleted_at": null,
    "created_at": "2023-03-25T09:14:29.000000Z",
    "updated_at": "2024-07-09T13:35:33.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "children": []
  },
  {
    "id": 3506,
    "client_id": 207,
    "hysform_id": 3039,
    "donor_hysform_id": 639,
    "setting_id": 410,
    "emailset_id": 1557,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": null,
    "name": "Kupenda",
    "prefix": "KP",
    "counter": 200,
    "lft": 12,
    "rgt": 13,
    "tree": 207,
    "box_folder_id": null,
    "deleted_at": null,
    "created_at": "2023-04-29T15:08:37.000000Z",
    "updated_at": "2024-07-09T13:33:24.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "children": []
  },
  {
    "id": 3507,
    "client_id": 207,
    "hysform_id": 3019,
    "donor_hysform_id": 3040,
    "setting_id": 1641,
    "emailset_id": null,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": null,
    "name": "Kupe",
    "prefix": "KUP",
    "counter": null,
    "lft": 10,
    "rgt": 11,
    "tree": 207,
    "box_folder_id": null,
    "deleted_at": null,
    "created_at": "2023-05-03T06:41:45.000000Z",
    "updated_at": "2024-06-21T11:08:10.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "children": []
  },
  {
    "id": 3510,
    "client_id": 207,
    "hysform_id": 3043,
    "donor_hysform_id": null,
    "setting_id": 410,
    "emailset_id": null,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": null,
    "name": "us2uganda",
    "prefix": "usa",
    "counter": null,
    "lft": 8,
    "rgt": 9,
    "tree": 207,
    "box_folder_id": null,
    "deleted_at": null,
    "created_at": "2023-06-02T09:24:28.000000Z",
    "updated_at": "2023-06-02T09:36:45.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "children": []
  },
  {
    "id": 3517,
    "client_id": 207,
    "hysform_id": null,
    "donor_hysform_id": null,
    "setting_id": null,
    "emailset_id": null,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": null,
    "name": "hellochild",
    "prefix": "hc",
    "counter": null,
    "lft": 6,
    "rgt": 7,
    "tree": 207,
    "box_folder_id": null,
    "deleted_at": null,
    "created_at": "2023-07-11T11:00:56.000000Z",
    "updated_at": "2023-07-11T11:00:56.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "children": []
  },
  {
    "id": 3518,
    "client_id": 207,
    "hysform_id": 3048,
    "donor_hysform_id": 639,
    "setting_id": 1650,
    "emailset_id": null,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": null,
    "name": "Masaka BoreHole",
    "prefix": "MBH",
    "counter": 1,
    "lft": 4,
    "rgt": 5,
    "tree": 207,
    "box_folder_id": null,
    "deleted_at": null,
    "created_at": "2023-10-17T06:26:48.000000Z",
    "updated_at": "2024-06-17T12:10:38.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "children": []
  },
  {
    "id": 3521,
    "client_id": 207,
    "hysform_id": 3051,
    "donor_hysform_id": 639,
    "setting_id": 1652,
    "emailset_id": null,
    "entity_submit": null,
    "donor_submit": null,
    "link_id": null,
    "name": "Demo Campaign",
    "prefix": "DC",
    "counter": 1,
    "lft": 2,
    "rgt": 3,
    "tree": 207,
    "box_folder_id": null,
    "deleted_at": null,
    "created_at": "2024-06-13T08:35:10.000000Z",
    "updated_at": "2024-06-13T08:40:15.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "children": []
  }
]

export const sponsorships_programs = {
  "programs": [
      {
        "id": 929,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 337,
        "entity_submit": "",
        "donor_submit": "0",
        "link_id": 0,
        "name": "Education",
        "prefix": "",
        "counter": 427,
        "lft": 20,
        "rgt": 21,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2017-02-23T01:40:22.000000Z",
        "updated_at": "2024-06-17T13:15:33.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1680004248741,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1680003822000,
        "children": []
      },
      {
        "id": 3438,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 639,
        "setting_id": 1641,
        "emailset_id": 0,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Marathon for the disabled",
        "prefix": "",
        "counter": 0,
        "lft": 14,
        "rgt": 15,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2022-12-21T16:50:33.000000Z",
        "updated_at": "2024-06-25T06:11:37.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679910350683,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1679909849000,
        "children": []
      },
      {
        "id": 3494,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 337,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": 929,
        "name": "Youth Mentorship Program",
        "prefix": "",
        "counter": 1,
        "lft": 21,
        "rgt": 22,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-03-25T09:14:29.000000Z",
        "updated_at": "2024-07-09T13:35:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "parent_program": "Education",
        "children": []
      },
      {
        "id": 3518,
        "client_id": 207,
        "hysform_id": 3048,
        "donor_hysform_id": 639,
        "setting_id": 1650,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Masaka BoreHole",
        "prefix": "MBH",
        "counter": 1,
        "lft": 4,
        "rgt": 5,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-10-17T06:26:48.000000Z",
        "updated_at": "2024-06-17T12:10:38.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      {
        "id": 3521,
        "client_id": 207,
        "hysform_id": 3051,
        "donor_hysform_id": 639,
        "setting_id": 1652,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Sustainable Living Expo",
        "prefix": "DC",
        "counter": 1,
        "lft": 2,
        "rgt": 3,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2024-06-13T08:35:10.000000Z",
        "updated_at": "2024-06-13T08:40:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      }
  ],
  "archived": [
    {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 427,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T01:40:22.000000Z",
      "updated_at": "2024-06-17T13:15:33.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    {
      "id": 3438,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 1641,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Marathon for the disabled",
      "prefix": "",
      "counter": 0,
      "lft": 14,
      "rgt": 15,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-21T16:50:33.000000Z",
      "updated_at": "2024-06-25T06:11:37.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679910350683,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1679909849000,
      "children": []
    },
    {
      "id": 3494,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": 929,
      "name": "SubTest2",
      "prefix": "",
      "counter": 1,
      "lft": 21,
      "rgt": 22,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-03-25T09:14:29.000000Z",
      "updated_at": "2024-07-09T13:35:33.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    {
      "id": 3518,
      "client_id": 207,
      "hysform_id": 3048,
      "donor_hysform_id": 639,
      "setting_id": 1650,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Masaka BoreHole",
      "prefix": "MBH",
      "counter": 1,
      "lft": 4,
      "rgt": 5,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-10-17T06:26:48.000000Z",
      "updated_at": "2024-06-17T12:10:38.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    {
      "id": 3521,
      "client_id": 207,
      "hysform_id": 3051,
      "donor_hysform_id": 639,
      "setting_id": 1652,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Sustainable Living Expo",
      "prefix": "DC",
      "counter": 1,
      "lft": 2,
      "rgt": 3,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2024-06-13T08:35:10.000000Z",
      "updated_at": "2024-06-13T08:40:15.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    }
  ],
  "number_of_programs": 11
}

export const programs_headers = {
  929: {
    "data": {
      "fields": [
        {
          "id": 2442,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_child_name",
          "field_label": "Child Name",
          "field_data": "Enter Name",
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 0,
          "deleted_at": null,
          "created_at": null,
          "updated_at": "2019-01-23T04:52:56.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2444,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_gender",
          "field_label": "Gender",
          "field_data": ",Male,Female",
          "field_type": "hysSelect",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 1,
          "deleted_at": null,
          "created_at": null,
          "updated_at": "2022-11-25T17:22:20.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2446,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_grade",
          "field_label": "Grade",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 2,
          "deleted_at": null,
          "created_at": "2017-02-22T21:57:53.000000Z",
          "updated_at": "2019-01-23T04:52:56.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2907,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_age",
          "field_label": "Age",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 3,
          "deleted_at": null,
          "created_at": "2018-09-29T20:27:08.000000Z",
          "updated_at": "2019-01-23T04:52:56.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2994,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_birthdate",
          "field_label": "Birthdate",
          "field_data": "",
          "field_type": "hysDate",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 1,
          "field_order": 4,
          "deleted_at": null,
          "created_at": "2018-11-24T07:11:48.000000Z",
          "updated_at": "2023-03-31T14:17:50.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2445,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_favorite_subject",
          "field_label": "Favorite Subject",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 8,
          "deleted_at": null,
          "created_at": "2017-02-22T21:57:18.000000Z",
          "updated_at": "2023-01-12T16:58:21.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        }
      ],
      "nameFields": {
        "en_child_name": "Child Name"
      },
      "program": {
        "id": 929,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 337,
        "entity_submit": "",
        "donor_submit": "0",
        "link_id": 0,
        "name": "Education",
        "prefix": "",
        "counter": 413,
        "lft": 20,
        "rgt": 21,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2017-02-23T04:40:22.000000Z",
        "updated_at": "2024-06-12T13:48:46.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1680004248741,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1680003822000,
        "children": []
      },
      "manage": true,
      "status": false,
      "thumbnail": true,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    }
  },
  1221: {
    "data": {
      "fields": [
        {
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_type": "hysText",
          "field_data": ""
        },
        {
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_type": "hysText",
          "field_data": ""
        },
        {
          "field_key": "en_age",
          "field_label": "Age",
          "field_type": "hysAge",
          "field_data": ""
        }
      ],
      "nameFields": {
        "en_first_name": "First Name",
        "en_second_name": "Second Name"
      },
      "program": {
        "id": 1221,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 0,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Sponsored",
        "prefix": "",
        "counter": 54,
        "lft": 18,
        "rgt": 19,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2019-01-22T01:50:21.000000Z",
        "updated_at": "2024-07-26T09:58:46.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679910350681,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1679909849000,
        "children": []
      },
      "manage": false,
      "status": false,
      "thumbnail": false,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    }
  },
  3437: {
    "data": {
      "fields": [
        {
          "field_key": "en_child_name",
          "field_label": "Child Name",
          "field_type": "hysText",
          "field_data": "Enter Name"
        }
      ],
      "nameFields": {
        "en_child_name": "Child Name"
      },
      "program": {
        "id": 3437,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 0,
        "setting_id": 410,
        "emailset_id": 0,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Medical",
        "prefix": "",
        "counter": 0,
        "lft": 16,
        "rgt": 17,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2022-12-14T20:13:03.000000Z",
        "updated_at": "2023-03-28T18:44:07.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1680004248746,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1680003847000,
        "children": []
      },
      "manage": false,
      "status": false,
      "thumbnail": false,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    }
  },
  3438: {
    "data": {
      "fields": {
        "0": {
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_type": "hysText",
          "field_data": null
        },
        "1": {
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_type": "hysText",
          "field_data": null
        },
        "2": {
          "field_key": "en_age",
          "field_label": "Age",
          "field_type": "hysAge",
          "field_data": null
        }
      },
      "nameFields": {
        "en_first_name": "First Name",
        "en_second_name": "Second Name"
      },
      "program": {
        "id": 3438,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 639,
        "setting_id": 1641,
        "emailset_id": 0,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Marathon for the Disabled",
        "prefix": "C1",
        "counter": 5,
        "lft": 14,
        "rgt": 15,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2022-12-21T16:50:33.000000Z",
        "updated_at": "2024-08-06T12:02:58.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679910350683,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1679909849000,
        "children": []
      },
      "manage": true,
      "status": false,
      "thumbnail": true,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"1\",\"\",\"\",\"\",\"1\",\"\",\"\",\"\",\"\",\"\"]"
    }
  },
  3494: {
    "data": {
      "fields": [
        {
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_type": "hysText",
          "field_data": null
        },
        {
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_type": "hysText",
          "field_data": null
        },
        {
          "field_key": "en_age",
          "field_label": "Age",
          "field_type": "hysAge",
          "field_data": null
        }
      ],
      "nameFields": {
        "en_first_name": "First Name",
        "en_second_name": "Second Name"
      },
      "program": {
        "id": 3494,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 1542,
        "entity_submit": "3058",
        "donor_submit": null,
        "link_id": 929,
        "name": "Youth Mentorship Program",
        "prefix": "",
        "counter": 5,
        "lft": 21,
        "rgt": 22,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-03-25T09:14:29.000000Z",
        "updated_at": "2024-08-06T12:51:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "manage": false,
      "status": false,
      "thumbnail": false,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    }
  },
  3506: {
    "data": {
      "fields": [
        {
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_type": "hysText",
          "field_data": null
        },
        {
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_type": "hysText",
          "field_data": null
        },
        {
          "field_key": "en_age",
          "field_label": "Age",
          "field_type": "hysAge",
          "field_data": null
        }
      ],
      "nameFields": {
        "en_first_name": "First Name",
        "en_second_name": "Second Name"
      },
      "program": {
        "id": 3506,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 3030,
        "setting_id": 410,
        "emailset_id": 1557,
        "entity_submit": "3058",
        "donor_submit": "",
        "link_id": null,
        "name": "Kupenda",
        "prefix": "KP",
        "counter": 200,
        "lft": 12,
        "rgt": 13,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-04-29T15:08:37.000000Z",
        "updated_at": "2024-07-29T09:01:30.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "manage": false,
      "status": false,
      "thumbnail": false,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    }
  },
  3507: {
    "data": {
      "fields": [
        {
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_type": "hysText",
          "field_data": ""
        },
        {
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_type": "hysText",
          "field_data": ""
        },
        {
          "field_key": "en_age",
          "field_label": "Age",
          "field_type": "hysAge",
          "field_data": ""
        }
      ],
      "nameFields": {
        "en_first_name": "First Name",
        "en_second_name": "Second Name"
      },
      "program": {
        "id": 3507,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 3040,
        "setting_id": 1646,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Kupe",
        "prefix": "KUP",
        "counter": null,
        "lft": 10,
        "rgt": 11,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-05-03T06:41:45.000000Z",
        "updated_at": "2024-07-25T08:23:28.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "manage": true,
      "status": false,
      "thumbnail": false,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    }
  },
  3510: {
    "data": {
      "fields": [
        {
          "id": 6612,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_student_id",
          "field_label": "Student Id",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 1,
          "deleted_at": null,
          "created_at": "2023-06-02T09:28:15.000000Z",
          "updated_at": "2023-06-02T09:28:15.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6613,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_student_grade",
          "field_label": "Student Grade",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 2,
          "deleted_at": null,
          "created_at": "2023-06-02T09:28:33.000000Z",
          "updated_at": "2023-06-02T09:28:33.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6614,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_school_attending",
          "field_label": "School Attending",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 3,
          "deleted_at": null,
          "created_at": "2023-06-02T09:28:55.000000Z",
          "updated_at": "2023-06-02T09:28:55.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6615,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 4,
          "deleted_at": null,
          "created_at": "2023-06-02T09:29:08.000000Z",
          "updated_at": "2023-06-02T09:29:08.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6616,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 5,
          "deleted_at": null,
          "created_at": "2023-06-02T09:30:17.000000Z",
          "updated_at": "2023-06-02T09:30:17.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6617,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_last_name_1",
          "field_label": "Last Name 1",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 6,
          "deleted_at": null,
          "created_at": "2023-06-02T09:30:32.000000Z",
          "updated_at": "2023-06-02T09:30:32.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "nameFields": [],
      "program": {
        "id": 3510,
        "client_id": 207,
        "hysform_id": 3043,
        "donor_hysform_id": null,
        "setting_id": 410,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "us2uganda",
        "prefix": "usa",
        "counter": null,
        "lft": 8,
        "rgt": 9,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-06-02T09:24:28.000000Z",
        "updated_at": "2023-06-02T09:36:45.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "manage": true,
      "status": false,
      "thumbnail": true,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    }
  },
  3521: {
    "data": {
      "fields": [
        {
          "field_key": "en_name",
          "field_label": "Name",
          "field_type": "hysText",
          "field_data": null
        }
      ],
      "nameFields": {
        "en_name": "Name"
      },
      "program": {
        "id": 3521,
        "client_id": 207,
        "hysform_id": 3051,
        "donor_hysform_id": 3030,
        "setting_id": 1652,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Sustainable Living Expo",
        "prefix": "DC",
        "counter": 1,
        "lft": 4,
        "rgt": 5,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2024-06-13T08:35:10.000000Z",
        "updated_at": "2024-08-06T12:03:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "manage": false,
      "status": false,
      "thumbnail": false,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    }
  },
  3518: {
    "data": {
      "fields": [
        {
          "id": 6643,
          "client_id": 207,
          "hysform_id": 3048,
          "field_key": "en_name",
          "field_label": "Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 1,
          "deleted_at": null,
          "created_at": "2023-10-17T06:27:32.000000Z",
          "updated_at": "2023-10-17T06:27:32.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "nameFields": {
        "en_name": "Name"
      },
      "program": {
        "id": 3518,
        "client_id": 207,
        "hysform_id": 3048,
        "donor_hysform_id": 639,
        "setting_id": 1650,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Masaka BoreHole",
        "prefix": "MBH",
        "counter": 1,
        "lft": 6,
        "rgt": 7,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-10-17T06:26:48.000000Z",
        "updated_at": "2024-06-17T12:10:38.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "manage": true,
      "status": false,
      "thumbnail": true,
      "profile_link": false,
      "created_at": false,
      "updated_at": false,
      "trashed": false,
      "trashed_name": "",
      "details_display": [],
      "nowrap": "[\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    }
  }
}

export const programs_statistics = {
  929: {
    "All": 347,
    "Available": 181,
    "Sponsored": 166,
    "Unsponsored": 297,
    "Archived": 48
  },
  1221: {
    "All": 2,
    "Available": 1,
    "Sponsored": 1,
    "Unsponsored": 1,
    "Archived": 0
  },
  3437: {
    "All": 6,
    "Available": 6,
    "Sponsored": 0,
    "Unsponsored": 6,
    "Archived": 0
  },
  3438: {
    "All": 5,
    "Available": 5,
    "Sponsored": 0,
    "Unsponsored": 5,
    "Archived": 0
  },
  3494: {
    "All": 5,
    "Available": 5,
    "Sponsored": 0,
    "Unsponsored": 4,
    "Archived": 0
  },
  3506: {
    "All": 200,
    "Available": 200,
    "Sponsored": 0,
    "Unsponsored": 200,
    "Archived": 0
  },
  3507: {
    "All": 464,
    "Available": 464,
    "Sponsored": 0,
    "Unsponsored": 464,
    "Archived": 0
  },
  3510: {
    "All": 326,
    "Available": 326,
    "Sponsored": 0,
    "Unsponsored": 326,
    "Archived": 0
  },
  3521: {
    "All": 1,
    "Available": 0,
    "Sponsored": 1,
    "Unsponsored": 0,
    "Archived": 0
  },
  3518: {
    "All": 1,
    "Available": 0,
    "Sponsored": 1,
    "Unsponsored": 0,
    "Archived": 0
  },
}

export const program_entities = [
  {
    "id": 929,
    "data": [
      {
        "id": 35915,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/5add42698590b15e892ba55953b571fd8eb122a21_t_.jpg",
        "status": "Sponsored",
        "en_child_name": "Emerdjina Charles",
        "en_gender": "Male",
        "en_grade": "4",
        "en_age": "",
        "en_birthdate": "Mar 11, 2023",
        "en_favorite_subject": "Mathematics"
      },
      {
        "id": 36303,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/0becc7d3242e43a025878a9abb4033dcf75d94da1_t_.jpg",
        "status": "Sponsored",
        "en_child_name": "Estilien Claudensky",
        "en_gender": "Male",
        "en_grade": "PS I",
        "en_age": "4",
        "en_birthdate": "Feb 05, 2015",
        "en_favorite_subject": ""
      },
      {
        "id": 36309,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/5b7eb9354eec560e3b68d0c6e17b999dc03bc7241_t_.jpg",
        "status": "Sponsored",
        "en_child_name": "Ismylove Jean",
        "en_gender": "Female",
        "en_grade": "PS 1",
        "en_age": "3",
        "en_birthdate": "Jun 14, 2015",
        "en_favorite_subject": ""
      },
      {
        "id": 36310,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/4d44a2d51707bf262eddc314dae9b22e122833d51_t_.jpg",
        "status": "Sponsored",
        "en_child_name": "Isedervensley Saint-Julles",
        "en_gender": "Male",
        "en_grade": "PS I",
        "en_age": "3",
        "en_birthdate": "Mar 03, 2016",
        "en_favorite_subject": ""
      },
      {
        "id": 36311,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/8d51ccbd2deb8b2064936295c8f7b97cd3218f6f1_t_.jpg",
        "status": "Sponsored",
        "en_child_name": "Peterson Jean",
        "en_gender": "Male",
        "en_grade": "PS I",
        "en_age": "4",
        "en_birthdate": "Mar 05, 2015",
        "en_favorite_subject": ""
      },
      {
        "id": 36313,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/f1d10f0b26749334b8c7c353cfac4707cc7212db1_t_.jpg",
        "status": "Sponsored",
        "en_child_name": "Stevenson Simon",
        "en_gender": "Male",
        "en_grade": "PS I",
        "en_age": "3",
        "en_birthdate": "Dec 27, 2015",
        "en_favorite_subject": ""
      },
      {
        "id": 36314,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/580e5bec44ac3065de041519d7e97c2861bdf8501_t_.jpg",
        "status": "Sponsored",
        "en_child_name": "Erline Helas",
        "en_gender": "Female",
        "en_grade": "PS I",
        "en_age": "3",
        "en_birthdate": "Dec 02, 2015",
        "en_favorite_subject": ""
      },
      {
        "id": 36316,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/c9387811ec79a4b857902a553ef158be966f08661_t_.jpg",
        "status": "Unsponsored",
        "en_child_name": "Jonalis Jude-Na\u00edca",
        "en_gender": "Female",
        "en_grade": "PS I",
        "en_age": "3",
        "en_birthdate": "Nov 02, 2015",
        "en_favorite_subject": ""
      },
      {
        "id": 36317,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/7c45cfea57db39146724937f8947bcc5613c4a4a1_t_.jpg",
        "status": "Sponsored",
        "en_child_name": "Dashe Landie Tilus",
        "en_gender": "Female",
        "en_grade": "PS I",
        "en_age": "3",
        "en_birthdate": "Dec 31, 2015",
        "en_favorite_subject": ""
      },
      {
        "id": 36322,
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/5f1d764c3aeffc37e3ab516ecdeaefa5b6f739bf1_t_.jpg",
        "status": "Sponsored",
        "en_child_name": "Jocel\u00e8ne Jocelyn",
        "en_gender": "Female",
        "en_grade": "PS I",
        "en_age": "3",
        "en_birthdate": "Mar 27, 2015",
        "en_favorite_subject": ""
      }
    ],
    "length": 10,
    "filter": "false"
  },
  {
    "id": 1221,
    "data": [
      {
        "id": 36305,
        "status": "Sponsored",
        "en_age": "3",
        "en_first_name": "Fred",
        "en_second_name": "Wishmonger",
        "thumbnail": "https://s3-us-west-1.amazonaws.com/hys/c07e54b8f0c5686e2837e10950152f7dbc9b33fe1_t_.png"
      },
      {
        "id": 45642,
        "status": "Unsponsored",
        "en_age": "6",
        "en_first_name": "Michelle",
        "en_second_name": "Barker",
        "thumbnail": ""
      }
    ],
    "length": 2,
    "filter": "false"
  },
  {
    "id": 3437,
    "data": [
      {
        "id": 46798,
        "status": "Unsponsored",
        "en_child_name": "Kashuru",
        "thumbnail": ""
      },
      {
        "id": 46799,
        "status": "Unsponsored",
        "en_child_name": "Amina",
        "thumbnail": ""
      },
      {
        "id": 46800,
        "status": "Unsponsored",
        "en_child_name": "Baraka",
        "thumbnail": ""
      },
      {
        "id": 46801,
        "status": "Unsponsored",
        "en_child_name": "Kennedy",
        "thumbnail": ""
      },
      {
        "id": 46802,
        "status": "Unsponsored",
        "en_child_name": "Grace",
        "thumbnail": ""
      },
      {
        "id": 46803,
        "status": "Unsponsored",
        "en_child_name": "Martha",
        "thumbnail": ""
      }
    ],
    "length": 6,
    "filter": "false"
  },
  {
    "id": 3438,
    "data": [
      {
        "id": 48048,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_first_name": "Daniel",
        "en_second_name": "Cox",
        "en_age": "14 (Feb 26, 2010)"
      },
      {
        "id": 48049,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_first_name": "Morwenna",
        "en_second_name": "Barlow",
        "en_age": "25 (Feb 10, 1999)"
      },
      {
        "id": 48050,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_first_name": "Kimberly",
        "en_second_name": "Parker",
        "en_age": "18 (Jul 13, 2006)"
      },
      {
        "id": 48051,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_first_name": "Mathias",
        "en_second_name": "Wu",
        "en_age": "23 (Aug 24, 2000)"
      },
      {
        "id": 48052,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_first_name": "Michelle",
        "en_second_name": "Olsson",
        "en_age": "12 (Jul 17, 2012)"
      }
    ],
    "length": 5,
    "filter": "false"
  },
  {
    "id": 3494,
    "data": [
      {
        "id": 48046,
        "status": "Partially Sponsored",
        "en_first_name": "Dolly",
        "en_second_name": "Blackman",
        "en_age": "8 (Feb 3, 2016)"
      },
      {
        "id": 48067,
        "status": "Unsponsored",
        "en_first_name": "Matthew",
        "en_second_name": "Lakemans",
        "en_age": "10 (Jul 10, 2014)"
      },
      {
        "id": 48068,
        "status": "Unsponsored",
        "en_first_name": "Mavis",
        "en_second_name": "Vader",
        "en_age": "12 (Jun 12, 2012)"
      },
      {
        "id": 48069,
        "status": "Unsponsored",
        "en_first_name": "Fred",
        "en_second_name": "Johnson",
        "en_age": "15 (Dec 20, 2008)"
      },
      {
        "id": 48070,
        "status": "Unsponsored",
        "en_first_name": "Charity",
        "en_second_name": "Smart",
        "en_age": "14 (Jun 9, 2010)"
      }
    ],
    "length": 5,
    "filter": "false"
  },
  {
    "id": 3506,
    "data": [
      {
        "id": 47502,
        "status": "Unsponsored",
        "en_first_name": "Said",
        "en_second_name": "Kitsao",
        "en_age": ""
      },
      {
        "id": 47503,
        "status": "Unsponsored",
        "en_first_name": "Amani",
        "en_second_name": "",
        "en_age": ""
      },
      {
        "id": 47504,
        "status": "Unsponsored",
        "en_first_name": "Fatuma",
        "en_second_name": "",
        "en_age": ""
      },
      {
        "id": 47505,
        "status": "Unsponsored",
        "en_first_name": "Furaha",
        "en_second_name": "",
        "en_age": ""
      },
      {
        "id": 47506,
        "status": "Unsponsored",
        "en_first_name": "Joyce",
        "en_second_name": "",
        "en_age": ""
      },
      {
        "id": 47507,
        "status": "Unsponsored",
        "en_first_name": "Kashuru",
        "en_second_name": "Msanzu",
        "en_age": ""
      },
      {
        "id": 47508,
        "status": "Unsponsored",
        "en_first_name": "Amina",
        "en_second_name": "Nyundo",
        "en_age": ""
      },
      {
        "id": 47509,
        "status": "Unsponsored",
        "en_first_name": "Baraka",
        "en_second_name": "",
        "en_age": ""
      },
      {
        "id": 47510,
        "status": "Unsponsored",
        "en_first_name": "Kennedy",
        "en_second_name": "",
        "en_age": ""
      },
      {
        "id": 47511,
        "status": "Unsponsored",
        "en_first_name": "Grace",
        "en_second_name": "Mahenzo",
        "en_age": ""
      }
    ],
    "length": 200,
    "filter": "false"
  },
  {
    "id": 3507,
    "data": [
      {
        "id": 47038,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Juliana",
        "en_second_name": "Neema",
        "thumbnail": ""
      },
      {
        "id": 47039,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Mary",
        "en_second_name": "Dama",
        "thumbnail": ""
      },
      {
        "id": 47040,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Hezron",
        "en_second_name": "Kenga",
        "thumbnail": ""
      },
      {
        "id": 47041,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Lewiz",
        "en_second_name": "Chirimo",
        "thumbnail": ""
      },
      {
        "id": 47042,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Esther",
        "en_second_name": "",
        "thumbnail": ""
      },
      {
        "id": 47043,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Daniel",
        "en_second_name": "",
        "thumbnail": ""
      },
      {
        "id": 47044,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Samuel",
        "en_second_name": "Ushindi",
        "thumbnail": ""
      },
      {
        "id": 47045,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Charity",
        "en_second_name": "Pendo",
        "thumbnail": ""
      },
      {
        "id": 47046,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Faith",
        "en_second_name": "Sidi",
        "thumbnail": ""
      },
      {
        "id": 47047,
        "status": "Unsponsored",
        "en_age": "",
        "en_first_name": "Easther",
        "en_second_name": "Dhahabu",
        "thumbnail": ""
      }
    ],
    "length": 464,
    "filter": "false"
  },
  {
    "id": 3510,
    "data": [
      {
        "id": 47702,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "2134",
        "en_student_grade": "S4",
        "en_school_attending": "YAHS",
        "en_first_name": "Obedience",
        "en_second_name": "",
        "en_last_name_1": "Akansasira"
      },
      {
        "id": 47703,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "2137-0000",
        "en_student_grade": "Left-no contact",
        "en_school_attending": "Masaka Baptist School",
        "en_first_name": "Jonathan",
        "en_second_name": "",
        "en_last_name_1": "Mwesigwa"
      },
      {
        "id": 47704,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "2140",
        "en_student_grade": "Left-no contact",
        "en_school_attending": "Masaka Baptist School",
        "en_first_name": "David",
        "en_second_name": "",
        "en_last_name_1": "Mumo"
      },
      {
        "id": 47705,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "1004",
        "en_student_grade": "GRADUATED",
        "en_school_attending": "KIU University",
        "en_first_name": "Godwill",
        "en_second_name": "",
        "en_last_name_1": "Atuheire"
      },
      {
        "id": 47706,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "2009-2120",
        "en_student_grade": "P7",
        "en_school_attending": "Masaka Baptist School",
        "en_first_name": "Joan",
        "en_second_name": "",
        "en_last_name_1": "Nandago"
      },
      {
        "id": 47707,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "1082",
        "en_student_grade": "S3",
        "en_school_attending": "YAHS",
        "en_first_name": "Angel",
        "en_second_name": "Princess",
        "en_last_name_1": "Mirembe"
      },
      {
        "id": 47708,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "1084",
        "en_student_grade": "Left-not interested",
        "en_school_attending": "YAHS",
        "en_first_name": "Hajarah",
        "en_second_name": "",
        "en_last_name_1": "Kirabo"
      },
      {
        "id": 47709,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "2006-1085",
        "en_student_grade": "S3",
        "en_school_attending": "YAHS",
        "en_first_name": "Abdul",
        "en_second_name": "",
        "en_last_name_1": "Hassan"
      },
      {
        "id": 47710,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "1006",
        "en_student_grade": "P7",
        "en_school_attending": "Masaka Baptist School",
        "en_first_name": "Godfrey",
        "en_second_name": "",
        "en_last_name_1": "Bulegeya"
      },
      {
        "id": 47711,
        "thumbnail": "",
        "status": "Unsponsored",
        "en_student_id": "2169",
        "en_student_grade": "S3",
        "en_school_attending": "YAHS",
        "en_first_name": "Racheal",
        "en_second_name": "",
        "en_last_name_1": "Nabukenya"
      }
    ],
    "length": 326,
    "filter": "false"
  },
  {
    "id": 3521,
    "data": [
      {
        "id": 48045,
        "status": "Sponsored",
        "en_name": "Demo campaign recipient"
      }
    ],
    "length": 1,
    "filter": "false"
  },
  {
    "id": 3518,
    "data": [
      {
        "id": 48028,
        "thumbnail": "",
        "status": "Sponsored",
        "en_name": "Masaka BoreHole"
      }
    ],
    "length": 1,
    "filter": "false"
  }
]

export const programs_fields = {
  929: {
    "data": {
      "program": {
        "id": 929,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 337,
        "entity_submit": "",
        "donor_submit": "0",
        "link_id": 0,
        "name": "Education",
        "prefix": "",
        "counter": 413,
        "lft": 20,
        "rgt": 21,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2017-02-23T04:40:22.000000Z",
        "updated_at": "2024-06-12T13:48:46.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1680004248741,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1680003822000,
        "children": []
      },
      "fieldOptions": {
        "program-929": [
          {
            "field_key": "en_child_name",
            "field_label": "Child Name"
          },
          {
            "field_key": "en_gender",
            "field_label": "Gender"
          },
          {
            "field_key": "en_grade",
            "field_label": "Grade"
          },
          {
            "field_key": "en_age",
            "field_label": "Age"
          },
          {
            "field_key": "en_birthdate",
            "field_label": "Birthdate"
          },
          {
            "field_key": "en_favorite_subject",
            "field_label": "Favorite Subject"
          },
          {
            "field_key": "en_test_table",
            "field_label": "Test Table"
          },
          {
            "field_key": "en_test_check_box",
            "field_label": "Test Check box"
          },
          {
            "field_key": "en_test_field_boolea",
            "field_label": "Test Field boolean"
          },
          {
            "field_key": "en_test_checkbox_2",
            "field_label": "Test Checkbox 2"
          }
        ],
        "donor-639": [
          {
            "field_key": "dn_donor_name",
            "field_label": "Donor Name"
          },
          {
            "field_key": "dn_payment_type",
            "field_label": "Payment Type"
          },
          {
            "field_key": "dn_child_sponsored",
            "field_label": "Child Sponsored"
          }
        ]
      },
      "fields": [
        {
          "id": 2442,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_child_name",
          "field_label": "Child Name",
          "field_data": "Enter Name",
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 0,
          "deleted_at": null,
          "created_at": null,
          "updated_at": "2019-01-23T04:52:56.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2444,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_gender",
          "field_label": "Gender",
          "field_data": ",Male,Female",
          "field_type": "hysSelect",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 1,
          "deleted_at": null,
          "created_at": null,
          "updated_at": "2022-11-25T17:22:20.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2446,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_grade",
          "field_label": "Grade",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 2,
          "deleted_at": null,
          "created_at": "2017-02-22T21:57:53.000000Z",
          "updated_at": "2019-01-23T04:52:56.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2907,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_age",
          "field_label": "Age",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 3,
          "deleted_at": null,
          "created_at": "2018-09-29T20:27:08.000000Z",
          "updated_at": "2019-01-23T04:52:56.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2994,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_birthdate",
          "field_label": "Birthdate",
          "field_data": "",
          "field_type": "hysDate",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 1,
          "field_order": 4,
          "deleted_at": null,
          "created_at": "2018-11-24T07:11:48.000000Z",
          "updated_at": "2023-03-31T14:17:50.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2445,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_favorite_subject",
          "field_label": "Favorite Subject",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 8,
          "deleted_at": null,
          "created_at": "2017-02-22T21:57:18.000000Z",
          "updated_at": "2023-01-12T16:58:21.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6523,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_test_table",
          "field_label": "Test Table",
          "field_data": "age, gender",
          "field_type": "hysTable",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 12,
          "deleted_at": null,
          "created_at": "2023-01-16T14:11:19.000000Z",
          "updated_at": "2023-01-16T14:11:19.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6536,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_test_check_box",
          "field_label": "Test Check box",
          "field_data": "yes,no",
          "field_type": "hysCheckbox",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 13,
          "deleted_at": null,
          "created_at": "2023-03-17T10:04:48.000000Z",
          "updated_at": "2023-03-17T10:04:48.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6537,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_test_field_boolea",
          "field_label": "Test Field boolean",
          "field_data": "yes,no",
          "field_type": "hysSelect",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 14,
          "deleted_at": null,
          "created_at": "2023-03-17T12:42:48.000000Z",
          "updated_at": "2023-03-17T12:42:48.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6538,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_test_checkbox_2",
          "field_label": "Test Checkbox 2",
          "field_data": "maybe,later",
          "field_type": "hysCheckbox",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 15,
          "deleted_at": null,
          "created_at": "2023-03-31T16:06:06.000000Z",
          "updated_at": "2023-03-31T16:06:06.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [
        {
          "id": 561,
          "client_id": 207,
          "hysform_id": 638,
          "name": "Child Sponsorship Program",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},\\\"1\\\":{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},\\\"2\\\":{\\\"field_key\\\":\\\"en_grade\\\",\\\"field_label\\\":\\\"Grade\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},\\\"3\\\":{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},\\\"4\\\":{\\\"field_key\\\":\\\"en_birthdate\\\",\\\"field_label\\\":\\\"Birthdate\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},\\\"number_of_sponsors\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2019-02-06T02:22:33.000000Z",
          "updated_at": "2019-02-06T02:22:33.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 562,
          "client_id": 207,
          "hysform_id": 638,
          "name": "Sponsored Children",
          "fields": "{\"program\":\"[{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},{\\\"field_key\\\":\\\"en_grade\\\",\\\"field_label\\\":\\\"Grade\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_birthdate\\\",\\\"field_label\\\":\\\"Birthdate\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"}]\"}",
          "deleted_at": null,
          "created_at": "2019-02-06T02:42:06.000000Z",
          "updated_at": "2019-02-06T02:42:06.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 711,
          "client_id": 207,
          "hysform_id": 638,
          "name": "New Program",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},\\\"1\\\":{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},\\\"thumb\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2022-11-19T13:09:35.000000Z",
          "updated_at": "2022-11-19T13:09:35.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 723,
          "client_id": 207,
          "hysform_id": 638,
          "name": "childname",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},\\\"thumb\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2023-02-13T16:46:46.000000Z",
          "updated_at": "2023-02-13T16:46:46.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 724,
          "client_id": 207,
          "hysform_id": 638,
          "name": "Test Report 5",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},\\\"1\\\":{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},\\\"thumb\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2023-02-24T14:14:55.000000Z",
          "updated_at": "2023-02-24T14:14:55.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 726,
          "client_id": 207,
          "hysform_id": 638,
          "name": "Test report 6",
          "fields": "{\"program\":\"{\\\"thumb\\\":true,\\\"number_of_sponsors\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2023-02-24T18:00:54.000000Z",
          "updated_at": "2023-02-24T18:00:54.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 734,
          "client_id": 207,
          "hysform_id": 638,
          "name": "view name",
          "fields": "{\"program\":\"[{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"}]\"}",
          "deleted_at": null,
          "created_at": "2023-06-28T13:33:10.000000Z",
          "updated_at": "2023-06-28T13:33:10.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        }
      ],
      "details": {
        "To Date": "",
        "Number of Sponsors": "",
        "Percent Complete": ""
      }
    }
  },
  1221: {
    "data": {
      "program": {
        "id": 1221,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 0,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Sponsored",
        "prefix": "",
        "counter": 54,
        "lft": 18,
        "rgt": 19,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2019-01-22T01:50:21.000000Z",
        "updated_at": "2024-07-26T09:58:46.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679910350681,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1679909849000,
        "children": []
      },
      "fieldOptions": {
        "program-1221": [
          {
            "field_key": "en_first_name",
            "field_label": "First Name"
          },
          {
            "field_key": "en_second_name",
            "field_label": "Second Name"
          },
          {
            "field_key": "en_age",
            "field_label": "Age"
          }
        ],
        "donor-639": [
          {
            "field_key": "dn_donor_name",
            "field_label": "Donor Name"
          },
          {
            "field_key": "dn_payment_type",
            "field_label": "Payment Type"
          },
          {
            "field_key": "dn_address",
            "field_label": "Address"
          },
          {
            "field_key": "dn_id_field",
            "field_label": "Id fIELD"
          }
        ]
      },
      "fields": [
        {
          "id": 6717,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 8,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6718,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 9,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6719,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_age",
          "field_label": "Age",
          "field_data": null,
          "field_type": "hysAge",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 10,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [
        {
          "id": 736,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "ttt",
          "fields": "{\"program\":\"[{\\\"field_key\\\":\\\"en_test_textarea\\\",\\\"field_label\\\":\\\"test TextArea\\\",\\\"field_type\\\":\\\"hysTextarea\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_text_link\\\",\\\"field_label\\\":\\\"Text Link\\\",\\\"field_type\\\":\\\"hysLink\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_test_static_text\\\",\\\"field_label\\\":\\\"Test static Text\\\",\\\"field_type\\\":\\\"hysStatic\\\",\\\"field_data\\\":\\\"\\\"}]\"}",
          "deleted_at": null,
          "created_at": "2024-05-01T08:22:30.000000Z",
          "updated_at": "2024-05-01T08:22:30.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        },
        {
          "id": 737,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "Names",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_first_name\\\",\\\"field_label\\\":\\\"First Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"1\\\":{\\\"field_key\\\":\\\"en_second_name\\\",\\\"field_label\\\":\\\"Second Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"2\\\":{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysAge\\\",\\\"field_data\\\":null},\\\"thumb\\\":true,\\\"manage\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2024-07-29T18:42:43.000000Z",
          "updated_at": "2024-07-29T18:42:43.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        }
      ],
      "details": {
        "To Date": "",
        "Number of Sponsors": "",
        "Percent Complete": ""
      }
    }
  },
  3437: {
    "data": {
      "program": {
        "id": 3437,
        "client_id": 207,
        "hysform_id": 638,
        "donor_hysform_id": 0,
        "setting_id": 410,
        "emailset_id": 0,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Medical",
        "prefix": "",
        "counter": 0,
        "lft": 16,
        "rgt": 17,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2022-12-14T20:13:03.000000Z",
        "updated_at": "2023-03-28T18:44:07.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1680004248746,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1680003847000,
        "children": []
      },
      "fieldOptions": {
        "program-3437": [
          {
            "field_key": "en_child_name",
            "field_label": "Child Name"
          },
          {
            "field_key": "en_gender",
            "field_label": "Gender"
          },
          {
            "field_key": "en_grade",
            "field_label": "Grade"
          },
          {
            "field_key": "en_age",
            "field_label": "Age"
          },
          {
            "field_key": "en_birthdate",
            "field_label": "Birthdate"
          },
          {
            "field_key": "en_favorite_subject",
            "field_label": "Favorite Subject"
          },
          {
            "field_key": "en_test_table",
            "field_label": "Test Table"
          },
          {
            "field_key": "en_test_check_box",
            "field_label": "Test Check box"
          },
          {
            "field_key": "en_test_field_boolea",
            "field_label": "Test Field boolean"
          },
          {
            "field_key": "en_test_checkbox_2",
            "field_label": "Test Checkbox 2"
          },
          {
            "field_key": "en_id_field",
            "field_label": "Id fIELD"
          }
        ],
        "donor-0": []
      },
      "fields": [
        {
          "id": 2442,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_child_name",
          "field_label": "Child Name",
          "field_data": "Enter Name",
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 1,
          "filter": 1,
          "field_order": 0,
          "deleted_at": null,
          "created_at": null,
          "updated_at": "2024-07-11T09:50:19.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2444,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_gender",
          "field_label": "Gender",
          "field_data": ",Male,Female",
          "field_type": "hysSelect",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 1,
          "deleted_at": null,
          "created_at": null,
          "updated_at": "2022-11-25T14:22:20.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2446,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_grade",
          "field_label": "Grade",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 2,
          "deleted_at": null,
          "created_at": "2017-02-22T18:57:53.000000Z",
          "updated_at": "2019-01-23T01:52:56.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2907,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_age",
          "field_label": "Age",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 3,
          "deleted_at": null,
          "created_at": "2018-09-29T17:27:08.000000Z",
          "updated_at": "2019-01-23T01:52:56.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2994,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_birthdate",
          "field_label": "Birthdate",
          "field_data": "",
          "field_type": "hysDate",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 1,
          "field_order": 4,
          "deleted_at": null,
          "created_at": "2018-11-24T04:11:48.000000Z",
          "updated_at": "2023-03-31T11:17:50.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 2445,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_favorite_subject",
          "field_label": "Favorite Subject",
          "field_data": "",
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 8,
          "deleted_at": null,
          "created_at": "2017-02-22T18:57:18.000000Z",
          "updated_at": "2023-01-12T13:58:21.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6523,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_test_table",
          "field_label": "Test Table",
          "field_data": "age, gender",
          "field_type": "hysTable",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 12,
          "deleted_at": null,
          "created_at": "2023-01-16T11:11:19.000000Z",
          "updated_at": "2023-01-16T11:11:19.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725257287,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6536,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_test_check_box",
          "field_label": "Test Check box",
          "field_data": "yes,no",
          "field_type": "hysCheckbox",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 13,
          "deleted_at": null,
          "created_at": "2023-03-17T07:04:48.000000Z",
          "updated_at": "2023-03-17T07:04:48.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6537,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_test_field_boolea",
          "field_label": "Test Field boolean",
          "field_data": "yes,no",
          "field_type": "hysSelect",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 14,
          "deleted_at": null,
          "created_at": "2023-03-17T09:42:48.000000Z",
          "updated_at": "2023-03-17T09:42:48.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6538,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_test_checkbox_2",
          "field_label": "Test Checkbox 2",
          "field_data": "maybe,later",
          "field_type": "hysCheckbox",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 15,
          "deleted_at": null,
          "created_at": "2023-03-31T13:06:06.000000Z",
          "updated_at": "2023-03-31T13:06:06.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6735,
          "client_id": 207,
          "hysform_id": 638,
          "field_key": "en_id_field",
          "field_label": "Id fIELD",
          "field_data": null,
          "field_type": "hysCustomid",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 17,
          "deleted_at": null,
          "created_at": "2024-08-06T09:10:00.000000Z",
          "updated_at": "2024-08-06T09:10:00.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [
        {
          "id": 561,
          "client_id": 207,
          "hysform_id": 638,
          "sponsorships": null,
          "name": "Child Sponsorship Program",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},\\\"1\\\":{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},\\\"2\\\":{\\\"field_key\\\":\\\"en_grade\\\",\\\"field_label\\\":\\\"Grade\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},\\\"3\\\":{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},\\\"4\\\":{\\\"field_key\\\":\\\"en_birthdate\\\",\\\"field_label\\\":\\\"Birthdate\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},\\\"number_of_sponsors\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2019-02-05T23:22:33.000000Z",
          "updated_at": "2019-02-05T23:22:33.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 562,
          "client_id": 207,
          "hysform_id": 638,
          "sponsorships": null,
          "name": "Sponsored Children",
          "fields": "{\"program\":\"[{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},{\\\"field_key\\\":\\\"en_grade\\\",\\\"field_label\\\":\\\"Grade\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_birthdate\\\",\\\"field_label\\\":\\\"Birthdate\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"}]\"}",
          "deleted_at": null,
          "created_at": "2019-02-05T23:42:06.000000Z",
          "updated_at": "2019-02-05T23:42:06.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 711,
          "client_id": 207,
          "hysform_id": 638,
          "sponsorships": null,
          "name": "New Program",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},\\\"1\\\":{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},\\\"thumb\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2022-11-19T10:09:35.000000Z",
          "updated_at": "2022-11-19T10:09:35.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 723,
          "client_id": 207,
          "hysform_id": 638,
          "sponsorships": null,
          "name": "childname",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},\\\"thumb\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2023-02-13T13:46:46.000000Z",
          "updated_at": "2023-02-13T13:46:46.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 724,
          "client_id": 207,
          "hysform_id": 638,
          "sponsorships": null,
          "name": "Test Report 5",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},\\\"1\\\":{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},\\\"thumb\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2023-02-24T11:14:55.000000Z",
          "updated_at": "2023-02-24T11:14:55.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 726,
          "client_id": 207,
          "hysform_id": 638,
          "sponsorships": null,
          "name": "Test report 6",
          "fields": "{\"program\":\"{\\\"thumb\\\":true,\\\"number_of_sponsors\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2023-02-24T15:00:54.000000Z",
          "updated_at": "2023-02-24T15:00:54.000000Z",
          "__hevo__ingested_at": 1679725257686,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": "apphys_new"
        },
        {
          "id": 734,
          "client_id": 207,
          "hysform_id": 638,
          "sponsorships": null,
          "name": "view name",
          "fields": "{\"program\":\"[{\\\"field_key\\\":\\\"en_child_name\\\",\\\"field_label\\\":\\\"Child Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"Enter Name\\\"},{\\\"field_key\\\":\\\"en_gender\\\",\\\"field_label\\\":\\\"Gender\\\",\\\"field_type\\\":\\\"hysSelect\\\",\\\"field_data\\\":\\\",Male,Female\\\"},{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":\\\"\\\"}]\"}",
          "deleted_at": null,
          "created_at": "2023-06-28T10:33:10.000000Z",
          "updated_at": "2023-06-28T10:33:10.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        }
      ],
      "details": {
        "To Date": "",
        "Number of Sponsors": "",
        "Percent Complete": ""
      }
    }
  },
  3438: {
    "data": {
      "program": {
        "id": 3438,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 639,
        "setting_id": 1641,
        "emailset_id": 0,
        "entity_submit": "",
        "donor_submit": "",
        "link_id": 0,
        "name": "Marathon for the Disabled",
        "prefix": "C1",
        "counter": 5,
        "lft": 14,
        "rgt": 15,
        "tree": 207,
        "box_folder_id": "",
        "deleted_at": null,
        "created_at": "2022-12-21T16:50:33.000000Z",
        "updated_at": "2024-08-06T12:02:58.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679910350683,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": 1679909849000,
        "children": []
      },
      "fieldOptions": {
        "program-3438": [
          {
            "field_key": "en_first_name",
            "field_label": "First Name"
          },
          {
            "field_key": "en_second_name",
            "field_label": "Second Name"
          },
          {
            "field_key": "en_age",
            "field_label": "Age"
          }
        ],
        "donor-639": [
          {
            "field_key": "dn_donor_name",
            "field_label": "Donor Name"
          },
          {
            "field_key": "dn_payment_type",
            "field_label": "Payment Type"
          },
          {
            "field_key": "dn_address",
            "field_label": "Address"
          },
          {
            "field_key": "dn_id_field",
            "field_label": "Id fIELD"
          }
        ]
      },
      "fields": [
        {
          "id": 6717,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 8,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6718,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 9,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6719,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_age",
          "field_label": "Age",
          "field_data": null,
          "field_type": "hysAge",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 10,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [
        {
          "id": 736,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "ttt",
          "fields": "{\"program\":\"[{\\\"field_key\\\":\\\"en_test_textarea\\\",\\\"field_label\\\":\\\"test TextArea\\\",\\\"field_type\\\":\\\"hysTextarea\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_text_link\\\",\\\"field_label\\\":\\\"Text Link\\\",\\\"field_type\\\":\\\"hysLink\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_test_static_text\\\",\\\"field_label\\\":\\\"Test static Text\\\",\\\"field_type\\\":\\\"hysStatic\\\",\\\"field_data\\\":\\\"\\\"}]\"}",
          "deleted_at": null,
          "created_at": "2024-05-01T08:22:30.000000Z",
          "updated_at": "2024-05-01T08:22:30.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        },
        {
          "id": 737,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "Names",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_first_name\\\",\\\"field_label\\\":\\\"First Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"1\\\":{\\\"field_key\\\":\\\"en_second_name\\\",\\\"field_label\\\":\\\"Second Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"2\\\":{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysAge\\\",\\\"field_data\\\":null},\\\"thumb\\\":true,\\\"manage\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2024-07-29T18:42:43.000000Z",
          "updated_at": "2024-07-29T18:42:43.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        }
      ],
      "details": {
        "To Date": "",
        "Monthly Total": "",
        "Percent Complete": ""
      }
    }
  },
  3494: {
    "data": {
      "program": {
        "id": 3494,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 639,
        "setting_id": 410,
        "emailset_id": 1542,
        "entity_submit": "3058",
        "donor_submit": null,
        "link_id": 929,
        "name": "Youth Mentorship Program",
        "prefix": "",
        "counter": 5,
        "lft": 21,
        "rgt": 22,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-03-25T09:14:29.000000Z",
        "updated_at": "2024-08-06T12:51:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "fieldOptions": {
        "program-3494": [
          {
            "field_key": "en_first_name",
            "field_label": "First Name"
          },
          {
            "field_key": "en_second_name",
            "field_label": "Second Name"
          },
          {
            "field_key": "en_age",
            "field_label": "Age"
          }
        ],
        "donor-639": [
          {
            "field_key": "dn_donor_name",
            "field_label": "Donor Name"
          },
          {
            "field_key": "dn_payment_type",
            "field_label": "Payment Type"
          },
          {
            "field_key": "dn_address",
            "field_label": "Address"
          },
          {
            "field_key": "dn_id_field",
            "field_label": "Id fIELD"
          }
        ]
      },
      "fields": [
        {
          "id": 6717,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 8,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6718,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 9,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6719,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_age",
          "field_label": "Age",
          "field_data": null,
          "field_type": "hysAge",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 10,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [
        {
          "id": 736,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "ttt",
          "fields": "{\"program\":\"[{\\\"field_key\\\":\\\"en_test_textarea\\\",\\\"field_label\\\":\\\"test TextArea\\\",\\\"field_type\\\":\\\"hysTextarea\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_text_link\\\",\\\"field_label\\\":\\\"Text Link\\\",\\\"field_type\\\":\\\"hysLink\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_test_static_text\\\",\\\"field_label\\\":\\\"Test static Text\\\",\\\"field_type\\\":\\\"hysStatic\\\",\\\"field_data\\\":\\\"\\\"}]\"}",
          "deleted_at": null,
          "created_at": "2024-05-01T08:22:30.000000Z",
          "updated_at": "2024-05-01T08:22:30.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        },
        {
          "id": 737,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "Names",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_first_name\\\",\\\"field_label\\\":\\\"First Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"1\\\":{\\\"field_key\\\":\\\"en_second_name\\\",\\\"field_label\\\":\\\"Second Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"2\\\":{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysAge\\\",\\\"field_data\\\":null},\\\"thumb\\\":true,\\\"manage\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2024-07-29T18:42:43.000000Z",
          "updated_at": "2024-07-29T18:42:43.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        }
      ],
      "details": {
        "To Date": "",
        "Number of Sponsors": "",
        "Percent Complete": ""
      }
    }
  },
  3506: {
    "data": {
      "program": {
        "id": 3506,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 3030,
        "setting_id": 410,
        "emailset_id": 1557,
        "entity_submit": "3058",
        "donor_submit": "",
        "link_id": null,
        "name": "Kupenda",
        "prefix": "KP",
        "counter": 200,
        "lft": 12,
        "rgt": 13,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-04-29T15:08:37.000000Z",
        "updated_at": "2024-07-29T09:01:30.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "fieldOptions": {
        "program-3506": [
          {
            "field_key": "en_first_name",
            "field_label": "First Name"
          },
          {
            "field_key": "en_second_name",
            "field_label": "Second Name"
          },
          {
            "field_key": "en_age",
            "field_label": "Age"
          }
        ],
        "donor-3030": [
          {
            "field_key": "dn_first_name",
            "field_label": "First Name"
          }
        ]
      },
      "fields": [
        {
          "id": 6717,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 8,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6718,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 9,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6719,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_age",
          "field_label": "Age",
          "field_data": null,
          "field_type": "hysAge",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 10,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [
        {
          "id": 736,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "ttt",
          "fields": "{\"program\":\"[{\\\"field_key\\\":\\\"en_test_textarea\\\",\\\"field_label\\\":\\\"test TextArea\\\",\\\"field_type\\\":\\\"hysTextarea\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_text_link\\\",\\\"field_label\\\":\\\"Text Link\\\",\\\"field_type\\\":\\\"hysLink\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_test_static_text\\\",\\\"field_label\\\":\\\"Test static Text\\\",\\\"field_type\\\":\\\"hysStatic\\\",\\\"field_data\\\":\\\"\\\"}]\"}",
          "deleted_at": null,
          "created_at": "2024-05-01T08:22:30.000000Z",
          "updated_at": "2024-05-01T08:22:30.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        },
        {
          "id": 737,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "Names",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_first_name\\\",\\\"field_label\\\":\\\"First Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"1\\\":{\\\"field_key\\\":\\\"en_second_name\\\",\\\"field_label\\\":\\\"Second Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"2\\\":{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysAge\\\",\\\"field_data\\\":null},\\\"thumb\\\":true,\\\"manage\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2024-07-29T18:42:43.000000Z",
          "updated_at": "2024-07-29T18:42:43.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        }
      ],
      "details": {
        "To Date": "",
        "Number of Sponsors": "",
        "Percent Complete": ""
      }
    }
  },
  3507: {
    "data": {
      "program": {
        "id": 3507,
        "client_id": 207,
        "hysform_id": 3019,
        "donor_hysform_id": 3040,
        "setting_id": 1646,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Kupe",
        "prefix": "KUP",
        "counter": null,
        "lft": 10,
        "rgt": 11,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-05-03T06:41:45.000000Z",
        "updated_at": "2024-07-25T08:23:28.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "fieldOptions": {
        "program-3507": [
          {
            "field_key": "en_first_name",
            "field_label": "First Name"
          },
          {
            "field_key": "en_second_name",
            "field_label": "Second Name"
          },
          {
            "field_key": "en_age",
            "field_label": "Age"
          }
        ],
        "donor-3040": [
          {
            "field_key": "dn_first_name",
            "field_label": "First Name"
          },
          {
            "field_key": "dn_last_name",
            "field_label": "Last Name"
          },
          {
            "field_key": "dn_address",
            "field_label": "Address"
          },
          {
            "field_key": "dn_city",
            "field_label": "City"
          },
          {
            "field_key": "dn_state",
            "field_label": "State"
          },
          {
            "field_key": "dn_zip",
            "field_label": "Zip"
          },
          {
            "field_key": "dn_phone",
            "field_label": "Phone"
          },
          {
            "field_key": "dn_private_notes",
            "field_label": "Private Notes"
          },
          {
            "field_key": "dn_date_of_sponsorsh",
            "field_label": "Date Of Sponsorship"
          },
          {
            "field_key": "dn_type_of_payment",
            "field_label": "Type Of Payment"
          },
          {
            "field_key": "dn_sponsor_id",
            "field_label": "Sponsor ID"
          }
        ]
      },
      "fields": [
        {
          "id": 6717,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 8,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6718,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 9,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6719,
          "client_id": 207,
          "hysform_id": 3019,
          "field_key": "en_age",
          "field_label": "Age",
          "field_data": null,
          "field_type": "hysAge",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 10,
          "deleted_at": null,
          "created_at": "2024-07-29T08:35:13.000000Z",
          "updated_at": "2024-07-29T08:35:13.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [
        {
          "id": 736,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "ttt",
          "fields": "{\"program\":\"[{\\\"field_key\\\":\\\"en_test_textarea\\\",\\\"field_label\\\":\\\"test TextArea\\\",\\\"field_type\\\":\\\"hysTextarea\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_text_link\\\",\\\"field_label\\\":\\\"Text Link\\\",\\\"field_type\\\":\\\"hysLink\\\",\\\"field_data\\\":\\\"\\\"},{\\\"field_key\\\":\\\"en_test_static_text\\\",\\\"field_label\\\":\\\"Test static Text\\\",\\\"field_type\\\":\\\"hysStatic\\\",\\\"field_data\\\":\\\"\\\"}]\"}",
          "deleted_at": null,
          "created_at": "2024-05-01T08:22:30.000000Z",
          "updated_at": "2024-05-01T08:22:30.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        },
        {
          "id": 737,
          "client_id": 207,
          "hysform_id": 3019,
          "sponsorships": null,
          "name": "Names",
          "fields": "{\"program\":\"{\\\"0\\\":{\\\"field_key\\\":\\\"en_first_name\\\",\\\"field_label\\\":\\\"First Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"1\\\":{\\\"field_key\\\":\\\"en_second_name\\\",\\\"field_label\\\":\\\"Second Name\\\",\\\"field_type\\\":\\\"hysText\\\",\\\"field_data\\\":null},\\\"2\\\":{\\\"field_key\\\":\\\"en_age\\\",\\\"field_label\\\":\\\"Age\\\",\\\"field_type\\\":\\\"hysAge\\\",\\\"field_data\\\":null},\\\"thumb\\\":true,\\\"manage\\\":true}\"}",
          "deleted_at": null,
          "created_at": "2024-07-29T18:42:43.000000Z",
          "updated_at": "2024-07-29T18:42:43.000000Z",
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null,
          "__hevo__database_name": null
        }
      ],
      "details": {
        "To Date": "",
        "Number of Sponsors": "",
        "Percent Complete": ""
      }
    }
  },
  3510: {
    "data": {
      "program": {
        "id": 3510,
        "client_id": 207,
        "hysform_id": 3043,
        "donor_hysform_id": null,
        "setting_id": 410,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "us2uganda",
        "prefix": "usa",
        "counter": null,
        "lft": 8,
        "rgt": 9,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-06-02T09:24:28.000000Z",
        "updated_at": "2023-06-02T09:36:45.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "fieldOptions": {
        "program-3510": [
          {
            "field_key": "en_student_id",
            "field_label": "Student Id"
          },
          {
            "field_key": "en_student_grade",
            "field_label": "Student Grade"
          },
          {
            "field_key": "en_school_attending",
            "field_label": "School Attending"
          },
          {
            "field_key": "en_first_name",
            "field_label": "First Name"
          },
          {
            "field_key": "en_second_name",
            "field_label": "Second Name"
          },
          {
            "field_key": "en_last_name_1",
            "field_label": "Last Name 1"
          },
          {
            "field_key": "en_gender",
            "field_label": "Gender"
          },
          {
            "field_key": "en_date_of_birth",
            "field_label": "Date Of Birth"
          },
          {
            "field_key": "en_health_status",
            "field_label": "Health Status"
          },
          {
            "field_key": "en_health_record",
            "field_label": "Health Record"
          },
          {
            "field_key": "en_living_mother_nam",
            "field_label": "Living Mother Name"
          },
          {
            "field_key": "en_living_father_nam",
            "field_label": "Living Father Name"
          },
          {
            "field_key": "en_guardian_name",
            "field_label": "Guardian Name"
          },
          {
            "field_key": "en_contact_phone_num",
            "field_label": "Contact Phone Number"
          },
          {
            "field_key": "en_home_town_or_vill",
            "field_label": "Home town or village"
          },
          {
            "field_key": "en_payment_participa",
            "field_label": "Payment participation"
          },
          {
            "field_key": "en_number_of_sisters",
            "field_label": "Number of sisters"
          },
          {
            "field_key": "en_number_of_brother",
            "field_label": "Number of brothers"
          },
          {
            "field_key": "en_favorite_subject",
            "field_label": "favorite subject"
          },
          {
            "field_key": "en_private_comments",
            "field_label": "private comments"
          },
          {
            "field_key": "en_favorite_activity",
            "field_label": "favorite activity"
          },
          {
            "field_key": "en_public_comments",
            "field_label": "public comments"
          },
          {
            "field_key": "en_privates_notes",
            "field_label": "privates notes"
          },
          {
            "field_key": "en_sponsor_updates",
            "field_label": "sponsor updates"
          },
          {
            "field_key": "en_child_id",
            "field_label": "Child Id"
          }
        ],
        "donor-": []
      },
      "fields": [
        {
          "id": 6612,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_student_id",
          "field_label": "Student Id",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 1,
          "deleted_at": null,
          "created_at": "2023-06-02T09:28:15.000000Z",
          "updated_at": "2023-06-02T09:28:15.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6613,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_student_grade",
          "field_label": "Student Grade",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 2,
          "deleted_at": null,
          "created_at": "2023-06-02T09:28:33.000000Z",
          "updated_at": "2023-06-02T09:28:33.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6614,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_school_attending",
          "field_label": "School Attending",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 3,
          "deleted_at": null,
          "created_at": "2023-06-02T09:28:55.000000Z",
          "updated_at": "2023-06-02T09:28:55.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6615,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_first_name",
          "field_label": "First Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 4,
          "deleted_at": null,
          "created_at": "2023-06-02T09:29:08.000000Z",
          "updated_at": "2023-06-02T09:29:08.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6616,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_second_name",
          "field_label": "Second Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 5,
          "deleted_at": null,
          "created_at": "2023-06-02T09:30:17.000000Z",
          "updated_at": "2023-06-02T09:30:17.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6617,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_last_name_1",
          "field_label": "Last Name 1",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 6,
          "deleted_at": null,
          "created_at": "2023-06-02T09:30:32.000000Z",
          "updated_at": "2023-06-02T09:30:32.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6618,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_gender",
          "field_label": "Gender",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 7,
          "deleted_at": null,
          "created_at": "2023-06-02T09:30:47.000000Z",
          "updated_at": "2023-06-02T09:30:47.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6619,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_date_of_birth",
          "field_label": "Date Of Birth",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 8,
          "deleted_at": null,
          "created_at": "2023-06-02T09:31:00.000000Z",
          "updated_at": "2023-06-02T09:31:00.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6620,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_health_status",
          "field_label": "Health Status",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 9,
          "deleted_at": null,
          "created_at": "2023-06-02T09:31:24.000000Z",
          "updated_at": "2023-06-02T09:31:24.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6621,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_health_record",
          "field_label": "Health Record",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 10,
          "deleted_at": null,
          "created_at": "2023-06-02T09:31:35.000000Z",
          "updated_at": "2023-06-02T09:31:35.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6622,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_living_mother_nam",
          "field_label": "Living Mother Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 11,
          "deleted_at": null,
          "created_at": "2023-06-02T09:31:51.000000Z",
          "updated_at": "2023-06-02T09:31:51.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6623,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_living_father_nam",
          "field_label": "Living Father Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 12,
          "deleted_at": null,
          "created_at": "2023-06-02T09:32:07.000000Z",
          "updated_at": "2023-06-02T09:32:07.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6624,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_guardian_name",
          "field_label": "Guardian Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 13,
          "deleted_at": null,
          "created_at": "2023-06-02T09:32:53.000000Z",
          "updated_at": "2023-06-02T09:32:53.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6625,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_contact_phone_num",
          "field_label": "Contact Phone Number",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 14,
          "deleted_at": null,
          "created_at": "2023-06-02T09:33:15.000000Z",
          "updated_at": "2023-06-02T09:33:15.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6626,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_home_town_or_vill",
          "field_label": "Home town or village",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 15,
          "deleted_at": null,
          "created_at": "2023-06-02T09:33:31.000000Z",
          "updated_at": "2023-06-02T09:33:31.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6627,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_payment_participa",
          "field_label": "Payment participation",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 16,
          "deleted_at": null,
          "created_at": "2023-06-02T09:33:47.000000Z",
          "updated_at": "2023-06-02T09:33:47.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6628,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_number_of_sisters",
          "field_label": "Number of sisters",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 17,
          "deleted_at": null,
          "created_at": "2023-06-02T09:34:01.000000Z",
          "updated_at": "2023-06-02T09:34:01.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6629,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_number_of_brother",
          "field_label": "Number of brothers",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 18,
          "deleted_at": null,
          "created_at": "2023-06-02T09:34:18.000000Z",
          "updated_at": "2023-06-02T09:34:18.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6630,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_favorite_subject",
          "field_label": "favorite subject",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 19,
          "deleted_at": null,
          "created_at": "2023-06-02T09:34:33.000000Z",
          "updated_at": "2023-06-02T09:34:33.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6631,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_private_comments",
          "field_label": "private comments",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 20,
          "deleted_at": null,
          "created_at": "2023-06-02T09:35:03.000000Z",
          "updated_at": "2023-06-02T09:35:03.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6632,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_favorite_activity",
          "field_label": "favorite activity",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 21,
          "deleted_at": null,
          "created_at": "2023-06-02T09:35:29.000000Z",
          "updated_at": "2023-06-02T09:35:29.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6633,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_public_comments",
          "field_label": "public comments",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 22,
          "deleted_at": null,
          "created_at": "2023-06-02T09:35:41.000000Z",
          "updated_at": "2023-06-02T09:35:41.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6634,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_privates_notes",
          "field_label": "privates notes",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 23,
          "deleted_at": null,
          "created_at": "2023-06-02T09:36:01.000000Z",
          "updated_at": "2023-06-02T09:36:01.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6635,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_sponsor_updates",
          "field_label": "sponsor updates",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 24,
          "deleted_at": null,
          "created_at": "2023-06-02T09:36:12.000000Z",
          "updated_at": "2023-06-02T09:36:12.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        },
        {
          "id": 6636,
          "client_id": 207,
          "hysform_id": 3043,
          "field_key": "en_child_id",
          "field_label": "Child Id",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 0,
          "sortable": 0,
          "filter": 0,
          "field_order": 25,
          "deleted_at": null,
          "created_at": "2023-06-02T09:37:54.000000Z",
          "updated_at": "2023-06-02T09:37:54.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [],
      "details": {
        "To Date": "",
        "Number of Sponsors": "",
        "Percent Complete": ""
      }
    }
  },
  3521: {
    "data": {
      "program": {
        "id": 3521,
        "client_id": 207,
        "hysform_id": 3051,
        "donor_hysform_id": 3030,
        "setting_id": 1652,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Sustainable Living Expo",
        "prefix": "DC",
        "counter": 1,
        "lft": 4,
        "rgt": 5,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2024-06-13T08:35:10.000000Z",
        "updated_at": "2024-08-06T12:03:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "fieldOptions": {
        "program-3521": [
          {
            "field_key": "en_name",
            "field_label": "Name"
          }
        ],
        "donor-3030": [
          {
            "field_key": "dn_first_name",
            "field_label": "First Name"
          }
        ]
      },
      "fields": [
        {
          "id": 6701,
          "client_id": 207,
          "hysform_id": 3051,
          "field_key": "en_name",
          "field_label": "Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 1,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 1,
          "deleted_at": null,
          "created_at": "2024-06-13T08:38:33.000000Z",
          "updated_at": "2024-06-13T08:38:33.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [],
      "details": []
    }
  },
  3518: {
    "data": {
      "program": {
        "id": 3518,
        "client_id": 207,
        "hysform_id": 3048,
        "donor_hysform_id": 639,
        "setting_id": 1650,
        "emailset_id": null,
        "entity_submit": null,
        "donor_submit": null,
        "link_id": null,
        "name": "Masaka BoreHole",
        "prefix": "MBH",
        "counter": 1,
        "lft": 6,
        "rgt": 7,
        "tree": 207,
        "box_folder_id": null,
        "deleted_at": null,
        "created_at": "2023-10-17T06:26:48.000000Z",
        "updated_at": "2024-06-17T12:10:38.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null,
        "children": []
      },
      "fieldOptions": {
        "program-3518": [
          {
            "field_key": "en_name",
            "field_label": "Name"
          }
        ],
        "donor-639": [
          {
            "field_key": "dn_donor_name",
            "field_label": "Donor Name"
          },
          {
            "field_key": "dn_payment_type",
            "field_label": "Payment Type"
          },
          {
            "field_key": "dn_address",
            "field_label": "Address"
          },
          {
            "field_key": "dn_id_field",
            "field_label": "Id fIELD"
          }
        ]
      },
      "fields": [
        {
          "id": 6643,
          "client_id": 207,
          "hysform_id": 3048,
          "field_key": "en_name",
          "field_label": "Name",
          "field_data": null,
          "field_type": "hysText",
          "required": 0,
          "permissions": "public",
          "admingroup_id": 0,
          "is_title": 1,
          "sortable": 0,
          "filter": 0,
          "field_order": 1,
          "deleted_at": null,
          "created_at": "2023-10-17T06:27:32.000000Z",
          "updated_at": "2023-10-17T06:27:32.000000Z",
          "__hevo__database_name": null,
          "__hevo__ingested_at": null,
          "__hevo__marked_deleted": null,
          "__hevo__source_modified_at": null
        }
      ],
      "type": "all",
      "reports": [],
      "details": []
    }
  },
}

export const programs_entities = [
  {
    "id": 35915,
    "profile": {
      "en_child_name": "Emerdjina Charles",
      "en_gender": "Male",
      "en_grade": "4",
      "en_age": "",
      "en_birthdate": "2023-03-11",
      "en_favorite_subject": "Mathematics",
      "en_test_check_box": "\"[\\\"no\\\"]\"",
      "en_test_field_boolea": "yes",
      "en_test_checkbox_2": "\"[\\\"maybe\\\"]\"",
      "id": 35915,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Emerdjina Charles\",\"en_gender\":\"Male\",\"en_grade\":\"4\",\"en_age\":\"\",\"en_birthdate\":\"2023-03-11\",\"en_favorite_subject\":\"Mathematics\",\"en_test_check_box\":\"\\\"[\\\\\\\"no\\\\\\\"]\\\"\",\"en_test_field_boolea\":\"yes\",\"en_test_checkbox_2\":\"\\\"[\\\\\\\"maybe\\\\\\\"]\\\"\",\"id\":\"35915\",\"client_id\":\"207\",\"program_id\":\"929\",\"status\":\"1\",\"re_add\":\"\",\"wait_time\":\"0000-00-00\",\"json_fields\":\"{\\\"en_child_name\\\":\\\"Emerdjina Charles\\\",\\\"en_gender\\\":\\\"Female\\\",\\\"en_grade\\\":\\\"4\\\",\\\"en_age\\\":\\\"\\\",\\\"en_birthdate\\\":\\\"2023-03-11\\\",\\\"en_favorite_subject\\\":\\\"Mathematics\\\",\\\"en_test_check_box\\\":\\\"[\\\\\\\"no\\\\\\\"]\\\",\\\"en_test_field_boolea\\\":\\\"yes\\\",\\\"en_test_checkbox_2\\\":\\\"[\\\\\\\"maybe\\\\\\\"]\\\",\\\"client_id\\\":\\\"207\\\",\\\"entity_id\\\":\\\"35915\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-08-19T20:40:04.000000Z\",\"updated_at\":\"2024-05-24T19:19:00.000000Z\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725261350\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"entity_id\":\"35915\"}",
      "deleted_at": null,
      "created_at": "2018-08-19T20:40:04.000000Z",
      "updated_at": "2024-06-10T11:37:14.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null,
      "entity_id": "35915",
      "sp_amount": "32",
      "sp_num": "2"
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Emerdjina Charles",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "4",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "2023-03-11",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "Mathematics",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "\"[\\\"no\\\"]\"",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "\"[\\\"maybe\\\"]\"",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/5add42698590b15e892ba55953b571fd8eb122a21.jpg",
    "donations": [],
    "entity": {
      "id": 35915,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Emerdjina Charles\",\"en_gender\":\"Male\",\"en_grade\":\"4\",\"en_age\":\"\",\"en_birthdate\":\"2023-03-11\",\"en_favorite_subject\":\"Mathematics\",\"en_test_check_box\":\"\\\"[\\\\\\\"no\\\\\\\"]\\\"\",\"en_test_field_boolea\":\"yes\",\"en_test_checkbox_2\":\"\\\"[\\\\\\\"maybe\\\\\\\"]\\\"\",\"id\":\"35915\",\"client_id\":\"207\",\"program_id\":\"929\",\"status\":\"1\",\"re_add\":\"\",\"wait_time\":\"0000-00-00\",\"json_fields\":\"{\\\"en_child_name\\\":\\\"Emerdjina Charles\\\",\\\"en_gender\\\":\\\"Female\\\",\\\"en_grade\\\":\\\"4\\\",\\\"en_age\\\":\\\"\\\",\\\"en_birthdate\\\":\\\"2023-03-11\\\",\\\"en_favorite_subject\\\":\\\"Mathematics\\\",\\\"en_test_check_box\\\":\\\"[\\\\\\\"no\\\\\\\"]\\\",\\\"en_test_field_boolea\\\":\\\"yes\\\",\\\"en_test_checkbox_2\\\":\\\"[\\\\\\\"maybe\\\\\\\"]\\\",\\\"client_id\\\":\\\"207\\\",\\\"entity_id\\\":\\\"35915\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-08-19T20:40:04.000000Z\",\"updated_at\":\"2024-05-24T19:19:00.000000Z\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725261350\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"entity_id\":\"35915\"}",
      "deleted_at": null,
      "created_at": "2018-08-19T20:40:04.000000Z",
      "updated_at": "2024-06-10T11:37:14.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/5add42698590b15e892ba55953b571fd8eb122a21_t_.jpg",
    "sponsors": [
      {
        "id": 17273,
        "hysform_id": 639,
        "name": "Jim test CC monthly",
        "email": "dev+7@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      },
      {
        "id": 15799,
        "hysform_id": 639,
        "name": "Test Sarah ",
        "email": "dev+2@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Emerdjina Charles",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$1,254": "To Date",
      "2 of 2": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 36309,
    "profile": {
      "en_child_name": "Ismylove Jean",
      "en_gender": "Female",
      "en_grade": "PS 1",
      "en_age": "3",
      "en_birthdate": "06-14-2015",
      "en_favorite_subject": "",
      "en_test_check_box": "\"[\\\"yes\\\"]\"",
      "en_test_field_boolea": "yes",
      "en_test_checkbox_2": "\"[\\\"maybe\\\"]\"",
      "client_id": 207,
      "entity_id": "36309",
      "id": 36309,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Ismylove Jean\",\"en_gender\":\"Female\",\"en_grade\":\"PS 1\",\"en_age\":\"3\",\"en_birthdate\":\"06-14-2015\",\"en_favorite_subject\":\"\",\"en_test_check_box\":\"\\\"[\\\\\\\"yes\\\\\\\"]\\\"\",\"en_test_field_boolea\":\"yes\",\"en_test_checkbox_2\":\"\\\"[\\\\\\\"maybe\\\\\\\"]\\\"\",\"client_id\":\"207\",\"entity_id\":\"36309\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:41:56.000000Z",
      "updated_at": "2023-10-18T19:05:21.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Ismylove Jean",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS 1",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "06-14-2015",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "\"[\\\"yes\\\"]\"",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "\"[\\\"maybe\\\"]\"",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/5b7eb9354eec560e3b68d0c6e17b999dc03bc7241.jpg",
    "donations": [],
    "entity": {
      "id": 36309,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Ismylove Jean\",\"en_gender\":\"Female\",\"en_grade\":\"PS 1\",\"en_age\":\"3\",\"en_birthdate\":\"06-14-2015\",\"en_favorite_subject\":\"\",\"en_test_check_box\":\"\\\"[\\\\\\\"yes\\\\\\\"]\\\"\",\"en_test_field_boolea\":\"yes\",\"en_test_checkbox_2\":\"\\\"[\\\\\\\"maybe\\\\\\\"]\\\"\",\"client_id\":\"207\",\"entity_id\":\"36309\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:41:56.000000Z",
      "updated_at": "2023-10-18T19:05:21.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/5b7eb9354eec560e3b68d0c6e17b999dc03bc7241_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      },
      {
        "id": 26091,
        "hysform_id": 639,
        "name": "No Name Found",
        "email": "s.charlesderrick10@gmail.com",
        "frequency": "",
        "amount": ""
      },
      {
        "id": 26092,
        "hysform_id": 639,
        "name": "Diama Magic",
        "email": "diamamagic@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Ismylove Jean",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$384": "To Date",
      "3 of 2": "Sponsors",
      "150%": "Complete"
    }
  },
  {
    "id": 37194,
    "profile": {
      "en_child_name": "Wismika Chery",
      "en_gender": "Female",
      "en_grade": "PS II",
      "en_age": "5",
      "en_birthdate": "02-04-2014",
      "en_favorite_subject": "",
      "en_test_check_box": "\"\\\"\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"yes,no\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\"\\\"\"",
      "en_test_field_boolea": "yes,no",
      "client_id": 207,
      "entity_id": "37194",
      "id": 37194,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Wismika Chery\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"5\",\"en_birthdate\":\"02-04-2014\",\"en_favorite_subject\":\"\",\"en_test_check_box\":\"\\\"\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"yes,no\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\"\\\"\",\"en_test_field_boolea\":\"yes,no\",\"client_id\":\"207\",\"entity_id\":\"37194\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:02:07.000000Z",
      "updated_at": "2023-04-04T11:20:45.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Wismika Chery",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS II",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "5",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "02-04-2014",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "\"\\\"\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"yes,no\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\"\\\"\"",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/e36e28f0f6461f541a454da14fcf59cb13a5ef091.jpg",
    "donations": [],
    "entity": {
      "id": 37194,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Wismika Chery\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"5\",\"en_birthdate\":\"02-04-2014\",\"en_favorite_subject\":\"\",\"en_test_check_box\":\"\\\"\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"yes,no\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\"\\\"\",\"en_test_field_boolea\":\"yes,no\",\"client_id\":\"207\",\"entity_id\":\"37194\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:02:07.000000Z",
      "updated_at": "2023-04-04T11:20:45.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/e36e28f0f6461f541a454da14fcf59cb13a5ef091_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Wismika Chery",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$834": "To Date",
      "1 of ": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 37187,
    "profile": {
      "en_child_name": "I. Chris Bernado Florestal",
      "en_gender": "Male",
      "en_grade": "PS II",
      "en_age": "3",
      "en_birthdate": "5-31-2015",
      "en_favorite_subject": "",
      "id": 37187,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"I. Chris Bernado Florestal\",\"en_gender\":\"Male\",\"en_grade\":\"PS II\",\"en_age\":\"3\",\"en_birthdate\":\"5-31-2015\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T05:17:53.000000Z",
      "updated_at": "2023-01-28T18:34:30.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "I. Chris Bernado Florestal",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS II",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "5-31-2015",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/a0baebb6ab581bb3051ef66c761b99dbd2159c4e1.jpg",
    "donations": [],
    "entity": {
      "id": 37187,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"I. Chris Bernado Florestal\",\"en_gender\":\"Male\",\"en_grade\":\"PS II\",\"en_age\":\"3\",\"en_birthdate\":\"5-31-2015\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T05:17:53.000000Z",
      "updated_at": "2023-01-28T18:34:30.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/a0baebb6ab581bb3051ef66c761b99dbd2159c4e1_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "I. Chris Bernado Florestal",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$0": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37195,
    "profile": {
      "en_child_name": "Enelcia Ch\u00e9ry",
      "en_gender": "Female",
      "en_grade": "PS II",
      "en_age": "6",
      "en_birthdate": "01-09-2013",
      "en_favorite_subject": "",
      "id": 37195,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Enelcia Ch\\u00e9ry\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"6\",\"en_birthdate\":\"01-09-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:07:29.000000Z",
      "updated_at": "2023-01-28T18:35:13.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Enelcia Ch\u00e9ry",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS II",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "6",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "01-09-2013",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/882a258560c9aaef2b21540f3a64acae5fa7887d1.jpg",
    "donations": [],
    "entity": {
      "id": 37195,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Enelcia Ch\\u00e9ry\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"6\",\"en_birthdate\":\"01-09-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:07:29.000000Z",
      "updated_at": "2023-01-28T18:35:13.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/882a258560c9aaef2b21540f3a64acae5fa7887d1_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Enelcia Ch\u00e9ry",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$0": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37197,
    "profile": {
      "en_child_name": "Dieuvensky Resy",
      "en_gender": "Male",
      "en_grade": "PS II",
      "en_age": "4",
      "en_birthdate": "10-10-2014",
      "en_favorite_subject": "",
      "id": 37197,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Dieuvensky Resy\",\"en_gender\":\"Male\",\"en_grade\":\"PS II\",\"en_age\":\"4\",\"en_birthdate\":\"10-10-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:15:54.000000Z",
      "updated_at": "2023-01-28T18:38:33.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Dieuvensky Resy",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS II",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "4",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "10-10-2014",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/5c36e87e5e217d99453c947b7d1b268c51c1aa241.jpg",
    "donations": [],
    "entity": {
      "id": 37197,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Dieuvensky Resy\",\"en_gender\":\"Male\",\"en_grade\":\"PS II\",\"en_age\":\"4\",\"en_birthdate\":\"10-10-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:15:54.000000Z",
      "updated_at": "2023-01-28T18:38:33.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/5c36e87e5e217d99453c947b7d1b268c51c1aa241_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every 6 Months",
        "amount": 192
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Dieuvensky Resy",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$64": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37192,
    "profile": {
      "en_child_name": "Wedson Daristen",
      "en_gender": "Male",
      "en_grade": "PS II",
      "en_age": "4",
      "en_birthdate": "08-16-2014",
      "en_favorite_subject": "",
      "id": 37192,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Wedson Daristen\",\"en_gender\":\"Male\",\"en_grade\":\"PS II\",\"en_age\":\"4\",\"en_birthdate\":\"08-16-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T05:42:17.000000Z",
      "updated_at": "2023-02-07T17:46:54.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Wedson Daristen",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS II",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "4",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "08-16-2014",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/19365eb8e8032a5e066de90abc65a0df5cfd6ff61.jpg",
    "donations": [],
    "entity": {
      "id": 37192,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Wedson Daristen\",\"en_gender\":\"Male\",\"en_grade\":\"PS II\",\"en_age\":\"4\",\"en_birthdate\":\"08-16-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T05:42:17.000000Z",
      "updated_at": "2023-02-07T17:46:54.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/19365eb8e8032a5e066de90abc65a0df5cfd6ff61_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Wedson Daristen",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$0": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37198,
    "profile": {
      "en_child_name": "Sacha Dieufhta Turenne",
      "en_gender": "Female",
      "en_grade": "PS II",
      "en_age": "",
      "en_birthdate": "",
      "en_favorite_subject": "",
      "id": 37198,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Sacha Dieufhta Turenne\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"\",\"en_birthdate\":\"\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:19:53.000000Z",
      "updated_at": "2023-02-08T12:11:40.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Sacha Dieufhta Turenne",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS II",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/f36d6245603c926aed4543ca908c9f8e882390b71.jpg",
    "donations": [],
    "entity": {
      "id": 37198,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Sacha Dieufhta Turenne\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"\",\"en_birthdate\":\"\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:19:53.000000Z",
      "updated_at": "2023-02-08T12:11:40.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/f36d6245603c926aed4543ca908c9f8e882390b71_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Sacha Dieufhta Turenne",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$64": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37200,
    "profile": {
      "en_child_name": "Edwine Exum\u00e9",
      "en_gender": "Female",
      "en_grade": "PS II",
      "en_age": "4",
      "en_birthdate": "12-17-2014",
      "en_favorite_subject": "",
      "id": 37200,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Edwine Exum\\u00e9\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"4\",\"en_birthdate\":\"12-17-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:32:24.000000Z",
      "updated_at": "2023-02-08T12:22:18.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Edwine Exum\u00e9",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS II",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "4",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "12-17-2014",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/3e0b5c6902bbcc5d1e9c7f9dfa8255490d8a69291.jpg",
    "donations": [],
    "entity": {
      "id": 37200,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Edwine Exum\\u00e9\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"4\",\"en_birthdate\":\"12-17-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T06:32:24.000000Z",
      "updated_at": "2023-02-08T12:22:18.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/3e0b5c6902bbcc5d1e9c7f9dfa8255490d8a69291_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Edwine Exum\u00e9",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$64": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37217,
    "profile": {
      "en_child_name": "RosemyAntha Paul",
      "en_gender": "Female",
      "en_grade": "PS III",
      "en_age": "",
      "en_birthdate": "",
      "en_favorite_subject": "",
      "id": 37217,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"RosemyAntha Paul\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"\",\"en_birthdate\":\"\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T02:26:40.000000Z",
      "updated_at": "2023-02-08T12:38:24.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "RosemyAntha Paul",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS III",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/8f4bd0a0789b7f1d1de0bf610ce32caf281c213b1.jpg",
    "donations": [],
    "entity": {
      "id": 37217,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"RosemyAntha Paul\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"\",\"en_birthdate\":\"\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T02:26:40.000000Z",
      "updated_at": "2023-02-08T12:38:24.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/8f4bd0a0789b7f1d1de0bf610ce32caf281c213b1_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "RosemyAntha Paul",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$64": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37237,
    "profile": {
      "en_child_name": "Thamara Louis",
      "en_gender": "Female",
      "en_grade": "PS III",
      "en_age": "5",
      "en_birthdate": "11-16-2013",
      "en_favorite_subject": "",
      "id": 37237,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Thamara Louis\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"5\",\"en_birthdate\":\"11-16-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T03:44:40.000000Z",
      "updated_at": "2023-02-08T12:45:21.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Thamara Louis",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS III",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "5",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "11-16-2013",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/1ec28d790eb21e3a13f0f3c2cde825d57b2039c71.jpg",
    "donations": [],
    "entity": {
      "id": 37237,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Thamara Louis\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"5\",\"en_birthdate\":\"11-16-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T03:44:40.000000Z",
      "updated_at": "2023-02-08T12:45:21.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/1ec28d790eb21e3a13f0f3c2cde825d57b2039c71_t_.jpg",
    "sponsors": [
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Thamara Louis",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$64": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37528,
    "profile": {
      "en_child_name": "Dermilton Coq",
      "en_gender": "Male",
      "en_grade": "8",
      "en_age": "17",
      "en_birthdate": "11-19-2001",
      "en_favorite_subject": "",
      "id": 37528,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Dermilton Coq\",\"en_gender\":\"Male\",\"en_grade\":\"8\",\"en_age\":\"17\",\"en_birthdate\":\"11-19-2001\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-31T07:54:11.000000Z",
      "updated_at": "2019-02-26T20:28:04.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Dermilton Coq",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "8",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "17",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "11-19-2001",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/b28893486c86e5e479985b289ee4ca639f33f6b21.jpg",
    "donations": [],
    "entity": {
      "id": 37528,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Dermilton Coq\",\"en_gender\":\"Male\",\"en_grade\":\"8\",\"en_age\":\"17\",\"en_birthdate\":\"11-19-2001\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-31T07:54:11.000000Z",
      "updated_at": "2019-02-26T20:28:04.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/b28893486c86e5e479985b289ee4ca639f33f6b21_t_.jpg",
    "sponsors": [
      {
        "id": 16924,
        "hysform_id": 639,
        "name": "Thad & Test Collins Paypal",
        "email": "dev+4@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Dermilton Coq",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$460": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37216,
    "profile": {
      "en_child_name": "Claudania Estilien",
      "en_gender": "Female",
      "en_grade": "PS III",
      "en_age": "4",
      "en_birthdate": "07-27-2014",
      "en_favorite_subject": "",
      "id": 37216,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "2023-04-13",
      "json_fields": "{\"en_child_name\":\"Claudania Estilien\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"4\",\"en_birthdate\":\"07-27-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T02:22:26.000000Z",
      "updated_at": "2023-04-13T16:50:01.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Claudania Estilien",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS III",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "4",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "07-27-2014",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/8d1a1b69f1b340d82b9e4ee9c2f750e07a3abf7f1.jpg",
    "donations": [],
    "entity": {
      "id": 37216,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "2023-04-13",
      "json_fields": "{\"en_child_name\":\"Claudania Estilien\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"4\",\"en_birthdate\":\"07-27-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T02:22:26.000000Z",
      "updated_at": "2023-04-13T16:50:01.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/8d1a1b69f1b340d82b9e4ee9c2f750e07a3abf7f1_t_.jpg",
    "sponsors": [
      {
        "id": 16924,
        "hysform_id": 639,
        "name": "Thad & Test Collins Paypal",
        "email": "dev+4@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Claudania Estilien",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$0": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 36310,
    "profile": {
      "en_child_name": "Isedervensley Saint-Julles",
      "en_gender": "Male",
      "en_grade": "PS I",
      "en_age": "3",
      "en_birthdate": "03-03-2016",
      "en_favorite_subject": "",
      "id": 36310,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Isedervensley Saint-Julles\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"3\",\"en_birthdate\":\"03-03-2016\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:43:28.000000Z",
      "updated_at": "2023-06-01T13:00:28.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Isedervensley Saint-Julles",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS I",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "03-03-2016",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/4d44a2d51707bf262eddc314dae9b22e122833d51.jpg",
    "donations": [],
    "entity": {
      "id": 36310,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Isedervensley Saint-Julles\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"3\",\"en_birthdate\":\"03-03-2016\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:43:28.000000Z",
      "updated_at": "2023-06-01T13:00:28.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/4d44a2d51707bf262eddc314dae9b22e122833d51_t_.jpg",
    "sponsors": [
      {
        "id": 17017,
        "hysform_id": 639,
        "name": "Test Donor Shaban Paypal, monthly",
        "email": "shabanlubanga@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Isedervensley Saint-Julles",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$42": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 36311,
    "profile": {
      "en_child_name": "Peterson Jean",
      "en_gender": "Male",
      "en_grade": "PS I",
      "en_age": "4",
      "en_birthdate": "2015-03-05",
      "en_favorite_subject": "",
      "en_test_check_box": "\"yes,no\"",
      "en_test_field_boolea": "yes,no",
      "en_test_checkbox_2": "\"maybe,later\"",
      "id": 36311,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "wait_time": "2023-04-13",
      "json_fields": "{\"en_child_name\":\"Peterson Jean\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"4\",\"en_birthdate\":\"2015-03-05\",\"en_favorite_subject\":\"\",\"en_test_check_box\":\"\\\"yes,no\\\"\",\"en_test_field_boolea\":\"yes,no\",\"en_test_checkbox_2\":\"\\\"maybe,later\\\"\",\"id\":\"36311\",\"client_id\":\"207\",\"program_id\":\"929\",\"status\":\"1\",\"re_add\":\"\",\"wait_time\":\"2023-04-13\",\"json_fields\":\"{\\\"en_child_name\\\":\\\"Peterson Jean\\\",\\\"en_gender\\\":\\\"Male\\\",\\\"en_grade\\\":\\\"PS I\\\",\\\"en_age\\\":\\\"3\\\",\\\"en_birthdate\\\":\\\"03-05-2015\\\",\\\"en_favorite_subject\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-09-29T20:45:07.000000Z\",\"updated_at\":\"2023-04-13T11:25:48.000000Z\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725261350\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"entity_id\":\"36311\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:45:07.000000Z",
      "updated_at": "2024-04-29T11:37:09.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null,
      "entity_id": "36311",
      "sp_amount": "32",
      "sp_num": "1"
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Peterson Jean",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS I",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "4",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "2015-03-05",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "\"yes,no\"",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "\"maybe,later\"",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/8d51ccbd2deb8b2064936295c8f7b97cd3218f6f1.jpg",
    "donations": [],
    "entity": {
      "id": 36311,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "2023-04-13",
      "json_fields": "{\"en_child_name\":\"Peterson Jean\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"4\",\"en_birthdate\":\"2015-03-05\",\"en_favorite_subject\":\"\",\"en_test_check_box\":\"\\\"yes,no\\\"\",\"en_test_field_boolea\":\"yes,no\",\"en_test_checkbox_2\":\"\\\"maybe,later\\\"\",\"id\":\"36311\",\"client_id\":\"207\",\"program_id\":\"929\",\"status\":\"1\",\"re_add\":\"\",\"wait_time\":\"2023-04-13\",\"json_fields\":\"{\\\"en_child_name\\\":\\\"Peterson Jean\\\",\\\"en_gender\\\":\\\"Male\\\",\\\"en_grade\\\":\\\"PS I\\\",\\\"en_age\\\":\\\"3\\\",\\\"en_birthdate\\\":\\\"03-05-2015\\\",\\\"en_favorite_subject\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-09-29T20:45:07.000000Z\",\"updated_at\":\"2023-04-13T11:25:48.000000Z\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725261350\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"entity_id\":\"36311\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:45:07.000000Z",
      "updated_at": "2024-04-29T11:37:09.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/8d51ccbd2deb8b2064936295c8f7b97cd3218f6f1_t_.jpg",
    "sponsors": [
      {
        "id": 17017,
        "hysform_id": 639,
        "name": "Test Donor Shaban Paypal, monthly",
        "email": "shabanlubanga@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Peterson Jean",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$0": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 36323,
    "profile": {
      "en_child_name": "Alvens John Kennley Estil",
      "en_gender": "Male",
      "en_grade": "PS I",
      "en_age": "5",
      "en_birthdate": "12-19-2015",
      "en_favorite_subject": "",
      "en_test_check_box": "\"\\\"\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"yes,no\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\"\\\"\"",
      "en_test_field_boolea": "yes,no",
      "client_id": 207,
      "entity_id": "36323",
      "id": 36323,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Alvens John Kennley Estil\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"5\",\"en_birthdate\":\"12-19-2015\",\"en_favorite_subject\":\"\",\"en_test_check_box\":\"\\\"\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"yes,no\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\"\\\"\",\"en_test_field_boolea\":\"yes,no\",\"client_id\":\"207\",\"entity_id\":\"36323\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:59:00.000000Z",
      "updated_at": "2023-03-29T09:56:56.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Alvens John Kennley Estil",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS I",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "5",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "12-19-2015",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "\"\\\"\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"yes,no\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\"\\\"\"",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/4127293dc997cf6f74d05293cc76da2080e8131a1.jpg",
    "donations": [],
    "entity": {
      "id": 36323,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Alvens John Kennley Estil\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"5\",\"en_birthdate\":\"12-19-2015\",\"en_favorite_subject\":\"\",\"en_test_check_box\":\"\\\"\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"yes,no\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\"\\\\\\\"\\\"\",\"en_test_field_boolea\":\"yes,no\",\"client_id\":\"207\",\"entity_id\":\"36323\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:59:00.000000Z",
      "updated_at": "2023-03-29T09:56:56.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/4127293dc997cf6f74d05293cc76da2080e8131a1_t_.jpg",
    "sponsors": [
      {
        "id": 17135,
        "hysform_id": 639,
        "name": "Dianne Test CC Monthly",
        "email": "dev+5@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Alvens John Kennley Estil",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$264": "To Date",
      "1 of ": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 37501,
    "profile": {
      "en_child_name": "Djedjilove Auralus",
      "en_gender": "Male",
      "en_grade": "7",
      "en_age": "13",
      "en_birthdate": "12-12-2005",
      "en_favorite_subject": "",
      "id": 37501,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Djedjilove Auralus\",\"en_gender\":\"Male\",\"en_grade\":\"7\",\"en_age\":\"13\",\"en_birthdate\":\"12-12-2005\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-31T05:50:36.000000Z",
      "updated_at": "2019-02-26T20:26:44.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Djedjilove Auralus",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "7",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "13",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "12-12-2005",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/51501e7285eaf929c7952e1b23b59e4b81c72d2a1.jpg",
    "donations": [],
    "entity": {
      "id": 37501,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": null,
      "json_fields": "{\"en_child_name\":\"Djedjilove Auralus\",\"en_gender\":\"Male\",\"en_grade\":\"7\",\"en_age\":\"13\",\"en_birthdate\":\"12-12-2005\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-31T05:50:36.000000Z",
      "updated_at": "2019-02-26T20:26:44.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/51501e7285eaf929c7952e1b23b59e4b81c72d2a1_t_.jpg",
    "sponsors": [
      {
        "id": 17135,
        "hysform_id": 639,
        "name": "Dianne Test CC Monthly",
        "email": "dev+5@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Djedjilove Auralus",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$0": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 36303,
    "profile": {
      "en_child_name": "Estilien Claudensky",
      "en_gender": "Male",
      "en_grade": "PS I",
      "en_age": "4",
      "en_birthdate": "02-05-2015",
      "en_favorite_subject": "",
      "id": 36303,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Estilien Claudensky\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"4\",\"en_birthdate\":\"02-05-2015\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:24:45.000000Z",
      "updated_at": "2023-06-28T12:08:30.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Estilien Claudensky",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Male",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS I",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "4",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "02-05-2015",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/0becc7d3242e43a025878a9abb4033dcf75d94da1.jpg",
    "donations": [],
    "entity": {
      "id": 36303,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Estilien Claudensky\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"4\",\"en_birthdate\":\"02-05-2015\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T20:24:45.000000Z",
      "updated_at": "2023-06-28T12:08:30.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/0becc7d3242e43a025878a9abb4033dcf75d94da1_t_.jpg",
    "sponsors": [
      {
        "id": 17166,
        "hysform_id": 639,
        "name": "John, Katie & Clara Richter CC Monthly",
        "email": "dev+6@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      },
      {
        "id": 16043,
        "hysform_id": 639,
        "name": "Test Sule Cash",
        "email": "alsongdunstan2@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Estilien Claudensky",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$936": "To Date",
      "2 of 1": "Sponsors",
      "200%": "Complete"
    }
  },
  {
    "id": 37224,
    "profile": {
      "en_child_name": "Wilna Dervil",
      "en_gender": "Female",
      "en_grade": "PS III",
      "en_age": "5",
      "en_birthdate": "11-26-2013",
      "en_favorite_subject": "",
      "id": 37224,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Wilna Dervil\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"5\",\"en_birthdate\":\"11-26-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T03:12:42.000000Z",
      "updated_at": "2024-04-15T12:02:09.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Wilna Dervil",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS III",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "5",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "11-26-2013",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/926ae6d704e497aebb8ea808738757082195ced41.jpg",
    "donations": [],
    "entity": {
      "id": 37224,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Wilna Dervil\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"5\",\"en_birthdate\":\"11-26-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T03:12:42.000000Z",
      "updated_at": "2024-04-15T12:02:09.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/926ae6d704e497aebb8ea808738757082195ced41_t_.jpg",
    "sponsors": [
      {
        "id": 17166,
        "hysform_id": 639,
        "name": "John, Katie & Clara Richter CC Monthly",
        "email": "dev+6@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Wilna Dervil",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$452": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 37229,
    "profile": {
      "en_child_name": "Berline Fran\u00e7ois",
      "en_gender": "Female",
      "en_grade": "PS III",
      "en_age": "5",
      "en_birthdate": "04-29-2013",
      "en_favorite_subject": "",
      "id": 37229,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Berline Fran\\u00e7ois\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"5\",\"en_birthdate\":\"04-29-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T03:27:59.000000Z",
      "updated_at": "2024-04-25T08:31:42.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Berline Fran\u00e7ois",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS III",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "5",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "04-29-2013",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/7bed8a15c6037e58812dc2c14b78b1e77dd0b1401.jpg",
    "donations": [],
    "entity": {
      "id": 37229,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Berline Fran\\u00e7ois\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"5\",\"en_birthdate\":\"04-29-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-24T03:27:59.000000Z",
      "updated_at": "2024-04-25T08:31:42.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/7bed8a15c6037e58812dc2c14b78b1e77dd0b1401_t_.jpg",
    "sponsors": [
      {
        "id": 17166,
        "hysform_id": 639,
        "name": "John, Katie & Clara Richter CC Monthly",
        "email": "dev+6@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Berline Fran\u00e7ois",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$107": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 48028,
    "profile": {
      "en_name": "Masaka BoreHole",
      "id": 48028,
      "client_id": 207,
      "program_id": 3518,
      "status": "1",
      "re_add": null,
      "sp_amount": "",
      "sp_num": "",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_name\":\"Masaka BoreHole\"}",
      "deleted_at": null,
      "created_at": "2023-10-17T09:28:06.000000Z",
      "updated_at": "2023-10-17T16:59:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 6643,
        "client_id": 207,
        "hysform_id": 3048,
        "field_key": "en_name",
        "field_label": "Name",
        "field_data": "Masaka BoreHole",
        "field_type": "hysText",
        "required": 0,
        "permissions": "donor",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-10-17T09:27:32.000000Z",
        "updated_at": "2024-06-25T20:10:19.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6727,
        "client_id": 207,
        "hysform_id": 3048,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2024-06-25T18:44:19.000000Z",
        "updated_at": "2024-06-25T20:10:19.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6728,
        "client_id": 207,
        "hysform_id": 3048,
        "field_key": "en_third_name",
        "field_label": "Third Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2024-06-25T18:48:08.000000Z",
        "updated_at": "2024-06-25T20:10:19.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6729,
        "client_id": 207,
        "hysform_id": 3048,
        "field_key": "en_forth_name",
        "field_label": "Forth Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2024-06-25T18:48:53.000000Z",
        "updated_at": "2024-06-25T20:10:19.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48028,
      "client_id": 207,
      "program_id": 3518,
      "status": "1",
      "re_add": null,
      "sp_amount": "",
      "sp_num": "",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_name\":\"Masaka BoreHole\"}",
      "deleted_at": null,
      "created_at": "2023-10-17T09:28:06.000000Z",
      "updated_at": "2023-10-17T16:59:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "",
    "sponsors": [
      {
        "id": 26087,
        "hysform_id": 639,
        "name": "Schade",
        "email": "s.charlesderrick9@gmail.com",
        "frequency": "Every Month",
        "amount": 262.5
      },
      {
        "id": 26087,
        "hysform_id": 639,
        "name": "Schade",
        "email": "s.charlesderrick9@gmail.com",
        "frequency": "Every Month",
        "amount": 105
      },
      {
        "id": 17166,
        "hysform_id": 639,
        "name": "John, Katie & Clara Richter CC Monthly",
        "email": "dev+6@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 220.5
      },
      {
        "id": 17166,
        "hysform_id": 639,
        "name": "John, Katie & Clara Richter CC Monthly",
        "email": "dev+6@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 220.5
      },
      {
        "id": 17166,
        "hysform_id": 639,
        "name": "John, Katie & Clara Richter CC Monthly",
        "email": "dev+6@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 110.25
      }
    ],
    "programData": {
      "type": "campaign",
      "currency_symbol": "$",
      "sp_num": [
        {
          "symbol": "$",
          "amount": "20000"
        }
      ],
      "funded_amounts": [
        ""
      ]
    },
    "submit": [],
    "program": {
      "id": 3518,
      "client_id": 207,
      "hysform_id": 3048,
      "donor_hysform_id": 639,
      "setting_id": 1650,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Masaka BoreHole",
      "prefix": "MBH",
      "counter": 2,
      "lft": 4,
      "rgt": 5,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-10-17T09:26:48.000000Z",
      "updated_at": "2024-07-10T19:03:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Masaka BoreHole",
    "settings": {
      "program_type": "campaign",
      "sp_num": "",
      "labels": "",
      "number_spon": "",
      "donation_target": "20000",
      "sponsorship_amount": "",
      "transaction_amount": "50,100,200,500",
      "currency_symbol": "$",
      "duration": "",
      "stripe": "1",
      "login_box": "1",
      "checks": "",
      "designations": "",
      "sorting": "",
      "display_all": "",
      "wire_transfer": "",
      "cash": "",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAABFFBMVEX////ysHa3FDH97iHcj1vyrnLqpGzvrHPkmmT1yKHptwDlsgD2z620ACK2Dy7tugC1ACjxqWu0ACD89/jam6P57O+7JD7ak53PdIH58PDlrwC1ACmxAAuzABvir7bPgU/Yi5atWyv86h743hjHUmXqyszNbHnBOlH55dP1tnnqwAvzzQ348NTvvwHyxwn22hfsx2jTZ1TXcVjw2Nrdf1+9MEexAADnvML79eDw1IvpwDr15rjryGD9+/Ly253nuinqwkzw1o/z4KfvznjuumHrsT70v5LjpEe3aSrbpA7EfxvhoTa+bTzdklPipSvgmkz538nZhUnnspDhjGTNWE3EQEHCOz/57cTSfonIX2zESV29Hz6FIrDPAAAK1ElEQVR4nO2cCV/bNh/HE9ECxbVmnIvYcZbmbJKWDEIIjKZ07VbWjW7dUnhCeP/v49HhQz4SO6y2Zapf209BURx9+Z+S/SGXExISEhISEhISEhISEhISEhISEsqeZmdn/zs7m6W9jHg0uzj/WdKopJ/PLx4Z5uzijaRJkrRHhb7SpDePCHL29lKz4BxJ2uXbR8J4wfD9gMUwXqS9uG+g2TuT7we3TMZ3mTfjheTie314ePjaxShl3IxvqQEJ0XDU3KJqjoY2o6S9TXuR/0XnmsV32Npyq3VoMWrnaS/z4fpFW8XnYtR+SXuhD9V7y4KjAD6skWXF92kv9WF6RWIQZZcgA5pmfE0QJe1V2ot9kC5NwOZKQJRzTMTLLBaND1o4oI2ofUh7uZuL+CiKMwLYXO2oTRKLknaW9oI31jsKSNCamjbAUTfQJL9FWxTxXdoL3lSvqI8OKYQmaYMm4pO0od+KQ+qnWUs2byQ2CBEc/oP+BrgrDUXpTdpL3kxnNI/ahXAgYQ1agWlnRPNptiLxQvPkUbzr3VuVbIgRtWy14NRJnaBr4R2+drgCcZg9N51dEkIn6HCWWY3YIoSZqvpn1EkdBlTwRjjdDNa5aZYCkYbhoYuwtbUa8TBzgXiuucMQ5VJcCU3E1mg0cidVEoiZ2id+kFy1AiFo2IgUcY+cmR6yjKReSFnqTX/yJJqtJk40o2ZzT7Kk7TEv01TzU9rL3kA+QlIutD0TcIDsiMpj81ERbo00jdoO/Tukbjt4XIRbqPNGGrTMdIMQnY1G9gh9mcaEJEgmokRyT1YzzbmnaXOLIrKEtG3LUrV47634AYgS46W04mfpxO2Vd2vhR8Qp1fZe2rVlaQ/s67x9iDir2nGawc7bt3vyamgWDTYMM7V7MgNxpZsO6WZq4HLSLIWh/xSDUXM0JGUfpxtq5EyeYnhOotxZhjRwTfzFwDFhxpzUc5roEt5aSGR8QJvvjJ4muk6EXWoNBkPWtFk9EbaMGHLbwrlxkTkTfgd3ZnIzaYO7a1Kmqr2lV+Yt4DWIJiC3Pvry+Xr9KkW8yy39GnKllykB7j9dr/xvFuLqJxUI4G/5kCvtp4I4y4fLRlz3tAkCDFcKcTrrP42MSBhfD1t0j4+2+q3ha+epqCiAT/vJI35cD7izTXWlMY/skYe+7Me+6AvalTlzZz3ix6QBn4VY8PqFqd8/sY8lep7c29v79Ls18ccQKz5LFvB5COD2C0d/aHteSGtA+4OZt96I+afPkwT8sr9+NfknL65/dPSn//lZEoF/MnOuXzwJueb+l+QAX4YB5q+vn7h09ckLKX26ck+5vg67aHI1YxaaRbc9gE+ezD9f/UVOvclD3tpfV5/n3inX22GXfZpQQp3lQwm9i7f0+W+szyte3Q0lTKgshtQJrBVJY8eS51v38DrERGpGWJ2IVUnUjLA6ETdi7DUjtE7ErbhrRnidiB8x1poRXicSUKw1Y5sPxQdY+GdVoUtU/xTiQ9z3lbA0tB8fYC79PIMlCAWhIExfglAQCsL0JQgFoSBMX7ESkluGKcKRm4lxEr7E+ribnj6SFcRISPRvipvff+OG+04In6V4QpPMTcQUD70Tuk0qCAWhIBSEglAQCkJBGKg+UvhQVgn7O/OTo6Pj+TZD1O9vz4+Pjk7mO5tR8kjY3/0KIBG4ObHG8ic31uDX3U0Y+SPs73xFFKYgvJ1jnP78lh38uoEd+SPcBTYKxTnu5/vH0D0IQp+F4pdw2w2IpB/3j3XPGAShD7RxS3jjBUQ4xwFjNxkl7M/9MMBnVTI2jxiKnBEGmTBYkY3IGeFOVECEGP5YIoeEwU66gjCim3JGeLIB4UkmCQOy5krCY0HII2F+Iy+NdknOCDfKNJkkzEcGBCDiFTkj7D/6ih89EKOGIXeEO5GdNGJLwx1h1HoRtVbwR4j2h9/WhPwRRjNidBPyR5jP34Yjwtvol+OPMMr+IvL2l0vCCH66gY9ySRha9uFNts9L87gorkOE0fMot4QhJSPyQSLHhOuyzSZZhl/CNccZUQ8veCdcibgxILeEKxA3B+SXMBDxAYAcEwakm02TDO+E+b77RhsEG90ZzQJhvr/NdOHwdvshgHwT5vs7dgMHbza8f58NQqQjigiPHnoB7gn7c0L4kByTEUKUb2712wflmKwQIkU9OMwu4X+SIBSEglAQCkJByBFhekqG8Muz9JTgr04UEhISEhISEhISEhIS+u5VmlYWXaRFsVMKeLWOXmx0mF8TO516JrjeVb/rkP/HRb/G+IXiomFrUYzx1886SzIMWVF0XVFU477rXn2uugCGoiuyMalbQ9PTWpGdcl9bMsssncoT/G3JUGWvVBl/XI0ZUWqNGMksdWWgq6phqKoCoaK2x8xr44kKoYwWC6FxZ44V0TfsnFNYZoxYlIGBf0qI1IQAAFhAp4i9Qj7OUq0SP2DuQNHv6vXptF5c3NcUoMuOGce6Do1JcVpv6DJQlzaD0mbeX3MR3kOgkJ/F1HJECIDllNh/K7J+5/htPZeADhTV/pzxgQFhzUIsAGRA+lphYQC1S75EhMBg/NRF2DGQyVQ2MAsKBOzHVWTZ5eQJiCXEfonMZq6wy/pjRaXuRwiB6vipi/AAOQGQWderIkI2nSDCJDyTlZswVypD6ma5cQ0wHpvrKrCHl4oIIdCX9jhLWEVWP1BgmUHijzA3laFMLNRVlDtmvKBCYkSUadr3jJ+yhHUVTgplOs8Uh4S5tk7WUNWh3GHHG7KCI7EoK5UiclkLiyVEby2ieTrzk+GRsK4SH5yqsOcaHxuwXMWEciPX020/ZQjHJIbHsh3JOT4Jxyohacjywj3zHhpjk7CDqofppwwhsh6uI3c6AxFAmG4uxZIhGON1qp4Gp6sbdZMw11ChTsEcwkKPRuDUgLr9Jj8hnLRtdQP6xG8uPyGAOiLsQbXjHm/I2G6UMDeBpp86hB0D4r4sV5gwucZPiC5vyzj41jgB8hPeQ4UQyh5CGkImIaolNJ86hCj5Ur82vZUogFA3bNWSaGr8hDqx4TLAhrJjQ+ynpB+wCUuQxGmOZBzZagn8hMpBxxbb4MYmHyEqfKAUGIdkpkVYmOikP7UJcTEcUyH7N8w38ZhpOmilOWKxhntm2cmlWGOD+KlNuNQBVKnzQWD3NTxWiwqt7KgeLl3jpRoEVYYQ+6lSsgkRMHQELAfgkBB3XXigJJOE46hCexWHsEDqvkXYkOF9z1IZWn0Nh4RopXRJbV1x5XKZkjuEyJ+Rn8omIcozTmYq1YBOfzz8EU5Vq6vuoL0Fk00XqFTTvYUTnw0VbZYoISrzE4ZkqZuzuCNEJlGsdrSN9kG2n9ZRXqnTGQ4h8lNgEt7prsRkA/NFWJ0uDaDYbWYJFcayaUW0m5BpZLGEuD+lhMgt3VELzL6Gi2qhNFAJ60wr3bKBNgc95kwCbfLVu+l4XFyqQOnRhboIsZ8SwqKqt12XtfZQfkK9O61b8vQU8ehAAbKBD9tkHfEoFXY5HUAP4lD7YiyrdMxNiPpTQjiB3h2KAcl5TUjXloQ9GzVFxxVMl9VaueLp9UvdGgZXDCd4iobBBtL4VMeEsqx73tqWT7GbVlXFRVisKYwMzwYtFhXqi/akXO61G/WgLnFcbJcn3XrVHqgul1V2QvEeG6/Tnnrf2Osyrzsf1+gyWlRzQkJCQkJCQkJCQkJCQnHo/+f0vMFYMMbWAAAAAElFTkSuQmCC",
      "disable_program_link": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "1",
      "processing_percentage": "5"
    },
    "details": []
  },
  {
    "id": 37193,
    "profile": {
      "en_child_name": "Patricia Charles",
      "en_gender": "Female",
      "en_grade": "PS II",
      "en_age": "5",
      "en_birthdate": "10-27-2013",
      "en_favorite_subject": "",
      "id": 37193,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Patricia Charles\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"5\",\"en_birthdate\":\"10-27-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T05:56:53.000000Z",
      "updated_at": "2024-06-14T07:44:14.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Patricia Charles",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Female",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T17:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "PS II",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:53.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "5",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T20:27:08.000000Z",
        "updated_at": "2019-01-23T04:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "10-27-2013",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T07:11:48.000000Z",
        "updated_at": "2023-03-31T14:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T21:57:18.000000Z",
        "updated_at": "2023-01-12T16:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T14:11:19.000000Z",
        "updated_at": "2023-01-16T14:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T10:04:48.000000Z",
        "updated_at": "2023-03-17T10:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T12:42:48.000000Z",
        "updated_at": "2023-03-17T12:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T16:06:06.000000Z",
        "updated_at": "2023-03-31T16:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/828f63590949ff1f9258c16be1a8936627d668951.jpg",
    "donations": [],
    "entity": {
      "id": 37193,
      "client_id": 207,
      "program_id": 929,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Patricia Charles\",\"en_gender\":\"Female\",\"en_grade\":\"PS II\",\"en_age\":\"5\",\"en_birthdate\":\"10-27-2013\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2019-01-23T05:56:53.000000Z",
      "updated_at": "2024-06-14T07:44:14.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/828f63590949ff1f9258c16be1a8936627d668951_t_.jpg",
    "sponsors": [
      {
        "id": 17166,
        "hysform_id": 639,
        "name": "John, Katie & Clara Richter CC Monthly",
        "email": "dev+6@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 929,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 337,
      "entity_submit": "",
      "donor_submit": "0",
      "link_id": 0,
      "name": "Education",
      "prefix": "",
      "counter": 413,
      "lft": 20,
      "rgt": 21,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2017-02-23T04:40:22.000000Z",
      "updated_at": "2024-06-12T13:48:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003822000,
      "children": []
    },
    "name": "Patricia Charles",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "number_spon": "2",
      "sponsorship_amount": "32,40,50",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1"
    },
    "details": {
      "$0": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 48045,
    "profile": {
      "en_name": "Demo campaign recipient",
      "id": 48045,
      "client_id": 207,
      "program_id": 3521,
      "status": "1",
      "re_add": null,
      "sp_amount": "",
      "sp_num": "",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_name\":\"Demo campaign recipient\"}",
      "deleted_at": null,
      "created_at": "2024-06-13T08:40:15.000000Z",
      "updated_at": "2024-06-13T11:51:01.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6701,
        "client_id": 207,
        "hysform_id": 3051,
        "field_key": "en_name",
        "field_label": "Name",
        "field_data": "Demo campaign recipient",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2024-06-13T08:38:33.000000Z",
        "updated_at": "2024-06-13T08:38:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48045,
      "client_id": 207,
      "program_id": 3521,
      "status": "1",
      "re_add": null,
      "sp_amount": "",
      "sp_num": "",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_name\":\"Demo campaign recipient\"}",
      "deleted_at": null,
      "created_at": "2024-06-13T08:40:15.000000Z",
      "updated_at": "2024-06-13T11:51:01.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [
      {
        "id": 17166,
        "hysform_id": 639,
        "name": "John, Katie & Clara Richter CC Monthly",
        "email": "dev+6@helpyousponsor.com",
        "frequency": "Every Month",
        "amount": 52.94
      }
    ],
    "programData": {
      "type": "campaign",
      "currency_symbol": "$",
      "sp_num": [
        {
          "symbol": "$",
          "amount": ""
        }
      ],
      "funded_amounts": [
        ""
      ]
    },
    "submit": [],
    "program": {
      "id": 3521,
      "client_id": 207,
      "hysform_id": 3051,
      "donor_hysform_id": 3030,
      "setting_id": 1652,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Sustainable Living Expo",
      "prefix": "DC",
      "counter": 1,
      "lft": 4,
      "rgt": 5,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2024-06-13T08:35:10.000000Z",
      "updated_at": "2024-08-06T12:03:55.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Demo campaign recipient",
    "settings": {
      "program_type": "campaign",
      "sp_num": "",
      "labels": "",
      "number_spon": "",
      "donation_target": "",
      "sponsorship_amount": "",
      "transaction_amount": "10,20,50,100",
      "currency_symbol": "$",
      "duration": "",
      "stripe": "1",
      "login_box": "",
      "checks": "1",
      "designations": "",
      "sorting": "",
      "display_all": "",
      "wire_transfer": "",
      "cash": "",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "disable_program_link": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "1",
      "processing_percentage": "2.9"
    },
    "details": []
  },
  {
    "id": 47702,
    "profile": {
      "en_child_id": "418",
      "en_first_name": "Obedience",
      "en_second_name": "",
      "en_last_name_1": "Akansasira",
      "en_gender": "M",
      "en_date_of_birth": "15/06/2003",
      "en_living_mother_nam": "Cate Kyampire (deceased)",
      "en_living_father_nam": "Benson Bayenda",
      "en_number_of_sisters": "1",
      "en_number_of_brother": "3",
      "en_favorite_subject": "Physics",
      "en_favorite_activity": "playing football",
      "en_public_comments": "13 years old.He is now 19 years old,He loves mechanics like repairing radios and other items.He is obedient and humble boy.8.22",
      "en_private_comments": "When his father remarried the new woman did not treat them well so he came from the village with his brothers.\r\n\r\nWants to be a pilot.Obedience stays at the ranch during holidays.8.22",
      "en_privates_notes": "He was promoted to P7 class for 2018.Obedience is now in S.3 and his performance is fair.8.22.He was promoted to S4.01.23.",
      "en_student_id": "2134",
      "en_health_status": "Good",
      "en_student_grade": "S4",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "",
      "en_contact_phone_num": "779308975",
      "en_school_attending": "YAHS",
      "en_sponsor_updates": "",
      "en_health_record": "Skin infection. Which is being managed effectively. 7.22 Allergies 10.22",
      "id": 47702,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"418\",\"en_first_name\":\"Obedience\",\"en_second_name\":\"\",\"en_last_name_1\":\"Akansasira\",\"en_gender\":\"M\",\"en_date_of_birth\":\"15\\/06\\/2003\",\"en_living_mother_nam\":\"Cate Kyampire (deceased)\",\"en_living_father_nam\":\"Benson Bayenda\",\"en_number_of_sisters\":\"1\",\"en_number_of_brother\":\"3\",\"en_favorite_subject\":\"Physics\",\"en_favorite_activity\":\"playing football\",\"en_public_comments\":\"13 years old.He is now 19 years old,He loves mechanics like repairing radios and other items.He is obedient and humble boy.8.22\",\"en_private_comments\":\"When his father remarried the new woman did not treat them well so he came from the village with his brothers.\\r\\n\\r\\nWants to be a pilot.Obedience stays at the ranch during holidays.8.22\",\"en_privates_notes\":\"He was promoted to P7 class for 2018.Obedience is now in S.3 and his performance is fair.8.22.He was promoted to S4.01.23.\",\"en_student_id\":\"2134\",\"en_health_status\":\"Good\",\"en_student_grade\":\"S4\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"779308975\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"Skin infection. Which is being managed effectively. 7.22 Allergies 10.22\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "2134",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "S4",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "YAHS",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Obedience",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Akansasira",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "M",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "15/06/2003",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "Good",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "Skin infection. Which is being managed effectively. 7.22 Allergies 10.22",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Cate Kyampire (deceased)",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "Benson Bayenda",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "779308975",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "1",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "Physics",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "When his father remarried the new woman did not treat them well so he came from the village with his brothers.\r\n\r\nWants to be a pilot.Obedience stays at the ranch during holidays.8.22",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "playing football",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "13 years old.He is now 19 years old,He loves mechanics like repairing radios and other items.He is obedient and humble boy.8.22",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "He was promoted to P7 class for 2018.Obedience is now in S.3 and his performance is fair.8.22.He was promoted to S4.01.23.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "418",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47702,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"418\",\"en_first_name\":\"Obedience\",\"en_second_name\":\"\",\"en_last_name_1\":\"Akansasira\",\"en_gender\":\"M\",\"en_date_of_birth\":\"15\\/06\\/2003\",\"en_living_mother_nam\":\"Cate Kyampire (deceased)\",\"en_living_father_nam\":\"Benson Bayenda\",\"en_number_of_sisters\":\"1\",\"en_number_of_brother\":\"3\",\"en_favorite_subject\":\"Physics\",\"en_favorite_activity\":\"playing football\",\"en_public_comments\":\"13 years old.He is now 19 years old,He loves mechanics like repairing radios and other items.He is obedient and humble boy.8.22\",\"en_private_comments\":\"When his father remarried the new woman did not treat them well so he came from the village with his brothers.\\r\\n\\r\\nWants to be a pilot.Obedience stays at the ranch during holidays.8.22\",\"en_privates_notes\":\"He was promoted to P7 class for 2018.Obedience is now in S.3 and his performance is fair.8.22.He was promoted to S4.01.23.\",\"en_student_id\":\"2134\",\"en_health_status\":\"Good\",\"en_student_grade\":\"S4\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"779308975\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"Skin infection. Which is being managed effectively. 7.22 Allergies 10.22\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47711,
    "profile": {
      "en_child_id": "450",
      "en_first_name": "Racheal",
      "en_second_name": "",
      "en_last_name_1": "Nabukenya",
      "en_gender": "F",
      "en_date_of_birth": "15/12/2006",
      "en_living_mother_nam": "Annet Nalunga",
      "en_living_father_nam": "None",
      "en_number_of_sisters": "1",
      "en_number_of_brother": "2",
      "en_favorite_subject": "Biology",
      "en_favorite_activity": "playing netball",
      "en_public_comments": "She also enjoys playing netball and loves debating.",
      "en_private_comments": "She stays with her mother in Ssembabule district who is completely unable to take care of her children. \r\nThe husband is deceased\r\n\r\n0706362323",
      "en_privates_notes": "She is in P6 Class for 2018.Racheal is now in S2.11.22.Racheal was promoted to S3.01.23",
      "en_student_id": "2169",
      "en_health_status": "Good",
      "en_student_grade": "S3",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "",
      "en_contact_phone_num": "706362323",
      "en_school_attending": "YAHS",
      "en_sponsor_updates": "",
      "en_health_record": "Good Health status. 7.22",
      "id": 47711,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"450\",\"en_first_name\":\"Racheal\",\"en_second_name\":\"\",\"en_last_name_1\":\"Nabukenya\",\"en_gender\":\"F\",\"en_date_of_birth\":\"15\\/12\\/2006\",\"en_living_mother_nam\":\"Annet Nalunga\",\"en_living_father_nam\":\"None\",\"en_number_of_sisters\":\"1\",\"en_number_of_brother\":\"2\",\"en_favorite_subject\":\"Biology\",\"en_favorite_activity\":\"playing netball\",\"en_public_comments\":\"She also enjoys playing netball and loves debating.\",\"en_private_comments\":\"She stays with her mother in Ssembabule district who is completely unable to take care of her children. \\r\\nThe husband is deceased\\r\\n\\r\\n0706362323\",\"en_privates_notes\":\"She is in P6 Class for 2018.Racheal is now in S2.11.22.Racheal was promoted to S3.01.23\",\"en_student_id\":\"2169\",\"en_health_status\":\"Good\",\"en_student_grade\":\"S3\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"706362323\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"Good Health status. 7.22\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:47.000000Z",
      "updated_at": "2023-06-02T09:43:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "2169",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "S3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "YAHS",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Racheal",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Nabukenya",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "F",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "15/12/2006",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "Good",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "Good Health status. 7.22",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Annet Nalunga",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "None",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "706362323",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "1",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "2",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "Biology",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "She stays with her mother in Ssembabule district who is completely unable to take care of her children. \r\nThe husband is deceased\r\n\r\n0706362323",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "playing netball",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "She also enjoys playing netball and loves debating.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "She is in P6 Class for 2018.Racheal is now in S2.11.22.Racheal was promoted to S3.01.23",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "450",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47711,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"450\",\"en_first_name\":\"Racheal\",\"en_second_name\":\"\",\"en_last_name_1\":\"Nabukenya\",\"en_gender\":\"F\",\"en_date_of_birth\":\"15\\/12\\/2006\",\"en_living_mother_nam\":\"Annet Nalunga\",\"en_living_father_nam\":\"None\",\"en_number_of_sisters\":\"1\",\"en_number_of_brother\":\"2\",\"en_favorite_subject\":\"Biology\",\"en_favorite_activity\":\"playing netball\",\"en_public_comments\":\"She also enjoys playing netball and loves debating.\",\"en_private_comments\":\"She stays with her mother in Ssembabule district who is completely unable to take care of her children. \\r\\nThe husband is deceased\\r\\n\\r\\n0706362323\",\"en_privates_notes\":\"She is in P6 Class for 2018.Racheal is now in S2.11.22.Racheal was promoted to S3.01.23\",\"en_student_id\":\"2169\",\"en_health_status\":\"Good\",\"en_student_grade\":\"S3\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"706362323\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"Good Health status. 7.22\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:47.000000Z",
      "updated_at": "2023-06-02T09:43:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47710,
    "profile": {
      "en_child_id": "114",
      "en_first_name": "Godfrey",
      "en_second_name": "",
      "en_last_name_1": "Bulegeya",
      "en_gender": "M",
      "en_date_of_birth": "28/03/2008",
      "en_living_mother_nam": "Fokushaba Sharon",
      "en_living_father_nam": "Muhimbura Moses (Absent)",
      "en_number_of_sisters": "5",
      "en_number_of_brother": "1",
      "en_favorite_subject": "Mathematics",
      "en_favorite_activity": "Soccer",
      "en_public_comments": "Godfrey is a very active young boy who loves to be playing constantly.  He is the third of the four siblings at the village Rugushuru in Sembabule district their home. Godfrey's father is not present with the mother so his mother must work hard to care for the family.",
      "en_private_comments": "The family has very many children whom they can not afford to take of .01.23",
      "en_privates_notes": "Godfrey has been Promoted to  to P.5 this year 2020. Based upon the current performance, we believe and hope that Godfrey is going to do even better for he is both promising and encouraging. He\u00e2\u20ac\u2122s now in P6.His performance is amazing,We hope for the best out of him.11.22.Bulegeya was promoted to P7.01.23",
      "en_student_id": "1006",
      "en_health_status": "He is very fine and doing well.",
      "en_student_grade": "P7",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "",
      "en_contact_phone_num": "752565247",
      "en_school_attending": "Masaka Baptist School",
      "en_sponsor_updates": "",
      "en_health_record": "",
      "id": 47710,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"114\",\"en_first_name\":\"Godfrey\",\"en_second_name\":\"\",\"en_last_name_1\":\"Bulegeya\",\"en_gender\":\"M\",\"en_date_of_birth\":\"28\\/03\\/2008\",\"en_living_mother_nam\":\"Fokushaba Sharon\",\"en_living_father_nam\":\"Muhimbura Moses (Absent)\",\"en_number_of_sisters\":\"5\",\"en_number_of_brother\":\"1\",\"en_favorite_subject\":\"Mathematics\",\"en_favorite_activity\":\"Soccer\",\"en_public_comments\":\"Godfrey is a very active young boy who loves to be playing constantly.  He is the third of the four siblings at the village Rugushuru in Sembabule district their home. Godfrey's father is not present with the mother so his mother must work hard to care for the family.\",\"en_private_comments\":\"The family has very many children whom they can not afford to take of .01.23\",\"en_privates_notes\":\"Godfrey has been Promoted to  to P.5 this year 2020. Based upon the current performance, we believe and hope that Godfrey is going to do even better for he is both promising and encouraging. He\\u00e2\\u20ac\\u2122s now in P6.His performance is amazing,We hope for the best out of him.11.22.Bulegeya was promoted to P7.01.23\",\"en_student_id\":\"1006\",\"en_health_status\":\"He is very fine and doing well.\",\"en_student_grade\":\"P7\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"752565247\",\"en_school_attending\":\"Masaka Baptist School\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:47.000000Z",
      "updated_at": "2023-06-02T09:43:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "1006",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "P7",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "Masaka Baptist School",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Godfrey",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Bulegeya",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "M",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "28/03/2008",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "He is very fine and doing well.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Fokushaba Sharon",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "Muhimbura Moses (Absent)",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "752565247",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "5",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "1",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "Mathematics",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "The family has very many children whom they can not afford to take of .01.23",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "Soccer",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "Godfrey is a very active young boy who loves to be playing constantly.  He is the third of the four siblings at the village Rugushuru in Sembabule district their home. Godfrey's father is not present with the mother so his mother must work hard to care for the family.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "Godfrey has been Promoted to  to P.5 this year 2020. Based upon the current performance, we believe and hope that Godfrey is going to do even better for he is both promising and encouraging. He\u00e2\u20ac\u2122s now in P6.His performance is amazing,We hope for the best out of him.11.22.Bulegeya was promoted to P7.01.23",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "114",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47710,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"114\",\"en_first_name\":\"Godfrey\",\"en_second_name\":\"\",\"en_last_name_1\":\"Bulegeya\",\"en_gender\":\"M\",\"en_date_of_birth\":\"28\\/03\\/2008\",\"en_living_mother_nam\":\"Fokushaba Sharon\",\"en_living_father_nam\":\"Muhimbura Moses (Absent)\",\"en_number_of_sisters\":\"5\",\"en_number_of_brother\":\"1\",\"en_favorite_subject\":\"Mathematics\",\"en_favorite_activity\":\"Soccer\",\"en_public_comments\":\"Godfrey is a very active young boy who loves to be playing constantly.  He is the third of the four siblings at the village Rugushuru in Sembabule district their home. Godfrey's father is not present with the mother so his mother must work hard to care for the family.\",\"en_private_comments\":\"The family has very many children whom they can not afford to take of .01.23\",\"en_privates_notes\":\"Godfrey has been Promoted to  to P.5 this year 2020. Based upon the current performance, we believe and hope that Godfrey is going to do even better for he is both promising and encouraging. He\\u00e2\\u20ac\\u2122s now in P6.His performance is amazing,We hope for the best out of him.11.22.Bulegeya was promoted to P7.01.23\",\"en_student_id\":\"1006\",\"en_health_status\":\"He is very fine and doing well.\",\"en_student_grade\":\"P7\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"752565247\",\"en_school_attending\":\"Masaka Baptist School\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:47.000000Z",
      "updated_at": "2023-06-02T09:43:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47709,
    "profile": {
      "en_child_id": "286",
      "en_first_name": "Abdul",
      "en_second_name": "",
      "en_last_name_1": "Hassan",
      "en_gender": "M",
      "en_date_of_birth": "19/09/2006",
      "en_living_mother_nam": "Zaituni Namwanje",
      "en_living_father_nam": "None",
      "en_number_of_sisters": "3",
      "en_number_of_brother": "1",
      "en_favorite_subject": "PE",
      "en_favorite_activity": "Football and watching television",
      "en_public_comments": "Abdul is a reserved boy.",
      "en_private_comments": "He comes from an extremely needy family and stays with the mother who can not afford basic needs. Mobile: 0785-888-425 He is an orphan.Hassan now spends his holiday at the ranch.01.23",
      "en_privates_notes": "Due to his good performance in P5 Class in 2017, he was therefore promoted to P6 Class \r\n this year 2018. In 2019 he was promoted to P7. See Report card scan.He is now in S2 and his performance is good.8.22.He was promoted to S3.01.23",
      "en_student_id": "2006-1085",
      "en_health_status": "Good",
      "en_student_grade": "S3",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "Zaituni Namwanje",
      "en_contact_phone_num": "785888425",
      "en_school_attending": "YAHS",
      "en_sponsor_updates": "",
      "en_health_record": "Good Health status. 7.22",
      "id": 47709,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"286\",\"en_first_name\":\"Abdul\",\"en_second_name\":\"\",\"en_last_name_1\":\"Hassan\",\"en_gender\":\"M\",\"en_date_of_birth\":\"19\\/09\\/2006\",\"en_living_mother_nam\":\"Zaituni Namwanje\",\"en_living_father_nam\":\"None\",\"en_number_of_sisters\":\"3\",\"en_number_of_brother\":\"1\",\"en_favorite_subject\":\"PE\",\"en_favorite_activity\":\"Football and watching television\",\"en_public_comments\":\"Abdul is a reserved boy.\",\"en_private_comments\":\"He comes from an extremely needy family and stays with the mother who can not afford basic needs. Mobile: 0785-888-425 He is an orphan.Hassan now spends his holiday at the ranch.01.23\",\"en_privates_notes\":\"Due to his good performance in P5 Class in 2017, he was therefore promoted to P6 Class \\r\\n this year 2018. In 2019 he was promoted to P7. See Report card scan.He is now in S2 and his performance is good.8.22.He was promoted to S3.01.23\",\"en_student_id\":\"2006-1085\",\"en_health_status\":\"Good\",\"en_student_grade\":\"S3\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"Zaituni Namwanje\",\"en_contact_phone_num\":\"785888425\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"Good Health status. 7.22\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:47.000000Z",
      "updated_at": "2023-06-02T09:43:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "2006-1085",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "S3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "YAHS",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Abdul",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Hassan",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "M",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "19/09/2006",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "Good",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "Good Health status. 7.22",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Zaituni Namwanje",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "None",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "Zaituni Namwanje",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "785888425",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "1",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "PE",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "He comes from an extremely needy family and stays with the mother who can not afford basic needs. Mobile: 0785-888-425 He is an orphan.Hassan now spends his holiday at the ranch.01.23",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "Football and watching television",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "Abdul is a reserved boy.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "Due to his good performance in P5 Class in 2017, he was therefore promoted to P6 Class \r\n this year 2018. In 2019 he was promoted to P7. See Report card scan.He is now in S2 and his performance is good.8.22.He was promoted to S3.01.23",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "286",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47709,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"286\",\"en_first_name\":\"Abdul\",\"en_second_name\":\"\",\"en_last_name_1\":\"Hassan\",\"en_gender\":\"M\",\"en_date_of_birth\":\"19\\/09\\/2006\",\"en_living_mother_nam\":\"Zaituni Namwanje\",\"en_living_father_nam\":\"None\",\"en_number_of_sisters\":\"3\",\"en_number_of_brother\":\"1\",\"en_favorite_subject\":\"PE\",\"en_favorite_activity\":\"Football and watching television\",\"en_public_comments\":\"Abdul is a reserved boy.\",\"en_private_comments\":\"He comes from an extremely needy family and stays with the mother who can not afford basic needs. Mobile: 0785-888-425 He is an orphan.Hassan now spends his holiday at the ranch.01.23\",\"en_privates_notes\":\"Due to his good performance in P5 Class in 2017, he was therefore promoted to P6 Class \\r\\n this year 2018. In 2019 he was promoted to P7. See Report card scan.He is now in S2 and his performance is good.8.22.He was promoted to S3.01.23\",\"en_student_id\":\"2006-1085\",\"en_health_status\":\"Good\",\"en_student_grade\":\"S3\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"Zaituni Namwanje\",\"en_contact_phone_num\":\"785888425\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"Good Health status. 7.22\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:47.000000Z",
      "updated_at": "2023-06-02T09:43:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47708,
    "profile": {
      "en_child_id": "285",
      "en_first_name": "Hajarah",
      "en_second_name": "",
      "en_last_name_1": "Kirabo",
      "en_gender": "F",
      "en_date_of_birth": "28/10/2004",
      "en_living_mother_nam": "Jalia Mayanja",
      "en_living_father_nam": "None",
      "en_number_of_sisters": "0",
      "en_number_of_brother": "1",
      "en_favorite_subject": "Science",
      "en_favorite_activity": "Singing",
      "en_public_comments": "She loves God and participates by singing in church.",
      "en_private_comments": "0772-506-398\r\n\r\nShe is a total orphan and comes from a completely needy family since she lost all her parents.\r\nShe is  a sister to Haruna Ntambazi. They stay at Munyonyo Kampala.\r\n\r\nToday 24th February 2020I have received a call from school that Hajarah is unconscious! Of which I have received now to take her for further treatment.",
      "en_privates_notes": "Her performance was fair, therefore she was promoted to P7 class this year 2018.\r\nHajarah is now in S2 year 2020 .",
      "en_student_id": "1084",
      "en_health_status": "Good",
      "en_student_grade": "Left-not interested",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "",
      "en_contact_phone_num": "",
      "en_school_attending": "YAHS",
      "en_sponsor_updates": "",
      "en_health_record": "",
      "id": 47708,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"285\",\"en_first_name\":\"Hajarah\",\"en_second_name\":\"\",\"en_last_name_1\":\"Kirabo\",\"en_gender\":\"F\",\"en_date_of_birth\":\"28\\/10\\/2004\",\"en_living_mother_nam\":\"Jalia Mayanja\",\"en_living_father_nam\":\"None\",\"en_number_of_sisters\":\"0\",\"en_number_of_brother\":\"1\",\"en_favorite_subject\":\"Science\",\"en_favorite_activity\":\"Singing\",\"en_public_comments\":\"She loves God and participates by singing in church.\",\"en_private_comments\":\"0772-506-398\\r\\n\\r\\nShe is a total orphan and comes from a completely needy family since she lost all her parents.\\r\\nShe is  a sister to Haruna Ntambazi. They stay at Munyonyo Kampala.\\r\\n\\r\\nToday 24th February 2020I have received a call from school that Hajarah is unconscious! Of which I have received now to take her for further treatment.\",\"en_privates_notes\":\"Her performance was fair, therefore she was promoted to P7 class this year 2018.\\r\\nHajarah is now in S2 year 2020 .\",\"en_student_id\":\"1084\",\"en_health_status\":\"Good\",\"en_student_grade\":\"Left-not interested\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "1084",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "Left-not interested",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "YAHS",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Hajarah",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Kirabo",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "F",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "28/10/2004",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "Good",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Jalia Mayanja",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "None",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "0",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "1",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "Science",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "0772-506-398\r\n\r\nShe is a total orphan and comes from a completely needy family since she lost all her parents.\r\nShe is  a sister to Haruna Ntambazi. They stay at Munyonyo Kampala.\r\n\r\nToday 24th February 2020I have received a call from school that Hajarah is unconscious! Of which I have received now to take her for further treatment.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "Singing",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "She loves God and participates by singing in church.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "Her performance was fair, therefore she was promoted to P7 class this year 2018.\r\nHajarah is now in S2 year 2020 .",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "285",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47708,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"285\",\"en_first_name\":\"Hajarah\",\"en_second_name\":\"\",\"en_last_name_1\":\"Kirabo\",\"en_gender\":\"F\",\"en_date_of_birth\":\"28\\/10\\/2004\",\"en_living_mother_nam\":\"Jalia Mayanja\",\"en_living_father_nam\":\"None\",\"en_number_of_sisters\":\"0\",\"en_number_of_brother\":\"1\",\"en_favorite_subject\":\"Science\",\"en_favorite_activity\":\"Singing\",\"en_public_comments\":\"She loves God and participates by singing in church.\",\"en_private_comments\":\"0772-506-398\\r\\n\\r\\nShe is a total orphan and comes from a completely needy family since she lost all her parents.\\r\\nShe is  a sister to Haruna Ntambazi. They stay at Munyonyo Kampala.\\r\\n\\r\\nToday 24th February 2020I have received a call from school that Hajarah is unconscious! Of which I have received now to take her for further treatment.\",\"en_privates_notes\":\"Her performance was fair, therefore she was promoted to P7 class this year 2018.\\r\\nHajarah is now in S2 year 2020 .\",\"en_student_id\":\"1084\",\"en_health_status\":\"Good\",\"en_student_grade\":\"Left-not interested\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47707,
    "profile": {
      "en_child_id": "283",
      "en_first_name": "Angel",
      "en_second_name": "Princess",
      "en_last_name_1": "Mirembe",
      "en_gender": "F",
      "en_date_of_birth": "02/07/2007",
      "en_living_mother_nam": "Norah Mirembe",
      "en_living_father_nam": "Stephen Mande",
      "en_number_of_sisters": "3",
      "en_number_of_brother": "3",
      "en_favorite_subject": "Math",
      "en_favorite_activity": "Music",
      "en_public_comments": "Angel is a role model to her sisters and provides alot of counseling to them.",
      "en_private_comments": "She is at MBS with other children now and no longer staying with the grandmother as she used to during her studies at JICC.Angel now lives with her aunt in Masaka town.They were abandoned by their mother.she is a sister to Mirembe Grace and Mirembe Angel.11.22",
      "en_privates_notes": "Thank you for taking the responsibility to sponsor our child, Mirembe Angel. Her performance was very good last year in 2017. She has therefore been promoted to P.6 Class for 2018. She was 7th out of the 54 children in class.Mirembe is now in S2.11.22.She was promoted to S3.01.23",
      "en_student_id": "1082",
      "en_health_status": "Good",
      "en_student_grade": "S3",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "",
      "en_contact_phone_num": "0781411978/ 0776341920",
      "en_school_attending": "YAHS",
      "en_sponsor_updates": "",
      "en_health_record": "Epigastric pain with severe headache. Being managed for PUD and symptomatic treatment. 7.22",
      "id": 47707,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"283\",\"en_first_name\":\"Angel\",\"en_second_name\":\"Princess\",\"en_last_name_1\":\"Mirembe\",\"en_gender\":\"F\",\"en_date_of_birth\":\"02\\/07\\/2007\",\"en_living_mother_nam\":\"Norah Mirembe\",\"en_living_father_nam\":\"Stephen Mande\",\"en_number_of_sisters\":\"3\",\"en_number_of_brother\":\"3\",\"en_favorite_subject\":\"Math\",\"en_favorite_activity\":\"Music\",\"en_public_comments\":\"Angel is a role model to her sisters and provides alot of counseling to them.\",\"en_private_comments\":\"She is at MBS with other children now and no longer staying with the grandmother as she used to during her studies at JICC.Angel now lives with her aunt in Masaka town.They were abandoned by their mother.she is a sister to Mirembe Grace and Mirembe Angel.11.22\",\"en_privates_notes\":\"Thank you for taking the responsibility to sponsor our child, Mirembe Angel. Her performance was very good last year in 2017. She has therefore been promoted to P.6 Class for 2018. She was 7th out of the 54 children in class.Mirembe is now in S2.11.22.She was promoted to S3.01.23\",\"en_student_id\":\"1082\",\"en_health_status\":\"Good\",\"en_student_grade\":\"S3\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"0781411978\\/ 0776341920\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"Epigastric pain with severe headache. Being managed for PUD and symptomatic treatment. 7.22\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "1082",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "S3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "YAHS",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Angel",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Princess",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Mirembe",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "F",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "02/07/2007",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "Good",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "Epigastric pain with severe headache. Being managed for PUD and symptomatic treatment. 7.22",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Norah Mirembe",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "Stephen Mande",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "0781411978/ 0776341920",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "Math",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "She is at MBS with other children now and no longer staying with the grandmother as she used to during her studies at JICC.Angel now lives with her aunt in Masaka town.They were abandoned by their mother.she is a sister to Mirembe Grace and Mirembe Angel.11.22",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "Music",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "Angel is a role model to her sisters and provides alot of counseling to them.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "Thank you for taking the responsibility to sponsor our child, Mirembe Angel. Her performance was very good last year in 2017. She has therefore been promoted to P.6 Class for 2018. She was 7th out of the 54 children in class.Mirembe is now in S2.11.22.She was promoted to S3.01.23",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "283",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47707,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"283\",\"en_first_name\":\"Angel\",\"en_second_name\":\"Princess\",\"en_last_name_1\":\"Mirembe\",\"en_gender\":\"F\",\"en_date_of_birth\":\"02\\/07\\/2007\",\"en_living_mother_nam\":\"Norah Mirembe\",\"en_living_father_nam\":\"Stephen Mande\",\"en_number_of_sisters\":\"3\",\"en_number_of_brother\":\"3\",\"en_favorite_subject\":\"Math\",\"en_favorite_activity\":\"Music\",\"en_public_comments\":\"Angel is a role model to her sisters and provides alot of counseling to them.\",\"en_private_comments\":\"She is at MBS with other children now and no longer staying with the grandmother as she used to during her studies at JICC.Angel now lives with her aunt in Masaka town.They were abandoned by their mother.she is a sister to Mirembe Grace and Mirembe Angel.11.22\",\"en_privates_notes\":\"Thank you for taking the responsibility to sponsor our child, Mirembe Angel. Her performance was very good last year in 2017. She has therefore been promoted to P.6 Class for 2018. She was 7th out of the 54 children in class.Mirembe is now in S2.11.22.She was promoted to S3.01.23\",\"en_student_id\":\"1082\",\"en_health_status\":\"Good\",\"en_student_grade\":\"S3\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"0781411978\\/ 0776341920\",\"en_school_attending\":\"YAHS\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"Epigastric pain with severe headache. Being managed for PUD and symptomatic treatment. 7.22\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47706,
    "profile": {
      "en_child_id": "396",
      "en_first_name": "Joan",
      "en_second_name": "",
      "en_last_name_1": "Nandago",
      "en_gender": "F",
      "en_date_of_birth": "03/04/2009",
      "en_living_mother_nam": "Christine Namulinde",
      "en_living_father_nam": "Frank Kasedwa (Late)",
      "en_number_of_sisters": "1",
      "en_number_of_brother": "2",
      "en_favorite_subject": "Mathematics",
      "en_favorite_activity": "Singing and debating",
      "en_public_comments": "She is a disciplined girl, quite and bright girl.She is obedient and committed to her studies.",
      "en_private_comments": "She comes from a very needy family , as she stays with her parents who cannot afford a living. She stays in Ssembabule distrct. Grandmother.\r\n\r\nHer mother stays in Kampala, Nansana.Joan now lives with her grandmother in kinoni Lwengo district.8.22\r\n\r\n0755286724",
      "en_privates_notes": "She was promoted to P3 class since she emerged the best in class. In 2018 she graduated to P4 see report.\r\n\r\nShe is looking forward to be promoted in P5 because her performance is impressive.\r\nShe was promoted to P5 Class in 2020 due to her excellent performance in 2019\r\n\r\nJoan is now in P6 at MBS.\r\nHer perfomance is amazing.8.22.Joan was promoted to P7.01.23.",
      "en_student_id": "2009-2120",
      "en_health_status": "Good",
      "en_student_grade": "P7",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "Namazzi Annet(grandmother)",
      "en_contact_phone_num": "755286724",
      "en_school_attending": "Masaka Baptist School",
      "en_sponsor_updates": "",
      "en_health_record": "",
      "id": 47706,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"396\",\"en_first_name\":\"Joan\",\"en_second_name\":\"\",\"en_last_name_1\":\"Nandago\",\"en_gender\":\"F\",\"en_date_of_birth\":\"03\\/04\\/2009\",\"en_living_mother_nam\":\"Christine Namulinde\",\"en_living_father_nam\":\"Frank Kasedwa (Late)\",\"en_number_of_sisters\":\"1\",\"en_number_of_brother\":\"2\",\"en_favorite_subject\":\"Mathematics\",\"en_favorite_activity\":\"Singing and debating\",\"en_public_comments\":\"She is a disciplined girl, quite and bright girl.She is obedient and committed to her studies.\",\"en_private_comments\":\"She comes from a very needy family , as she stays with her parents who cannot afford a living. She stays in Ssembabule distrct. Grandmother.\\r\\n\\r\\nHer mother stays in Kampala, Nansana.Joan now lives with her grandmother in kinoni Lwengo district.8.22\\r\\n\\r\\n0755286724\",\"en_privates_notes\":\"She was promoted to P3 class since she emerged the best in class. In 2018 she graduated to P4 see report.\\r\\n\\r\\nShe is looking forward to be promoted in P5 because her performance is impressive.\\r\\nShe was promoted to P5 Class in 2020 due to her excellent performance in 2019\\r\\n\\r\\nJoan is now in P6 at MBS.\\r\\nHer perfomance is amazing.8.22.Joan was promoted to P7.01.23.\",\"en_student_id\":\"2009-2120\",\"en_health_status\":\"Good\",\"en_student_grade\":\"P7\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"Namazzi Annet(grandmother)\",\"en_contact_phone_num\":\"755286724\",\"en_school_attending\":\"Masaka Baptist School\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "2009-2120",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "P7",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "Masaka Baptist School",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Joan",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Nandago",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "F",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "03/04/2009",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "Good",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Christine Namulinde",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "Frank Kasedwa (Late)",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "Namazzi Annet(grandmother)",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "755286724",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "1",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "2",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "Mathematics",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "She comes from a very needy family , as she stays with her parents who cannot afford a living. She stays in Ssembabule distrct. Grandmother.\r\n\r\nHer mother stays in Kampala, Nansana.Joan now lives with her grandmother in kinoni Lwengo district.8.22\r\n\r\n0755286724",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "Singing and debating",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "She is a disciplined girl, quite and bright girl.She is obedient and committed to her studies.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "She was promoted to P3 class since she emerged the best in class. In 2018 she graduated to P4 see report.\r\n\r\nShe is looking forward to be promoted in P5 because her performance is impressive.\r\nShe was promoted to P5 Class in 2020 due to her excellent performance in 2019\r\n\r\nJoan is now in P6 at MBS.\r\nHer perfomance is amazing.8.22.Joan was promoted to P7.01.23.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "396",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47706,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"396\",\"en_first_name\":\"Joan\",\"en_second_name\":\"\",\"en_last_name_1\":\"Nandago\",\"en_gender\":\"F\",\"en_date_of_birth\":\"03\\/04\\/2009\",\"en_living_mother_nam\":\"Christine Namulinde\",\"en_living_father_nam\":\"Frank Kasedwa (Late)\",\"en_number_of_sisters\":\"1\",\"en_number_of_brother\":\"2\",\"en_favorite_subject\":\"Mathematics\",\"en_favorite_activity\":\"Singing and debating\",\"en_public_comments\":\"She is a disciplined girl, quite and bright girl.She is obedient and committed to her studies.\",\"en_private_comments\":\"She comes from a very needy family , as she stays with her parents who cannot afford a living. She stays in Ssembabule distrct. Grandmother.\\r\\n\\r\\nHer mother stays in Kampala, Nansana.Joan now lives with her grandmother in kinoni Lwengo district.8.22\\r\\n\\r\\n0755286724\",\"en_privates_notes\":\"She was promoted to P3 class since she emerged the best in class. In 2018 she graduated to P4 see report.\\r\\n\\r\\nShe is looking forward to be promoted in P5 because her performance is impressive.\\r\\nShe was promoted to P5 Class in 2020 due to her excellent performance in 2019\\r\\n\\r\\nJoan is now in P6 at MBS.\\r\\nHer perfomance is amazing.8.22.Joan was promoted to P7.01.23.\",\"en_student_id\":\"2009-2120\",\"en_health_status\":\"Good\",\"en_student_grade\":\"P7\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"Namazzi Annet(grandmother)\",\"en_contact_phone_num\":\"755286724\",\"en_school_attending\":\"Masaka Baptist School\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47705,
    "profile": {
      "en_child_id": "103",
      "en_first_name": "Godwill",
      "en_second_name": "",
      "en_last_name_1": "Atuheire",
      "en_gender": "M",
      "en_date_of_birth": "0000-00-00",
      "en_living_mother_nam": "Kate kampaire (Late)",
      "en_living_father_nam": "Bayenda Benison",
      "en_number_of_sisters": "1",
      "en_number_of_brother": "3",
      "en_favorite_subject": "Biology and Chemistry",
      "en_favorite_activity": "Playing football",
      "en_public_comments": "Godwil is now studying at a University doing a diploma in  Clinical medicine.God will finished his clinical course and he will be graduating in November 2022.8.22.",
      "en_private_comments": "Godwill is well behaved and trustworthy.\r\nHe is 100% depending on our program.\r\n\r\nBy Peter.",
      "en_privates_notes": "Godwill is in his last semester at Kalungi school of nursing.\r\n\r\nGodwill finished a certificate Nursing and joined Kampala International University Ishaka.\r\n18.10.2019\r\nBy Peter.",
      "en_student_id": "1004",
      "en_health_status": "Good",
      "en_student_grade": "GRADUATED",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "",
      "en_contact_phone_num": "",
      "en_school_attending": "KIU University",
      "en_sponsor_updates": "",
      "en_health_record": "",
      "id": 47705,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"103\",\"en_first_name\":\"Godwill\",\"en_second_name\":\"\",\"en_last_name_1\":\"Atuheire\",\"en_gender\":\"M\",\"en_date_of_birth\":\"0000-00-00\",\"en_living_mother_nam\":\"Kate kampaire (Late)\",\"en_living_father_nam\":\"Bayenda Benison\",\"en_number_of_sisters\":\"1\",\"en_number_of_brother\":\"3\",\"en_favorite_subject\":\"Biology and Chemistry\",\"en_favorite_activity\":\"Playing football\",\"en_public_comments\":\"Godwil is now studying at a University doing a diploma in  Clinical medicine.God will finished his clinical course and he will be graduating in November 2022.8.22.\",\"en_private_comments\":\"Godwill is well behaved and trustworthy.\\r\\nHe is 100% depending on our program.\\r\\n\\r\\nBy Peter.\",\"en_privates_notes\":\"Godwill is in his last semester at Kalungi school of nursing.\\r\\n\\r\\nGodwill finished a certificate Nursing and joined Kampala International University Ishaka.\\r\\n18.10.2019\\r\\nBy Peter.\",\"en_student_id\":\"1004\",\"en_health_status\":\"Good\",\"en_student_grade\":\"GRADUATED\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"\",\"en_school_attending\":\"KIU University\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "1004",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "GRADUATED",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "KIU University",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Godwill",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Atuheire",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "M",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "0000-00-00",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "Good",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Kate kampaire (Late)",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "Bayenda Benison",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "1",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "Biology and Chemistry",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "Godwill is well behaved and trustworthy.\r\nHe is 100% depending on our program.\r\n\r\nBy Peter.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "Playing football",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "Godwil is now studying at a University doing a diploma in  Clinical medicine.God will finished his clinical course and he will be graduating in November 2022.8.22.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "Godwill is in his last semester at Kalungi school of nursing.\r\n\r\nGodwill finished a certificate Nursing and joined Kampala International University Ishaka.\r\n18.10.2019\r\nBy Peter.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "103",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47705,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"103\",\"en_first_name\":\"Godwill\",\"en_second_name\":\"\",\"en_last_name_1\":\"Atuheire\",\"en_gender\":\"M\",\"en_date_of_birth\":\"0000-00-00\",\"en_living_mother_nam\":\"Kate kampaire (Late)\",\"en_living_father_nam\":\"Bayenda Benison\",\"en_number_of_sisters\":\"1\",\"en_number_of_brother\":\"3\",\"en_favorite_subject\":\"Biology and Chemistry\",\"en_favorite_activity\":\"Playing football\",\"en_public_comments\":\"Godwil is now studying at a University doing a diploma in  Clinical medicine.God will finished his clinical course and he will be graduating in November 2022.8.22.\",\"en_private_comments\":\"Godwill is well behaved and trustworthy.\\r\\nHe is 100% depending on our program.\\r\\n\\r\\nBy Peter.\",\"en_privates_notes\":\"Godwill is in his last semester at Kalungi school of nursing.\\r\\n\\r\\nGodwill finished a certificate Nursing and joined Kampala International University Ishaka.\\r\\n18.10.2019\\r\\nBy Peter.\",\"en_student_id\":\"1004\",\"en_health_status\":\"Good\",\"en_student_grade\":\"GRADUATED\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"\",\"en_school_attending\":\"KIU University\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47704,
    "profile": {
      "en_child_id": "422",
      "en_first_name": "David",
      "en_second_name": "",
      "en_last_name_1": "Mumo",
      "en_gender": "M",
      "en_date_of_birth": "0000-00-00",
      "en_living_mother_nam": "Rachael Mwanzia",
      "en_living_father_nam": "Sammy Mwanzia (deceased)",
      "en_number_of_sisters": "0",
      "en_number_of_brother": "1",
      "en_favorite_subject": "English",
      "en_favorite_activity": "",
      "en_public_comments": "10 years old\r\nbrother is Jeremiah in P3",
      "en_private_comments": "birthdate is unknown",
      "en_privates_notes": "",
      "en_student_id": "2140",
      "en_health_status": "",
      "en_student_grade": "Left-no contact",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "",
      "en_contact_phone_num": "",
      "en_school_attending": "Masaka Baptist School",
      "en_sponsor_updates": "",
      "en_health_record": "",
      "id": 47704,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"422\",\"en_first_name\":\"David\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mumo\",\"en_gender\":\"M\",\"en_date_of_birth\":\"0000-00-00\",\"en_living_mother_nam\":\"Rachael Mwanzia\",\"en_living_father_nam\":\"Sammy Mwanzia (deceased)\",\"en_number_of_sisters\":\"0\",\"en_number_of_brother\":\"1\",\"en_favorite_subject\":\"English\",\"en_favorite_activity\":\"\",\"en_public_comments\":\"10 years old\\r\\nbrother is Jeremiah in P3\",\"en_private_comments\":\"birthdate is unknown\",\"en_privates_notes\":\"\",\"en_student_id\":\"2140\",\"en_health_status\":\"\",\"en_student_grade\":\"Left-no contact\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"\",\"en_school_attending\":\"Masaka Baptist School\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "2140",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "Left-no contact",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "Masaka Baptist School",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "David",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Mumo",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "M",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "0000-00-00",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Rachael Mwanzia",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "Sammy Mwanzia (deceased)",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "0",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "1",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "English",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "birthdate is unknown",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "10 years old\r\nbrother is Jeremiah in P3",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "422",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47704,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"422\",\"en_first_name\":\"David\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mumo\",\"en_gender\":\"M\",\"en_date_of_birth\":\"0000-00-00\",\"en_living_mother_nam\":\"Rachael Mwanzia\",\"en_living_father_nam\":\"Sammy Mwanzia (deceased)\",\"en_number_of_sisters\":\"0\",\"en_number_of_brother\":\"1\",\"en_favorite_subject\":\"English\",\"en_favorite_activity\":\"\",\"en_public_comments\":\"10 years old\\r\\nbrother is Jeremiah in P3\",\"en_private_comments\":\"birthdate is unknown\",\"en_privates_notes\":\"\",\"en_student_id\":\"2140\",\"en_health_status\":\"\",\"en_student_grade\":\"Left-no contact\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"\",\"en_school_attending\":\"Masaka Baptist School\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47703,
    "profile": {
      "en_child_id": "419",
      "en_first_name": "Jonathan",
      "en_second_name": "",
      "en_last_name_1": "Mwesigwa",
      "en_gender": "M",
      "en_date_of_birth": "05/05/2008",
      "en_living_mother_nam": "Rachael Kwagalakwe",
      "en_living_father_nam": "Juma Badru",
      "en_number_of_sisters": "2",
      "en_number_of_brother": "5",
      "en_favorite_subject": "Reading and Writing",
      "en_favorite_activity": "Soccer",
      "en_public_comments": "11 years old.",
      "en_private_comments": "Jonathan is studying well now and by God's grace is going to be a strong man and helpful at home. The mother stays in a temporary structure; in one room. It is used as a kitchen, a store and a bedroom as well all in one place.",
      "en_privates_notes": "Jonathan's performance is one of the best we have in our records this year 2018.\r\nHe was promoted to P3 Class for 2020.",
      "en_student_id": "2137-0000",
      "en_health_status": "His health is good.",
      "en_student_grade": "Left-no contact",
      "en_payment_participa": "Zero %",
      "en_home_town_or_vill": "",
      "en_guardian_name": "",
      "en_contact_phone_num": "",
      "en_school_attending": "Masaka Baptist School",
      "en_sponsor_updates": "",
      "en_health_record": "",
      "id": 47703,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"419\",\"en_first_name\":\"Jonathan\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mwesigwa\",\"en_gender\":\"M\",\"en_date_of_birth\":\"05\\/05\\/2008\",\"en_living_mother_nam\":\"Rachael Kwagalakwe\",\"en_living_father_nam\":\"Juma Badru\",\"en_number_of_sisters\":\"2\",\"en_number_of_brother\":\"5\",\"en_favorite_subject\":\"Reading and Writing\",\"en_favorite_activity\":\"Soccer\",\"en_public_comments\":\"11 years old.\",\"en_private_comments\":\"Jonathan is studying well now and by God's grace is going to be a strong man and helpful at home. The mother stays in a temporary structure; in one room. It is used as a kitchen, a store and a bedroom as well all in one place.\",\"en_privates_notes\":\"Jonathan's performance is one of the best we have in our records this year 2018.\\r\\nHe was promoted to P3 Class for 2020.\",\"en_student_id\":\"2137-0000\",\"en_health_status\":\"His health is good.\",\"en_student_grade\":\"Left-no contact\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"\",\"en_school_attending\":\"Masaka Baptist School\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6612,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_id",
        "field_label": "Student Id",
        "field_data": "2137-0000",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:15.000000Z",
        "updated_at": "2023-06-02T09:28:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6613,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_student_grade",
        "field_label": "Student Grade",
        "field_data": "Left-no contact",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:33.000000Z",
        "updated_at": "2023-06-02T09:28:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6614,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_school_attending",
        "field_label": "School Attending",
        "field_data": "Masaka Baptist School",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2023-06-02T09:28:55.000000Z",
        "updated_at": "2023-06-02T09:28:55.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6615,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Jonathan",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2023-06-02T09:29:08.000000Z",
        "updated_at": "2023-06-02T09:29:08.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6616,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 5,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:17.000000Z",
        "updated_at": "2023-06-02T09:30:17.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6617,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_last_name_1",
        "field_label": "Last Name 1",
        "field_data": "Mwesigwa",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 6,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:32.000000Z",
        "updated_at": "2023-06-02T09:30:32.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6618,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "M",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 7,
        "deleted_at": null,
        "created_at": "2023-06-02T09:30:47.000000Z",
        "updated_at": "2023-06-02T09:30:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6619,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_date_of_birth",
        "field_label": "Date Of Birth",
        "field_data": "05/05/2008",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:00.000000Z",
        "updated_at": "2023-06-02T09:31:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6620,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_status",
        "field_label": "Health Status",
        "field_data": "His health is good.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:24.000000Z",
        "updated_at": "2023-06-02T09:31:24.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6621,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_health_record",
        "field_label": "Health Record",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:35.000000Z",
        "updated_at": "2023-06-02T09:31:35.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6622,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_mother_nam",
        "field_label": "Living Mother Name",
        "field_data": "Rachael Kwagalakwe",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 11,
        "deleted_at": null,
        "created_at": "2023-06-02T09:31:51.000000Z",
        "updated_at": "2023-06-02T09:31:51.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6623,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_living_father_nam",
        "field_label": "Living Father Name",
        "field_data": "Juma Badru",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:07.000000Z",
        "updated_at": "2023-06-02T09:32:07.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6624,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_guardian_name",
        "field_label": "Guardian Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-06-02T09:32:53.000000Z",
        "updated_at": "2023-06-02T09:32:53.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6625,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_contact_phone_num",
        "field_label": "Contact Phone Number",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:15.000000Z",
        "updated_at": "2023-06-02T09:33:15.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6626,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_home_town_or_vill",
        "field_label": "Home town or village",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:31.000000Z",
        "updated_at": "2023-06-02T09:33:31.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6627,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_payment_participa",
        "field_label": "Payment participation",
        "field_data": "Zero %",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 16,
        "deleted_at": null,
        "created_at": "2023-06-02T09:33:47.000000Z",
        "updated_at": "2023-06-02T09:33:47.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6628,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_sisters",
        "field_label": "Number of sisters",
        "field_data": "2",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:01.000000Z",
        "updated_at": "2023-06-02T09:34:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6629,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_number_of_brother",
        "field_label": "Number of brothers",
        "field_data": "5",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 18,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:18.000000Z",
        "updated_at": "2023-06-02T09:34:18.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6630,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_subject",
        "field_label": "favorite subject",
        "field_data": "Reading and Writing",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 19,
        "deleted_at": null,
        "created_at": "2023-06-02T09:34:33.000000Z",
        "updated_at": "2023-06-02T09:34:33.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6631,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_private_comments",
        "field_label": "private comments",
        "field_data": "Jonathan is studying well now and by God's grace is going to be a strong man and helpful at home. The mother stays in a temporary structure; in one room. It is used as a kitchen, a store and a bedroom as well all in one place.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 20,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:03.000000Z",
        "updated_at": "2023-06-02T09:35:03.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6632,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_favorite_activity",
        "field_label": "favorite activity",
        "field_data": "Soccer",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 21,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:29.000000Z",
        "updated_at": "2023-06-02T09:35:29.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6633,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_public_comments",
        "field_label": "public comments",
        "field_data": "11 years old.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 22,
        "deleted_at": null,
        "created_at": "2023-06-02T09:35:41.000000Z",
        "updated_at": "2023-06-02T09:35:41.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6634,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_privates_notes",
        "field_label": "privates notes",
        "field_data": "Jonathan's performance is one of the best we have in our records this year 2018.\r\nHe was promoted to P3 Class for 2020.",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 23,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:01.000000Z",
        "updated_at": "2023-06-02T09:36:01.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6635,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_sponsor_updates",
        "field_label": "sponsor updates",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 24,
        "deleted_at": null,
        "created_at": "2023-06-02T09:36:12.000000Z",
        "updated_at": "2023-06-02T09:36:12.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6636,
        "client_id": 207,
        "hysform_id": 3043,
        "field_key": "en_child_id",
        "field_label": "Child Id",
        "field_data": "419",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 25,
        "deleted_at": null,
        "created_at": "2023-06-02T09:37:54.000000Z",
        "updated_at": "2023-06-02T09:37:54.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47703,
      "client_id": 207,
      "program_id": 3510,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-06-02",
      "json_fields": "{\"en_child_id\":\"419\",\"en_first_name\":\"Jonathan\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mwesigwa\",\"en_gender\":\"M\",\"en_date_of_birth\":\"05\\/05\\/2008\",\"en_living_mother_nam\":\"Rachael Kwagalakwe\",\"en_living_father_nam\":\"Juma Badru\",\"en_number_of_sisters\":\"2\",\"en_number_of_brother\":\"5\",\"en_favorite_subject\":\"Reading and Writing\",\"en_favorite_activity\":\"Soccer\",\"en_public_comments\":\"11 years old.\",\"en_private_comments\":\"Jonathan is studying well now and by God's grace is going to be a strong man and helpful at home. The mother stays in a temporary structure; in one room. It is used as a kitchen, a store and a bedroom as well all in one place.\",\"en_privates_notes\":\"Jonathan's performance is one of the best we have in our records this year 2018.\\r\\nHe was promoted to P3 Class for 2020.\",\"en_student_id\":\"2137-0000\",\"en_health_status\":\"His health is good.\",\"en_student_grade\":\"Left-no contact\",\"en_payment_participa\":\"Zero %\",\"en_home_town_or_vill\":\"\",\"en_guardian_name\":\"\",\"en_contact_phone_num\":\"\",\"en_school_attending\":\"Masaka Baptist School\",\"en_sponsor_updates\":\"\",\"en_health_record\":\"\"}",
      "deleted_at": null,
      "created_at": "2023-06-02T09:43:46.000000Z",
      "updated_at": "2023-06-02T09:43:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3510,
      "client_id": 207,
      "hysform_id": 3043,
      "donor_hysform_id": null,
      "setting_id": 410,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "us2uganda",
      "prefix": "usa",
      "counter": null,
      "lft": 8,
      "rgt": 9,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-06-02T09:24:28.000000Z",
      "updated_at": "2023-06-02T09:36:45.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": " ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47047,
    "profile": {
      "en_first_name": "Easther",
      "en_second_name": "Dhahabu",
      "en_last_name_1": "Julius",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "16/05/2019",
      "en_mental_disability": "Normal",
      "en_public_comments": "Easther is a young girl with a physical disability since birth that causes challenges walking and feeding. She currently lives with her parents in a mud hut with a tin roof. Her father works small jobs, but he is unable to support all of his daughter\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s additional needs. Sponsorship will enable Easther to receive medical care, physical therapy, and nutritional support. In addition, Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s counseling will provide Easther\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s family with an awareness of her rights as well as brighter opportunities for her future.",
      "en_private_comments": "",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "Normal",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "No",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "Since birth",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "Julius Charo Mturi",
      "en_fathers_occupatio": "short-term jobs (making charcoal, small carpentry projects, etc.)",
      "en_mothers_name": "",
      "en_mothers_occupatio": "",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "Unwilling few resources",
      "en_situation_explain": "",
      "en_house_location": "Watamu Ward",
      "en_distance_away": "",
      "en_house_state": "mud walls with tin roof (mabati)",
      "en_why_need_sponsors": "Family relies on casual jobs",
      "en_total_needed": "0",
      "en_other_needs": "",
      "en_languages": "",
      "en_religion": "Christian",
      "en_church_name": "The Loard of Sabaoth Church",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "small head",
      "en_school_name": "",
      "en_out_reach_app_cas": "5048b5d5-5f48-4182-910d-0d2ac20ff6d2",
      "en_disability_type": "Physical Challenges",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "649",
      "id": 47047,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Easther\",\"en_second_name\":\"Dhahabu\",\"en_last_name_1\":\"Julius\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"16\\/05\\/2019\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Easther is a young girl with a physical disability since birth that causes challenges walking and feeding. She currently lives with her parents in a mud hut with a tin roof. Her father works small jobs, but he is unable to support all of his daughter\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s additional needs. Sponsorship will enable Easther to receive medical care, physical therapy, and nutritional support. In addition, Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s counseling will provide Easther\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family with an awareness of her rights as well as brighter opportunities for her future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"Julius Charo Mturi\",\"en_fathers_occupatio\":\"short-term jobs (making charcoal, small carpentry projects, etc.)\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Watamu Ward\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with tin roof (mabati)\",\"en_why_need_sponsors\":\"Family relies on casual jobs\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"The Loard of Sabaoth Church\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"small head\",\"en_school_name\":\"\",\"en_out_reach_app_cas\":\"5048b5d5-5f48-4182-910d-0d2ac20ff6d2\",\"en_disability_type\":\"Physical Challenges\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"649\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Easther",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Dhahabu",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47047,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Easther\",\"en_second_name\":\"Dhahabu\",\"en_last_name_1\":\"Julius\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"16\\/05\\/2019\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Easther is a young girl with a physical disability since birth that causes challenges walking and feeding. She currently lives with her parents in a mud hut with a tin roof. Her father works small jobs, but he is unable to support all of his daughter\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s additional needs. Sponsorship will enable Easther to receive medical care, physical therapy, and nutritional support. In addition, Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s counseling will provide Easther\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family with an awareness of her rights as well as brighter opportunities for her future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"Julius Charo Mturi\",\"en_fathers_occupatio\":\"short-term jobs (making charcoal, small carpentry projects, etc.)\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Watamu Ward\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with tin roof (mabati)\",\"en_why_need_sponsors\":\"Family relies on casual jobs\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"The Loard of Sabaoth Church\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"small head\",\"en_school_name\":\"\",\"en_out_reach_app_cas\":\"5048b5d5-5f48-4182-910d-0d2ac20ff6d2\",\"en_disability_type\":\"Physical Challenges\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"649\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Easther Dhahabu",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47046,
    "profile": {
      "en_first_name": "Faith",
      "en_second_name": "Sidi",
      "en_last_name_1": "Kaka",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "24/06/2019",
      "en_mental_disability": "Moderate",
      "en_public_comments": "Faith is a young girl with intellectual and physical disabilities since birth. Her condition causes recurring seizures and challenges with speech. Currently, Faith lives with her mother in a mud hut with a thatched roof. Her mother works small jobs, but she is unable to provide for all of her child's needs in addition to full time care. Sponsorship will enable Faith to receive medication, physical therapy, and nutritional support. Additionally, Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s family and community counseling will provide Faith with a more supportive environment that recognizes her value and worth.",
      "en_private_comments": "",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "Normal",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "No",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "can say some words",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "Since birth",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "Rehema Kahindi Pande",
      "en_mothers_occupatio": "**Short_term_jobs (making charcoal, small carpentry projects, etc.)**",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "Unwilling few resources",
      "en_situation_explain": "The mother is a single mother who can not meet all the needs of her child as she\r\nrequires many doctor visits, uses medicine daily, and needs regular therapy. The mother is also unable to engage in any income generating activity due to the full time care she has for her\r\nchild.",
      "en_house_location": "Malindi Town Ward",
      "en_distance_away": "",
      "en_house_state": "mud walls with thatched roof (mkuti)",
      "en_why_need_sponsors": "",
      "en_total_needed": "0",
      "en_other_needs": "medicine, doctor's visits, physical therapy",
      "en_languages": "Swahili Giriama",
      "en_religion": "Christian",
      "en_church_name": "IFC Bondeni",
      "en_favorite_activity": "",
      "en_other_disabilitie": "Yes",
      "en_describe_disabili": "seizures and physical disability",
      "en_school_name": "Homebased",
      "en_out_reach_app_cas": "3126853d-1995-42eb-b464-c7156cb22125",
      "en_disability_type": "Intellectual Delays",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "648",
      "id": 47046,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Faith\",\"en_second_name\":\"Sidi\",\"en_last_name_1\":\"Kaka\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"24\\/06\\/2019\",\"en_mental_disability\":\"Moderate\",\"en_public_comments\":\"Faith is a young girl with intellectual and physical disabilities since birth. Her condition causes recurring seizures and challenges with speech. Currently, Faith lives with her mother in a mud hut with a thatched roof. Her mother works small jobs, but she is unable to provide for all of her child's needs in addition to full time care. Sponsorship will enable Faith to receive medication, physical therapy, and nutritional support. Additionally, Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family and community counseling will provide Faith with a more supportive environment that recognizes her value and worth.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"can say some words\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Rehema Kahindi Pande\",\"en_mothers_occupatio\":\"**Short_term_jobs (making charcoal, small carpentry projects, etc.)**\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"The mother is a single mother who can not meet all the needs of her child as she\\r\\nrequires many doctor visits, uses medicine daily, and needs regular therapy. The mother is also unable to engage in any income generating activity due to the full time care she has for her\\r\\nchild.\",\"en_house_location\":\"Malindi Town Ward\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"medicine, doctor's visits, physical therapy\",\"en_languages\":\"Swahili Giriama\",\"en_religion\":\"Christian\",\"en_church_name\":\"IFC Bondeni\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"Yes\",\"en_describe_disabili\":\"seizures and physical disability\",\"en_school_name\":\"Homebased\",\"en_out_reach_app_cas\":\"3126853d-1995-42eb-b464-c7156cb22125\",\"en_disability_type\":\"Intellectual Delays\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"648\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Faith",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Sidi",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47046,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Faith\",\"en_second_name\":\"Sidi\",\"en_last_name_1\":\"Kaka\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"24\\/06\\/2019\",\"en_mental_disability\":\"Moderate\",\"en_public_comments\":\"Faith is a young girl with intellectual and physical disabilities since birth. Her condition causes recurring seizures and challenges with speech. Currently, Faith lives with her mother in a mud hut with a thatched roof. Her mother works small jobs, but she is unable to provide for all of her child's needs in addition to full time care. Sponsorship will enable Faith to receive medication, physical therapy, and nutritional support. Additionally, Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family and community counseling will provide Faith with a more supportive environment that recognizes her value and worth.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"can say some words\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Rehema Kahindi Pande\",\"en_mothers_occupatio\":\"**Short_term_jobs (making charcoal, small carpentry projects, etc.)**\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"The mother is a single mother who can not meet all the needs of her child as she\\r\\nrequires many doctor visits, uses medicine daily, and needs regular therapy. The mother is also unable to engage in any income generating activity due to the full time care she has for her\\r\\nchild.\",\"en_house_location\":\"Malindi Town Ward\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"medicine, doctor's visits, physical therapy\",\"en_languages\":\"Swahili Giriama\",\"en_religion\":\"Christian\",\"en_church_name\":\"IFC Bondeni\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"Yes\",\"en_describe_disabili\":\"seizures and physical disability\",\"en_school_name\":\"Homebased\",\"en_out_reach_app_cas\":\"3126853d-1995-42eb-b464-c7156cb22125\",\"en_disability_type\":\"Intellectual Delays\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"648\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Faith Sidi",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47045,
    "profile": {
      "en_first_name": "Charity",
      "en_second_name": "Pendo",
      "en_last_name_1": "Sulubu",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "26/04/2017",
      "en_mental_disability": "none",
      "en_public_comments": "Charity is a young girl with epilepsy since birth. She currently lives with her parents and brother in a mud hut with a tin roof. Unfortunately, her parents do not earn enough to support all of her needs. Sponsorship would provide Charity with medication, physical therapy, nutritional support, and schooling. In addition, she and her family would receive counseling to learn about her rights and tools for promoting inclusion in her community.",
      "en_private_comments": "September 2, 2022\r\nCherry had a fever and developed sores.  She was admitted to Kemri hospital for about 21 days.  She died on June 2, 2022.",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "none",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "No",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "Since birth",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "Kangombe Menza Gona",
      "en_mothers_occupatio": "**Short_term_jobs (making charcoal, small carpentry projects, etc.)**",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "1",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "willing few resources",
      "en_situation_explain": "",
      "en_house_location": "Matsangoni",
      "en_distance_away": "",
      "en_house_state": "mud walls with tin roof",
      "en_why_need_sponsors": "Parents have no reliable source of income",
      "en_total_needed": "0",
      "en_other_needs": "medicine; physical therapy",
      "en_languages": "",
      "en_religion": "Christian",
      "en_church_name": "Jerusalem Worship Centre",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "Cannot feed, bathe, toilet, or move on her own",
      "en_school_name": "",
      "en_out_reach_app_cas": "5efbb890-16b4-4f4d-901e-370e6bda3094",
      "en_disability_type": "Epilepsy",
      "en_child_has_died": "TRUE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "647",
      "id": 47045,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Charity\",\"en_second_name\":\"Pendo\",\"en_last_name_1\":\"Sulubu\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"26\\/04\\/2017\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Charity is a young girl with epilepsy since birth. She currently lives with her parents and brother in a mud hut with a tin roof. Unfortunately, her parents do not earn enough to support all of her needs. Sponsorship would provide Charity with medication, physical therapy, nutritional support, and schooling. In addition, she and her family would receive counseling to learn about her rights and tools for promoting inclusion in her community.\",\"en_private_comments\":\"September 2, 2022\\r\\nCherry had a fever and developed sores.  She was admitted to Kemri hospital for about 21 days.  She died on June 2, 2022.\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Kangombe Menza Gona\",\"en_mothers_occupatio\":\"**Short_term_jobs (making charcoal, small carpentry projects, etc.)**\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"1\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Matsangoni\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with tin roof\",\"en_why_need_sponsors\":\"Parents have no reliable source of income\",\"en_total_needed\":\"0\",\"en_other_needs\":\"medicine; physical therapy\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"Jerusalem Worship Centre\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"Cannot feed, bathe, toilet, or move on her own\",\"en_school_name\":\"\",\"en_out_reach_app_cas\":\"5efbb890-16b4-4f4d-901e-370e6bda3094\",\"en_disability_type\":\"Epilepsy\",\"en_child_has_died\":\"TRUE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"647\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Charity",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Pendo",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47045,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Charity\",\"en_second_name\":\"Pendo\",\"en_last_name_1\":\"Sulubu\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"26\\/04\\/2017\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Charity is a young girl with epilepsy since birth. She currently lives with her parents and brother in a mud hut with a tin roof. Unfortunately, her parents do not earn enough to support all of her needs. Sponsorship would provide Charity with medication, physical therapy, nutritional support, and schooling. In addition, she and her family would receive counseling to learn about her rights and tools for promoting inclusion in her community.\",\"en_private_comments\":\"September 2, 2022\\r\\nCherry had a fever and developed sores.  She was admitted to Kemri hospital for about 21 days.  She died on June 2, 2022.\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Kangombe Menza Gona\",\"en_mothers_occupatio\":\"**Short_term_jobs (making charcoal, small carpentry projects, etc.)**\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"1\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Matsangoni\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with tin roof\",\"en_why_need_sponsors\":\"Parents have no reliable source of income\",\"en_total_needed\":\"0\",\"en_other_needs\":\"medicine; physical therapy\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"Jerusalem Worship Centre\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"Cannot feed, bathe, toilet, or move on her own\",\"en_school_name\":\"\",\"en_out_reach_app_cas\":\"5efbb890-16b4-4f4d-901e-370e6bda3094\",\"en_disability_type\":\"Epilepsy\",\"en_child_has_died\":\"TRUE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"647\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Charity Pendo",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47044,
    "profile": {
      "en_first_name": "Samuel",
      "en_second_name": "Ushindi",
      "en_last_name_1": "Sulubu",
      "en_last_name_2": "",
      "en_gender": "Male",
      "en_date_of_birth": "27/04/2018",
      "en_mental_disability": "none",
      "en_public_comments": "Samuel is a young boy with a physical disability since birth. He currently lives with his parents and sister in a mud hut with a tin roof. Unfortunately, his parents do not earn enough to support all of his needs. Samuel would benefit from sponsorship because it would allow him to receive medical care, physical therapy, assistive devices, nutritional support, and schooling once he is an appropriate age. Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s family and community counseling would also help ensure that he has a more inclusive future.",
      "en_private_comments": "",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "none",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "No",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "can say some words",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "Since birth",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "Kangombe Menza Gona",
      "en_mothers_occupatio": "**Short_term_jobs (making charcoal, small carpentry projects, etc.)**",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "1",
      "en_willingness_of_pa": "willing few resources",
      "en_situation_explain": "",
      "en_house_location": "Matsangoni Kiringi",
      "en_distance_away": "",
      "en_house_state": "mud walls with tin roof",
      "en_why_need_sponsors": "Parents have no reliable source of income",
      "en_total_needed": "0",
      "en_other_needs": "physical therapy; assistive devices",
      "en_languages": "",
      "en_religion": "Christian",
      "en_church_name": "Jerusalem Worship Centre",
      "en_favorite_activity": "",
      "en_other_disabilitie": "Yes",
      "en_describe_disabili": "Cannot feed, bathe, toilet, or move around on his own",
      "en_school_name": "",
      "en_out_reach_app_cas": "8b20a953-80d9-468d-9925-dc769a407be4",
      "en_disability_type": "Not specified",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "646",
      "id": 47044,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Samuel\",\"en_second_name\":\"Ushindi\",\"en_last_name_1\":\"Sulubu\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"27\\/04\\/2018\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Samuel is a young boy with a physical disability since birth. He currently lives with his parents and sister in a mud hut with a tin roof. Unfortunately, his parents do not earn enough to support all of his needs. Samuel would benefit from sponsorship because it would allow him to receive medical care, physical therapy, assistive devices, nutritional support, and schooling once he is an appropriate age. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family and community counseling would also help ensure that he has a more inclusive future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"can say some words\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Kangombe Menza Gona\",\"en_mothers_occupatio\":\"**Short_term_jobs (making charcoal, small carpentry projects, etc.)**\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"1\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Matsangoni Kiringi\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with tin roof\",\"en_why_need_sponsors\":\"Parents have no reliable source of income\",\"en_total_needed\":\"0\",\"en_other_needs\":\"physical therapy; assistive devices\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"Jerusalem Worship Centre\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"Yes\",\"en_describe_disabili\":\"Cannot feed, bathe, toilet, or move around on his own\",\"en_school_name\":\"\",\"en_out_reach_app_cas\":\"8b20a953-80d9-468d-9925-dc769a407be4\",\"en_disability_type\":\"Not specified\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"646\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Samuel",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Ushindi",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47044,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Samuel\",\"en_second_name\":\"Ushindi\",\"en_last_name_1\":\"Sulubu\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"27\\/04\\/2018\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Samuel is a young boy with a physical disability since birth. He currently lives with his parents and sister in a mud hut with a tin roof. Unfortunately, his parents do not earn enough to support all of his needs. Samuel would benefit from sponsorship because it would allow him to receive medical care, physical therapy, assistive devices, nutritional support, and schooling once he is an appropriate age. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family and community counseling would also help ensure that he has a more inclusive future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"can say some words\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Kangombe Menza Gona\",\"en_mothers_occupatio\":\"**Short_term_jobs (making charcoal, small carpentry projects, etc.)**\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"1\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Matsangoni Kiringi\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with tin roof\",\"en_why_need_sponsors\":\"Parents have no reliable source of income\",\"en_total_needed\":\"0\",\"en_other_needs\":\"physical therapy; assistive devices\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"Jerusalem Worship Centre\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"Yes\",\"en_describe_disabili\":\"Cannot feed, bathe, toilet, or move around on his own\",\"en_school_name\":\"\",\"en_out_reach_app_cas\":\"8b20a953-80d9-468d-9925-dc769a407be4\",\"en_disability_type\":\"Not specified\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"646\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Samuel Ushindi",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47043,
    "profile": {
      "en_first_name": "Daniel",
      "en_second_name": "",
      "en_last_name_1": "Mwambire",
      "en_last_name_2": "Emmanuel",
      "en_gender": "Male",
      "en_date_of_birth": "06/08/2015",
      "en_mental_disability": "none",
      "en_public_comments": "Daniel is a young boy with a physical disability since birth. He currently lives with his mother and father in a mud hut with a thatched roof. Unfortunately, his father does not earn enough to provide for the family\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s daily needs as well as Daniel\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s school fees. Sponsorship will enable Daniel to attend school and receive physical therapy, assistive devices, and nutritional support. He will also benefit from Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s counseling. This will provide him with greater inclusion in his community and more opportunities for a successful future.",
      "en_private_comments": "",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "none",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "No",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "Since birth",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "Margaret Kaingu Fande",
      "en_mothers_occupatio": "**Short_term_jobs (making charcoal, small carpentry projects, etc.)**",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "willing few resources",
      "en_situation_explain": "The mother took the initiative to go for assessment and receive school placement at Marafa Special.The father is the only provider for the family\r\nas the mother stays with the child all the time.The mother knows the rights of her child.",
      "en_house_location": "Kwa kapapayu",
      "en_distance_away": "",
      "en_house_state": "mud walls with thatched roof (mkuti)",
      "en_why_need_sponsors": "The father is the only provider for the family and cannot afford school fees.",
      "en_total_needed": "0",
      "en_other_needs": "physical therapy; assistive devices",
      "en_languages": "",
      "en_religion": "Christian",
      "en_church_name": "Family Altar",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "Cannot feed, bathe, toilet or move on his own.",
      "en_school_name": "Marafa Special School",
      "en_out_reach_app_cas": "87aa22f8-5b73-41ab-80e2-2b40afedaf02",
      "en_disability_type": "Not specified",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "645",
      "id": 47043,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Daniel\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mwambire\",\"en_last_name_2\":\"Emmanuel\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"06\\/08\\/2015\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Daniel is a young boy with a physical disability since birth. He currently lives with his mother and father in a mud hut with a thatched roof. Unfortunately, his father does not earn enough to provide for the family\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s daily needs as well as Daniel\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school fees. Sponsorship will enable Daniel to attend school and receive physical therapy, assistive devices, and nutritional support. He will also benefit from Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s counseling. This will provide him with greater inclusion in his community and more opportunities for a successful future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Margaret Kaingu Fande\",\"en_mothers_occupatio\":\"**Short_term_jobs (making charcoal, small carpentry projects, etc.)**\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"The mother took the initiative to go for assessment and receive school placement at Marafa Special.The father is the only provider for the family\\r\\nas the mother stays with the child all the time.The mother knows the rights of her child.\",\"en_house_location\":\"Kwa kapapayu\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"The father is the only provider for the family and cannot afford school fees.\",\"en_total_needed\":\"0\",\"en_other_needs\":\"physical therapy; assistive devices\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"Family Altar\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"Cannot feed, bathe, toilet or move on his own.\",\"en_school_name\":\"Marafa Special School\",\"en_out_reach_app_cas\":\"87aa22f8-5b73-41ab-80e2-2b40afedaf02\",\"en_disability_type\":\"Not specified\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"645\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Daniel",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47043,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Daniel\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mwambire\",\"en_last_name_2\":\"Emmanuel\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"06\\/08\\/2015\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Daniel is a young boy with a physical disability since birth. He currently lives with his mother and father in a mud hut with a thatched roof. Unfortunately, his father does not earn enough to provide for the family\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s daily needs as well as Daniel\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school fees. Sponsorship will enable Daniel to attend school and receive physical therapy, assistive devices, and nutritional support. He will also benefit from Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s counseling. This will provide him with greater inclusion in his community and more opportunities for a successful future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Since birth\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Margaret Kaingu Fande\",\"en_mothers_occupatio\":\"**Short_term_jobs (making charcoal, small carpentry projects, etc.)**\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"The mother took the initiative to go for assessment and receive school placement at Marafa Special.The father is the only provider for the family\\r\\nas the mother stays with the child all the time.The mother knows the rights of her child.\",\"en_house_location\":\"Kwa kapapayu\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"The father is the only provider for the family and cannot afford school fees.\",\"en_total_needed\":\"0\",\"en_other_needs\":\"physical therapy; assistive devices\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"Family Altar\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"Cannot feed, bathe, toilet or move on his own.\",\"en_school_name\":\"Marafa Special School\",\"en_out_reach_app_cas\":\"87aa22f8-5b73-41ab-80e2-2b40afedaf02\",\"en_disability_type\":\"Not specified\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"645\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Daniel ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47042,
    "profile": {
      "en_first_name": "Esther",
      "en_second_name": "",
      "en_last_name_1": "Mchombo",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "15/06/2010",
      "en_mental_disability": "Normal",
      "en_public_comments": "Esther is a young woman whose disability affects her right arm and leg as well as her intellectual functioning. She currently lives with her mother and two siblings in a mud hut with a thatched roof. Unfortunately, her mother does not earn enough income to support the family\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s daily needs as well as Esther\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s school fees. Sponsorship will enable Esther to enroll in a school where she will learn from special education teachers and receive weekly physical therapy and counseling while experiencing the joy of living in community with many friends.",
      "en_private_comments": "February 3, 2023\r\nEsther is currently a 4th grader at Gede Special School where she is doing well.  She is able to write and draw and loves art projects.  She rarely misses school and her grades are improving as a result.\r\n\r\nEsther is friendly, kind, and helpful to others.   She has many friends with whom she enjoys spending time.   She is a member of the Wasihana wote Wasome Club.  She enjoys watching television, singing, dancing, playing sports, and doing art projects. She recently competed in the county games in track and field events.\r\n\r\nEsther and her family have been counselled by our staff as well as a teacher at the school.  As a result, Esther now feels more confident making friends.  \r\n\r\nHer family earn a living with small businesses.  The drought in the area and pandemic restrictions have made it difficult.  They have barely enough to provide for their basic needs.",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "Normal",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "Sickness",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "Phedis Dhahabu Jefa",
      "en_mothers_occupatio": "Short_term_jobs (making charcoal, small carpentry projects, etc.)",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "Unwilling few resources",
      "en_situation_explain": "The mother is a single mother who recently secure a job as a casual labourer with EPZ, however, the salary she receives can nor sustain the boarding fees of a child and the basic needs of all her 3 children",
      "en_house_location": "Matsangoni Ward",
      "en_distance_away": "",
      "en_house_state": "Mud walls with thatched roof (mkuti)",
      "en_why_need_sponsors": "School fees",
      "en_total_needed": "0",
      "en_other_needs": "",
      "en_languages": "",
      "en_religion": "",
      "en_church_name": "",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Gede Special School",
      "en_out_reach_app_cas": "e698a27eddf946cbbb6c78aa251be5d3",
      "en_disability_type": "Limb Deformity or Loss or Reduction",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "644",
      "id": 47042,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Esther\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mchombo\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"15\\/06\\/2010\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Esther is a young woman whose disability affects her right arm and leg as well as her intellectual functioning. She currently lives with her mother and two siblings in a mud hut with a thatched roof. Unfortunately, her mother does not earn enough income to support the family\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s daily needs as well as Esther\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school fees. Sponsorship will enable Esther to enroll in a school where she will learn from special education teachers and receive weekly physical therapy and counseling while experiencing the joy of living in community with many friends.\",\"en_private_comments\":\"February 3, 2023\\r\\nEsther is currently a 4th grader at Gede Special School where she is doing well.  She is able to write and draw and loves art projects.  She rarely misses school and her grades are improving as a result.\\r\\n\\r\\nEsther is friendly, kind, and helpful to others.   She has many friends with whom she enjoys spending time.   She is a member of the Wasihana wote Wasome Club.  She enjoys watching television, singing, dancing, playing sports, and doing art projects. She recently competed in the county games in track and field events.\\r\\n\\r\\nEsther and her family have been counselled by our staff as well as a teacher at the school.  As a result, Esther now feels more confident making friends.  \\r\\n\\r\\nHer family earn a living with small businesses.  The drought in the area and pandemic restrictions have made it difficult.  They have barely enough to provide for their basic needs.\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Sickness\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Phedis Dhahabu Jefa\",\"en_mothers_occupatio\":\"Short_term_jobs (making charcoal, small carpentry projects, etc.)\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"The mother is a single mother who recently secure a job as a casual labourer with EPZ, however, the salary she receives can nor sustain the boarding fees of a child and the basic needs of all her 3 children\",\"en_house_location\":\"Matsangoni Ward\",\"en_distance_away\":\"\",\"en_house_state\":\"Mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"School fees\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Special School\",\"en_out_reach_app_cas\":\"e698a27eddf946cbbb6c78aa251be5d3\",\"en_disability_type\":\"Limb Deformity or Loss or Reduction\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"644\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Esther",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47042,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Esther\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mchombo\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"15\\/06\\/2010\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Esther is a young woman whose disability affects her right arm and leg as well as her intellectual functioning. She currently lives with her mother and two siblings in a mud hut with a thatched roof. Unfortunately, her mother does not earn enough income to support the family\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s daily needs as well as Esther\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school fees. Sponsorship will enable Esther to enroll in a school where she will learn from special education teachers and receive weekly physical therapy and counseling while experiencing the joy of living in community with many friends.\",\"en_private_comments\":\"February 3, 2023\\r\\nEsther is currently a 4th grader at Gede Special School where she is doing well.  She is able to write and draw and loves art projects.  She rarely misses school and her grades are improving as a result.\\r\\n\\r\\nEsther is friendly, kind, and helpful to others.   She has many friends with whom she enjoys spending time.   She is a member of the Wasihana wote Wasome Club.  She enjoys watching television, singing, dancing, playing sports, and doing art projects. She recently competed in the county games in track and field events.\\r\\n\\r\\nEsther and her family have been counselled by our staff as well as a teacher at the school.  As a result, Esther now feels more confident making friends.  \\r\\n\\r\\nHer family earn a living with small businesses.  The drought in the area and pandemic restrictions have made it difficult.  They have barely enough to provide for their basic needs.\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Sickness\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Phedis Dhahabu Jefa\",\"en_mothers_occupatio\":\"Short_term_jobs (making charcoal, small carpentry projects, etc.)\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"The mother is a single mother who recently secure a job as a casual labourer with EPZ, however, the salary she receives can nor sustain the boarding fees of a child and the basic needs of all her 3 children\",\"en_house_location\":\"Matsangoni Ward\",\"en_distance_away\":\"\",\"en_house_state\":\"Mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"School fees\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Special School\",\"en_out_reach_app_cas\":\"e698a27eddf946cbbb6c78aa251be5d3\",\"en_disability_type\":\"Limb Deformity or Loss or Reduction\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"644\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Esther ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47041,
    "profile": {
      "en_first_name": "Lewis",
      "en_second_name": "Chirimo",
      "en_last_name_1": "Khamis",
      "en_last_name_2": "",
      "en_gender": "Male",
      "en_date_of_birth": "10/03/2020",
      "en_mental_disability": "Mild",
      "en_public_comments": "Lewis is a young boy who loves music and playing with his toys. A recent Yellow Fever infection caused him to develop a disability that makes it difficult for him to walk and speak. Currently, he lives with his parents in a mud hut with a thatched roof. His father is unable to earn enough income to support his family\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s daily needs as well as Lewis\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2 health expenses. Sponsorship will enable Lewis to receive physical therapy, assistive devices, and an education once he is of school age. Kupenda will also provide Lewis with food and counseling support to help him lead the healthiest life possible.",
      "en_private_comments": "",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "Normal",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "No",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "no speech",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "sickness",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "Lives with both parents",
      "en_father_name": "",
      "en_fathers_occupatio": "Casual Laborer",
      "en_mothers_name": "Jumwa Kuzungu Salim",
      "en_mothers_occupatio": "",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "Unwilling few resources",
      "en_situation_explain": "Father does not earn enough to sustain child's needs",
      "en_house_location": "Msabaha",
      "en_distance_away": "",
      "en_house_state": "mud walls with thatched roof (mkuti)",
      "en_why_need_sponsors": "Parents cannot afford to support his therapy, assistive device, and future education needs",
      "en_total_needed": "0",
      "en_other_needs": "therapy; assistive device; education once of school age",
      "en_languages": "",
      "en_religion": "Christian",
      "en_church_name": "Light of God Msabaha",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "Intellectual and physical (difficulty walking/unable to walk, difficulty speaking/unable to speak)",
      "en_school_name": "Homebased",
      "en_out_reach_app_cas": "d4cc4c30-90e3-4629-ac01-2ab52022541a",
      "en_disability_type": "Physical Challenges",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "643",
      "id": 47041,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Lewis\",\"en_second_name\":\"Chirimo\",\"en_last_name_1\":\"Khamis\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"10\\/03\\/2020\",\"en_mental_disability\":\"Mild\",\"en_public_comments\":\"Lewis is a young boy who loves music and playing with his toys. A recent Yellow Fever infection caused him to develop a disability that makes it difficult for him to walk and speak. Currently, he lives with his parents in a mud hut with a thatched roof. His father is unable to earn enough income to support his family\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s daily needs as well as Lewis\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2 health expenses. Sponsorship will enable Lewis to receive physical therapy, assistive devices, and an education once he is of school age. Kupenda will also provide Lewis with food and counseling support to help him lead the healthiest life possible.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"no speech\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"sickness\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"Lives with both parents\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"Casual Laborer\",\"en_mothers_name\":\"Jumwa Kuzungu Salim\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"Father does not earn enough to sustain child's needs\",\"en_house_location\":\"Msabaha\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"Parents cannot afford to support his therapy, assistive device, and future education needs\",\"en_total_needed\":\"0\",\"en_other_needs\":\"therapy; assistive device; education once of school age\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"Light of God Msabaha\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"Intellectual and physical (difficulty walking\\/unable to walk, difficulty speaking\\/unable to speak)\",\"en_school_name\":\"Homebased\",\"en_out_reach_app_cas\":\"d4cc4c30-90e3-4629-ac01-2ab52022541a\",\"en_disability_type\":\"Physical Challenges\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"643\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Lewis",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Chirimo",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47041,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Lewis\",\"en_second_name\":\"Chirimo\",\"en_last_name_1\":\"Khamis\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"10\\/03\\/2020\",\"en_mental_disability\":\"Mild\",\"en_public_comments\":\"Lewis is a young boy who loves music and playing with his toys. A recent Yellow Fever infection caused him to develop a disability that makes it difficult for him to walk and speak. Currently, he lives with his parents in a mud hut with a thatched roof. His father is unable to earn enough income to support his family\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s daily needs as well as Lewis\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2 health expenses. Sponsorship will enable Lewis to receive physical therapy, assistive devices, and an education once he is of school age. Kupenda will also provide Lewis with food and counseling support to help him lead the healthiest life possible.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"No\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"no speech\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"sickness\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"Lives with both parents\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"Casual Laborer\",\"en_mothers_name\":\"Jumwa Kuzungu Salim\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"Father does not earn enough to sustain child's needs\",\"en_house_location\":\"Msabaha\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"Parents cannot afford to support his therapy, assistive device, and future education needs\",\"en_total_needed\":\"0\",\"en_other_needs\":\"therapy; assistive device; education once of school age\",\"en_languages\":\"\",\"en_religion\":\"Christian\",\"en_church_name\":\"Light of God Msabaha\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"Intellectual and physical (difficulty walking\\/unable to walk, difficulty speaking\\/unable to speak)\",\"en_school_name\":\"Homebased\",\"en_out_reach_app_cas\":\"d4cc4c30-90e3-4629-ac01-2ab52022541a\",\"en_disability_type\":\"Physical Challenges\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"643\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Lewis Chirimo",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47040,
    "profile": {
      "en_first_name": "Hezron",
      "en_second_name": "Kenga",
      "en_last_name_1": "Katengo",
      "en_last_name_2": "",
      "en_gender": "Male",
      "en_date_of_birth": "16/12/2005",
      "en_mental_disability": "Normal",
      "en_public_comments": "Hezron is a young man who loves animals. He has a disability that affects his mental functioning. His father works small jobs to support his wife and six children, but his income is not enough to cover the costs of the additional care that Hezron needs. The family currently lives in a mud hut with a tin roof. Sponsorship will enable Hezron to attend a school where he will receive an education, support from special education teachers, and three meals each day. He will also benefit from Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s counseling and family support which will provide him with opportunities for a brighter future.",
      "en_private_comments": "",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "Normal",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "Unknown",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "Claris Sidi Kenga Mtinda",
      "en_mothers_occupatio": "Short_term_jobs (making charcoal, small carpentry projects, etc.)",
      "en_guardians_name": "Sidi katengo",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "Grandmother",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "Unwilling few resources",
      "en_situation_explain": "",
      "en_house_location": "Dungicha",
      "en_distance_away": "",
      "en_house_state": "Mud walls with tin roof (mabati)",
      "en_why_need_sponsors": "School fees",
      "en_total_needed": "0",
      "en_other_needs": "",
      "en_languages": "Giriama",
      "en_religion": "Christian",
      "en_church_name": "Neema Church",
      "en_favorite_activity": "",
      "en_other_disabilitie": "Yes",
      "en_describe_disabili": "Mentally handicapped",
      "en_school_name": "Homebased",
      "en_out_reach_app_cas": "b6020b64-5448-4783-be73-7b2e6ea4ab94",
      "en_disability_type": "Intellectual Delays",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "642",
      "id": 47040,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Hezron\",\"en_second_name\":\"Kenga\",\"en_last_name_1\":\"Katengo\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"16\\/12\\/2005\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Hezron is a young man who loves animals. He has a disability that affects his mental functioning. His father works small jobs to support his wife and six children, but his income is not enough to cover the costs of the additional care that Hezron needs. The family currently lives in a mud hut with a tin roof. Sponsorship will enable Hezron to attend a school where he will receive an education, support from special education teachers, and three meals each day. He will also benefit from Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s counseling and family support which will provide him with opportunities for a brighter future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Unknown\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Claris Sidi Kenga Mtinda\",\"en_mothers_occupatio\":\"Short_term_jobs (making charcoal, small carpentry projects, etc.)\",\"en_guardians_name\":\"Sidi katengo\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"Grandmother\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Dungicha\",\"en_distance_away\":\"\",\"en_house_state\":\"Mud walls with tin roof (mabati)\",\"en_why_need_sponsors\":\"School fees\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"Giriama\",\"en_religion\":\"Christian\",\"en_church_name\":\"Neema Church\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"Yes\",\"en_describe_disabili\":\"Mentally handicapped\",\"en_school_name\":\"Homebased\",\"en_out_reach_app_cas\":\"b6020b64-5448-4783-be73-7b2e6ea4ab94\",\"en_disability_type\":\"Intellectual Delays\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"642\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Hezron",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Kenga",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47040,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Hezron\",\"en_second_name\":\"Kenga\",\"en_last_name_1\":\"Katengo\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"16\\/12\\/2005\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Hezron is a young man who loves animals. He has a disability that affects his mental functioning. His father works small jobs to support his wife and six children, but his income is not enough to cover the costs of the additional care that Hezron needs. The family currently lives in a mud hut with a tin roof. Sponsorship will enable Hezron to attend a school where he will receive an education, support from special education teachers, and three meals each day. He will also benefit from Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s counseling and family support which will provide him with opportunities for a brighter future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Unknown\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Claris Sidi Kenga Mtinda\",\"en_mothers_occupatio\":\"Short_term_jobs (making charcoal, small carpentry projects, etc.)\",\"en_guardians_name\":\"Sidi katengo\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"Grandmother\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Dungicha\",\"en_distance_away\":\"\",\"en_house_state\":\"Mud walls with tin roof (mabati)\",\"en_why_need_sponsors\":\"School fees\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"Giriama\",\"en_religion\":\"Christian\",\"en_church_name\":\"Neema Church\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"Yes\",\"en_describe_disabili\":\"Mentally handicapped\",\"en_school_name\":\"Homebased\",\"en_out_reach_app_cas\":\"b6020b64-5448-4783-be73-7b2e6ea4ab94\",\"en_disability_type\":\"Intellectual Delays\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"642\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Hezron Kenga",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47039,
    "profile": {
      "en_first_name": "Mary",
      "en_second_name": "Dama",
      "en_last_name_1": "Baya",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "04/12/2012",
      "en_mental_disability": "none",
      "en_public_comments": "Mary is a young girl who developed a hearing impairment after a childhood illness. She currently lives with her parents and four siblings in a mud hut with a thatched roof. Although her mother makes a living selling cooked potatoes, she is unable to earn enough to support her daughter\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s school expenses. Sponsorship will enable Mary to attend school where she will participate in classes with sign language instruction and receive three meals each day. She will also benefit from Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s counseling and family support which will provide her with opportunities for a brighter future.",
      "en_private_comments": "",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "none",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "Sickness",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "Jane Sikubali Kalume",
      "en_mothers_occupatio": "Short_term_jobs (making charcoal, small carpentry projects, etc.)",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "unwilling few resources",
      "en_situation_explain": "",
      "en_house_location": "Matsangon Ward",
      "en_distance_away": "",
      "en_house_state": "Mud walls with thatched roof (mkuti)",
      "en_why_need_sponsors": "School fees",
      "en_total_needed": "0",
      "en_other_needs": "",
      "en_languages": "Sign Language",
      "en_religion": "Christian",
      "en_church_name": "Bethlehem Matsanjeni",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "",
      "en_out_reach_app_cas": "59d3fc0c-5f89-4dfb-b846-462036efde47",
      "en_disability_type": "Hearing Impairment",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "641",
      "id": 47039,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Mary\",\"en_second_name\":\"Dama\",\"en_last_name_1\":\"Baya\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"04\\/12\\/2012\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Mary is a young girl who developed a hearing impairment after a childhood illness. She currently lives with her parents and four siblings in a mud hut with a thatched roof. Although her mother makes a living selling cooked potatoes, she is unable to earn enough to support her daughter\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school expenses. Sponsorship will enable Mary to attend school where she will participate in classes with sign language instruction and receive three meals each day. She will also benefit from Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s counseling and family support which will provide her with opportunities for a brighter future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Sickness\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Jane Sikubali Kalume\",\"en_mothers_occupatio\":\"Short_term_jobs (making charcoal, small carpentry projects, etc.)\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Matsangon Ward\",\"en_distance_away\":\"\",\"en_house_state\":\"Mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"School fees\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"Sign Language\",\"en_religion\":\"Christian\",\"en_church_name\":\"Bethlehem Matsanjeni\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"\",\"en_out_reach_app_cas\":\"59d3fc0c-5f89-4dfb-b846-462036efde47\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"641\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Mary",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Dama",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47039,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Mary\",\"en_second_name\":\"Dama\",\"en_last_name_1\":\"Baya\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"04\\/12\\/2012\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Mary is a young girl who developed a hearing impairment after a childhood illness. She currently lives with her parents and four siblings in a mud hut with a thatched roof. Although her mother makes a living selling cooked potatoes, she is unable to earn enough to support her daughter\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school expenses. Sponsorship will enable Mary to attend school where she will participate in classes with sign language instruction and receive three meals each day. She will also benefit from Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s counseling and family support which will provide her with opportunities for a brighter future.\",\"en_private_comments\":\"\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"Sickness\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"Jane Sikubali Kalume\",\"en_mothers_occupatio\":\"Short_term_jobs (making charcoal, small carpentry projects, etc.)\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Matsangon Ward\",\"en_distance_away\":\"\",\"en_house_state\":\"Mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"School fees\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"Sign Language\",\"en_religion\":\"Christian\",\"en_church_name\":\"Bethlehem Matsanjeni\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"\",\"en_out_reach_app_cas\":\"59d3fc0c-5f89-4dfb-b846-462036efde47\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"641\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:47.000000Z",
      "updated_at": "2023-05-10T04:38:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Mary Dama",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47038,
    "profile": {
      "en_first_name": "Juliana",
      "en_second_name": "Neema",
      "en_last_name_1": "Rodgers",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "06/12/2006",
      "en_mental_disability": "Normal",
      "en_public_comments": "Juliana is a young woman with a physical disability due to an illness. Since she is an orphan, she lives with her aunt in a mud hut with a thatched roof. While her aunt works as a farmer, she is unable to support her niece\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s school fees. Sponsorship will enable Juliana to receive physical therapy, an assistive device, and an education. She will also benefit from three meals a day, counseling about her rights, as well as other inclusive support she may need.",
      "en_private_comments": "March 21, 2023\r\nJuliana is a 1st grader at Gede Special School.  She received average scores on her exams.  Her assessment scores are improving as she attends school more regularly.  She has an IEP (Individualized Learning Plan).      She is meeting some of the goals. She likes to read storybooks.\r\n\r\nJuliana can walk independently.  She can grasp objects of all sizes and shapes which means she can write and draw.  She attends therapy twice a week.  Otherwise, she has been healthy this past year.\r\n\r\nJuliana is friendly, kind, and helpful to others.  She interacts with others very well.  She likes to watch television, play board games, talk with friends, play team sports, play with toys, sing, art, and dance.\r\n\r\nIn the past year the family has faced challenges earning an income.  Her caregiver earned very little to provide for her family.  Fortunately, Juliana has her needs met at school.",
      "en_birth_certificate": "",
      "en_sponsor_documents": "",
      "en_level_hearing": "Normal",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_cause_of_disabili": "sickness",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "Orphan; lives with aunt",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "",
      "en_mothers_occupatio": "",
      "en_guardians_name": "Elizabeth Chizi Kalu",
      "en_guardians_occupat": "Peasant Farmer",
      "en_guardians_relatio": "Aunt",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "Unwilling few resources",
      "en_situation_explain": "",
      "en_house_location": "Kwa Shume",
      "en_distance_away": "",
      "en_house_state": "mud walls with thatched roof (mkuti)",
      "en_why_need_sponsors": "Physical disability; aunt cannot pay boarding fees",
      "en_total_needed": "0",
      "en_other_needs": "school fees; assistive device",
      "en_languages": "English, Swahili, Giriama",
      "en_religion": "Christian",
      "en_church_name": "Kizingo PEFIC Church",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "walks unsteady",
      "en_school_name": "Homebased",
      "en_out_reach_app_cas": "fa679540-b98c-4bf3-9fa2-fbfc8ff9faed",
      "en_disability_type": "Physical Challenges",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "640",
      "id": 47038,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Juliana\",\"en_second_name\":\"Neema\",\"en_last_name_1\":\"Rodgers\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"06\\/12\\/2006\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Juliana is a young woman with a physical disability due to an illness. Since she is an orphan, she lives with her aunt in a mud hut with a thatched roof. While her aunt works as a farmer, she is unable to support her niece\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school fees. Sponsorship will enable Juliana to receive physical therapy, an assistive device, and an education. She will also benefit from three meals a day, counseling about her rights, as well as other inclusive support she may need.\",\"en_private_comments\":\"March 21, 2023\\r\\nJuliana is a 1st grader at Gede Special School.  She received average scores on her exams.  Her assessment scores are improving as she attends school more regularly.  She has an IEP (Individualized Learning Plan).      She is meeting some of the goals. She likes to read storybooks.\\r\\n\\r\\nJuliana can walk independently.  She can grasp objects of all sizes and shapes which means she can write and draw.  She attends therapy twice a week.  Otherwise, she has been healthy this past year.\\r\\n\\r\\nJuliana is friendly, kind, and helpful to others.  She interacts with others very well.  She likes to watch television, play board games, talk with friends, play team sports, play with toys, sing, art, and dance.\\r\\n\\r\\nIn the past year the family has faced challenges earning an income.  Her caregiver earned very little to provide for her family.  Fortunately, Juliana has her needs met at school.\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"sickness\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"Orphan; lives with aunt\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"Elizabeth Chizi Kalu\",\"en_guardians_occupat\":\"Peasant Farmer\",\"en_guardians_relatio\":\"Aunt\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Kwa Shume\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"Physical disability; aunt cannot pay boarding fees\",\"en_total_needed\":\"0\",\"en_other_needs\":\"school fees; assistive device\",\"en_languages\":\"English, Swahili, Giriama\",\"en_religion\":\"Christian\",\"en_church_name\":\"Kizingo PEFIC Church\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"walks unsteady\",\"en_school_name\":\"Homebased\",\"en_out_reach_app_cas\":\"fa679540-b98c-4bf3-9fa2-fbfc8ff9faed\",\"en_disability_type\":\"Physical Challenges\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"640\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:46.000000Z",
      "updated_at": "2023-05-10T04:38:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Juliana",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Neema",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 47038,
      "client_id": 207,
      "program_id": 3507,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-10",
      "json_fields": "{\"en_first_name\":\"Juliana\",\"en_second_name\":\"Neema\",\"en_last_name_1\":\"Rodgers\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"06\\/12\\/2006\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Juliana is a young woman with a physical disability due to an illness. Since she is an orphan, she lives with her aunt in a mud hut with a thatched roof. While her aunt works as a farmer, she is unable to support her niece\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school fees. Sponsorship will enable Juliana to receive physical therapy, an assistive device, and an education. She will also benefit from three meals a day, counseling about her rights, as well as other inclusive support she may need.\",\"en_private_comments\":\"March 21, 2023\\r\\nJuliana is a 1st grader at Gede Special School.  She received average scores on her exams.  Her assessment scores are improving as she attends school more regularly.  She has an IEP (Individualized Learning Plan).      She is meeting some of the goals. She likes to read storybooks.\\r\\n\\r\\nJuliana can walk independently.  She can grasp objects of all sizes and shapes which means she can write and draw.  She attends therapy twice a week.  Otherwise, she has been healthy this past year.\\r\\n\\r\\nJuliana is friendly, kind, and helpful to others.  She interacts with others very well.  She likes to watch television, play board games, talk with friends, play team sports, play with toys, sing, art, and dance.\\r\\n\\r\\nIn the past year the family has faced challenges earning an income.  Her caregiver earned very little to provide for her family.  Fortunately, Juliana has her needs met at school.\",\"en_birth_certificate\":\"\",\"en_sponsor_documents\":\"\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_cause_of_disabili\":\"sickness\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"Orphan; lives with aunt\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"Elizabeth Chizi Kalu\",\"en_guardians_occupat\":\"Peasant Farmer\",\"en_guardians_relatio\":\"Aunt\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Kwa Shume\",\"en_distance_away\":\"\",\"en_house_state\":\"mud walls with thatched roof (mkuti)\",\"en_why_need_sponsors\":\"Physical disability; aunt cannot pay boarding fees\",\"en_total_needed\":\"0\",\"en_other_needs\":\"school fees; assistive device\",\"en_languages\":\"English, Swahili, Giriama\",\"en_religion\":\"Christian\",\"en_church_name\":\"Kizingo PEFIC Church\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"walks unsteady\",\"en_school_name\":\"Homebased\",\"en_out_reach_app_cas\":\"fa679540-b98c-4bf3-9fa2-fbfc8ff9faed\",\"en_disability_type\":\"Physical Challenges\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"640\"}",
      "deleted_at": null,
      "created_at": "2023-05-10T04:38:46.000000Z",
      "updated_at": "2023-05-10T04:38:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "32"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3507,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3040,
      "setting_id": 1646,
      "emailset_id": null,
      "entity_submit": null,
      "donor_submit": null,
      "link_id": null,
      "name": "Kupe",
      "prefix": "KUP",
      "counter": null,
      "lft": 10,
      "rgt": 11,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-05-03T06:41:45.000000Z",
      "updated_at": "2024-07-25T08:23:28.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Juliana Neema",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "32",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "365",
      "stripe": "",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "hidden",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47511,
    "profile": {
      "en_first_name": "Grace",
      "en_second_name": "Mahenzo",
      "en_last_name_1": "Chengo",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "01/01/1993",
      "en_mental_disability": "none",
      "en_public_comments": "Mahenzo is an eighteen years old girl with a hearing impairment.  She suffered from untreated malaria when she was young and she lost some of her hearing ability because of it.  Mahenzo loves to read and dance.  With sponsorship, she will get her hearing tested and will receive a hearing aid that will allow her to be put into mainstream classes.",
      "en_private_comments": "May 25, 2022\r\nGrace is 29 years ago and a senior at Pwani Secondary\r\nSchool for the Deaf. She received the highest grades in\r\nKenya Sign Language. She will be sitting \u00c3\u00a2\u00e2\u0082\u00ac\u00cb\u009cfor Kenya\r\nCertificate of Secondary examination in December.\r\nDue to her hearing impairment Grace can not speak but\r\nshe can read lips. She relies on sign language for all of her\r\ncommunication needs. At least one of her parents can\r\ncommunicate fluently in sign language. She has not had\r\nany illness in the past year.\r\nGrace is friendly and kind. She is described as an introvert\r\nhaving only a few good friends. She enjoys watching\r\ntelevision, reading, playing board games, talking with her\r\npeers and playing team sports. She is a competitive\r\nathlete in volleyball and running. She is also a member of\r\nthe school\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s Scouting Club.\r\nDespite the challenges brought by the pandemic, her\r\nparents were able to care for their daughter by providing\r\nfor her needs and creating a safe environment. There is an\r\nongoing drought in the area that has caused the farms to\r\nbe less productive.\r\nThank you for your support of Grace.\r\nMay 25, 2020\r\nGrace is 29 years ago and a senior at Pwani Secondary School for the Deaf. She received the highest grades in Kenya Sign Language.  She will be sitting \u00c3\u00a2\u00e2\u0082\u00ac\u00cb\u009cfor Kenya Certificate of Secondary examination in December.\r\n\r\nDue to her hearing impairment Grace can not speak but she can read lips.  She relies on sign language for all of her communication needs.  At least one of her parents can communicate fluently in sign language.  She has not had any illness in the past year.  \r\n\r\nGrace is friendly and kind.  She is described as an introvert having only a few good friends.  She enjoys watching television, reading, playing board games, talking with her peers and playing team sports.  She is a competitive athlete in volleyball and running.  She is also a member of the school\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s Scouting Club.\r\n\r\nDespite the challenges brought by the pandemic, her parents were able to care for their daughter by providing for her needs and creating a safe environment.  There is an ongoing drought in the area that has caused the farms to be less productive.\r\n\r\nThank you for your support of Grace.\r\n\r\nMarch 18, 2020\r\nMahenzo is now 27 years old.  She is in form 2 at Pwani Secondary/Vocational School for the Deaf.  She is mostly interested in Kenyan Sign Language and is having difficulty with her other subjects.  She is a slow learner who needs time to comprehend concepts taught.  Her teachers believe she can improve with more engagement in learning activities.\r\n      Mahenzo is friendly at times but sometimes prefers to be alone.  She enjoys watching television, reading, trading stories with friends, and playing team sports.  She is a very good volleyball player and has competed at the national level.  She now participates in walking races.  She is a member of the Scount club which is an organization that cleans the grounds of the school and raise the flag during assemblies.  They also perform first aid whenever there is an emergency.\r\n      Counselling is a new component to the services offered by our Kenyan staff.  The family has been advised about the rights and laws of children with disability.  They have been referred to appropriate medical and educational facilities.  They have been counselled on the proper physical and nutritional care of their daughter.  Mahenzo has been counselled in issues of self-esteem.  She used to be shy and refused to share any issues regarding her disability.  Now, after counselling, she reports any of her problems to her teachers.\r\n\r\n   Your support is contributing to so many improvements in Mahenzo's life.  Thank you for caring for this young woman.\r\nDecember 12, 2018\r\n      Mahenzo is 25 years old and an 8th grader at Marafa Special School.  Her academic subjects are remaining constant as she continues to report late to school at the beginning of the term.  She has challenges understanding the language.  The school is offering her guidance and counseling which is improving her study behaviors.  She has taken her final examination to qualify for secondary school but has not received her grades.  Her attention in class and the completion of her assignments is helping her improve.  When she completes her education she would like to be a tailor.\r\n       Mahenzo is learning sign language but has not yet mastered it.  She still uses gestures to communicate.   She has not had any major illnesses this year and has been quite healthy.\r\n      Mahenzo helps other students at her school and is consider a leader at the school.  She is friendly and interacts freely with her classmates.   She participates in track and field events such as relays, sprints, and javelin throws.  She has competed at the county level in these events.  She also plays volleyball and netball.  She enjoys watching television.\r\n      Her family allows Mahenzo to attend school and give her the basic toiletries.  Otherwise they are uncooperative with the school and do not participate in any school functions. \r\n       Your sponsorship is giving Mahenzo a chance to get an education, participate in sports, learn sign language and make friends.  Thank you for your generosity. \r\n\r\nDecember 5, 2017\r\n    Kupenda continues to grow as staff continues to educate Kenyans that disability is not inability.  At one of the schools there will be a new dormitory to meet the needs of students needing residential services. In another location a large track of land was given to build a new school for children with disabilities in a remote area that currently can offer no services to these children.  In Gede new staff is being added to Kuhenza to handle the needs of students and parents.  Some of the first sponsored children are now graduating from college and working as professionals.  Kupenda staff is thankful for all the sponsors and supporters which have allowed for this work to continue and grow.\r\n     Mahenzo is now 8 years old and a student at Marafa Special School.  She has been working hard at her studies and some of her grades reflect that effort.  She used to be quite temperamental but this has improved and she does what is instructed.  She needs to come to school earlier and continue to work hard for her grades  to continue to improve.  She is learning sign language and can understand it.  She would like to be a tailor when she completes her education.\r\n      She is a healthy young girl and her hearing impairment is not causing any hinderances to her education.  She is friendly and makes friends easily.  She is very active athletically.  She plays netball, volleyball, track, javelin, shot put and discus.  She has competed at the regional level in some of these sports.  She also enjoys watching TV and story telling.\r\n      Mahenzo\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s father is the sole wage earner of a large nuclear family.  He is a hunter and most of the game preserves protect the hunting areas.  This makes the family engulfed in poverty.  The family is supportive of Mahenzo\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s education and provide her with the basics needed to make her comfortable.\r\n       Thank you for your support, without it Mahenzos family would not be able to afford her education.\r\n\r\n11/23/2016\r\nExciting things are happening for disabled children in Kenya and Tanzania.  More and more people are being educated about disabilities and are taking ownership of these children in their communities.  Cynthia and Leonard have been travelling to remote locations and conducting workshops for government leaders, pastors, parents, and natural healers. Thousands of children are being impacted in a positive way.  The government of Kenya is building a couple of model classrooms at Gede school that will be used to model instruction for children with disabilities.  Big news is that a couple of Los Angeles based film makers are making a full feature film about the Kupenda story.  Some of the final filming was done in Kenya and New England this fall.  Hopefully the film will come to an area near you.\r\n\r\nMahenzo is a 23 year old young lady at Marafa Special School.  She is passing all her subjects and prefers her Kiswahili class.  She will start her secondary school education soon.  She would like to be a nurse when she completes her education.\r\n\r\nBeing able to express herself fluently through sign language has opened many doors for Mahenzo.  She interacts well with others and has become a leader.  She has been selected to be a prefect at her school.\r\n\r\nUnfortunately things are not changing with Mahenzo\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s family  They have not learned sign language and can not communicate well with her.  That makes your sponsorship that much more important. She is happy to be sponsored as it not only gives her an education but she knows that someone cares about her,  Thank you.\r\n\r\n5/24/2016\r\nThings have improved this year for the Kenyan Schools.  Students are now in school  without interruption from teacher strikes.  Terrorism continues to be a concern in Kenya especially with the on going battles with Somalia.  Despite this, volunteers were able to visit the schools this January.  There has been much progress made in the school facilities in the past few years with dormitories, access ramps, dining halls and class rooms. Also, the workshops that Cynthia and Leonard are conducting are making a huge impact on attitudes toward disabilities. Due to these workshops many villages are now taking ownership of the disabled children in their communities.\r\n     Mahenzo is now 23 years old and in Primary Class 6 at Marafa Special School.  Marafa is a fairly new school so Mahenzo got started with her education later than most children.  She is doing well with her subjects and likes her English classes the best.  She hopes to be a tailor when she finishes school.\r\n       She has improved in her sign language.  As communication has improved so have other facets of Mahenzo\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s life.  She can now maintain her own cleanliness.  She is captain of the school because she can relate to others so well.  She enjoys making friends.  She proceeded to the regionals for ball games and was awarded certificates for this accomplishment.\r\n       Her parents have taken advantage of sign language classes that Kupenda has provided.   However, her parents leave her at school for most of the year and don\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2t visit her.  She is capable of doing all household chores including tending animals and watching younger siblings.  She can be reliable when given responsibilities.\r\n      She is grateful to you, her sponsors, for the opportunity to attend school and learn valuable skills.  Thank You.                                                                                                                                                                                                                        \r\n\r\n9-10-14\r\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year.  Mahenzo may have benefitted from the speech therapist the Australian Red Cross was scheduled to send to us this year.  However the travel warnings resulted in postponement of this placement until things are deemed safe.   In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\r\nMahenzo is now 21 years old and doing well at the Marafa Special School.  She is now talking more after the meetings Kupenda held with hard of hearing children and parents.  She uses both sign and speech now.  Her teachers say that she can sign fluently.  She is also always helping the housemothers at school in the kitchen.  She also helps to feed the younger children.  Mahenzo has an especially big heart.  She\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s also involved in music and sports like javelling, shotput, and volley ball.  \r\nMahenzo\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s father attends school meetings and functions.  He is also contributing what he can to her school fees.  Mahenzo is very helpful with chores at home including looking after her younger siblings.\r\nThank you for making a difference in Mahenzo\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s life!\r\n\r\n10-4-2013\r\nMahenzo is now 20 years old and in the 4th grade at the Marafa Special School.  There were no schools for her when she was younger so she is much older than most 4th graders. She was unable to do the end of year exams so was held in the fourth grade this year.  Many girls in her area, especially those with disabilities, never get this kind of opportunity and often are married with children by now never having had a chance at education.  We are looking into getting her hearing aids but it is difficult to find trained professionals who can teach her to use them properly.  She uses sign language and is not speaking as much as she used to.  Children who are hard of hearing do not have alternatives to deaf classrooms or main stream classrooms.  We are working on this issue.  \r\nHer father is very involved in her education. He attends all school meeting and functions.  He is even trying to provide what he can to her schooling even though he only earns a little from his small plot of land.  Mahenzo is very helpful to her family at home.  She helps with watching her younger siblings and washing dishes.\r\nThanks to your support Mahenzo wants to be a nurse one day!\r\n\r\n\r\nMahenzo is an eighteen year old girl whose hearing was affected by a bout of malaria that struck her when she was young. Her parents work hard to farm their small plot of land but are unable to even properly feed their family.  Mahenzo has three brothers and three sisters who do not normally have three meals a day at home.  Through sponsorship, she would be able to have her hearing tested and would receive a hearing aid.  With a hearing aid, Mahenzo could be integrated into a mainstream classroom because her speech is not badly affected by her hearing loss.  Mahenzo likes to dance, tell stories, and read.",
      "en_level_hearing": "",
      "en_hearing_test": "Yes",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Yes",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "",
      "en_mothers_occupatio": "",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "unwilling few resources",
      "en_situation_explain": "",
      "en_house_location": "Marafa",
      "en_distance_away": "",
      "en_house_state": "",
      "en_why_need_sponsors": "",
      "en_total_needed": "0",
      "en_other_needs": "",
      "en_languages": "",
      "en_religion": "",
      "en_church_name": "",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Pwani Secondary/Vocational School for the Deaf",
      "en_out_reach_app_cas": "2fedc4cf-0005-49c5-b12b-513ec29b07ea",
      "en_disability_type": "Hearing Impairment",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "126",
      "en_cid": "KP10",
      "id": 47511,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Grace\",\"en_second_name\":\"Mahenzo\",\"en_last_name_1\":\"Chengo\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"01\\/01\\/1993\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Mahenzo is an eighteen years old girl with a hearing impairment.  She suffered from untreated malaria when she was young and she lost some of her hearing ability because of it.  Mahenzo loves to read and dance.  With sponsorship, she will get her hearing tested and will receive a hearing aid that will allow her to be put into mainstream classes.\",\"en_private_comments\":\"May 25, 2022\\r\\nGrace is 29 years ago and a senior at Pwani Secondary\\r\\nSchool for the Deaf. She received the highest grades in\\r\\nKenya Sign Language. She will be sitting \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00cb\\u009cfor Kenya\\r\\nCertificate of Secondary examination in December.\\r\\nDue to her hearing impairment Grace can not speak but\\r\\nshe can read lips. She relies on sign language for all of her\\r\\ncommunication needs. At least one of her parents can\\r\\ncommunicate fluently in sign language. She has not had\\r\\nany illness in the past year.\\r\\nGrace is friendly and kind. She is described as an introvert\\r\\nhaving only a few good friends. She enjoys watching\\r\\ntelevision, reading, playing board games, talking with her\\r\\npeers and playing team sports. She is a competitive\\r\\nathlete in volleyball and running. She is also a member of\\r\\nthe school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Scouting Club.\\r\\nDespite the challenges brought by the pandemic, her\\r\\nparents were able to care for their daughter by providing\\r\\nfor her needs and creating a safe environment. There is an\\r\\nongoing drought in the area that has caused the farms to\\r\\nbe less productive.\\r\\nThank you for your support of Grace.\\r\\nMay 25, 2020\\r\\nGrace is 29 years ago and a senior at Pwani Secondary School for the Deaf. She received the highest grades in Kenya Sign Language.  She will be sitting \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00cb\\u009cfor Kenya Certificate of Secondary examination in December.\\r\\n\\r\\nDue to her hearing impairment Grace can not speak but she can read lips.  She relies on sign language for all of her communication needs.  At least one of her parents can communicate fluently in sign language.  She has not had any illness in the past year.  \\r\\n\\r\\nGrace is friendly and kind.  She is described as an introvert having only a few good friends.  She enjoys watching television, reading, playing board games, talking with her peers and playing team sports.  She is a competitive athlete in volleyball and running.  She is also a member of the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Scouting Club.\\r\\n\\r\\nDespite the challenges brought by the pandemic, her parents were able to care for their daughter by providing for her needs and creating a safe environment.  There is an ongoing drought in the area that has caused the farms to be less productive.\\r\\n\\r\\nThank you for your support of Grace.\\r\\n\\r\\nMarch 18, 2020\\r\\nMahenzo is now 27 years old.  She is in form 2 at Pwani Secondary\\/Vocational School for the Deaf.  She is mostly interested in Kenyan Sign Language and is having difficulty with her other subjects.  She is a slow learner who needs time to comprehend concepts taught.  Her teachers believe she can improve with more engagement in learning activities.\\r\\n      Mahenzo is friendly at times but sometimes prefers to be alone.  She enjoys watching television, reading, trading stories with friends, and playing team sports.  She is a very good volleyball player and has competed at the national level.  She now participates in walking races.  She is a member of the Scount club which is an organization that cleans the grounds of the school and raise the flag during assemblies.  They also perform first aid whenever there is an emergency.\\r\\n      Counselling is a new component to the services offered by our Kenyan staff.  The family has been advised about the rights and laws of children with disability.  They have been referred to appropriate medical and educational facilities.  They have been counselled on the proper physical and nutritional care of their daughter.  Mahenzo has been counselled in issues of self-esteem.  She used to be shy and refused to share any issues regarding her disability.  Now, after counselling, she reports any of her problems to her teachers.\\r\\n\\r\\n   Your support is contributing to so many improvements in Mahenzo's life.  Thank you for caring for this young woman.\\r\\nDecember 12, 2018\\r\\n      Mahenzo is 25 years old and an 8th grader at Marafa Special School.  Her academic subjects are remaining constant as she continues to report late to school at the beginning of the term.  She has challenges understanding the language.  The school is offering her guidance and counseling which is improving her study behaviors.  She has taken her final examination to qualify for secondary school but has not received her grades.  Her attention in class and the completion of her assignments is helping her improve.  When she completes her education she would like to be a tailor.\\r\\n       Mahenzo is learning sign language but has not yet mastered it.  She still uses gestures to communicate.   She has not had any major illnesses this year and has been quite healthy.\\r\\n      Mahenzo helps other students at her school and is consider a leader at the school.  She is friendly and interacts freely with her classmates.   She participates in track and field events such as relays, sprints, and javelin throws.  She has competed at the county level in these events.  She also plays volleyball and netball.  She enjoys watching television.\\r\\n      Her family allows Mahenzo to attend school and give her the basic toiletries.  Otherwise they are uncooperative with the school and do not participate in any school functions. \\r\\n       Your sponsorship is giving Mahenzo a chance to get an education, participate in sports, learn sign language and make friends.  Thank you for your generosity. \\r\\n\\r\\nDecember 5, 2017\\r\\n    Kupenda continues to grow as staff continues to educate Kenyans that disability is not inability.  At one of the schools there will be a new dormitory to meet the needs of students needing residential services. In another location a large track of land was given to build a new school for children with disabilities in a remote area that currently can offer no services to these children.  In Gede new staff is being added to Kuhenza to handle the needs of students and parents.  Some of the first sponsored children are now graduating from college and working as professionals.  Kupenda staff is thankful for all the sponsors and supporters which have allowed for this work to continue and grow.\\r\\n     Mahenzo is now 8 years old and a student at Marafa Special School.  She has been working hard at her studies and some of her grades reflect that effort.  She used to be quite temperamental but this has improved and she does what is instructed.  She needs to come to school earlier and continue to work hard for her grades  to continue to improve.  She is learning sign language and can understand it.  She would like to be a tailor when she completes her education.\\r\\n      She is a healthy young girl and her hearing impairment is not causing any hinderances to her education.  She is friendly and makes friends easily.  She is very active athletically.  She plays netball, volleyball, track, javelin, shot put and discus.  She has competed at the regional level in some of these sports.  She also enjoys watching TV and story telling.\\r\\n      Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s father is the sole wage earner of a large nuclear family.  He is a hunter and most of the game preserves protect the hunting areas.  This makes the family engulfed in poverty.  The family is supportive of Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education and provide her with the basics needed to make her comfortable.\\r\\n       Thank you for your support, without it Mahenzos family would not be able to afford her education.\\r\\n\\r\\n11\\/23\\/2016\\r\\nExciting things are happening for disabled children in Kenya and Tanzania.  More and more people are being educated about disabilities and are taking ownership of these children in their communities.  Cynthia and Leonard have been travelling to remote locations and conducting workshops for government leaders, pastors, parents, and natural healers. Thousands of children are being impacted in a positive way.  The government of Kenya is building a couple of model classrooms at Gede school that will be used to model instruction for children with disabilities.  Big news is that a couple of Los Angeles based film makers are making a full feature film about the Kupenda story.  Some of the final filming was done in Kenya and New England this fall.  Hopefully the film will come to an area near you.\\r\\n\\r\\nMahenzo is a 23 year old young lady at Marafa Special School.  She is passing all her subjects and prefers her Kiswahili class.  She will start her secondary school education soon.  She would like to be a nurse when she completes her education.\\r\\n\\r\\nBeing able to express herself fluently through sign language has opened many doors for Mahenzo.  She interacts well with others and has become a leader.  She has been selected to be a prefect at her school.\\r\\n\\r\\nUnfortunately things are not changing with Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family  They have not learned sign language and can not communicate well with her.  That makes your sponsorship that much more important. She is happy to be sponsored as it not only gives her an education but she knows that someone cares about her,  Thank you.\\r\\n\\r\\n5\\/24\\/2016\\r\\nThings have improved this year for the Kenyan Schools.  Students are now in school  without interruption from teacher strikes.  Terrorism continues to be a concern in Kenya especially with the on going battles with Somalia.  Despite this, volunteers were able to visit the schools this January.  There has been much progress made in the school facilities in the past few years with dormitories, access ramps, dining halls and class rooms. Also, the workshops that Cynthia and Leonard are conducting are making a huge impact on attitudes toward disabilities. Due to these workshops many villages are now taking ownership of the disabled children in their communities.\\r\\n     Mahenzo is now 23 years old and in Primary Class 6 at Marafa Special School.  Marafa is a fairly new school so Mahenzo got started with her education later than most children.  She is doing well with her subjects and likes her English classes the best.  She hopes to be a tailor when she finishes school.\\r\\n       She has improved in her sign language.  As communication has improved so have other facets of Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life.  She can now maintain her own cleanliness.  She is captain of the school because she can relate to others so well.  She enjoys making friends.  She proceeded to the regionals for ball games and was awarded certificates for this accomplishment.\\r\\n       Her parents have taken advantage of sign language classes that Kupenda has provided.   However, her parents leave her at school for most of the year and don\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2t visit her.  She is capable of doing all household chores including tending animals and watching younger siblings.  She can be reliable when given responsibilities.\\r\\n      She is grateful to you, her sponsors, for the opportunity to attend school and learn valuable skills.  Thank You.                                                                                                                                                                                                                        \\r\\n\\r\\n9-10-14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year.  Mahenzo may have benefitted from the speech therapist the Australian Red Cross was scheduled to send to us this year.  However the travel warnings resulted in postponement of this placement until things are deemed safe.   In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nMahenzo is now 21 years old and doing well at the Marafa Special School.  She is now talking more after the meetings Kupenda held with hard of hearing children and parents.  She uses both sign and speech now.  Her teachers say that she can sign fluently.  She is also always helping the housemothers at school in the kitchen.  She also helps to feed the younger children.  Mahenzo has an especially big heart.  She\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s also involved in music and sports like javelling, shotput, and volley ball.  \\r\\nMahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s father attends school meetings and functions.  He is also contributing what he can to her school fees.  Mahenzo is very helpful with chores at home including looking after her younger siblings.\\r\\nThank you for making a difference in Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life!\\r\\n\\r\\n10-4-2013\\r\\nMahenzo is now 20 years old and in the 4th grade at the Marafa Special School.  There were no schools for her when she was younger so she is much older than most 4th graders. She was unable to do the end of year exams so was held in the fourth grade this year.  Many girls in her area, especially those with disabilities, never get this kind of opportunity and often are married with children by now never having had a chance at education.  We are looking into getting her hearing aids but it is difficult to find trained professionals who can teach her to use them properly.  She uses sign language and is not speaking as much as she used to.  Children who are hard of hearing do not have alternatives to deaf classrooms or main stream classrooms.  We are working on this issue.  \\r\\nHer father is very involved in her education. He attends all school meeting and functions.  He is even trying to provide what he can to her schooling even though he only earns a little from his small plot of land.  Mahenzo is very helpful to her family at home.  She helps with watching her younger siblings and washing dishes.\\r\\nThanks to your support Mahenzo wants to be a nurse one day!\\r\\n\\r\\n\\r\\nMahenzo is an eighteen year old girl whose hearing was affected by a bout of malaria that struck her when she was young. Her parents work hard to farm their small plot of land but are unable to even properly feed their family.  Mahenzo has three brothers and three sisters who do not normally have three meals a day at home.  Through sponsorship, she would be able to have her hearing tested and would receive a hearing aid.  With a hearing aid, Mahenzo could be integrated into a mainstream classroom because her speech is not badly affected by her hearing loss.  Mahenzo likes to dance, tell stories, and read.\",\"en_level_hearing\":\"\",\"en_hearing_test\":\"Yes\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Yes\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Marafa\",\"en_distance_away\":\"\",\"en_house_state\":\"\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Pwani Secondary\\/Vocational School for the Deaf\",\"en_out_reach_app_cas\":\"2fedc4cf-0005-49c5-b12b-513ec29b07ea\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"126\",\"en_cid\":\"KP10\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Grace",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Mahenzo",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/ad87cb553b99c626d78f86c953000eb1.jpg",
    "donations": [],
    "entity": {
      "id": 47511,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Grace\",\"en_second_name\":\"Mahenzo\",\"en_last_name_1\":\"Chengo\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"01\\/01\\/1993\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Mahenzo is an eighteen years old girl with a hearing impairment.  She suffered from untreated malaria when she was young and she lost some of her hearing ability because of it.  Mahenzo loves to read and dance.  With sponsorship, she will get her hearing tested and will receive a hearing aid that will allow her to be put into mainstream classes.\",\"en_private_comments\":\"May 25, 2022\\r\\nGrace is 29 years ago and a senior at Pwani Secondary\\r\\nSchool for the Deaf. She received the highest grades in\\r\\nKenya Sign Language. She will be sitting \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00cb\\u009cfor Kenya\\r\\nCertificate of Secondary examination in December.\\r\\nDue to her hearing impairment Grace can not speak but\\r\\nshe can read lips. She relies on sign language for all of her\\r\\ncommunication needs. At least one of her parents can\\r\\ncommunicate fluently in sign language. She has not had\\r\\nany illness in the past year.\\r\\nGrace is friendly and kind. She is described as an introvert\\r\\nhaving only a few good friends. She enjoys watching\\r\\ntelevision, reading, playing board games, talking with her\\r\\npeers and playing team sports. She is a competitive\\r\\nathlete in volleyball and running. She is also a member of\\r\\nthe school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Scouting Club.\\r\\nDespite the challenges brought by the pandemic, her\\r\\nparents were able to care for their daughter by providing\\r\\nfor her needs and creating a safe environment. There is an\\r\\nongoing drought in the area that has caused the farms to\\r\\nbe less productive.\\r\\nThank you for your support of Grace.\\r\\nMay 25, 2020\\r\\nGrace is 29 years ago and a senior at Pwani Secondary School for the Deaf. She received the highest grades in Kenya Sign Language.  She will be sitting \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00cb\\u009cfor Kenya Certificate of Secondary examination in December.\\r\\n\\r\\nDue to her hearing impairment Grace can not speak but she can read lips.  She relies on sign language for all of her communication needs.  At least one of her parents can communicate fluently in sign language.  She has not had any illness in the past year.  \\r\\n\\r\\nGrace is friendly and kind.  She is described as an introvert having only a few good friends.  She enjoys watching television, reading, playing board games, talking with her peers and playing team sports.  She is a competitive athlete in volleyball and running.  She is also a member of the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Scouting Club.\\r\\n\\r\\nDespite the challenges brought by the pandemic, her parents were able to care for their daughter by providing for her needs and creating a safe environment.  There is an ongoing drought in the area that has caused the farms to be less productive.\\r\\n\\r\\nThank you for your support of Grace.\\r\\n\\r\\nMarch 18, 2020\\r\\nMahenzo is now 27 years old.  She is in form 2 at Pwani Secondary\\/Vocational School for the Deaf.  She is mostly interested in Kenyan Sign Language and is having difficulty with her other subjects.  She is a slow learner who needs time to comprehend concepts taught.  Her teachers believe she can improve with more engagement in learning activities.\\r\\n      Mahenzo is friendly at times but sometimes prefers to be alone.  She enjoys watching television, reading, trading stories with friends, and playing team sports.  She is a very good volleyball player and has competed at the national level.  She now participates in walking races.  She is a member of the Scount club which is an organization that cleans the grounds of the school and raise the flag during assemblies.  They also perform first aid whenever there is an emergency.\\r\\n      Counselling is a new component to the services offered by our Kenyan staff.  The family has been advised about the rights and laws of children with disability.  They have been referred to appropriate medical and educational facilities.  They have been counselled on the proper physical and nutritional care of their daughter.  Mahenzo has been counselled in issues of self-esteem.  She used to be shy and refused to share any issues regarding her disability.  Now, after counselling, she reports any of her problems to her teachers.\\r\\n\\r\\n   Your support is contributing to so many improvements in Mahenzo's life.  Thank you for caring for this young woman.\\r\\nDecember 12, 2018\\r\\n      Mahenzo is 25 years old and an 8th grader at Marafa Special School.  Her academic subjects are remaining constant as she continues to report late to school at the beginning of the term.  She has challenges understanding the language.  The school is offering her guidance and counseling which is improving her study behaviors.  She has taken her final examination to qualify for secondary school but has not received her grades.  Her attention in class and the completion of her assignments is helping her improve.  When she completes her education she would like to be a tailor.\\r\\n       Mahenzo is learning sign language but has not yet mastered it.  She still uses gestures to communicate.   She has not had any major illnesses this year and has been quite healthy.\\r\\n      Mahenzo helps other students at her school and is consider a leader at the school.  She is friendly and interacts freely with her classmates.   She participates in track and field events such as relays, sprints, and javelin throws.  She has competed at the county level in these events.  She also plays volleyball and netball.  She enjoys watching television.\\r\\n      Her family allows Mahenzo to attend school and give her the basic toiletries.  Otherwise they are uncooperative with the school and do not participate in any school functions. \\r\\n       Your sponsorship is giving Mahenzo a chance to get an education, participate in sports, learn sign language and make friends.  Thank you for your generosity. \\r\\n\\r\\nDecember 5, 2017\\r\\n    Kupenda continues to grow as staff continues to educate Kenyans that disability is not inability.  At one of the schools there will be a new dormitory to meet the needs of students needing residential services. In another location a large track of land was given to build a new school for children with disabilities in a remote area that currently can offer no services to these children.  In Gede new staff is being added to Kuhenza to handle the needs of students and parents.  Some of the first sponsored children are now graduating from college and working as professionals.  Kupenda staff is thankful for all the sponsors and supporters which have allowed for this work to continue and grow.\\r\\n     Mahenzo is now 8 years old and a student at Marafa Special School.  She has been working hard at her studies and some of her grades reflect that effort.  She used to be quite temperamental but this has improved and she does what is instructed.  She needs to come to school earlier and continue to work hard for her grades  to continue to improve.  She is learning sign language and can understand it.  She would like to be a tailor when she completes her education.\\r\\n      She is a healthy young girl and her hearing impairment is not causing any hinderances to her education.  She is friendly and makes friends easily.  She is very active athletically.  She plays netball, volleyball, track, javelin, shot put and discus.  She has competed at the regional level in some of these sports.  She also enjoys watching TV and story telling.\\r\\n      Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s father is the sole wage earner of a large nuclear family.  He is a hunter and most of the game preserves protect the hunting areas.  This makes the family engulfed in poverty.  The family is supportive of Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education and provide her with the basics needed to make her comfortable.\\r\\n       Thank you for your support, without it Mahenzos family would not be able to afford her education.\\r\\n\\r\\n11\\/23\\/2016\\r\\nExciting things are happening for disabled children in Kenya and Tanzania.  More and more people are being educated about disabilities and are taking ownership of these children in their communities.  Cynthia and Leonard have been travelling to remote locations and conducting workshops for government leaders, pastors, parents, and natural healers. Thousands of children are being impacted in a positive way.  The government of Kenya is building a couple of model classrooms at Gede school that will be used to model instruction for children with disabilities.  Big news is that a couple of Los Angeles based film makers are making a full feature film about the Kupenda story.  Some of the final filming was done in Kenya and New England this fall.  Hopefully the film will come to an area near you.\\r\\n\\r\\nMahenzo is a 23 year old young lady at Marafa Special School.  She is passing all her subjects and prefers her Kiswahili class.  She will start her secondary school education soon.  She would like to be a nurse when she completes her education.\\r\\n\\r\\nBeing able to express herself fluently through sign language has opened many doors for Mahenzo.  She interacts well with others and has become a leader.  She has been selected to be a prefect at her school.\\r\\n\\r\\nUnfortunately things are not changing with Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family  They have not learned sign language and can not communicate well with her.  That makes your sponsorship that much more important. She is happy to be sponsored as it not only gives her an education but she knows that someone cares about her,  Thank you.\\r\\n\\r\\n5\\/24\\/2016\\r\\nThings have improved this year for the Kenyan Schools.  Students are now in school  without interruption from teacher strikes.  Terrorism continues to be a concern in Kenya especially with the on going battles with Somalia.  Despite this, volunteers were able to visit the schools this January.  There has been much progress made in the school facilities in the past few years with dormitories, access ramps, dining halls and class rooms. Also, the workshops that Cynthia and Leonard are conducting are making a huge impact on attitudes toward disabilities. Due to these workshops many villages are now taking ownership of the disabled children in their communities.\\r\\n     Mahenzo is now 23 years old and in Primary Class 6 at Marafa Special School.  Marafa is a fairly new school so Mahenzo got started with her education later than most children.  She is doing well with her subjects and likes her English classes the best.  She hopes to be a tailor when she finishes school.\\r\\n       She has improved in her sign language.  As communication has improved so have other facets of Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life.  She can now maintain her own cleanliness.  She is captain of the school because she can relate to others so well.  She enjoys making friends.  She proceeded to the regionals for ball games and was awarded certificates for this accomplishment.\\r\\n       Her parents have taken advantage of sign language classes that Kupenda has provided.   However, her parents leave her at school for most of the year and don\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2t visit her.  She is capable of doing all household chores including tending animals and watching younger siblings.  She can be reliable when given responsibilities.\\r\\n      She is grateful to you, her sponsors, for the opportunity to attend school and learn valuable skills.  Thank You.                                                                                                                                                                                                                        \\r\\n\\r\\n9-10-14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year.  Mahenzo may have benefitted from the speech therapist the Australian Red Cross was scheduled to send to us this year.  However the travel warnings resulted in postponement of this placement until things are deemed safe.   In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nMahenzo is now 21 years old and doing well at the Marafa Special School.  She is now talking more after the meetings Kupenda held with hard of hearing children and parents.  She uses both sign and speech now.  Her teachers say that she can sign fluently.  She is also always helping the housemothers at school in the kitchen.  She also helps to feed the younger children.  Mahenzo has an especially big heart.  She\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s also involved in music and sports like javelling, shotput, and volley ball.  \\r\\nMahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s father attends school meetings and functions.  He is also contributing what he can to her school fees.  Mahenzo is very helpful with chores at home including looking after her younger siblings.\\r\\nThank you for making a difference in Mahenzo\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life!\\r\\n\\r\\n10-4-2013\\r\\nMahenzo is now 20 years old and in the 4th grade at the Marafa Special School.  There were no schools for her when she was younger so she is much older than most 4th graders. She was unable to do the end of year exams so was held in the fourth grade this year.  Many girls in her area, especially those with disabilities, never get this kind of opportunity and often are married with children by now never having had a chance at education.  We are looking into getting her hearing aids but it is difficult to find trained professionals who can teach her to use them properly.  She uses sign language and is not speaking as much as she used to.  Children who are hard of hearing do not have alternatives to deaf classrooms or main stream classrooms.  We are working on this issue.  \\r\\nHer father is very involved in her education. He attends all school meeting and functions.  He is even trying to provide what he can to her schooling even though he only earns a little from his small plot of land.  Mahenzo is very helpful to her family at home.  She helps with watching her younger siblings and washing dishes.\\r\\nThanks to your support Mahenzo wants to be a nurse one day!\\r\\n\\r\\n\\r\\nMahenzo is an eighteen year old girl whose hearing was affected by a bout of malaria that struck her when she was young. Her parents work hard to farm their small plot of land but are unable to even properly feed their family.  Mahenzo has three brothers and three sisters who do not normally have three meals a day at home.  Through sponsorship, she would be able to have her hearing tested and would receive a hearing aid.  With a hearing aid, Mahenzo could be integrated into a mainstream classroom because her speech is not badly affected by her hearing loss.  Mahenzo likes to dance, tell stories, and read.\",\"en_level_hearing\":\"\",\"en_hearing_test\":\"Yes\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Yes\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Marafa\",\"en_distance_away\":\"\",\"en_house_state\":\"\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Pwani Secondary\\/Vocational School for the Deaf\",\"en_out_reach_app_cas\":\"2fedc4cf-0005-49c5-b12b-513ec29b07ea\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"126\",\"en_cid\":\"KP10\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/ad87cb553b99c626d78f86c953000eb1_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Grace Mahenzo",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47510,
    "profile": {
      "en_first_name": "Kennedy",
      "en_second_name": "",
      "en_last_name_1": "Kahindi",
      "en_last_name_2": "",
      "en_gender": "Male",
      "en_date_of_birth": "20/10/2004",
      "en_mental_disability": "none",
      "en_public_comments": "Kennedy was born with cerebral palsy that affects his lower body.  Both of his legs are impacted and he is confined to a wheelchair.  With sponsorship, Kennedy will board at Gede Special School and will have the chance to get surgery to decrease his reliance on a wheelchair.",
      "en_private_comments": "January 26, 2022\r\nKennedy has been exited from sponsorship because he dropped out of school and refuses to return.  He says he is too old for school.\r\n\r\nDecember 16, 2020\r\nKennedy is now 16 years old.  He had correctivesurgery on his right leg last year and was in the hospital for most of the year making him unable to attend school.  He was in 7th grade at Marafa Primary School.  \r\n\r\nKennedy is friendly and kind.  He socializes well with others. He enjoys spending time talking with his friends.  \r\n\r\nKuhenza staff members referred the family to the appropriate medical facility.  They also counselled Kennedy which has  increased his self esteem.\r\nJuly 29, 2020 (Quick Update)\r\nHe continues to study at Marafa Special School.\r\n11-16-2018\r\nKennedy is now 14 years old and a student at Marafa Primary School.  He is in a mainstream school but lives in the special school\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s dormitory.  His grades are improving but he could do better if his parents brought him to school when the term begins.  When he completes his education he would like to be a motor vehicle engineer.\r\n\r\nKennedy does not interact with the other children at school.  His teachers assume it is because he is in a mainstream school and is self-conscious about his very visible disability.  The school plans to offer counseling services to help  him be more social.\r\n\r\nKennedy participates in sitting volleyball and wheelchair races.  He competed at the regional level and was awarded certificates.  He also enjoys watching films, playing darts, and playing cards.\r\n\r\nHis parents have separated  but both continue to provide for Kennedy\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s basic needs.  Both of them want Kennedy to get an education.\r\n\r\nYour sponsorship has given Kennedy an education, a wheelchair, and counseling.  Thank you for your generosity\r\n3-20-2017\r\n\tKenya is in the midst of one of its worst droughts in recent history.  This makes it difficult for parents to provide even food for their families.  Many children are lucky to receive one meal a day.  Kupenda recently delivered food staples to some remote villages that were particularly hit hard but even this is a short term fix.   This makes sponsorship even more important because along with academic and medical services our boarding students get three meals a day.\r\n       Kennedy is now a 13 year old young man attending Marafa Special School. His academics have been improving as he is now passing all of is subjects.  He has also learned to cooperate with teachers and other students.  He hopes to be a motor vehicle engineer when he finishes school.\r\n     He participates in sitting volleyball and Double Crutch races.  He interacts well with others as they play together.  He also enjoys African DJ music.  He is not allowing his disability to interfere with enjoying life.\r\n      Kennedy\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents are getting more involved in his education.  They can now see that their son, despite his disability, is now part of the school and progressing nicely. They even visit him at school and take him at school break.\t\r\n       Kupenda sponsorship has made all of this possible for Kennedy.  He can now dream of a productive future.Thank you.\t\t\t\t\t\r\n9-10-14\r\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year.  In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\r\nKennedy is now 11 years old and doing very well in third grade at the Marafa Special School.  As you can see from the photo, he is now using crutches to walk instead of his wheelchair and his legs are getting stronger every day.  Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s physical therapist visits his school once a week and his therapy sessions seem to be paying off.  We are currently working with a local organization to provide corrective surgery for his legs that could give him even more mobility.\r\nKennedy is the best student in his class with his highest grades in English and Math.  He also participated in the special school games at the county level.  He is well liked by all of his peers.  They are always playing creative games.  He also enjoys singing a lot.\r\nHis parents are very supportive of his education.  They are involved in parents meetings and functions at the school although they do not have the means to provide financially for their son.\r\nThank you for making a difference in Kennedy\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s life!  \r\n\r\n10-9-2013\r\nKennedy is now 10 years old and in the third grade at the Marafa Special School.  He is doing amazingly well in school.  He was ranked second in his class with almost all A\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s!  Weekly physical therapy with Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s physical therapist has helped him make some great progress physically.  He is now using crutches instead of his wheelchair.  However, he and some of his friends at school have been racing their wheelchairs for fun.  Plans are in progress for him to see an orthopedic surgeon for possible intervention. Teachers say that Kennedy interacts well with others and is known to be a very good story teller.  \r\nAlthough Kennedy\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents make very little from their small plot of farmland, they supply him with the essentials he needs for boarding school.  There was a time when many parents didn\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2t think it was important to contribute even these small things.  Any increase in support of a child with a disability by their family is a sign of acceptance and change in attitude.\r\nThank you for making so many things possible for Kennedy!\r\n\r\n\r\nKennedy is a boy who has had cerebral palsy since birth for unknown reasons. Both of his legs are impacted by this condition confining him to a wheelchair. With sponsorship, he may have the opportunity to get correctional surgery that will allow him at least to walk with braces on his legs.  He will also board at Gede Special School to receive primary education.  His parents farm their small plot of land to provide for their 8 children but they often go hungry.  Kennedy has no mental disability and would thrive with the proper education.  He recently began wheelchair racing and has gained confidence from it.",
      "en_level_hearing": "",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "",
      "en_mothers_occupatio": "",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "unwilling few resources",
      "en_situation_explain": "",
      "en_house_location": "",
      "en_distance_away": "",
      "en_house_state": "",
      "en_why_need_sponsors": "",
      "en_total_needed": "0",
      "en_other_needs": "",
      "en_languages": "",
      "en_religion": "",
      "en_church_name": "",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Marafa Special",
      "en_out_reach_app_cas": "5db77e81cdda436a81973b3346371a6c",
      "en_disability_type": "Cerebral Palsy (CP)",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "125",
      "en_cid": "KP9",
      "id": 47510,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Kennedy\",\"en_second_name\":\"\",\"en_last_name_1\":\"Kahindi\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"20\\/10\\/2004\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Kennedy was born with cerebral palsy that affects his lower body.  Both of his legs are impacted and he is confined to a wheelchair.  With sponsorship, Kennedy will board at Gede Special School and will have the chance to get surgery to decrease his reliance on a wheelchair.\",\"en_private_comments\":\"January 26, 2022\\r\\nKennedy has been exited from sponsorship because he dropped out of school and refuses to return.  He says he is too old for school.\\r\\n\\r\\nDecember 16, 2020\\r\\nKennedy is now 16 years old.  He had correctivesurgery on his right leg last year and was in the hospital for most of the year making him unable to attend school.  He was in 7th grade at Marafa Primary School.  \\r\\n\\r\\nKennedy is friendly and kind.  He socializes well with others. He enjoys spending time talking with his friends.  \\r\\n\\r\\nKuhenza staff members referred the family to the appropriate medical facility.  They also counselled Kennedy which has  increased his self esteem.\\r\\nJuly 29, 2020 (Quick Update)\\r\\nHe continues to study at Marafa Special School.\\r\\n11-16-2018\\r\\nKennedy is now 14 years old and a student at Marafa Primary School.  He is in a mainstream school but lives in the special school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s dormitory.  His grades are improving but he could do better if his parents brought him to school when the term begins.  When he completes his education he would like to be a motor vehicle engineer.\\r\\n\\r\\nKennedy does not interact with the other children at school.  His teachers assume it is because he is in a mainstream school and is self-conscious about his very visible disability.  The school plans to offer counseling services to help  him be more social.\\r\\n\\r\\nKennedy participates in sitting volleyball and wheelchair races.  He competed at the regional level and was awarded certificates.  He also enjoys watching films, playing darts, and playing cards.\\r\\n\\r\\nHis parents have separated  but both continue to provide for Kennedy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s basic needs.  Both of them want Kennedy to get an education.\\r\\n\\r\\nYour sponsorship has given Kennedy an education, a wheelchair, and counseling.  Thank you for your generosity\\r\\n3-20-2017\\r\\n\\tKenya is in the midst of one of its worst droughts in recent history.  This makes it difficult for parents to provide even food for their families.  Many children are lucky to receive one meal a day.  Kupenda recently delivered food staples to some remote villages that were particularly hit hard but even this is a short term fix.   This makes sponsorship even more important because along with academic and medical services our boarding students get three meals a day.\\r\\n       Kennedy is now a 13 year old young man attending Marafa Special School. His academics have been improving as he is now passing all of is subjects.  He has also learned to cooperate with teachers and other students.  He hopes to be a motor vehicle engineer when he finishes school.\\r\\n     He participates in sitting volleyball and Double Crutch races.  He interacts well with others as they play together.  He also enjoys African DJ music.  He is not allowing his disability to interfere with enjoying life.\\r\\n      Kennedy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are getting more involved in his education.  They can now see that their son, despite his disability, is now part of the school and progressing nicely. They even visit him at school and take him at school break.\\t\\r\\n       Kupenda sponsorship has made all of this possible for Kennedy.  He can now dream of a productive future.Thank you.\\t\\t\\t\\t\\t\\r\\n9-10-14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year.  In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nKennedy is now 11 years old and doing very well in third grade at the Marafa Special School.  As you can see from the photo, he is now using crutches to walk instead of his wheelchair and his legs are getting stronger every day.  Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s physical therapist visits his school once a week and his therapy sessions seem to be paying off.  We are currently working with a local organization to provide corrective surgery for his legs that could give him even more mobility.\\r\\nKennedy is the best student in his class with his highest grades in English and Math.  He also participated in the special school games at the county level.  He is well liked by all of his peers.  They are always playing creative games.  He also enjoys singing a lot.\\r\\nHis parents are very supportive of his education.  They are involved in parents meetings and functions at the school although they do not have the means to provide financially for their son.\\r\\nThank you for making a difference in Kennedy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life!  \\r\\n\\r\\n10-9-2013\\r\\nKennedy is now 10 years old and in the third grade at the Marafa Special School.  He is doing amazingly well in school.  He was ranked second in his class with almost all A\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s!  Weekly physical therapy with Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s physical therapist has helped him make some great progress physically.  He is now using crutches instead of his wheelchair.  However, he and some of his friends at school have been racing their wheelchairs for fun.  Plans are in progress for him to see an orthopedic surgeon for possible intervention. Teachers say that Kennedy interacts well with others and is known to be a very good story teller.  \\r\\nAlthough Kennedy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents make very little from their small plot of farmland, they supply him with the essentials he needs for boarding school.  There was a time when many parents didn\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2t think it was important to contribute even these small things.  Any increase in support of a child with a disability by their family is a sign of acceptance and change in attitude.\\r\\nThank you for making so many things possible for Kennedy!\\r\\n\\r\\n\\r\\nKennedy is a boy who has had cerebral palsy since birth for unknown reasons. Both of his legs are impacted by this condition confining him to a wheelchair. With sponsorship, he may have the opportunity to get correctional surgery that will allow him at least to walk with braces on his legs.  He will also board at Gede Special School to receive primary education.  His parents farm their small plot of land to provide for their 8 children but they often go hungry.  Kennedy has no mental disability and would thrive with the proper education.  He recently began wheelchair racing and has gained confidence from it.\",\"en_level_hearing\":\"\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"\",\"en_distance_away\":\"\",\"en_house_state\":\"\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Marafa Special\",\"en_out_reach_app_cas\":\"5db77e81cdda436a81973b3346371a6c\",\"en_disability_type\":\"Cerebral Palsy (CP)\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"125\",\"en_cid\":\"KP9\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Kennedy",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/091fe95adf7127904f38ab1cfd506999.jpg",
    "donations": [],
    "entity": {
      "id": 47510,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Kennedy\",\"en_second_name\":\"\",\"en_last_name_1\":\"Kahindi\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"20\\/10\\/2004\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Kennedy was born with cerebral palsy that affects his lower body.  Both of his legs are impacted and he is confined to a wheelchair.  With sponsorship, Kennedy will board at Gede Special School and will have the chance to get surgery to decrease his reliance on a wheelchair.\",\"en_private_comments\":\"January 26, 2022\\r\\nKennedy has been exited from sponsorship because he dropped out of school and refuses to return.  He says he is too old for school.\\r\\n\\r\\nDecember 16, 2020\\r\\nKennedy is now 16 years old.  He had correctivesurgery on his right leg last year and was in the hospital for most of the year making him unable to attend school.  He was in 7th grade at Marafa Primary School.  \\r\\n\\r\\nKennedy is friendly and kind.  He socializes well with others. He enjoys spending time talking with his friends.  \\r\\n\\r\\nKuhenza staff members referred the family to the appropriate medical facility.  They also counselled Kennedy which has  increased his self esteem.\\r\\nJuly 29, 2020 (Quick Update)\\r\\nHe continues to study at Marafa Special School.\\r\\n11-16-2018\\r\\nKennedy is now 14 years old and a student at Marafa Primary School.  He is in a mainstream school but lives in the special school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s dormitory.  His grades are improving but he could do better if his parents brought him to school when the term begins.  When he completes his education he would like to be a motor vehicle engineer.\\r\\n\\r\\nKennedy does not interact with the other children at school.  His teachers assume it is because he is in a mainstream school and is self-conscious about his very visible disability.  The school plans to offer counseling services to help  him be more social.\\r\\n\\r\\nKennedy participates in sitting volleyball and wheelchair races.  He competed at the regional level and was awarded certificates.  He also enjoys watching films, playing darts, and playing cards.\\r\\n\\r\\nHis parents have separated  but both continue to provide for Kennedy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s basic needs.  Both of them want Kennedy to get an education.\\r\\n\\r\\nYour sponsorship has given Kennedy an education, a wheelchair, and counseling.  Thank you for your generosity\\r\\n3-20-2017\\r\\n\\tKenya is in the midst of one of its worst droughts in recent history.  This makes it difficult for parents to provide even food for their families.  Many children are lucky to receive one meal a day.  Kupenda recently delivered food staples to some remote villages that were particularly hit hard but even this is a short term fix.   This makes sponsorship even more important because along with academic and medical services our boarding students get three meals a day.\\r\\n       Kennedy is now a 13 year old young man attending Marafa Special School. His academics have been improving as he is now passing all of is subjects.  He has also learned to cooperate with teachers and other students.  He hopes to be a motor vehicle engineer when he finishes school.\\r\\n     He participates in sitting volleyball and Double Crutch races.  He interacts well with others as they play together.  He also enjoys African DJ music.  He is not allowing his disability to interfere with enjoying life.\\r\\n      Kennedy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are getting more involved in his education.  They can now see that their son, despite his disability, is now part of the school and progressing nicely. They even visit him at school and take him at school break.\\t\\r\\n       Kupenda sponsorship has made all of this possible for Kennedy.  He can now dream of a productive future.Thank you.\\t\\t\\t\\t\\t\\r\\n9-10-14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year.  In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nKennedy is now 11 years old and doing very well in third grade at the Marafa Special School.  As you can see from the photo, he is now using crutches to walk instead of his wheelchair and his legs are getting stronger every day.  Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s physical therapist visits his school once a week and his therapy sessions seem to be paying off.  We are currently working with a local organization to provide corrective surgery for his legs that could give him even more mobility.\\r\\nKennedy is the best student in his class with his highest grades in English and Math.  He also participated in the special school games at the county level.  He is well liked by all of his peers.  They are always playing creative games.  He also enjoys singing a lot.\\r\\nHis parents are very supportive of his education.  They are involved in parents meetings and functions at the school although they do not have the means to provide financially for their son.\\r\\nThank you for making a difference in Kennedy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life!  \\r\\n\\r\\n10-9-2013\\r\\nKennedy is now 10 years old and in the third grade at the Marafa Special School.  He is doing amazingly well in school.  He was ranked second in his class with almost all A\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s!  Weekly physical therapy with Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s physical therapist has helped him make some great progress physically.  He is now using crutches instead of his wheelchair.  However, he and some of his friends at school have been racing their wheelchairs for fun.  Plans are in progress for him to see an orthopedic surgeon for possible intervention. Teachers say that Kennedy interacts well with others and is known to be a very good story teller.  \\r\\nAlthough Kennedy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents make very little from their small plot of farmland, they supply him with the essentials he needs for boarding school.  There was a time when many parents didn\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2t think it was important to contribute even these small things.  Any increase in support of a child with a disability by their family is a sign of acceptance and change in attitude.\\r\\nThank you for making so many things possible for Kennedy!\\r\\n\\r\\n\\r\\nKennedy is a boy who has had cerebral palsy since birth for unknown reasons. Both of his legs are impacted by this condition confining him to a wheelchair. With sponsorship, he may have the opportunity to get correctional surgery that will allow him at least to walk with braces on his legs.  He will also board at Gede Special School to receive primary education.  His parents farm their small plot of land to provide for their 8 children but they often go hungry.  Kennedy has no mental disability and would thrive with the proper education.  He recently began wheelchair racing and has gained confidence from it.\",\"en_level_hearing\":\"\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"\",\"en_distance_away\":\"\",\"en_house_state\":\"\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Marafa Special\",\"en_out_reach_app_cas\":\"5db77e81cdda436a81973b3346371a6c\",\"en_disability_type\":\"Cerebral Palsy (CP)\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"125\",\"en_cid\":\"KP9\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/091fe95adf7127904f38ab1cfd506999_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Kennedy ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47509,
    "profile": {
      "en_first_name": "Baraka",
      "en_second_name": "",
      "en_last_name_1": "Kashuru",
      "en_last_name_2": "Nzovu",
      "en_gender": "Male",
      "en_date_of_birth": "23/12/1999",
      "en_mental_disability": "none",
      "en_public_comments": "Baraka is a thirteen year old boy who was born deaf.  Due to his parents\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2 economic struggles, he did not attend school until he was sponsored through Kupenda in 2009.  This sponsorship ceased in 2010 but Kupenda could not turn him away.  Baraka thrived during his year of sponsorship at the Marafa Hearing Impaired Unit.  He learned introductory English and sign language and has earned the respect of his family who previously had little faith in his abilities.  Baraka, now thirteen, is still enjoying school, especially his math classes.  He is known to light up a room and says that one of his favorite things to do is make new friends.",
      "en_private_comments": "August 1, 2022\r\nBaraka is now 22 years old and is in his final year at Pwani Secondary School for the Deaf. His performance is average.\r\nHis best subject is Kenyan Sign Language. He is a well-disciplined student.\r\n\r\nDue to his hearing loss, Baraka has no speech at all.  Since the last report he has been healthy and active with no fever or other illness.  His disability does not affect his health.\r\n\r\nBaraka is friendly and kind.  He spends time with other children,  He also likes to watch television and play team sports.  He is a member of the scout club and has competed in his school\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s football team.\r\n\r\nThe family does not rely on farming to make a living.  The father is a driver and is doing well. Occasionally, pandemic restrictions effect transportation which makes making a living driving difficult.\r\n\r\nYour support is allowing Baraka to get an education no matter his family income.  Thank you.\r\n\r\nJune 22, 2021\r\nBaraka is now 21 years old.  He is a sophomore at Pwani Secondary School for the Deaf.  He is an average student who is passing his exams.  He is good at Kenyan Sign Language.  He is a well-disciplined student.\r\n\r\nBaraka is friendly and kind.  He plays with his peers at school and at home.  He likes to play team sports such as football and track and field.  He is well behaved with no behavioral challenges.\r\n\r\n\r\nDuring the last 15 months schools in Kenya have been closed for 11 months.  While at home he has been helping his parents.  His father is a driver which has been challenging because of pandemic restriction.\r\n\r\nOur staff in Kenya have been counselling the family about how to protect themselves from the coronavirus, and doing frequent wellness checks,  Thank you for your support.\r\n\r\nSeptember 1, 2020\r\nBaraka is now 20 years old and a Sophomore at Pwani Secondary  School for the Deaf.  He is described as being a well-disciplined student. He did not sit for his examinations this year because the coronavirus pandemic caused schools in Kenya to be shut down in March and will not reopen again until 2021.\r\n\r\nBaraka is friendly, kind, and helpful to others.  He interacts well with children with disability and with those without disability.  He enjoys watching television, talking with his friends, and playing team sports.  He competes in running and football.  He is a very good footballer.  He enjoys being with his many friends.\r\n\r\nThe family has been receiving counselling sessions from Kupenda and from the school which has resulted in knowledge that helps them care for their son.  They were advised to take Baraka to the doctor after he complained of chest pain.  Baraka is now on medication.  The organization is providing food and soap on a monthly basis during the pandemic. \r\n\r\nYour support is helping Baraka to achieve his full potential, thank you.\r\n\r\nJuly 9, 2019\r\nBaraka is now 20 years old and  in form 1 at Pwani Secondary School for the Deaf.  After completing his primary school education and passing the examinations Baraka was accepted into Pwani secondary school for the Deaf.  He is doing well academically.  He is a well disciplined student.\r\n\r\n       Baraka is a friendly young man with friends at home and at school.  He plays football and competes in track events.  This year the intensity of secondary school has kept Baraka from competition.\r\n\r\n      His family love him and support his education by bringing him to school on time and providing for his basic needs. \r\n\r\n       Your support is paying for Baraka\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s boarding fees.  With this support Baraka is able to develop his academic and physical talents, obtain an education taught in sign language, and make new friends.  Thank you for your generosity.\r\n\r\nNovember 24, 2018\r\n      Baraka is now 18 years old and a student in 8th grade at Marafa special School.  He has been coming back to school early after holidays with the result of better grades.  His disability does not impact his learning except he needs additional time to do his school work.   He is also getting better asking questions to clarify subject matter her does not understand.  He does his homework in a timely manner and helps other to complete their work.  He would like to be a shopkeeper when he finishes school.\r\n      He is learning sign language and can understand it but sometimes uses gestures to communicate.  He has been healthy this past year.\r\n      Baraka interacts well with the other students.  He rarely sits alone as he is a good storyteller. He participates in ballgames such as football, volleyball,  runs short and long races and throws the javelin, discus, and shot put.  He has competed at the county level.  He also enjoys watching television, playing cards, and scrabbles.  \r\n      His family supports Baraka\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s education.  They provide his toiletries and transportation to school.  The family does not have a reliable source of income and the father is too old to work.  \r\n        Your sponsorship has given Baraka an opportunity to live at a boarding school, obtain a solid education, make friends, and develop his athletic skills.  Thank you for your generosity.\r\n\r\nAugust 30, 2017\r\n       In recent months the coast of Kenya has had some very needed rainfall.  The drought is now abating.  In August, Kenya had their elections which can be volatile times and this election was no exception. However, all Kupenda students, teachers, and staff were safe.\r\n       There are many things happening with Kupenda right now that are very exciting.   A large track of land in a remote area was given to Kupenda with plans to build another special needs school.  Parent workshops are resulting in many new students needing services.  These kids will finally have an opportunity to develop their full potential.  A special thank you to all Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s sponsors, you have had a big part in making this happen.\r\n      Baraka is a 17 year old young man in class 7 at Marafa Special School.  As he progresses in grade level the subjects become more abstract.  It is difficult for the teachers to sign abstract and difficult for the students to understand.  His behavior is sadly reflecting his adolescence stage.  He needs to work harder.   He needs to engage in group discussions and revision to improve his performance.  He does follow instructions given to him, completes his assignments and hands them in for marking at the right time.  He would like to be a businessman when he completes his education.\r\n      Baraka is a friendly young man and makes friends easily.  He competes in track, football and volleyball.  This past year he competed at the regional level.  He also enjoys watching TV and playing card games.\r\n     His family is cooperative and participate in all school activities.  They also include Baraka in all family activities.  They send him to school early when the school term begins.   They have taught him to be well disciplined and responsible. \r\n      Thank you for your sponsorship.  Baraka is achieving and being part of a community.  With a little more work Baraka should be able to achieve his dream of being a businessman.\r\n\r\n\r\n11-4-2016\r\nExciting things are happening for disabled children in Kenya and Tanzania.  More and more people are being educated about disabilities and are taking ownership of these children in their communities.  Cynthia and Leonard have been travelling to remote locations and conducting workshops for government leaders, pastors, parents, and natural healers. Thousands of children are being impacted in a positive way.  As a result the government of Kenya is building a couple of model classrooms at Gede school that will be used to model instruction for children with disabilities.\r\n\r\n Big news is that a couple of Los Angeles based film makers are making a full feature film about the Kupenda story.  Some of the final filming was done in Kenya and New England this fall.  Hopefully the film will come to an area near you.\r\n\r\nBaraka is soon to be a 17 year old young man at Marafa Special School.  (His birthday is December 23)  He can now communicate fluently using sign language.  This has had a positive impact on his academics as he is now doing very well in his subjects.  He would like to be a teacher when he finishes his education.\r\n\r\nHe has good leadership skills and has been chosen to be a school prefect.  He interacts well with others which aids him in his leadership role.\r\n\r\nBaraka\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s family life has remained about the same.  His parents have yet to earn sign language so they can only communicate with gestures.  They do make sure he is  at school on time, pick him up at the end of the term and visit him while at school.  He is able to help them with many household chores.\r\n\r\n9-12-14\r\n\r\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year. In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\r\n\r\nBaraka is now 15 years old and in the third grade at the Marafa Special School.  According to his teachers he is perfect in sign language.  His grades are so high that he is ranked number one in his class.  He really enjoys his schoolwork which is likely the reason he wants to be a teacher one day.  He is always telling stories with other students and teachers.  He even gathers other students to help clean the school compound.  \r\n\r\nBaraka\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents are very appreciative of your support.  They are members of the Parent Teacher Association (PTA) and contribute what they can.  We are hopeful that Baraka\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents will participate in the Kupenda sponsored parent sign language workshops being offered three times a year at no cost to the parents.  Those participating in the workshops have not only learned sign language but are teaching it to other members of their family and community.\r\n\r\nThank you for making a difference in Baraka\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s life!\r\n--------------------\r\n(Uploaded on 15th August 2013) Baraka Kashuru is now 14 years old and he enjoys being a student at Marafa Special School. He is now in grade 3 and he has shown a great improvement in his studies. His favorite subject is Science, and received an A this past examination! He also continues to enjoy athletics and dancing. Baraka's teachers encourage these activities and believe he may have quite the dancing talent in the future. As you know, your sponsorship enables Baraka to have three meals a day at school and also provides him with hygienic resources including water to bathe and wash his clothes. While these may not seem like big things, they are incredibly important to his health and development. We are also excited to report that this year Baraka has shown improvement in his class work. His social life is amazing, especially considering the situation he came from, and he is a good team player both at school and home. Baraka's parents are very supportive and frequently visit him while at school. They also provide him with toiletries when they are able. Thank for your support of Baraka.  It has changed his life! Thank you and May God bless you abundantly.  (uploaded on 15th August,2013)",
      "en_level_hearing": "none",
      "en_hearing_test": "Yes",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "no speech",
      "en_lip_read": "No",
      "en_needs_met": "Yes",
      "en_treated_before": "With sympathy",
      "en_family_communicat": "through gestures",
      "en_school": "marafa special school.",
      "en_class_level": "class 3",
      "en_family_details": "both parents",
      "en_father_name": "KASHURU NZOVU",
      "en_fathers_occupatio": "Peasant farmer",
      "en_mothers_name": "Mapenzi Kiponda",
      "en_mothers_occupatio": "Fortune teller",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "1",
      "en_number_of_sisters": "2",
      "en_willingness_of_pa": "willing few resources",
      "en_situation_explain": "Daily needs are met with difficulties",
      "en_house_location": "Kambi ya waya marafa",
      "en_distance_away": "30 km",
      "en_house_state": "mud/makuti",
      "en_why_need_sponsors": "Boarding fees",
      "en_total_needed": "11",
      "en_other_needs": "school uniforms",
      "en_languages": "sign",
      "en_religion": "Christian",
      "en_church_name": "PEFA kambi ya waya",
      "en_favorite_activity": "Athletics\r\nDancing\r\nDrama",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Pwani Secondary school for the Deaf",
      "en_out_reach_app_cas": "288ae4bb-58b9-4de3-b1ca-29c01e8baff0",
      "en_disability_type": "Hearing Impairment",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "123",
      "en_cid": "KP8",
      "id": 47509,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Baraka\",\"en_second_name\":\"\",\"en_last_name_1\":\"Kashuru\",\"en_last_name_2\":\"Nzovu\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"23\\/12\\/1999\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Baraka is a thirteen year old boy who was born deaf.  Due to his parents\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2 economic struggles, he did not attend school until he was sponsored through Kupenda in 2009.  This sponsorship ceased in 2010 but Kupenda could not turn him away.  Baraka thrived during his year of sponsorship at the Marafa Hearing Impaired Unit.  He learned introductory English and sign language and has earned the respect of his family who previously had little faith in his abilities.  Baraka, now thirteen, is still enjoying school, especially his math classes.  He is known to light up a room and says that one of his favorite things to do is make new friends.\",\"en_private_comments\":\"August 1, 2022\\r\\nBaraka is now 22 years old and is in his final year at Pwani Secondary School for the Deaf. His performance is average.\\r\\nHis best subject is Kenyan Sign Language. He is a well-disciplined student.\\r\\n\\r\\nDue to his hearing loss, Baraka has no speech at all.  Since the last report he has been healthy and active with no fever or other illness.  His disability does not affect his health.\\r\\n\\r\\nBaraka is friendly and kind.  He spends time with other children,  He also likes to watch television and play team sports.  He is a member of the scout club and has competed in his school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s football team.\\r\\n\\r\\nThe family does not rely on farming to make a living.  The father is a driver and is doing well. Occasionally, pandemic restrictions effect transportation which makes making a living driving difficult.\\r\\n\\r\\nYour support is allowing Baraka to get an education no matter his family income.  Thank you.\\r\\n\\r\\nJune 22, 2021\\r\\nBaraka is now 21 years old.  He is a sophomore at Pwani Secondary School for the Deaf.  He is an average student who is passing his exams.  He is good at Kenyan Sign Language.  He is a well-disciplined student.\\r\\n\\r\\nBaraka is friendly and kind.  He plays with his peers at school and at home.  He likes to play team sports such as football and track and field.  He is well behaved with no behavioral challenges.\\r\\n\\r\\n\\r\\nDuring the last 15 months schools in Kenya have been closed for 11 months.  While at home he has been helping his parents.  His father is a driver which has been challenging because of pandemic restriction.\\r\\n\\r\\nOur staff in Kenya have been counselling the family about how to protect themselves from the coronavirus, and doing frequent wellness checks,  Thank you for your support.\\r\\n\\r\\nSeptember 1, 2020\\r\\nBaraka is now 20 years old and a Sophomore at Pwani Secondary  School for the Deaf.  He is described as being a well-disciplined student. He did not sit for his examinations this year because the coronavirus pandemic caused schools in Kenya to be shut down in March and will not reopen again until 2021.\\r\\n\\r\\nBaraka is friendly, kind, and helpful to others.  He interacts well with children with disability and with those without disability.  He enjoys watching television, talking with his friends, and playing team sports.  He competes in running and football.  He is a very good footballer.  He enjoys being with his many friends.\\r\\n\\r\\nThe family has been receiving counselling sessions from Kupenda and from the school which has resulted in knowledge that helps them care for their son.  They were advised to take Baraka to the doctor after he complained of chest pain.  Baraka is now on medication.  The organization is providing food and soap on a monthly basis during the pandemic. \\r\\n\\r\\nYour support is helping Baraka to achieve his full potential, thank you.\\r\\n\\r\\nJuly 9, 2019\\r\\nBaraka is now 20 years old and  in form 1 at Pwani Secondary School for the Deaf.  After completing his primary school education and passing the examinations Baraka was accepted into Pwani secondary school for the Deaf.  He is doing well academically.  He is a well disciplined student.\\r\\n\\r\\n       Baraka is a friendly young man with friends at home and at school.  He plays football and competes in track events.  This year the intensity of secondary school has kept Baraka from competition.\\r\\n\\r\\n      His family love him and support his education by bringing him to school on time and providing for his basic needs. \\r\\n\\r\\n       Your support is paying for Baraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s boarding fees.  With this support Baraka is able to develop his academic and physical talents, obtain an education taught in sign language, and make new friends.  Thank you for your generosity.\\r\\n\\r\\nNovember 24, 2018\\r\\n      Baraka is now 18 years old and a student in 8th grade at Marafa special School.  He has been coming back to school early after holidays with the result of better grades.  His disability does not impact his learning except he needs additional time to do his school work.   He is also getting better asking questions to clarify subject matter her does not understand.  He does his homework in a timely manner and helps other to complete their work.  He would like to be a shopkeeper when he finishes school.\\r\\n      He is learning sign language and can understand it but sometimes uses gestures to communicate.  He has been healthy this past year.\\r\\n      Baraka interacts well with the other students.  He rarely sits alone as he is a good storyteller. He participates in ballgames such as football, volleyball,  runs short and long races and throws the javelin, discus, and shot put.  He has competed at the county level.  He also enjoys watching television, playing cards, and scrabbles.  \\r\\n      His family supports Baraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education.  They provide his toiletries and transportation to school.  The family does not have a reliable source of income and the father is too old to work.  \\r\\n        Your sponsorship has given Baraka an opportunity to live at a boarding school, obtain a solid education, make friends, and develop his athletic skills.  Thank you for your generosity.\\r\\n\\r\\nAugust 30, 2017\\r\\n       In recent months the coast of Kenya has had some very needed rainfall.  The drought is now abating.  In August, Kenya had their elections which can be volatile times and this election was no exception. However, all Kupenda students, teachers, and staff were safe.\\r\\n       There are many things happening with Kupenda right now that are very exciting.   A large track of land in a remote area was given to Kupenda with plans to build another special needs school.  Parent workshops are resulting in many new students needing services.  These kids will finally have an opportunity to develop their full potential.  A special thank you to all Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s sponsors, you have had a big part in making this happen.\\r\\n      Baraka is a 17 year old young man in class 7 at Marafa Special School.  As he progresses in grade level the subjects become more abstract.  It is difficult for the teachers to sign abstract and difficult for the students to understand.  His behavior is sadly reflecting his adolescence stage.  He needs to work harder.   He needs to engage in group discussions and revision to improve his performance.  He does follow instructions given to him, completes his assignments and hands them in for marking at the right time.  He would like to be a businessman when he completes his education.\\r\\n      Baraka is a friendly young man and makes friends easily.  He competes in track, football and volleyball.  This past year he competed at the regional level.  He also enjoys watching TV and playing card games.\\r\\n     His family is cooperative and participate in all school activities.  They also include Baraka in all family activities.  They send him to school early when the school term begins.   They have taught him to be well disciplined and responsible. \\r\\n      Thank you for your sponsorship.  Baraka is achieving and being part of a community.  With a little more work Baraka should be able to achieve his dream of being a businessman.\\r\\n\\r\\n\\r\\n11-4-2016\\r\\nExciting things are happening for disabled children in Kenya and Tanzania.  More and more people are being educated about disabilities and are taking ownership of these children in their communities.  Cynthia and Leonard have been travelling to remote locations and conducting workshops for government leaders, pastors, parents, and natural healers. Thousands of children are being impacted in a positive way.  As a result the government of Kenya is building a couple of model classrooms at Gede school that will be used to model instruction for children with disabilities.\\r\\n\\r\\n Big news is that a couple of Los Angeles based film makers are making a full feature film about the Kupenda story.  Some of the final filming was done in Kenya and New England this fall.  Hopefully the film will come to an area near you.\\r\\n\\r\\nBaraka is soon to be a 17 year old young man at Marafa Special School.  (His birthday is December 23)  He can now communicate fluently using sign language.  This has had a positive impact on his academics as he is now doing very well in his subjects.  He would like to be a teacher when he finishes his education.\\r\\n\\r\\nHe has good leadership skills and has been chosen to be a school prefect.  He interacts well with others which aids him in his leadership role.\\r\\n\\r\\nBaraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family life has remained about the same.  His parents have yet to earn sign language so they can only communicate with gestures.  They do make sure he is  at school on time, pick him up at the end of the term and visit him while at school.  He is able to help them with many household chores.\\r\\n\\r\\n9-12-14\\r\\n\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year. In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\n\\r\\nBaraka is now 15 years old and in the third grade at the Marafa Special School.  According to his teachers he is perfect in sign language.  His grades are so high that he is ranked number one in his class.  He really enjoys his schoolwork which is likely the reason he wants to be a teacher one day.  He is always telling stories with other students and teachers.  He even gathers other students to help clean the school compound.  \\r\\n\\r\\nBaraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are very appreciative of your support.  They are members of the Parent Teacher Association (PTA) and contribute what they can.  We are hopeful that Baraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents will participate in the Kupenda sponsored parent sign language workshops being offered three times a year at no cost to the parents.  Those participating in the workshops have not only learned sign language but are teaching it to other members of their family and community.\\r\\n\\r\\nThank you for making a difference in Baraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life!\\r\\n--------------------\\r\\n(Uploaded on 15th August 2013) Baraka Kashuru is now 14 years old and he enjoys being a student at Marafa Special School. He is now in grade 3 and he has shown a great improvement in his studies. His favorite subject is Science, and received an A this past examination! He also continues to enjoy athletics and dancing. Baraka's teachers encourage these activities and believe he may have quite the dancing talent in the future. As you know, your sponsorship enables Baraka to have three meals a day at school and also provides him with hygienic resources including water to bathe and wash his clothes. While these may not seem like big things, they are incredibly important to his health and development. We are also excited to report that this year Baraka has shown improvement in his class work. His social life is amazing, especially considering the situation he came from, and he is a good team player both at school and home. Baraka's parents are very supportive and frequently visit him while at school. They also provide him with toiletries when they are able. Thank for your support of Baraka.  It has changed his life! Thank you and May God bless you abundantly.  (uploaded on 15th August,2013)\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Yes\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"no speech\",\"en_lip_read\":\"No\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"With sympathy\",\"en_family_communicat\":\"through gestures\",\"en_school\":\"marafa special school.\",\"en_class_level\":\"class 3\",\"en_family_details\":\"both parents\",\"en_father_name\":\"KASHURU NZOVU\",\"en_fathers_occupatio\":\"Peasant farmer\",\"en_mothers_name\":\"Mapenzi Kiponda\",\"en_mothers_occupatio\":\"Fortune teller\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"1\",\"en_number_of_sisters\":\"2\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"Daily needs are met with difficulties\",\"en_house_location\":\"Kambi ya waya marafa\",\"en_distance_away\":\"30 km\",\"en_house_state\":\"mud\\/makuti\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"11\",\"en_other_needs\":\"school uniforms\",\"en_languages\":\"sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"PEFA kambi ya waya\",\"en_favorite_activity\":\"Athletics\\r\\nDancing\\r\\nDrama\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Pwani Secondary school for the Deaf\",\"en_out_reach_app_cas\":\"288ae4bb-58b9-4de3-b1ca-29c01e8baff0\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"123\",\"en_cid\":\"KP8\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Baraka",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/1f86238d71e895c0d63bfbb201c2623e.jpg",
    "donations": [],
    "entity": {
      "id": 47509,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Baraka\",\"en_second_name\":\"\",\"en_last_name_1\":\"Kashuru\",\"en_last_name_2\":\"Nzovu\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"23\\/12\\/1999\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Baraka is a thirteen year old boy who was born deaf.  Due to his parents\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2 economic struggles, he did not attend school until he was sponsored through Kupenda in 2009.  This sponsorship ceased in 2010 but Kupenda could not turn him away.  Baraka thrived during his year of sponsorship at the Marafa Hearing Impaired Unit.  He learned introductory English and sign language and has earned the respect of his family who previously had little faith in his abilities.  Baraka, now thirteen, is still enjoying school, especially his math classes.  He is known to light up a room and says that one of his favorite things to do is make new friends.\",\"en_private_comments\":\"August 1, 2022\\r\\nBaraka is now 22 years old and is in his final year at Pwani Secondary School for the Deaf. His performance is average.\\r\\nHis best subject is Kenyan Sign Language. He is a well-disciplined student.\\r\\n\\r\\nDue to his hearing loss, Baraka has no speech at all.  Since the last report he has been healthy and active with no fever or other illness.  His disability does not affect his health.\\r\\n\\r\\nBaraka is friendly and kind.  He spends time with other children,  He also likes to watch television and play team sports.  He is a member of the scout club and has competed in his school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s football team.\\r\\n\\r\\nThe family does not rely on farming to make a living.  The father is a driver and is doing well. Occasionally, pandemic restrictions effect transportation which makes making a living driving difficult.\\r\\n\\r\\nYour support is allowing Baraka to get an education no matter his family income.  Thank you.\\r\\n\\r\\nJune 22, 2021\\r\\nBaraka is now 21 years old.  He is a sophomore at Pwani Secondary School for the Deaf.  He is an average student who is passing his exams.  He is good at Kenyan Sign Language.  He is a well-disciplined student.\\r\\n\\r\\nBaraka is friendly and kind.  He plays with his peers at school and at home.  He likes to play team sports such as football and track and field.  He is well behaved with no behavioral challenges.\\r\\n\\r\\n\\r\\nDuring the last 15 months schools in Kenya have been closed for 11 months.  While at home he has been helping his parents.  His father is a driver which has been challenging because of pandemic restriction.\\r\\n\\r\\nOur staff in Kenya have been counselling the family about how to protect themselves from the coronavirus, and doing frequent wellness checks,  Thank you for your support.\\r\\n\\r\\nSeptember 1, 2020\\r\\nBaraka is now 20 years old and a Sophomore at Pwani Secondary  School for the Deaf.  He is described as being a well-disciplined student. He did not sit for his examinations this year because the coronavirus pandemic caused schools in Kenya to be shut down in March and will not reopen again until 2021.\\r\\n\\r\\nBaraka is friendly, kind, and helpful to others.  He interacts well with children with disability and with those without disability.  He enjoys watching television, talking with his friends, and playing team sports.  He competes in running and football.  He is a very good footballer.  He enjoys being with his many friends.\\r\\n\\r\\nThe family has been receiving counselling sessions from Kupenda and from the school which has resulted in knowledge that helps them care for their son.  They were advised to take Baraka to the doctor after he complained of chest pain.  Baraka is now on medication.  The organization is providing food and soap on a monthly basis during the pandemic. \\r\\n\\r\\nYour support is helping Baraka to achieve his full potential, thank you.\\r\\n\\r\\nJuly 9, 2019\\r\\nBaraka is now 20 years old and  in form 1 at Pwani Secondary School for the Deaf.  After completing his primary school education and passing the examinations Baraka was accepted into Pwani secondary school for the Deaf.  He is doing well academically.  He is a well disciplined student.\\r\\n\\r\\n       Baraka is a friendly young man with friends at home and at school.  He plays football and competes in track events.  This year the intensity of secondary school has kept Baraka from competition.\\r\\n\\r\\n      His family love him and support his education by bringing him to school on time and providing for his basic needs. \\r\\n\\r\\n       Your support is paying for Baraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s boarding fees.  With this support Baraka is able to develop his academic and physical talents, obtain an education taught in sign language, and make new friends.  Thank you for your generosity.\\r\\n\\r\\nNovember 24, 2018\\r\\n      Baraka is now 18 years old and a student in 8th grade at Marafa special School.  He has been coming back to school early after holidays with the result of better grades.  His disability does not impact his learning except he needs additional time to do his school work.   He is also getting better asking questions to clarify subject matter her does not understand.  He does his homework in a timely manner and helps other to complete their work.  He would like to be a shopkeeper when he finishes school.\\r\\n      He is learning sign language and can understand it but sometimes uses gestures to communicate.  He has been healthy this past year.\\r\\n      Baraka interacts well with the other students.  He rarely sits alone as he is a good storyteller. He participates in ballgames such as football, volleyball,  runs short and long races and throws the javelin, discus, and shot put.  He has competed at the county level.  He also enjoys watching television, playing cards, and scrabbles.  \\r\\n      His family supports Baraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education.  They provide his toiletries and transportation to school.  The family does not have a reliable source of income and the father is too old to work.  \\r\\n        Your sponsorship has given Baraka an opportunity to live at a boarding school, obtain a solid education, make friends, and develop his athletic skills.  Thank you for your generosity.\\r\\n\\r\\nAugust 30, 2017\\r\\n       In recent months the coast of Kenya has had some very needed rainfall.  The drought is now abating.  In August, Kenya had their elections which can be volatile times and this election was no exception. However, all Kupenda students, teachers, and staff were safe.\\r\\n       There are many things happening with Kupenda right now that are very exciting.   A large track of land in a remote area was given to Kupenda with plans to build another special needs school.  Parent workshops are resulting in many new students needing services.  These kids will finally have an opportunity to develop their full potential.  A special thank you to all Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s sponsors, you have had a big part in making this happen.\\r\\n      Baraka is a 17 year old young man in class 7 at Marafa Special School.  As he progresses in grade level the subjects become more abstract.  It is difficult for the teachers to sign abstract and difficult for the students to understand.  His behavior is sadly reflecting his adolescence stage.  He needs to work harder.   He needs to engage in group discussions and revision to improve his performance.  He does follow instructions given to him, completes his assignments and hands them in for marking at the right time.  He would like to be a businessman when he completes his education.\\r\\n      Baraka is a friendly young man and makes friends easily.  He competes in track, football and volleyball.  This past year he competed at the regional level.  He also enjoys watching TV and playing card games.\\r\\n     His family is cooperative and participate in all school activities.  They also include Baraka in all family activities.  They send him to school early when the school term begins.   They have taught him to be well disciplined and responsible. \\r\\n      Thank you for your sponsorship.  Baraka is achieving and being part of a community.  With a little more work Baraka should be able to achieve his dream of being a businessman.\\r\\n\\r\\n\\r\\n11-4-2016\\r\\nExciting things are happening for disabled children in Kenya and Tanzania.  More and more people are being educated about disabilities and are taking ownership of these children in their communities.  Cynthia and Leonard have been travelling to remote locations and conducting workshops for government leaders, pastors, parents, and natural healers. Thousands of children are being impacted in a positive way.  As a result the government of Kenya is building a couple of model classrooms at Gede school that will be used to model instruction for children with disabilities.\\r\\n\\r\\n Big news is that a couple of Los Angeles based film makers are making a full feature film about the Kupenda story.  Some of the final filming was done in Kenya and New England this fall.  Hopefully the film will come to an area near you.\\r\\n\\r\\nBaraka is soon to be a 17 year old young man at Marafa Special School.  (His birthday is December 23)  He can now communicate fluently using sign language.  This has had a positive impact on his academics as he is now doing very well in his subjects.  He would like to be a teacher when he finishes his education.\\r\\n\\r\\nHe has good leadership skills and has been chosen to be a school prefect.  He interacts well with others which aids him in his leadership role.\\r\\n\\r\\nBaraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family life has remained about the same.  His parents have yet to earn sign language so they can only communicate with gestures.  They do make sure he is  at school on time, pick him up at the end of the term and visit him while at school.  He is able to help them with many household chores.\\r\\n\\r\\n9-12-14\\r\\n\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year. In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\n\\r\\nBaraka is now 15 years old and in the third grade at the Marafa Special School.  According to his teachers he is perfect in sign language.  His grades are so high that he is ranked number one in his class.  He really enjoys his schoolwork which is likely the reason he wants to be a teacher one day.  He is always telling stories with other students and teachers.  He even gathers other students to help clean the school compound.  \\r\\n\\r\\nBaraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are very appreciative of your support.  They are members of the Parent Teacher Association (PTA) and contribute what they can.  We are hopeful that Baraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents will participate in the Kupenda sponsored parent sign language workshops being offered three times a year at no cost to the parents.  Those participating in the workshops have not only learned sign language but are teaching it to other members of their family and community.\\r\\n\\r\\nThank you for making a difference in Baraka\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life!\\r\\n--------------------\\r\\n(Uploaded on 15th August 2013) Baraka Kashuru is now 14 years old and he enjoys being a student at Marafa Special School. He is now in grade 3 and he has shown a great improvement in his studies. His favorite subject is Science, and received an A this past examination! He also continues to enjoy athletics and dancing. Baraka's teachers encourage these activities and believe he may have quite the dancing talent in the future. As you know, your sponsorship enables Baraka to have three meals a day at school and also provides him with hygienic resources including water to bathe and wash his clothes. While these may not seem like big things, they are incredibly important to his health and development. We are also excited to report that this year Baraka has shown improvement in his class work. His social life is amazing, especially considering the situation he came from, and he is a good team player both at school and home. Baraka's parents are very supportive and frequently visit him while at school. They also provide him with toiletries when they are able. Thank for your support of Baraka.  It has changed his life! Thank you and May God bless you abundantly.  (uploaded on 15th August,2013)\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Yes\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"no speech\",\"en_lip_read\":\"No\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"With sympathy\",\"en_family_communicat\":\"through gestures\",\"en_school\":\"marafa special school.\",\"en_class_level\":\"class 3\",\"en_family_details\":\"both parents\",\"en_father_name\":\"KASHURU NZOVU\",\"en_fathers_occupatio\":\"Peasant farmer\",\"en_mothers_name\":\"Mapenzi Kiponda\",\"en_mothers_occupatio\":\"Fortune teller\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"1\",\"en_number_of_sisters\":\"2\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"Daily needs are met with difficulties\",\"en_house_location\":\"Kambi ya waya marafa\",\"en_distance_away\":\"30 km\",\"en_house_state\":\"mud\\/makuti\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"11\",\"en_other_needs\":\"school uniforms\",\"en_languages\":\"sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"PEFA kambi ya waya\",\"en_favorite_activity\":\"Athletics\\r\\nDancing\\r\\nDrama\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Pwani Secondary school for the Deaf\",\"en_out_reach_app_cas\":\"288ae4bb-58b9-4de3-b1ca-29c01e8baff0\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"123\",\"en_cid\":\"KP8\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/1f86238d71e895c0d63bfbb201c2623e_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Baraka ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47508,
    "profile": {
      "en_first_name": "Amina",
      "en_second_name": "Nyundo",
      "en_last_name_1": "Chengo",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "0000-00-00",
      "en_mental_disability": "none",
      "en_public_comments": "Amina is a young girl who is partially deaf. She is only able to hear loud noises that are close to her. Amina\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s mother passed away during childbirth, and she now lives with an unemployed aunt who cannot support her. She loves to play with toys, paint, and draw. With sponsorship, Amina will be able to board at the Gede Special School and attend classes that fit her needs.",
      "en_private_comments": "December 6, 2022\r\n\r\nJanAmina finished her primary education and is now \r\nattending Gede Vocational Centre. She began school by \r\nstudying beauty therapy, but it required too much time on \r\nher feet. Her legs were too weak to stand long enough to \r\nplait someone\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s hair. She changed majors and is now \r\nstudying tailoring which she loves.\r\nAmina has only minor speech problems but uses sign \r\nlanguage for most of her communication needs. She has \r\nhearing aids but does not use them. She can lip read. She \r\nhas had a healthy year with no fevers or other illnesses.\r\nAmina is friendly, kind, and helpful to others. She \r\ninteracts with others well and has many friends at home \r\nand at school. She is a member of the games club at \r\nschool. She also enjoys watching television, talking with \r\nfriends, and playing team sports.\r\nHer caregiver says, \u00c3\u00a2\u00e2\u0082\u00ac\u00c5\u0093I feel good that I was able to enroll my \r\nchild at Gede Vocational. Since she joined, I can see some \r\nprogress.\u00c3\u00a2\u00e2\u0082\u00ac\u00c2\u009d\r\nHer family sells vegetables for their livelihood. Due to \r\ninflation in Kenya it is difficult for the family to make a \r\nprofit\r\nJanuary 7, 2022\r\nAmina finished her primary education.  Kupenda is working with the family to get an appropriate placement for Amina at either a secondary school or vocational training.  It is hoped that she will be enrolled by this semester.\r\n\r\nAmina can hear some sounds but has trouble distinguishing voices.  She has hearing aids but does not use them.  If she looks directly at the speaker and is close, she can understand what is said.  At least one of her parents is fluent in sign language.  She can speak but is not understandable.\r\n\r\nAmina is friendly and kind.  She has many friends at home whom they do chores together.  She is a good ball player.  She also enjoys watching television, talking with friends, playing team sports, singing, and dancing.\r\n\r\nThe mother lost her job as household help last year during the pandemic, but the family received food relief from Kupenda during that time.  The mother is able to work 4 days a month but is unable to secure more days.  The ongoing drought caused the family farm to be less productive.\r\n\r\nThanks to your support Amina is doing well and has a bright future.\r\n\r\nNovember 17, 2020\r\nAmina is nearing the end of her primary school education at Gede Special School.  She continues to struggle academically.  She has some learning difficulties and tends to forget some concepts.  In March, all schools in Kenya were closed due to the coronavirus pandemic.  They plan to reopen in 2021 but all class 8 and form 4 candidates have been given permission to return to school.  So Amina will be  able to take her examinations to qualify for secondary school admission.\r\n\r\nAmina is friendly, kind, and helpful to others.  She is caring and friendly.  She enjoys serving food to those children in wheelchairs during lunch breaks.  She enjoys watching television, reading, talking with friends, and playing team sports.  She is especially good in leg ball.  She is a member of Rights of Child Club.  She competes in volleyball, netball, and running at the county level.  She likes to play with her peers and has many friends.\r\n\r\nKupenda counselling sessions with the parents has empowered them with knowledge of the rights of their child.  As a result they are supporting their daughter\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s preparation for the national examinations so that she can join a secondary school next year.  Kupenda is also supporting the family during the pandemic.  Thank you for supporting Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s efforts.\r\n\r\nOctober 7, 2019\r\nAmina is currently in 7th grade at Gede Special School.  She has learning difficulties which make her slow to master some of the concepts in school.  She is experiencing some memory issues and forgets what the teacher has taught.\r\n\r\nAt school Amina is a member of the ROC club (Rights of Children).  She is also involved in guidance and counselling sessions which are helping her to cope with her disability.\r\n\r\nAmina enjoys being with others and seeks them out during her free time.  She enjoys playing table games and watching television with her friends.  She competes in volleyball and football and competed at the regionals this year.\r\n\r\nOnce again, the family farm had environmental problems.  The area had problems with insect infestation resulting in no stable income for the family.  The family love Amina and include her in all family activities.  They are learning sign-language so they can better communicate with her.\r\n\r\nYour support is providing Amina with a boarding school education where she receives instruction in sign language.  At school she has opportunities to learn, have three meals a day, meet new friends, and participate in athletics.  Thank you for your generosity.\r\n\r\nMarch 27, 2019\r\nAmina is in seventh grade at Gede Special School.  There has been a slight improvement in her grades.  Her hearing impairment is accompanied by other learning difficulties which affect her ability to do her school work.  She is unable to understand concepts at the level of her peers.  It has been determined that she has a mild cerebral palsy condition which is also impacting her walking.\r\n      Amina is friendly and makes friends easily.  She is helpful at school by pushing those in wheelchairs and watering plants.  She likes to watch and participate in ball games but is limited by her walking disability.  She enjoys playing with friends and watching television.  \r\n    Her family is very supportive of Amina.  They bring her to school on time, attend school activities, visit her at school, and provide her basic needs.\r\n      Your sponsorship is providing Amina with sign language instruction, counseling, boarding fees, and access to church. Her boarding fees enable her to access education and medical intervention when she is sick.  She is able to live in a conducive environment getting educated by the use of sign language and living in a community where she has no communication barriers.  Thank you for your generosity.\r\n\r\nJanuary 10, 2019\r\n     Amina is now in level six at Gede Special School.  She is struggling academically especially after long holiday breaks.  Her parents are unable to assist their daughter in her learning as they can not communicate with her.  She does much better in her pre-vocational classes.\r\n     The school staff are considering classifying Amina as physically handicapped as well as hearing impaired.  She walks with a gait and her legs are very weak. She could benefit from physical therapy.  She has been healthy this year with no major illness.\r\n     Amina is a friendly and helpful young lady. She helps  the other children at school.  She participates in Netball and competed at the sub-county level this year.  She also enjoys watching movies and story-telling.\r\n     Her family love Amina very much and want what is best for her.  They are active in parent groups and  provide basic toiletries.  It would be helpful for them to learn sign language.\r\n      Your sponsorship is providing Amina an education, a place to live, a way to communicate, and medical attention.  Thank you for your generosity.\r\n\r\nJuly 20, 2017\r\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \r\n       Amini is a student at Gede Special School.  Her dual disabilities of hearing impairment and mental challenges have made learning difficult and progress slow.  Her behavior is improving as she watches the other students and tries to copy them.  She has moved on to the next level this year.  She would like to work in a salon plaiting customers hair.\r\n       Amina is friendly and makes friends easily.  She has a younger friend that she takes care of.  She makes sure she is neat and has been fed. Amina enjoys watching TV programs.\r\n         Amina\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s mother disowned her daughter at first claiming she was her sister\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s child.  She has now accepted Amina as her own child. Her mother is now very involved in Amina\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s education and attends meetings and activities at the school.  \r\n     Amina is struggling with her academics.  She does not perform as well as the other children who are much younger.  This makes her very uncomfortable.  The school is planning on a pre-vocational program where children will be taught skills that will empower them.  Amina would benefit from such a class as she has talents plaiting hair.\r\n     Thank you for your sponsorship which has given Amina the ability to communicate and a chance to support herself with a trade.\r\n\r\n(6 October 2014)\r\n\r\nThis past year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya.  This is something the children look forward to each year. In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\r\n\r\nAmina is in Primary Class 2 at the Gede Special School.  She was unfortunately not able to progress to be in Class 3, due to foundational challenges of her earlier education.  She has improved on her academic performance from last year, with English and Kiswahili being her best subjects.  She has mastered basic sign language and continues to develop her communication skills.  She can hear if the person speaking is very close to her.  \r\n\r\nShe enjoys athletics, dancing, music and movies.  Amina likes helping others and you will always find her in a group of other children.  She wants to be a teacher, so we are hopeful that she will be building a stronger foundation in her studies this year, to be able to keep moving forward in school.\r\n\r\nAmina\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s grandmother serves as her guardian and is very supportive of her education.  As a peasant farmer, she earns very little, but contributes what she can to Amina\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s school supplies (including toiletries and her uniform), and to the PTA.  At home, Amina likes to help with household chores such as cooking, fetching water, tending animals and also helping to look after younger siblings.\r\n\r\nThanks for making a difference in Amina\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s life.\r\n----------------------\r\n(2013)\r\nAmina is a very happy girl at the Gede Special School where she is now in Grade 3. She performs well in class and earned a B this year in her favorite subject, English. \r\n\r\nShe is also very active, especially in extra curricular activities. She loves dancing, movies, and athletics. In fact, she has become one of the best athletes in her school! She even participated at the national level with her team! \r\n\r\nAt home, her grandmother is very proud of her and works to provide Amina with basic items such as toiletries. In turn, Amina helps with chores like any other Kenyan girl of her age, including cooking, fetching water, digging, sweeping, doing laundry, fetching firewood, and helping look after her younger siblings.  \r\n\r\nOverall, Amina is very appreciative of your sponsorship. It has given her confidence at school and at home. She hopes that the opportunities you have helped provide will allow her to follow her dream of becoming a teacher when she completes her studies. She prays for you constantly and thanks you for the love you have shown her! God bless!\r\n\r\n(Uploaded on 18th July 2013)",
      "en_level_hearing": "residual",
      "en_hearing_test": "Yes",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "can say some words",
      "en_lip_read": "No",
      "en_needs_met": "Yes",
      "en_treated_before": "The mother claimed that the child was not hers.",
      "en_family_communicat": "Gestures",
      "en_school": "Gede Special School",
      "en_class_level": "Class 4",
      "en_family_details": "The child was abandoned by the parents and stays with another person.",
      "en_father_name": "Nicholas Garama",
      "en_fathers_occupatio": "Peasant farmer",
      "en_mothers_name": "Mapenzi Nyundo",
      "en_mothers_occupatio": "Small scale business",
      "en_guardians_name": "Not known",
      "en_guardians_occupat": "Peasant farmer",
      "en_guardians_relatio": "Grandmother",
      "en_number_of_brother": "2",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "willing few resources",
      "en_situation_explain": "The mother abandoned the child.",
      "en_house_location": "Malindi - Kijiwetanga",
      "en_distance_away": "15km",
      "en_house_state": "Mud/makuti",
      "en_why_need_sponsors": "Boarding fees",
      "en_total_needed": "12",
      "en_other_needs": "None",
      "en_languages": "Kiswahili, English, and Sign",
      "en_religion": "Christian",
      "en_church_name": "Baptist",
      "en_favorite_activity": "Art/ drawing\r\nMovies \r\nDancing",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Gede Vocational Centre",
      "en_out_reach_app_cas": "cd05844d-701e-48a8-b7f6-61f13e0a3c87",
      "en_disability_type": "Hearing Impairment",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "122",
      "en_cid": "KP7",
      "id": 47508,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Amina\",\"en_second_name\":\"Nyundo\",\"en_last_name_1\":\"Chengo\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"0000-00-00\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Amina is a young girl who is partially deaf. She is only able to hear loud noises that are close to her. Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s mother passed away during childbirth, and she now lives with an unemployed aunt who cannot support her. She loves to play with toys, paint, and draw. With sponsorship, Amina will be able to board at the Gede Special School and attend classes that fit her needs.\",\"en_private_comments\":\"December 6, 2022\\r\\n\\r\\nJanAmina finished her primary education and is now \\r\\nattending Gede Vocational Centre. She began school by \\r\\nstudying beauty therapy, but it required too much time on \\r\\nher feet. Her legs were too weak to stand long enough to \\r\\nplait someone\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s hair. She changed majors and is now \\r\\nstudying tailoring which she loves.\\r\\nAmina has only minor speech problems but uses sign \\r\\nlanguage for most of her communication needs. She has \\r\\nhearing aids but does not use them. She can lip read. She \\r\\nhas had a healthy year with no fevers or other illnesses.\\r\\nAmina is friendly, kind, and helpful to others. She \\r\\ninteracts with others well and has many friends at home \\r\\nand at school. She is a member of the games club at \\r\\nschool. She also enjoys watching television, talking with \\r\\nfriends, and playing team sports.\\r\\nHer caregiver says, \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093I feel good that I was able to enroll my \\r\\nchild at Gede Vocational. Since she joined, I can see some \\r\\nprogress.\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d\\r\\nHer family sells vegetables for their livelihood. Due to \\r\\ninflation in Kenya it is difficult for the family to make a \\r\\nprofit\\r\\nJanuary 7, 2022\\r\\nAmina finished her primary education.  Kupenda is working with the family to get an appropriate placement for Amina at either a secondary school or vocational training.  It is hoped that she will be enrolled by this semester.\\r\\n\\r\\nAmina can hear some sounds but has trouble distinguishing voices.  She has hearing aids but does not use them.  If she looks directly at the speaker and is close, she can understand what is said.  At least one of her parents is fluent in sign language.  She can speak but is not understandable.\\r\\n\\r\\nAmina is friendly and kind.  She has many friends at home whom they do chores together.  She is a good ball player.  She also enjoys watching television, talking with friends, playing team sports, singing, and dancing.\\r\\n\\r\\nThe mother lost her job as household help last year during the pandemic, but the family received food relief from Kupenda during that time.  The mother is able to work 4 days a month but is unable to secure more days.  The ongoing drought caused the family farm to be less productive.\\r\\n\\r\\nThanks to your support Amina is doing well and has a bright future.\\r\\n\\r\\nNovember 17, 2020\\r\\nAmina is nearing the end of her primary school education at Gede Special School.  She continues to struggle academically.  She has some learning difficulties and tends to forget some concepts.  In March, all schools in Kenya were closed due to the coronavirus pandemic.  They plan to reopen in 2021 but all class 8 and form 4 candidates have been given permission to return to school.  So Amina will be  able to take her examinations to qualify for secondary school admission.\\r\\n\\r\\nAmina is friendly, kind, and helpful to others.  She is caring and friendly.  She enjoys serving food to those children in wheelchairs during lunch breaks.  She enjoys watching television, reading, talking with friends, and playing team sports.  She is especially good in leg ball.  She is a member of Rights of Child Club.  She competes in volleyball, netball, and running at the county level.  She likes to play with her peers and has many friends.\\r\\n\\r\\nKupenda counselling sessions with the parents has empowered them with knowledge of the rights of their child.  As a result they are supporting their daughter\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s preparation for the national examinations so that she can join a secondary school next year.  Kupenda is also supporting the family during the pandemic.  Thank you for supporting Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s efforts.\\r\\n\\r\\nOctober 7, 2019\\r\\nAmina is currently in 7th grade at Gede Special School.  She has learning difficulties which make her slow to master some of the concepts in school.  She is experiencing some memory issues and forgets what the teacher has taught.\\r\\n\\r\\nAt school Amina is a member of the ROC club (Rights of Children).  She is also involved in guidance and counselling sessions which are helping her to cope with her disability.\\r\\n\\r\\nAmina enjoys being with others and seeks them out during her free time.  She enjoys playing table games and watching television with her friends.  She competes in volleyball and football and competed at the regionals this year.\\r\\n\\r\\nOnce again, the family farm had environmental problems.  The area had problems with insect infestation resulting in no stable income for the family.  The family love Amina and include her in all family activities.  They are learning sign-language so they can better communicate with her.\\r\\n\\r\\nYour support is providing Amina with a boarding school education where she receives instruction in sign language.  At school she has opportunities to learn, have three meals a day, meet new friends, and participate in athletics.  Thank you for your generosity.\\r\\n\\r\\nMarch 27, 2019\\r\\nAmina is in seventh grade at Gede Special School.  There has been a slight improvement in her grades.  Her hearing impairment is accompanied by other learning difficulties which affect her ability to do her school work.  She is unable to understand concepts at the level of her peers.  It has been determined that she has a mild cerebral palsy condition which is also impacting her walking.\\r\\n      Amina is friendly and makes friends easily.  She is helpful at school by pushing those in wheelchairs and watering plants.  She likes to watch and participate in ball games but is limited by her walking disability.  She enjoys playing with friends and watching television.  \\r\\n    Her family is very supportive of Amina.  They bring her to school on time, attend school activities, visit her at school, and provide her basic needs.\\r\\n      Your sponsorship is providing Amina with sign language instruction, counseling, boarding fees, and access to church. Her boarding fees enable her to access education and medical intervention when she is sick.  She is able to live in a conducive environment getting educated by the use of sign language and living in a community where she has no communication barriers.  Thank you for your generosity.\\r\\n\\r\\nJanuary 10, 2019\\r\\n     Amina is now in level six at Gede Special School.  She is struggling academically especially after long holiday breaks.  Her parents are unable to assist their daughter in her learning as they can not communicate with her.  She does much better in her pre-vocational classes.\\r\\n     The school staff are considering classifying Amina as physically handicapped as well as hearing impaired.  She walks with a gait and her legs are very weak. She could benefit from physical therapy.  She has been healthy this year with no major illness.\\r\\n     Amina is a friendly and helpful young lady. She helps  the other children at school.  She participates in Netball and competed at the sub-county level this year.  She also enjoys watching movies and story-telling.\\r\\n     Her family love Amina very much and want what is best for her.  They are active in parent groups and  provide basic toiletries.  It would be helpful for them to learn sign language.\\r\\n      Your sponsorship is providing Amina an education, a place to live, a way to communicate, and medical attention.  Thank you for your generosity.\\r\\n\\r\\nJuly 20, 2017\\r\\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \\r\\n       Amini is a student at Gede Special School.  Her dual disabilities of hearing impairment and mental challenges have made learning difficult and progress slow.  Her behavior is improving as she watches the other students and tries to copy them.  She has moved on to the next level this year.  She would like to work in a salon plaiting customers hair.\\r\\n       Amina is friendly and makes friends easily.  She has a younger friend that she takes care of.  She makes sure she is neat and has been fed. Amina enjoys watching TV programs.\\r\\n         Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s mother disowned her daughter at first claiming she was her sister\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s child.  She has now accepted Amina as her own child. Her mother is now very involved in Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education and attends meetings and activities at the school.  \\r\\n     Amina is struggling with her academics.  She does not perform as well as the other children who are much younger.  This makes her very uncomfortable.  The school is planning on a pre-vocational program where children will be taught skills that will empower them.  Amina would benefit from such a class as she has talents plaiting hair.\\r\\n     Thank you for your sponsorship which has given Amina the ability to communicate and a chance to support herself with a trade.\\r\\n\\r\\n(6 October 2014)\\r\\n\\r\\nThis past year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya.  This is something the children look forward to each year. In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\n\\r\\nAmina is in Primary Class 2 at the Gede Special School.  She was unfortunately not able to progress to be in Class 3, due to foundational challenges of her earlier education.  She has improved on her academic performance from last year, with English and Kiswahili being her best subjects.  She has mastered basic sign language and continues to develop her communication skills.  She can hear if the person speaking is very close to her.  \\r\\n\\r\\nShe enjoys athletics, dancing, music and movies.  Amina likes helping others and you will always find her in a group of other children.  She wants to be a teacher, so we are hopeful that she will be building a stronger foundation in her studies this year, to be able to keep moving forward in school.\\r\\n\\r\\nAmina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s grandmother serves as her guardian and is very supportive of her education.  As a peasant farmer, she earns very little, but contributes what she can to Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school supplies (including toiletries and her uniform), and to the PTA.  At home, Amina likes to help with household chores such as cooking, fetching water, tending animals and also helping to look after younger siblings.\\r\\n\\r\\nThanks for making a difference in Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life.\\r\\n----------------------\\r\\n(2013)\\r\\nAmina is a very happy girl at the Gede Special School where she is now in Grade 3. She performs well in class and earned a B this year in her favorite subject, English. \\r\\n\\r\\nShe is also very active, especially in extra curricular activities. She loves dancing, movies, and athletics. In fact, she has become one of the best athletes in her school! She even participated at the national level with her team! \\r\\n\\r\\nAt home, her grandmother is very proud of her and works to provide Amina with basic items such as toiletries. In turn, Amina helps with chores like any other Kenyan girl of her age, including cooking, fetching water, digging, sweeping, doing laundry, fetching firewood, and helping look after her younger siblings.  \\r\\n\\r\\nOverall, Amina is very appreciative of your sponsorship. It has given her confidence at school and at home. She hopes that the opportunities you have helped provide will allow her to follow her dream of becoming a teacher when she completes her studies. She prays for you constantly and thanks you for the love you have shown her! God bless!\\r\\n\\r\\n(Uploaded on 18th July 2013)\",\"en_level_hearing\":\"residual\",\"en_hearing_test\":\"Yes\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"can say some words\",\"en_lip_read\":\"No\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"The mother claimed that the child was not hers.\",\"en_family_communicat\":\"Gestures\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"Class 4\",\"en_family_details\":\"The child was abandoned by the parents and stays with another person.\",\"en_father_name\":\"Nicholas Garama\",\"en_fathers_occupatio\":\"Peasant farmer\",\"en_mothers_name\":\"Mapenzi Nyundo\",\"en_mothers_occupatio\":\"Small scale business\",\"en_guardians_name\":\"Not known\",\"en_guardians_occupat\":\"Peasant farmer\",\"en_guardians_relatio\":\"Grandmother\",\"en_number_of_brother\":\"2\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"The mother abandoned the child.\",\"en_house_location\":\"Malindi - Kijiwetanga\",\"en_distance_away\":\"15km\",\"en_house_state\":\"Mud\\/makuti\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12\",\"en_other_needs\":\"None\",\"en_languages\":\"Kiswahili, English, and Sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"Baptist\",\"en_favorite_activity\":\"Art\\/ drawing\\r\\nMovies \\r\\nDancing\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Vocational Centre\",\"en_out_reach_app_cas\":\"cd05844d-701e-48a8-b7f6-61f13e0a3c87\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"122\",\"en_cid\":\"KP7\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Amina",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Nyundo",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/2f3a9dbb0a280d91c4c07cca8fad924d.jpg",
    "donations": [],
    "entity": {
      "id": 47508,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Amina\",\"en_second_name\":\"Nyundo\",\"en_last_name_1\":\"Chengo\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"0000-00-00\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Amina is a young girl who is partially deaf. She is only able to hear loud noises that are close to her. Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s mother passed away during childbirth, and she now lives with an unemployed aunt who cannot support her. She loves to play with toys, paint, and draw. With sponsorship, Amina will be able to board at the Gede Special School and attend classes that fit her needs.\",\"en_private_comments\":\"December 6, 2022\\r\\n\\r\\nJanAmina finished her primary education and is now \\r\\nattending Gede Vocational Centre. She began school by \\r\\nstudying beauty therapy, but it required too much time on \\r\\nher feet. Her legs were too weak to stand long enough to \\r\\nplait someone\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s hair. She changed majors and is now \\r\\nstudying tailoring which she loves.\\r\\nAmina has only minor speech problems but uses sign \\r\\nlanguage for most of her communication needs. She has \\r\\nhearing aids but does not use them. She can lip read. She \\r\\nhas had a healthy year with no fevers or other illnesses.\\r\\nAmina is friendly, kind, and helpful to others. She \\r\\ninteracts with others well and has many friends at home \\r\\nand at school. She is a member of the games club at \\r\\nschool. She also enjoys watching television, talking with \\r\\nfriends, and playing team sports.\\r\\nHer caregiver says, \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093I feel good that I was able to enroll my \\r\\nchild at Gede Vocational. Since she joined, I can see some \\r\\nprogress.\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d\\r\\nHer family sells vegetables for their livelihood. Due to \\r\\ninflation in Kenya it is difficult for the family to make a \\r\\nprofit\\r\\nJanuary 7, 2022\\r\\nAmina finished her primary education.  Kupenda is working with the family to get an appropriate placement for Amina at either a secondary school or vocational training.  It is hoped that she will be enrolled by this semester.\\r\\n\\r\\nAmina can hear some sounds but has trouble distinguishing voices.  She has hearing aids but does not use them.  If she looks directly at the speaker and is close, she can understand what is said.  At least one of her parents is fluent in sign language.  She can speak but is not understandable.\\r\\n\\r\\nAmina is friendly and kind.  She has many friends at home whom they do chores together.  She is a good ball player.  She also enjoys watching television, talking with friends, playing team sports, singing, and dancing.\\r\\n\\r\\nThe mother lost her job as household help last year during the pandemic, but the family received food relief from Kupenda during that time.  The mother is able to work 4 days a month but is unable to secure more days.  The ongoing drought caused the family farm to be less productive.\\r\\n\\r\\nThanks to your support Amina is doing well and has a bright future.\\r\\n\\r\\nNovember 17, 2020\\r\\nAmina is nearing the end of her primary school education at Gede Special School.  She continues to struggle academically.  She has some learning difficulties and tends to forget some concepts.  In March, all schools in Kenya were closed due to the coronavirus pandemic.  They plan to reopen in 2021 but all class 8 and form 4 candidates have been given permission to return to school.  So Amina will be  able to take her examinations to qualify for secondary school admission.\\r\\n\\r\\nAmina is friendly, kind, and helpful to others.  She is caring and friendly.  She enjoys serving food to those children in wheelchairs during lunch breaks.  She enjoys watching television, reading, talking with friends, and playing team sports.  She is especially good in leg ball.  She is a member of Rights of Child Club.  She competes in volleyball, netball, and running at the county level.  She likes to play with her peers and has many friends.\\r\\n\\r\\nKupenda counselling sessions with the parents has empowered them with knowledge of the rights of their child.  As a result they are supporting their daughter\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s preparation for the national examinations so that she can join a secondary school next year.  Kupenda is also supporting the family during the pandemic.  Thank you for supporting Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s efforts.\\r\\n\\r\\nOctober 7, 2019\\r\\nAmina is currently in 7th grade at Gede Special School.  She has learning difficulties which make her slow to master some of the concepts in school.  She is experiencing some memory issues and forgets what the teacher has taught.\\r\\n\\r\\nAt school Amina is a member of the ROC club (Rights of Children).  She is also involved in guidance and counselling sessions which are helping her to cope with her disability.\\r\\n\\r\\nAmina enjoys being with others and seeks them out during her free time.  She enjoys playing table games and watching television with her friends.  She competes in volleyball and football and competed at the regionals this year.\\r\\n\\r\\nOnce again, the family farm had environmental problems.  The area had problems with insect infestation resulting in no stable income for the family.  The family love Amina and include her in all family activities.  They are learning sign-language so they can better communicate with her.\\r\\n\\r\\nYour support is providing Amina with a boarding school education where she receives instruction in sign language.  At school she has opportunities to learn, have three meals a day, meet new friends, and participate in athletics.  Thank you for your generosity.\\r\\n\\r\\nMarch 27, 2019\\r\\nAmina is in seventh grade at Gede Special School.  There has been a slight improvement in her grades.  Her hearing impairment is accompanied by other learning difficulties which affect her ability to do her school work.  She is unable to understand concepts at the level of her peers.  It has been determined that she has a mild cerebral palsy condition which is also impacting her walking.\\r\\n      Amina is friendly and makes friends easily.  She is helpful at school by pushing those in wheelchairs and watering plants.  She likes to watch and participate in ball games but is limited by her walking disability.  She enjoys playing with friends and watching television.  \\r\\n    Her family is very supportive of Amina.  They bring her to school on time, attend school activities, visit her at school, and provide her basic needs.\\r\\n      Your sponsorship is providing Amina with sign language instruction, counseling, boarding fees, and access to church. Her boarding fees enable her to access education and medical intervention when she is sick.  She is able to live in a conducive environment getting educated by the use of sign language and living in a community where she has no communication barriers.  Thank you for your generosity.\\r\\n\\r\\nJanuary 10, 2019\\r\\n     Amina is now in level six at Gede Special School.  She is struggling academically especially after long holiday breaks.  Her parents are unable to assist their daughter in her learning as they can not communicate with her.  She does much better in her pre-vocational classes.\\r\\n     The school staff are considering classifying Amina as physically handicapped as well as hearing impaired.  She walks with a gait and her legs are very weak. She could benefit from physical therapy.  She has been healthy this year with no major illness.\\r\\n     Amina is a friendly and helpful young lady. She helps  the other children at school.  She participates in Netball and competed at the sub-county level this year.  She also enjoys watching movies and story-telling.\\r\\n     Her family love Amina very much and want what is best for her.  They are active in parent groups and  provide basic toiletries.  It would be helpful for them to learn sign language.\\r\\n      Your sponsorship is providing Amina an education, a place to live, a way to communicate, and medical attention.  Thank you for your generosity.\\r\\n\\r\\nJuly 20, 2017\\r\\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \\r\\n       Amini is a student at Gede Special School.  Her dual disabilities of hearing impairment and mental challenges have made learning difficult and progress slow.  Her behavior is improving as she watches the other students and tries to copy them.  She has moved on to the next level this year.  She would like to work in a salon plaiting customers hair.\\r\\n       Amina is friendly and makes friends easily.  She has a younger friend that she takes care of.  She makes sure she is neat and has been fed. Amina enjoys watching TV programs.\\r\\n         Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s mother disowned her daughter at first claiming she was her sister\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s child.  She has now accepted Amina as her own child. Her mother is now very involved in Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education and attends meetings and activities at the school.  \\r\\n     Amina is struggling with her academics.  She does not perform as well as the other children who are much younger.  This makes her very uncomfortable.  The school is planning on a pre-vocational program where children will be taught skills that will empower them.  Amina would benefit from such a class as she has talents plaiting hair.\\r\\n     Thank you for your sponsorship which has given Amina the ability to communicate and a chance to support herself with a trade.\\r\\n\\r\\n(6 October 2014)\\r\\n\\r\\nThis past year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya.  This is something the children look forward to each year. In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\n\\r\\nAmina is in Primary Class 2 at the Gede Special School.  She was unfortunately not able to progress to be in Class 3, due to foundational challenges of her earlier education.  She has improved on her academic performance from last year, with English and Kiswahili being her best subjects.  She has mastered basic sign language and continues to develop her communication skills.  She can hear if the person speaking is very close to her.  \\r\\n\\r\\nShe enjoys athletics, dancing, music and movies.  Amina likes helping others and you will always find her in a group of other children.  She wants to be a teacher, so we are hopeful that she will be building a stronger foundation in her studies this year, to be able to keep moving forward in school.\\r\\n\\r\\nAmina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s grandmother serves as her guardian and is very supportive of her education.  As a peasant farmer, she earns very little, but contributes what she can to Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school supplies (including toiletries and her uniform), and to the PTA.  At home, Amina likes to help with household chores such as cooking, fetching water, tending animals and also helping to look after younger siblings.\\r\\n\\r\\nThanks for making a difference in Amina\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life.\\r\\n----------------------\\r\\n(2013)\\r\\nAmina is a very happy girl at the Gede Special School where she is now in Grade 3. She performs well in class and earned a B this year in her favorite subject, English. \\r\\n\\r\\nShe is also very active, especially in extra curricular activities. She loves dancing, movies, and athletics. In fact, she has become one of the best athletes in her school! She even participated at the national level with her team! \\r\\n\\r\\nAt home, her grandmother is very proud of her and works to provide Amina with basic items such as toiletries. In turn, Amina helps with chores like any other Kenyan girl of her age, including cooking, fetching water, digging, sweeping, doing laundry, fetching firewood, and helping look after her younger siblings.  \\r\\n\\r\\nOverall, Amina is very appreciative of your sponsorship. It has given her confidence at school and at home. She hopes that the opportunities you have helped provide will allow her to follow her dream of becoming a teacher when she completes her studies. She prays for you constantly and thanks you for the love you have shown her! God bless!\\r\\n\\r\\n(Uploaded on 18th July 2013)\",\"en_level_hearing\":\"residual\",\"en_hearing_test\":\"Yes\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"can say some words\",\"en_lip_read\":\"No\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"The mother claimed that the child was not hers.\",\"en_family_communicat\":\"Gestures\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"Class 4\",\"en_family_details\":\"The child was abandoned by the parents and stays with another person.\",\"en_father_name\":\"Nicholas Garama\",\"en_fathers_occupatio\":\"Peasant farmer\",\"en_mothers_name\":\"Mapenzi Nyundo\",\"en_mothers_occupatio\":\"Small scale business\",\"en_guardians_name\":\"Not known\",\"en_guardians_occupat\":\"Peasant farmer\",\"en_guardians_relatio\":\"Grandmother\",\"en_number_of_brother\":\"2\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"The mother abandoned the child.\",\"en_house_location\":\"Malindi - Kijiwetanga\",\"en_distance_away\":\"15km\",\"en_house_state\":\"Mud\\/makuti\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12\",\"en_other_needs\":\"None\",\"en_languages\":\"Kiswahili, English, and Sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"Baptist\",\"en_favorite_activity\":\"Art\\/ drawing\\r\\nMovies \\r\\nDancing\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Vocational Centre\",\"en_out_reach_app_cas\":\"cd05844d-701e-48a8-b7f6-61f13e0a3c87\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"122\",\"en_cid\":\"KP7\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/2f3a9dbb0a280d91c4c07cca8fad924d_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Amina Nyundo",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47507,
    "profile": {
      "en_first_name": "Kashuru",
      "en_second_name": "Msanzu",
      "en_last_name_1": "Kin\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2gan\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2ga",
      "en_last_name_2": "",
      "en_gender": "Male",
      "en_date_of_birth": "01/01/2000",
      "en_mental_disability": "Normal",
      "en_public_comments": "Kashuru is a young man who was born deaf for unknown reasons.  Although he cannot speak, he communicates using sign language.  Kashuru\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents are supportive of him, but with six children in the house, they are unable to pay for his boarding fees and the Gede Special School. Kashuru loves to be active, especially when it involves soccer or volleyball. With sponsorship, he will be able to board at the Gede Special School where he will receive an education that fits his needs.",
      "en_private_comments": "3-8-23\r\nKashuru is now a student at Gede Vocational Centre.  He is graded on his practicals but will be taking exams in April for his second year.  He puts what he is learned to practical use.  He has a friend who goes with him to look for repair work in the community.\r\n\r\nKashuru is friendly, kind, and helpful to others.  He is friendly, social, and enjoys being in the company of other students both with disabilities and without.  He has competed in the national games.\r\n\r\nKashuru has acquired many skills like game ball skills in football, volleyball, handball, and drama.  He is very good at acting.\r\n\r\n2-14-22\r\nKashuru is now 22 years old.  He is attending Gede Vocational Centre.  He passed his first-year exams and is preparing for his 2nd year exams.  He is a hardworking student, responsible and humble.  He also exhibits leadership skills.\r\n\r\nKashuru has no speech at all because of his profound hearing loss.  He uses sign language for all of his communication needs.  Since the last progress report Kashuru has been healthy and active.  He has had annual physicals and is up to date on his immunizations.\r\n\r\nKashuru is friendly, kind, and helpful to others.  He is social and friendly.  He makes friends easily and enjoys being in the company of others.  He enjoys talking with friends and playing team sports.  He has competed at the national level in track and field events.\r\n\r\nThe family relies on farming to make a living.  Their farm is in an area that has very little rain resulting in poor crops.  During the school shutdowns Kupenda furnished the family with deliveries of food every month.\r\n\r\nYour support is paying for his tuition to vocational school.  In a few years Kashuru will be ready to live an independent life.  Thank you.\r\n\r\n3.15.21\r\nKashuru is now 21 years old and is a student at the Gede  Vocational Centre.  Schools in Kenya have recently reopened after a nearly year long closure due to the coronavirus pandemic.  The Vocational Centre is looking for a sign language interpreter which is currently making things difficult for Kashuru.  He is a hard working, committed, focused and responsible boy.  \r\n\r\nKashuru is friendly, kind, and helpful to others.  He offers to assist anyone with a need.  He enjoys watching television, talking with friends, and playing team sports.  He has competed in track events at the national level.  He has mastered a lot of biblical knowledge and can preach to other students with hearing impairment.\r\n\r\nTeachers have been counselling Kashuru and his family annually.  This guidance has resulted in Kashuru attending Gede Vocational Centre.  The family farm was subject to an insect infestation this year which resulted in a small yield.  Kupenda has been making monthly deliveries of food and sanitation supplies.\r\n\r\nYour support is providing counselling, school fees, and food for Kashuru and his family.  Thank you.\r\n\r\n5/9/2019\r\nKashuru completed his high school level of education in 2018.  It has been difficult for hearing impaired students to attend vocational schools because of the lack of instruction in sign language.  Our Kenyan staff made a deal with Gede Vocational Centre in which Kupenda staff would train the Centre\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s staff to teach using sign language.  So in January of this year hearing impaired students began courses of study there.  Kashuru is attending this school to train to be an electrician.\r\n\r\nKashuru is a friendly young man who makes friends easily with other hearing impaired students.  He used to participate in football, volleyball, handball, poetry, and drama.  He even competed in the Kenyan National Games.  He enjoys watching television programs and reading books.  \r\n\r\nBoth the school and the home community treat Kashuru like any other child.  His parents love him very much, attend school activities, advocate for their son, and provide for his basic needs.\r\n\r\nKashuru is very happy to be joining a vocational institution to acquire skills which will empower him to live a self reliant life, to be able to support his family, and to be a role model in his community.  Your support has given Kashuru the opportunity to accomplish his dream  Thank you for your generosity.\r\n\r\n6/28/2018\r\nKashuru Msanzu is now 18 years old and a student at Pwani Secondary School for the deaf.  There has been a slight improvement  in sign language and agriculture as he now attends school regularly.  Kenyan schools for the deaf teach primarily with sign language instead of the written word.  This makes abstract concepts very difficult to teach and to understand.  He hopes to be a pastor when he completes his education.\r\n\r\nKashuru is a healthy, helpful, and kind young man.  He enjoys interactions with others especially his team mates.  He participates in football and volleyball. He has competed at the Coast Region Games and the Kenya National Games.  He was first runner-up in football.\r\n\r\nKashuru\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s family are struggling with little income as one of his parents recently lost their job.  They have yet to learn sign language so communication at home is difficult.  They seldom come to visit their son at school.  They are concerned about their son\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s welfare and call the school frequently to check on him.\r\n\r\nThank you for your support.  Kashuru is well on his way of fulfilling his dream and leading an independent life.\r\n\r\n7/14/2017\r\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \r\n     Kashuru is now a seventeen year old young man attending Pwani Secondary School for the Deaf.  His grades are ok but he has been studying hard through out the term.  He is improving in Agriculture and Biology because of his changing study behavior.  He is now more focused on his studies.  Kashuru now has a hearing aid which makes it easier for him to do well.\r\n    Kashuri is a very social young man.  He interacts well with other learners.  He loves to play football and has recently competed at the national level.  He has been awarded certificates for his competition.  He also enjoys drama.\r\n    The family is very supportive of Kashuri.  They love him and take good care of him.  The parents are learning Sign Language to be able to better communicate with their son.\r\n      Kashuru is hoping to be a teacher when he finishes his education.  Thank you for all you have done to give this young man hope for a future.\r\n\r\n10/21/14\r\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\r\nKashuru is now 17 years old and is repeating the eighth grade because he did not do well on his final exams.  Hopefully he will do better this year and be able to go on to higher education to achieve his dream of becoming a teacher.  In Kenya final exams in primary school determine whether or not students can go on to high school or vocational school.  Less than 2% of children of any ability in this area go to His teachers say he is a \u00c3\u00a2\u00e2\u0082\u00ac\u00c5\u0093very bright boy who understands the value of education as he is always studying to pass his final examination this year.\u00c3\u00a2\u00e2\u0082\u00ac\u00c2\u009d  He is also known to be a very caring and loving boy who was chosen to be the school\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s head boy.  This means he is a leader at the school responsible for the other children there.  \r\nKashuru\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents are very supportive of him and are doing what they can to help him pass his final exams.  Although they only earn and income from farming their small plot of land, they provide his school supplies and uniform as well as contributing to the Parent Teacher Association (PTA).  \r\nThank you for making such a difference!\r\n\r\nKashuru is a young man who was born deaf for unknown reasons.  Although he cannot speak, he communicates using sign language.  Kashuru\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents want to help him but they do not have the resources.  They are both peasant farmers and including Kashuru, they have six children to provide for.  Kashuru needs sponsorship to board at Gede Special School so he can get an education that fits his needs.  As he lives 130 kilometers away from the school, commuting is not an option.  Kashuru is known to be a good athlete and is especially talented at soccer and volleyball.  With sponsorship, he will attend primary class six and board at Gede where his special needs will be met.",
      "en_level_hearing": "",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "",
      "en_mothers_occupatio": "",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "Unwilling few resources",
      "en_situation_explain": "",
      "en_house_location": "Shomela",
      "en_distance_away": "",
      "en_house_state": "",
      "en_why_need_sponsors": "",
      "en_total_needed": "0",
      "en_other_needs": "",
      "en_languages": "",
      "en_religion": "",
      "en_church_name": "",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Gede Vocational Centre",
      "en_out_reach_app_cas": "51b80219-1925-4642-9c33-7b838a710275",
      "en_disability_type": "Hearing Impairment",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "121",
      "en_cid": "KP6",
      "id": 47507,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Kashuru\",\"en_second_name\":\"Msanzu\",\"en_last_name_1\":\"Kin\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2gan\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2ga\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"01\\/01\\/2000\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Kashuru is a young man who was born deaf for unknown reasons.  Although he cannot speak, he communicates using sign language.  Kashuru\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are supportive of him, but with six children in the house, they are unable to pay for his boarding fees and the Gede Special School. Kashuru loves to be active, especially when it involves soccer or volleyball. With sponsorship, he will be able to board at the Gede Special School where he will receive an education that fits his needs.\",\"en_private_comments\":\"3-8-23\\r\\nKashuru is now a student at Gede Vocational Centre.  He is graded on his practicals but will be taking exams in April for his second year.  He puts what he is learned to practical use.  He has a friend who goes with him to look for repair work in the community.\\r\\n\\r\\nKashuru is friendly, kind, and helpful to others.  He is friendly, social, and enjoys being in the company of other students both with disabilities and without.  He has competed in the national games.\\r\\n\\r\\nKashuru has acquired many skills like game ball skills in football, volleyball, handball, and drama.  He is very good at acting.\\r\\n\\r\\n2-14-22\\r\\nKashuru is now 22 years old.  He is attending Gede Vocational Centre.  He passed his first-year exams and is preparing for his 2nd year exams.  He is a hardworking student, responsible and humble.  He also exhibits leadership skills.\\r\\n\\r\\nKashuru has no speech at all because of his profound hearing loss.  He uses sign language for all of his communication needs.  Since the last progress report Kashuru has been healthy and active.  He has had annual physicals and is up to date on his immunizations.\\r\\n\\r\\nKashuru is friendly, kind, and helpful to others.  He is social and friendly.  He makes friends easily and enjoys being in the company of others.  He enjoys talking with friends and playing team sports.  He has competed at the national level in track and field events.\\r\\n\\r\\nThe family relies on farming to make a living.  Their farm is in an area that has very little rain resulting in poor crops.  During the school shutdowns Kupenda furnished the family with deliveries of food every month.\\r\\n\\r\\nYour support is paying for his tuition to vocational school.  In a few years Kashuru will be ready to live an independent life.  Thank you.\\r\\n\\r\\n3.15.21\\r\\nKashuru is now 21 years old and is a student at the Gede  Vocational Centre.  Schools in Kenya have recently reopened after a nearly year long closure due to the coronavirus pandemic.  The Vocational Centre is looking for a sign language interpreter which is currently making things difficult for Kashuru.  He is a hard working, committed, focused and responsible boy.  \\r\\n\\r\\nKashuru is friendly, kind, and helpful to others.  He offers to assist anyone with a need.  He enjoys watching television, talking with friends, and playing team sports.  He has competed in track events at the national level.  He has mastered a lot of biblical knowledge and can preach to other students with hearing impairment.\\r\\n\\r\\nTeachers have been counselling Kashuru and his family annually.  This guidance has resulted in Kashuru attending Gede Vocational Centre.  The family farm was subject to an insect infestation this year which resulted in a small yield.  Kupenda has been making monthly deliveries of food and sanitation supplies.\\r\\n\\r\\nYour support is providing counselling, school fees, and food for Kashuru and his family.  Thank you.\\r\\n\\r\\n5\\/9\\/2019\\r\\nKashuru completed his high school level of education in 2018.  It has been difficult for hearing impaired students to attend vocational schools because of the lack of instruction in sign language.  Our Kenyan staff made a deal with Gede Vocational Centre in which Kupenda staff would train the Centre\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s staff to teach using sign language.  So in January of this year hearing impaired students began courses of study there.  Kashuru is attending this school to train to be an electrician.\\r\\n\\r\\nKashuru is a friendly young man who makes friends easily with other hearing impaired students.  He used to participate in football, volleyball, handball, poetry, and drama.  He even competed in the Kenyan National Games.  He enjoys watching television programs and reading books.  \\r\\n\\r\\nBoth the school and the home community treat Kashuru like any other child.  His parents love him very much, attend school activities, advocate for their son, and provide for his basic needs.\\r\\n\\r\\nKashuru is very happy to be joining a vocational institution to acquire skills which will empower him to live a self reliant life, to be able to support his family, and to be a role model in his community.  Your support has given Kashuru the opportunity to accomplish his dream  Thank you for your generosity.\\r\\n\\r\\n6\\/28\\/2018\\r\\nKashuru Msanzu is now 18 years old and a student at Pwani Secondary School for the deaf.  There has been a slight improvement  in sign language and agriculture as he now attends school regularly.  Kenyan schools for the deaf teach primarily with sign language instead of the written word.  This makes abstract concepts very difficult to teach and to understand.  He hopes to be a pastor when he completes his education.\\r\\n\\r\\nKashuru is a healthy, helpful, and kind young man.  He enjoys interactions with others especially his team mates.  He participates in football and volleyball. He has competed at the Coast Region Games and the Kenya National Games.  He was first runner-up in football.\\r\\n\\r\\nKashuru\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family are struggling with little income as one of his parents recently lost their job.  They have yet to learn sign language so communication at home is difficult.  They seldom come to visit their son at school.  They are concerned about their son\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s welfare and call the school frequently to check on him.\\r\\n\\r\\nThank you for your support.  Kashuru is well on his way of fulfilling his dream and leading an independent life.\\r\\n\\r\\n7\\/14\\/2017\\r\\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \\r\\n     Kashuru is now a seventeen year old young man attending Pwani Secondary School for the Deaf.  His grades are ok but he has been studying hard through out the term.  He is improving in Agriculture and Biology because of his changing study behavior.  He is now more focused on his studies.  Kashuru now has a hearing aid which makes it easier for him to do well.\\r\\n    Kashuri is a very social young man.  He interacts well with other learners.  He loves to play football and has recently competed at the national level.  He has been awarded certificates for his competition.  He also enjoys drama.\\r\\n    The family is very supportive of Kashuri.  They love him and take good care of him.  The parents are learning Sign Language to be able to better communicate with their son.\\r\\n      Kashuru is hoping to be a teacher when he finishes his education.  Thank you for all you have done to give this young man hope for a future.\\r\\n\\r\\n10\\/21\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nKashuru is now 17 years old and is repeating the eighth grade because he did not do well on his final exams.  Hopefully he will do better this year and be able to go on to higher education to achieve his dream of becoming a teacher.  In Kenya final exams in primary school determine whether or not students can go on to high school or vocational school.  Less than 2% of children of any ability in this area go to His teachers say he is a \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093very bright boy who understands the value of education as he is always studying to pass his final examination this year.\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d  He is also known to be a very caring and loving boy who was chosen to be the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s head boy.  This means he is a leader at the school responsible for the other children there.  \\r\\nKashuru\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are very supportive of him and are doing what they can to help him pass his final exams.  Although they only earn and income from farming their small plot of land, they provide his school supplies and uniform as well as contributing to the Parent Teacher Association (PTA).  \\r\\nThank you for making such a difference!\\r\\n\\r\\nKashuru is a young man who was born deaf for unknown reasons.  Although he cannot speak, he communicates using sign language.  Kashuru\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents want to help him but they do not have the resources.  They are both peasant farmers and including Kashuru, they have six children to provide for.  Kashuru needs sponsorship to board at Gede Special School so he can get an education that fits his needs.  As he lives 130 kilometers away from the school, commuting is not an option.  Kashuru is known to be a good athlete and is especially talented at soccer and volleyball.  With sponsorship, he will attend primary class six and board at Gede where his special needs will be met.\",\"en_level_hearing\":\"\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Shomela\",\"en_distance_away\":\"\",\"en_house_state\":\"\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Vocational Centre\",\"en_out_reach_app_cas\":\"51b80219-1925-4642-9c33-7b838a710275\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"121\",\"en_cid\":\"KP6\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Kashuru",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Msanzu",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/160b68f12255946a8c4051affa6c1170.jpg",
    "donations": [],
    "entity": {
      "id": 47507,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Kashuru\",\"en_second_name\":\"Msanzu\",\"en_last_name_1\":\"Kin\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2gan\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2ga\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"01\\/01\\/2000\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Kashuru is a young man who was born deaf for unknown reasons.  Although he cannot speak, he communicates using sign language.  Kashuru\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are supportive of him, but with six children in the house, they are unable to pay for his boarding fees and the Gede Special School. Kashuru loves to be active, especially when it involves soccer or volleyball. With sponsorship, he will be able to board at the Gede Special School where he will receive an education that fits his needs.\",\"en_private_comments\":\"3-8-23\\r\\nKashuru is now a student at Gede Vocational Centre.  He is graded on his practicals but will be taking exams in April for his second year.  He puts what he is learned to practical use.  He has a friend who goes with him to look for repair work in the community.\\r\\n\\r\\nKashuru is friendly, kind, and helpful to others.  He is friendly, social, and enjoys being in the company of other students both with disabilities and without.  He has competed in the national games.\\r\\n\\r\\nKashuru has acquired many skills like game ball skills in football, volleyball, handball, and drama.  He is very good at acting.\\r\\n\\r\\n2-14-22\\r\\nKashuru is now 22 years old.  He is attending Gede Vocational Centre.  He passed his first-year exams and is preparing for his 2nd year exams.  He is a hardworking student, responsible and humble.  He also exhibits leadership skills.\\r\\n\\r\\nKashuru has no speech at all because of his profound hearing loss.  He uses sign language for all of his communication needs.  Since the last progress report Kashuru has been healthy and active.  He has had annual physicals and is up to date on his immunizations.\\r\\n\\r\\nKashuru is friendly, kind, and helpful to others.  He is social and friendly.  He makes friends easily and enjoys being in the company of others.  He enjoys talking with friends and playing team sports.  He has competed at the national level in track and field events.\\r\\n\\r\\nThe family relies on farming to make a living.  Their farm is in an area that has very little rain resulting in poor crops.  During the school shutdowns Kupenda furnished the family with deliveries of food every month.\\r\\n\\r\\nYour support is paying for his tuition to vocational school.  In a few years Kashuru will be ready to live an independent life.  Thank you.\\r\\n\\r\\n3.15.21\\r\\nKashuru is now 21 years old and is a student at the Gede  Vocational Centre.  Schools in Kenya have recently reopened after a nearly year long closure due to the coronavirus pandemic.  The Vocational Centre is looking for a sign language interpreter which is currently making things difficult for Kashuru.  He is a hard working, committed, focused and responsible boy.  \\r\\n\\r\\nKashuru is friendly, kind, and helpful to others.  He offers to assist anyone with a need.  He enjoys watching television, talking with friends, and playing team sports.  He has competed in track events at the national level.  He has mastered a lot of biblical knowledge and can preach to other students with hearing impairment.\\r\\n\\r\\nTeachers have been counselling Kashuru and his family annually.  This guidance has resulted in Kashuru attending Gede Vocational Centre.  The family farm was subject to an insect infestation this year which resulted in a small yield.  Kupenda has been making monthly deliveries of food and sanitation supplies.\\r\\n\\r\\nYour support is providing counselling, school fees, and food for Kashuru and his family.  Thank you.\\r\\n\\r\\n5\\/9\\/2019\\r\\nKashuru completed his high school level of education in 2018.  It has been difficult for hearing impaired students to attend vocational schools because of the lack of instruction in sign language.  Our Kenyan staff made a deal with Gede Vocational Centre in which Kupenda staff would train the Centre\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s staff to teach using sign language.  So in January of this year hearing impaired students began courses of study there.  Kashuru is attending this school to train to be an electrician.\\r\\n\\r\\nKashuru is a friendly young man who makes friends easily with other hearing impaired students.  He used to participate in football, volleyball, handball, poetry, and drama.  He even competed in the Kenyan National Games.  He enjoys watching television programs and reading books.  \\r\\n\\r\\nBoth the school and the home community treat Kashuru like any other child.  His parents love him very much, attend school activities, advocate for their son, and provide for his basic needs.\\r\\n\\r\\nKashuru is very happy to be joining a vocational institution to acquire skills which will empower him to live a self reliant life, to be able to support his family, and to be a role model in his community.  Your support has given Kashuru the opportunity to accomplish his dream  Thank you for your generosity.\\r\\n\\r\\n6\\/28\\/2018\\r\\nKashuru Msanzu is now 18 years old and a student at Pwani Secondary School for the deaf.  There has been a slight improvement  in sign language and agriculture as he now attends school regularly.  Kenyan schools for the deaf teach primarily with sign language instead of the written word.  This makes abstract concepts very difficult to teach and to understand.  He hopes to be a pastor when he completes his education.\\r\\n\\r\\nKashuru is a healthy, helpful, and kind young man.  He enjoys interactions with others especially his team mates.  He participates in football and volleyball. He has competed at the Coast Region Games and the Kenya National Games.  He was first runner-up in football.\\r\\n\\r\\nKashuru\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s family are struggling with little income as one of his parents recently lost their job.  They have yet to learn sign language so communication at home is difficult.  They seldom come to visit their son at school.  They are concerned about their son\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s welfare and call the school frequently to check on him.\\r\\n\\r\\nThank you for your support.  Kashuru is well on his way of fulfilling his dream and leading an independent life.\\r\\n\\r\\n7\\/14\\/2017\\r\\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \\r\\n     Kashuru is now a seventeen year old young man attending Pwani Secondary School for the Deaf.  His grades are ok but he has been studying hard through out the term.  He is improving in Agriculture and Biology because of his changing study behavior.  He is now more focused on his studies.  Kashuru now has a hearing aid which makes it easier for him to do well.\\r\\n    Kashuri is a very social young man.  He interacts well with other learners.  He loves to play football and has recently competed at the national level.  He has been awarded certificates for his competition.  He also enjoys drama.\\r\\n    The family is very supportive of Kashuri.  They love him and take good care of him.  The parents are learning Sign Language to be able to better communicate with their son.\\r\\n      Kashuru is hoping to be a teacher when he finishes his education.  Thank you for all you have done to give this young man hope for a future.\\r\\n\\r\\n10\\/21\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nKashuru is now 17 years old and is repeating the eighth grade because he did not do well on his final exams.  Hopefully he will do better this year and be able to go on to higher education to achieve his dream of becoming a teacher.  In Kenya final exams in primary school determine whether or not students can go on to high school or vocational school.  Less than 2% of children of any ability in this area go to His teachers say he is a \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093very bright boy who understands the value of education as he is always studying to pass his final examination this year.\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d  He is also known to be a very caring and loving boy who was chosen to be the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s head boy.  This means he is a leader at the school responsible for the other children there.  \\r\\nKashuru\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are very supportive of him and are doing what they can to help him pass his final exams.  Although they only earn and income from farming their small plot of land, they provide his school supplies and uniform as well as contributing to the Parent Teacher Association (PTA).  \\r\\nThank you for making such a difference!\\r\\n\\r\\nKashuru is a young man who was born deaf for unknown reasons.  Although he cannot speak, he communicates using sign language.  Kashuru\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents want to help him but they do not have the resources.  They are both peasant farmers and including Kashuru, they have six children to provide for.  Kashuru needs sponsorship to board at Gede Special School so he can get an education that fits his needs.  As he lives 130 kilometers away from the school, commuting is not an option.  Kashuru is known to be a good athlete and is especially talented at soccer and volleyball.  With sponsorship, he will attend primary class six and board at Gede where his special needs will be met.\",\"en_level_hearing\":\"\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"Shomela\",\"en_distance_away\":\"\",\"en_house_state\":\"\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Vocational Centre\",\"en_out_reach_app_cas\":\"51b80219-1925-4642-9c33-7b838a710275\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"121\",\"en_cid\":\"KP6\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/160b68f12255946a8c4051affa6c1170_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Kashuru Msanzu",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47506,
    "profile": {
      "en_first_name": "Joyce",
      "en_second_name": "",
      "en_last_name_1": "Kalu",
      "en_last_name_2": "Jefwa",
      "en_gender": "Female",
      "en_date_of_birth": "01/01/1998",
      "en_mental_disability": "none",
      "en_public_comments": "Joyce is a young woman who is deaf and mute. She communicates using sign language. After working with Kupenda, Joyce now understands that she can be an athlete despite her deafness. She has taken on a love for running and now races at the provincial level. However, being one of seven in the family has its downsides. Both of Joyce\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents have a very unstable income, and neither of them makes enough to pay for her boarding fees. With sponsorship, Joyce would be given the chance to continue running, and reach her full academic potential as well.",
      "en_private_comments": "October 11, 2022\r\nJoyce is enrolled at the Gede Vocational Centre.  She is studying tailoring.  She has started her course by cutting and sewing pieces of paper before she uses cloth.  She is happy to in her studies and asks questions when she doesn't understand.\r\n\r\nJoyce uses sign language for all of her communication needs.  At least one parent can communicate with her regarding her basic needs.  This past year she has been healthy and active with no illness or fever.\r\n\r\nJoyce is friendly, kind, and helpful to others.  She is a social and friendly girl who enjoys the company of others.  She enjoys watching television and talking with her friends.  She has competed in the county games.  \r\n\r\nThe family relies on farming for their livelihood.  Unfortunately, the area is experiencing a prolonged drought which is causing the farms to suffer.  \r\nFebruary 26, 2021\r\nJoyce is 23 years old and a student at Pwani Vocational School for the Deaf. Her performance is average.  She performs better in KSL than in other subjects.  The teachers have organizied remedial classes to assist her inother subjects.\r\n    Joyce is friendly and always helpful to others.  She is active in sports and games.  She enjoys watching television, talking with friends, and playing team sports.She has competed at the county level in running and netball. She is always happy, obedient, and respectful to teachers and prefects. \r\n    Kuhenza pays school fees,sensitizes the family on the rights of their child, and has linked the family to alternative funding opportunities.\r\n\r\n\r\nJuly 24, 2020 (Quick Update)\r\nThe child learns at Pwani Secondary school for the Deaf. She s in form 3.  Her family is receiving food support.\r\n3/10/20\r\nJoyce is now a student at Pwani School for the Deaf in form 3.  She enjoys her classes in KSl and actively participates in group activities. She has been concentrating more on her subjects unlike previous years when she only wanted to make friends.\r\n      Joyce is friendly and helpful to others.  She is active in games and sports.  She enjoys watching television, trading stories with friends, and playing team sports.  She competes in long distance races and netball.  This year she competed at the county level. She is a member of the sports club.\r\n     This year one of her parents became ill butt overall the parents are putting in more of an effort to make sure Joyce is at school on time.  They also had a good year on the farm.\r\n8/10/2017\r\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \r\n       Joyce is now a 19 year old young woman attending Gede Special School.  She is in 8th grade.  She is having trouble with her academics as hearing impaired students struggle with abstract concepts.  Her behavior is improving with the help of guidance and counseling sessions.  She understands her self better and is moving toward accepting her disability.\r\n       Joyce interacts with others really well.  She is very social.  She enjoys athletics including volleyball and net ball.  She competed in the coast regional games and was awarded certificates for her performance.  She also likes music, dancing, and drama.\r\n       Her parents are loving and  they have a positive attitude towards Joyce.  They provide basic toiletries and uniforms as well as participating in school activities. Joyce is a loving girl who helps care for the younger students at school.\r\n        Thank you for your sponsorship.  It has enabled Joyce to develop her full potential academically, socially, and athletically.  \r\n\r\n10/30/14\r\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\r\nJoyce is now 16 years old and in the fifth grade at the Gede Special School.  Her teachers say her sign language skills are improving.  She can now finger spell and sign read sentences.  In her free time, she enjoys playing netball and handball. She always has a broad smile and loves playing with others at the school.  \r\nJoyce\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents are supportive of her education.  They contribute what they can to her school supplies and to the Parent Teacher Association (PTA).  They also take her to church with them and visit her often at the school.  Joyce is helpful with chores at home like fetching water and firewood, cooking, washing clothes and helping to look after her younger siblings.  When she is finished with school, Joyce would like to be a waitress.  \r\nThank you for making a difference!\r\n\r\n(18TH JULY,2013)\r\nJoyce is beautiful 15 year-old young lady who is now in class four.  Her disability is responsible for the delay in her studies. During her free time she likes to dance, act, narrate stories and watch movies. She is a very happy girl.  She has wonderful social skills, and she likes to play with other children both at school and at home.  She is learning sign language, and she uses it to effectively communicate with others at school.  Her school work shows impressive achievement.  She is ranked in the top three positions with an average grade of C in all her subjects.  Her teachers love having her as a pupil! Her favorite subject is Social Studies. Her parents are very supportive in her education.  They try to ensure that Joyce is in school on time and they contribute towards the development of the school despite the fact that they are earning very little for a living.\r\nJoyce and her family members are very grateful for your continued support in her education since it has helped her to develop into a person who is full of hope for her life. She wants to become a teacher when she completes her studies.\r\nThank you so much for your continued support to Joyce!\r\n(Uploaded on 18th July,2013)\r\n\r\n\r\n\r\nJoyce is a fourteen year old girl who was born deaf.  Because of this, she is also unable to speak.  Joyce knows sign language and is able to communicate though still needs to work on it a bit more.  \r\n\r\nHer mother is a peasant farmer and her father is a mechanic.  With almost no income from her mother, and very inconsistent, low income from her father, the family of seven struggles.  Although her parents want her to get an education at Gede Special School, they cannot afford her boarding fees and their home is too far from the school to commute every day.  \r\n\r\nJoyce, with help from Kupenda, now understands that she can participate in athletics despite her deafness.  She took a liking to running and has recently moved up from the school\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s junior racing team to racing at the provincial level.  \r\n\r\nShe and her family appreciate your gift of sponsorship because it gives her a chance to reach her full potential in the classroom as well.  You enable her to have three meals a day, a place to sleep and access to the education she needs.",
      "en_level_hearing": "none",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "none",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_needs_met": "Yes",
      "en_treated_before": "with mixed  reactions",
      "en_family_communicat": "through gestures",
      "en_school": "Gede Special School",
      "en_class_level": "Class 4 H.I",
      "en_family_details": "both parents",
      "en_father_name": "Chengo Cahro",
      "en_fathers_occupatio": "mechanic",
      "en_mothers_name": "Kazosi Kahindi",
      "en_mothers_occupatio": "Peasant Farmer",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "3",
      "en_number_of_sisters": "2",
      "en_willingness_of_pa": "willing few resources",
      "en_situation_explain": "the parents are very supportive to Joyce education",
      "en_house_location": "Langobaya",
      "en_distance_away": "40km",
      "en_house_state": "mud/mabati",
      "en_why_need_sponsors": "Boarding fees",
      "en_total_needed": "12800",
      "en_other_needs": "none",
      "en_languages": "sign",
      "en_religion": "Christian",
      "en_church_name": "Pefa church",
      "en_favorite_activity": "Athletics, dancing, watching movies and acting drama",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Pwani Secondary School for the Deaf.",
      "en_out_reach_app_cas": "e0ae93d8c2564c3e91e74e5b66a2d246",
      "en_disability_type": "Hearing Impairment",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "120",
      "en_cid": "KP5",
      "id": 47506,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Joyce\",\"en_second_name\":\"\",\"en_last_name_1\":\"Kalu\",\"en_last_name_2\":\"Jefwa\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"01\\/01\\/1998\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Joyce is a young woman who is deaf and mute. She communicates using sign language. After working with Kupenda, Joyce now understands that she can be an athlete despite her deafness. She has taken on a love for running and now races at the provincial level. However, being one of seven in the family has its downsides. Both of Joyce\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents have a very unstable income, and neither of them makes enough to pay for her boarding fees. With sponsorship, Joyce would be given the chance to continue running, and reach her full academic potential as well.\",\"en_private_comments\":\"October 11, 2022\\r\\nJoyce is enrolled at the Gede Vocational Centre.  She is studying tailoring.  She has started her course by cutting and sewing pieces of paper before she uses cloth.  She is happy to in her studies and asks questions when she doesn't understand.\\r\\n\\r\\nJoyce uses sign language for all of her communication needs.  At least one parent can communicate with her regarding her basic needs.  This past year she has been healthy and active with no illness or fever.\\r\\n\\r\\nJoyce is friendly, kind, and helpful to others.  She is a social and friendly girl who enjoys the company of others.  She enjoys watching television and talking with her friends.  She has competed in the county games.  \\r\\n\\r\\nThe family relies on farming for their livelihood.  Unfortunately, the area is experiencing a prolonged drought which is causing the farms to suffer.  \\r\\nFebruary 26, 2021\\r\\nJoyce is 23 years old and a student at Pwani Vocational School for the Deaf. Her performance is average.  She performs better in KSL than in other subjects.  The teachers have organizied remedial classes to assist her inother subjects.\\r\\n    Joyce is friendly and always helpful to others.  She is active in sports and games.  She enjoys watching television, talking with friends, and playing team sports.She has competed at the county level in running and netball. She is always happy, obedient, and respectful to teachers and prefects. \\r\\n    Kuhenza pays school fees,sensitizes the family on the rights of their child, and has linked the family to alternative funding opportunities.\\r\\n\\r\\n\\r\\nJuly 24, 2020 (Quick Update)\\r\\nThe child learns at Pwani Secondary school for the Deaf. She s in form 3.  Her family is receiving food support.\\r\\n3\\/10\\/20\\r\\nJoyce is now a student at Pwani School for the Deaf in form 3.  She enjoys her classes in KSl and actively participates in group activities. She has been concentrating more on her subjects unlike previous years when she only wanted to make friends.\\r\\n      Joyce is friendly and helpful to others.  She is active in games and sports.  She enjoys watching television, trading stories with friends, and playing team sports.  She competes in long distance races and netball.  This year she competed at the county level. She is a member of the sports club.\\r\\n     This year one of her parents became ill butt overall the parents are putting in more of an effort to make sure Joyce is at school on time.  They also had a good year on the farm.\\r\\n8\\/10\\/2017\\r\\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \\r\\n       Joyce is now a 19 year old young woman attending Gede Special School.  She is in 8th grade.  She is having trouble with her academics as hearing impaired students struggle with abstract concepts.  Her behavior is improving with the help of guidance and counseling sessions.  She understands her self better and is moving toward accepting her disability.\\r\\n       Joyce interacts with others really well.  She is very social.  She enjoys athletics including volleyball and net ball.  She competed in the coast regional games and was awarded certificates for her performance.  She also likes music, dancing, and drama.\\r\\n       Her parents are loving and  they have a positive attitude towards Joyce.  They provide basic toiletries and uniforms as well as participating in school activities. Joyce is a loving girl who helps care for the younger students at school.\\r\\n        Thank you for your sponsorship.  It has enabled Joyce to develop her full potential academically, socially, and athletically.  \\r\\n\\r\\n10\\/30\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nJoyce is now 16 years old and in the fifth grade at the Gede Special School.  Her teachers say her sign language skills are improving.  She can now finger spell and sign read sentences.  In her free time, she enjoys playing netball and handball. She always has a broad smile and loves playing with others at the school.  \\r\\nJoyce\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are supportive of her education.  They contribute what they can to her school supplies and to the Parent Teacher Association (PTA).  They also take her to church with them and visit her often at the school.  Joyce is helpful with chores at home like fetching water and firewood, cooking, washing clothes and helping to look after her younger siblings.  When she is finished with school, Joyce would like to be a waitress.  \\r\\nThank you for making a difference!\\r\\n\\r\\n(18TH JULY,2013)\\r\\nJoyce is beautiful 15 year-old young lady who is now in class four.  Her disability is responsible for the delay in her studies. During her free time she likes to dance, act, narrate stories and watch movies. She is a very happy girl.  She has wonderful social skills, and she likes to play with other children both at school and at home.  She is learning sign language, and she uses it to effectively communicate with others at school.  Her school work shows impressive achievement.  She is ranked in the top three positions with an average grade of C in all her subjects.  Her teachers love having her as a pupil! Her favorite subject is Social Studies. Her parents are very supportive in her education.  They try to ensure that Joyce is in school on time and they contribute towards the development of the school despite the fact that they are earning very little for a living.\\r\\nJoyce and her family members are very grateful for your continued support in her education since it has helped her to develop into a person who is full of hope for her life. She wants to become a teacher when she completes her studies.\\r\\nThank you so much for your continued support to Joyce!\\r\\n(Uploaded on 18th July,2013)\\r\\n\\r\\n\\r\\n\\r\\nJoyce is a fourteen year old girl who was born deaf.  Because of this, she is also unable to speak.  Joyce knows sign language and is able to communicate though still needs to work on it a bit more.  \\r\\n\\r\\nHer mother is a peasant farmer and her father is a mechanic.  With almost no income from her mother, and very inconsistent, low income from her father, the family of seven struggles.  Although her parents want her to get an education at Gede Special School, they cannot afford her boarding fees and their home is too far from the school to commute every day.  \\r\\n\\r\\nJoyce, with help from Kupenda, now understands that she can participate in athletics despite her deafness.  She took a liking to running and has recently moved up from the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s junior racing team to racing at the provincial level.  \\r\\n\\r\\nShe and her family appreciate your gift of sponsorship because it gives her a chance to reach her full potential in the classroom as well.  You enable her to have three meals a day, a place to sleep and access to the education she needs.\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"none\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"with mixed  reactions\",\"en_family_communicat\":\"through gestures\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"Class 4 H.I\",\"en_family_details\":\"both parents\",\"en_father_name\":\"Chengo Cahro\",\"en_fathers_occupatio\":\"mechanic\",\"en_mothers_name\":\"Kazosi Kahindi\",\"en_mothers_occupatio\":\"Peasant Farmer\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"3\",\"en_number_of_sisters\":\"2\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"the parents are very supportive to Joyce education\",\"en_house_location\":\"Langobaya\",\"en_distance_away\":\"40km\",\"en_house_state\":\"mud\\/mabati\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12800\",\"en_other_needs\":\"none\",\"en_languages\":\"sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"Pefa church\",\"en_favorite_activity\":\"Athletics, dancing, watching movies and acting drama\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Pwani Secondary School for the Deaf.\",\"en_out_reach_app_cas\":\"e0ae93d8c2564c3e91e74e5b66a2d246\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"120\",\"en_cid\":\"KP5\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Joyce",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/d4ada57fa1776892dd04af5337e7731f.jpg",
    "donations": [],
    "entity": {
      "id": 47506,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Joyce\",\"en_second_name\":\"\",\"en_last_name_1\":\"Kalu\",\"en_last_name_2\":\"Jefwa\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"01\\/01\\/1998\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Joyce is a young woman who is deaf and mute. She communicates using sign language. After working with Kupenda, Joyce now understands that she can be an athlete despite her deafness. She has taken on a love for running and now races at the provincial level. However, being one of seven in the family has its downsides. Both of Joyce\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents have a very unstable income, and neither of them makes enough to pay for her boarding fees. With sponsorship, Joyce would be given the chance to continue running, and reach her full academic potential as well.\",\"en_private_comments\":\"October 11, 2022\\r\\nJoyce is enrolled at the Gede Vocational Centre.  She is studying tailoring.  She has started her course by cutting and sewing pieces of paper before she uses cloth.  She is happy to in her studies and asks questions when she doesn't understand.\\r\\n\\r\\nJoyce uses sign language for all of her communication needs.  At least one parent can communicate with her regarding her basic needs.  This past year she has been healthy and active with no illness or fever.\\r\\n\\r\\nJoyce is friendly, kind, and helpful to others.  She is a social and friendly girl who enjoys the company of others.  She enjoys watching television and talking with her friends.  She has competed in the county games.  \\r\\n\\r\\nThe family relies on farming for their livelihood.  Unfortunately, the area is experiencing a prolonged drought which is causing the farms to suffer.  \\r\\nFebruary 26, 2021\\r\\nJoyce is 23 years old and a student at Pwani Vocational School for the Deaf. Her performance is average.  She performs better in KSL than in other subjects.  The teachers have organizied remedial classes to assist her inother subjects.\\r\\n    Joyce is friendly and always helpful to others.  She is active in sports and games.  She enjoys watching television, talking with friends, and playing team sports.She has competed at the county level in running and netball. She is always happy, obedient, and respectful to teachers and prefects. \\r\\n    Kuhenza pays school fees,sensitizes the family on the rights of their child, and has linked the family to alternative funding opportunities.\\r\\n\\r\\n\\r\\nJuly 24, 2020 (Quick Update)\\r\\nThe child learns at Pwani Secondary school for the Deaf. She s in form 3.  Her family is receiving food support.\\r\\n3\\/10\\/20\\r\\nJoyce is now a student at Pwani School for the Deaf in form 3.  She enjoys her classes in KSl and actively participates in group activities. She has been concentrating more on her subjects unlike previous years when she only wanted to make friends.\\r\\n      Joyce is friendly and helpful to others.  She is active in games and sports.  She enjoys watching television, trading stories with friends, and playing team sports.  She competes in long distance races and netball.  This year she competed at the county level. She is a member of the sports club.\\r\\n     This year one of her parents became ill butt overall the parents are putting in more of an effort to make sure Joyce is at school on time.  They also had a good year on the farm.\\r\\n8\\/10\\/2017\\r\\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \\r\\n       Joyce is now a 19 year old young woman attending Gede Special School.  She is in 8th grade.  She is having trouble with her academics as hearing impaired students struggle with abstract concepts.  Her behavior is improving with the help of guidance and counseling sessions.  She understands her self better and is moving toward accepting her disability.\\r\\n       Joyce interacts with others really well.  She is very social.  She enjoys athletics including volleyball and net ball.  She competed in the coast regional games and was awarded certificates for her performance.  She also likes music, dancing, and drama.\\r\\n       Her parents are loving and  they have a positive attitude towards Joyce.  They provide basic toiletries and uniforms as well as participating in school activities. Joyce is a loving girl who helps care for the younger students at school.\\r\\n        Thank you for your sponsorship.  It has enabled Joyce to develop her full potential academically, socially, and athletically.  \\r\\n\\r\\n10\\/30\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nJoyce is now 16 years old and in the fifth grade at the Gede Special School.  Her teachers say her sign language skills are improving.  She can now finger spell and sign read sentences.  In her free time, she enjoys playing netball and handball. She always has a broad smile and loves playing with others at the school.  \\r\\nJoyce\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are supportive of her education.  They contribute what they can to her school supplies and to the Parent Teacher Association (PTA).  They also take her to church with them and visit her often at the school.  Joyce is helpful with chores at home like fetching water and firewood, cooking, washing clothes and helping to look after her younger siblings.  When she is finished with school, Joyce would like to be a waitress.  \\r\\nThank you for making a difference!\\r\\n\\r\\n(18TH JULY,2013)\\r\\nJoyce is beautiful 15 year-old young lady who is now in class four.  Her disability is responsible for the delay in her studies. During her free time she likes to dance, act, narrate stories and watch movies. She is a very happy girl.  She has wonderful social skills, and she likes to play with other children both at school and at home.  She is learning sign language, and she uses it to effectively communicate with others at school.  Her school work shows impressive achievement.  She is ranked in the top three positions with an average grade of C in all her subjects.  Her teachers love having her as a pupil! Her favorite subject is Social Studies. Her parents are very supportive in her education.  They try to ensure that Joyce is in school on time and they contribute towards the development of the school despite the fact that they are earning very little for a living.\\r\\nJoyce and her family members are very grateful for your continued support in her education since it has helped her to develop into a person who is full of hope for her life. She wants to become a teacher when she completes her studies.\\r\\nThank you so much for your continued support to Joyce!\\r\\n(Uploaded on 18th July,2013)\\r\\n\\r\\n\\r\\n\\r\\nJoyce is a fourteen year old girl who was born deaf.  Because of this, she is also unable to speak.  Joyce knows sign language and is able to communicate though still needs to work on it a bit more.  \\r\\n\\r\\nHer mother is a peasant farmer and her father is a mechanic.  With almost no income from her mother, and very inconsistent, low income from her father, the family of seven struggles.  Although her parents want her to get an education at Gede Special School, they cannot afford her boarding fees and their home is too far from the school to commute every day.  \\r\\n\\r\\nJoyce, with help from Kupenda, now understands that she can participate in athletics despite her deafness.  She took a liking to running and has recently moved up from the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s junior racing team to racing at the provincial level.  \\r\\n\\r\\nShe and her family appreciate your gift of sponsorship because it gives her a chance to reach her full potential in the classroom as well.  You enable her to have three meals a day, a place to sleep and access to the education she needs.\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"none\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"with mixed  reactions\",\"en_family_communicat\":\"through gestures\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"Class 4 H.I\",\"en_family_details\":\"both parents\",\"en_father_name\":\"Chengo Cahro\",\"en_fathers_occupatio\":\"mechanic\",\"en_mothers_name\":\"Kazosi Kahindi\",\"en_mothers_occupatio\":\"Peasant Farmer\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"3\",\"en_number_of_sisters\":\"2\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"the parents are very supportive to Joyce education\",\"en_house_location\":\"Langobaya\",\"en_distance_away\":\"40km\",\"en_house_state\":\"mud\\/mabati\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12800\",\"en_other_needs\":\"none\",\"en_languages\":\"sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"Pefa church\",\"en_favorite_activity\":\"Athletics, dancing, watching movies and acting drama\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Pwani Secondary School for the Deaf.\",\"en_out_reach_app_cas\":\"e0ae93d8c2564c3e91e74e5b66a2d246\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"120\",\"en_cid\":\"KP5\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/d4ada57fa1776892dd04af5337e7731f_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Joyce ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47505,
    "profile": {
      "en_first_name": "Furaha",
      "en_second_name": "",
      "en_last_name_1": "Leonard",
      "en_last_name_2": "Mariga",
      "en_gender": "Female",
      "en_date_of_birth": "01/01/1996",
      "en_mental_disability": "Normal",
      "en_public_comments": "Furaha is a young girl who is unable to hear, and has trouble speaking. Unfortunately, this means that she is unable to participate in normal classroom settings. Furaha and her three sisters are currently supported only by their father in a home that is 25 kilometers away from the Gede Special School. With sponsorship, Furaha will be able to be transported to and from school, and she will be enabled to pursue her passion for drama and dancing.",
      "en_private_comments": "February 14, 2023\r\nFuraha is a student at Gede Vocational Centre.  She has mastered most of the beauty therapy and hairdressings skills.  She is waiting to do her final examination in April of 2023.  Her favorite skill is facial work.\r\n\r\nFuraha is friendly, kind, and helpful to others.  She enjoys spending time with her many friends at home and at school.  She also enjoys watching television and plaiting hair.\r\n\r\nFuraha is married and pregnant.  She is more confident now that she has mastered skills to generate an income to help support her growing family.  \r\n\r\nFebruary 8, 2022\r\nFuraha is now 26 years old. She is attending Gede Vocational Center.  She is taking a course in beauty therapy.  she has mastered some skills like plaiting, shaping eyebrows, hair settings, and facial makeup.\r\n\r\nFuraha Has difficulty hearing sounds like people's voices or music.  She needs to look directly at the speaker and be close to the speaker to understand.  She has hearing aids but does not use them. She uses sign language for all her communication needs. She has been healthy this past year.  friendly, kind, and helpful to others.  She has many friends at home and at school.\r\nHer father is a hotel cook.  After giving birth Furaha's in-laws encouraged her return to school and are paying for her transportation and other needs.\r\n\r\n\r\nSeptember 1, 2020\r\nFuraha wanted to be an early childhood education teacher but while in college she got pregnant and was married to a fellow hearing impaired student who is volunteering as a teacher aid at Kakayuni Special School for the Deaf.  She has a baby but her mother in law is willing to nurse the baby and give her time to enroll at Gede Vocational Training Center for a beauty training course because she can no longer continue to pursue her teaching career due to the high entry requirements set by the ministry of education.  This made her change her mind and opt to join Gede Vocational center for Beauty Therapy training. \r\n\r\nHer new family has been counselled on the importance of helping Furaha to enroll at Gede Vocational Center so as to acquire skills that will make her independent.  They agreed and promised to provide transport and items that she will need to enroll at the vocational center when schools open.\r\nJuly 24, 2020\r\nFuraha is married to a fellow HI college student who is currently volunteering at Kakayuni Special School.  Furaha will be joining Gede Vocational Center when schools reopen.  Her family is receiving food support during the pandemic.\r\nJuly 18, 2018\r\n      Furaha is now 22 years old and a student at St. Angela Mumia Secondary Vocational School for the Deaf.  She is doing well academically partially because she has now mastered sign language.  She is very focused on her education and is striving to do well.  She would like to be a teacher when she completes her education.\r\n\r\n      Furaha has been healthy.  She makes friends easily as she really loves other people.  She enjoys watching television in her spare time.\r\n\r\n       Her family love their child and want what is best for them.  However, they rarely come to school to visit her.  They do support her desire to do well in school to become a teacher.  \r\n\r\n      Thank you for your support. Furaha is well on her way to achieve her dream of becoming a teacher and becoming self-reliant.\r\n\r\n3.22.2017\r\nKenya is in the midst of one of its worst droughts in recent history.  This makes it difficult for parents to provide even food for their families.    Many children are lucky to receive one meal a day.  Kupenda recently delivered food staples to some remote villages that were particularly hard hit but even this is a short term fix.  This makes sponsorship even more important because along with academic and medical services our boarding students get three meals a day.\r\n    Furaha is a 16 year old young woman attending Gede Special School.  She is currently in secondary school.  She is passing all of her subjects with English her best and Social Studies her most difficult.  She would like to be a teacher when she completes her education.\r\n      She has become a good actress especially in drama.  She shows talent in her performances.  She is also a good netball player.  Sophia cooperates well with others and loves to make new friends.\r\n      Sophia\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents have been participating in their child\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s education by making sure she reports to school on time.  They also visit her while she is at school.  Unfortunately they have not yet learned sign language.\r\n       Thank you for your sponsorship which has given Sophia opportunities that she would not have had.\r\n\r\n10/28/14\r\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year.  Since Furaha has limited speech he may have benefitted from the speech therapist the Australian Red Cross was scheduled to send to us this year.  However the travel warnings resulted in postponement of this placement until things are deemed safe.  In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.  \r\nFuraha is now 18 years old and in the eighth grade at the Gede Special School.  She also plays soccer and volleyball.  According to her teachers, Furaha has excellent signing skills and has improved academically.  She is always friendly and willing to give a helping hand to anyone who needs it.  \r\nHer mother takes care of Furaha, her 3 sisters and her deaf brother (in grade six at the same school) on her own since the father left them and is uninvolved.  Therefore she is unable to contribute very much financially to Furaha\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s education.  Therefore Furaha is very appreciative of your support.\r\nShe wants to be a teacher one day so your support may impact many others in the future!\r\n\r\nFuraha means \u00c3\u00a2\u00e2\u0082\u00ac\u00c5\u0093happy\u00c3\u00a2\u00e2\u0082\u00ac\u00c2\u009d in Swahili.  Furaha was born a healthy child but became ill when she was only 18 months old.  This illness affected her ability to hear to the point where she cannot participate in normal \r\nclassrooms.  Her speech is also difficult to understand.  Despite her disability, she understands Swahili and sign language.  If she is not able to pay her primary boarding fees at the Gede Special School, she will not be able to attain an education.  Her father is a plot attendant and her mother is a small business woman.  However, her parents are divorced and she and her three sisters are supported by their father only.  Although he wants Furaha to attend school, he cannot pay for her transportation, as they live 25 kilometers from the school.  Furaha means \u00c3\u00a2\u00e2\u0082\u00ac\u00c5\u0093happy\u00c3\u00a2\u00e2\u0082\u00ac\u00c2\u009d in Swahili.  Furaha was born a healthy child but became ill when she was only 18 months old.  This illness affected her ability to hear to the point where she cannot participate in  the mainstream classes.  Her speech is also difficult to understand.  Despite her disability, she understands Swahili and sign language. \r\n\r\nHer father is a caretaker for a private residence and her mother is a small business woman.  However, her parents are divorced and she and her three sisters are supported by their father only.  Although he wants Furaha to attend school, he cannot pay for her transportation, as they live 25 kilometers from the school.  \r\n\r\nShe is passionate about drama and dancing.  She likes to follow beats and rhythms and performs in plays.  Your sponsorship enables her to attend the Gede Special School where she is in class five.\r\n\r\nuploaded on (15th August 2013)\r\nFuraha is 17 years old and she is now in class 7. She continues to do well in school where she maintains an average grade of B in most of her subjects.  She is expected to join a secondary school when she completes her primary education. Her favourite subject is Kenyan sign language in which she scored an A. \r\n\r\nFuraha enjoys socializing with all of the students and teachers at the school and with the people in her community. She plays on the volleyball, football and netball teams and is a very good player. For this term she has even represented her school at the provisional level!  Furaha has gained very good sign language skills which have enabled her to flourish in her studies.  Going to school has enabled Furaha to be a happy and healthy girl in her school and community. She wants to be a teacher when she completes her studies. She is so grateful for your sponsorship and realizes the impact that it is having on her life. Her parents also send their thanks.  They are fully supportive of the school, attending school functions and meetings whenever it is possible and providing her with school items. Your sponsorship is greatly appreciated and is truly a blessing to this young woman\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s life! (uploaded on 15th August,2013)",
      "en_level_hearing": "Normal",
      "en_hearing_test": "Yes",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "can say some words",
      "en_lip_read": "No",
      "en_needs_met": "Yes",
      "en_treated_before": "With sympathy and fear",
      "en_family_communicat": "through gestures",
      "en_school": "Gede Special School",
      "en_class_level": "class  7 H.I",
      "en_family_details": "parents divorced and only father caring for the child",
      "en_father_name": "Leonard Katana",
      "en_fathers_occupatio": "Peasant farmer",
      "en_mothers_name": "Faida Safari",
      "en_mothers_occupatio": "Peasant Farmer",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "3",
      "en_willingness_of_pa": "Unwilling few resources",
      "en_situation_explain": "The father struggles to meet the basic needs of his child as he does not have any form of employment",
      "en_house_location": "Malindi",
      "en_distance_away": "20km",
      "en_house_state": "brick/mabati",
      "en_why_need_sponsors": "Boarding fees",
      "en_total_needed": "12800",
      "en_other_needs": "none",
      "en_languages": "sign, Kiswahili and Giriama",
      "en_religion": "Christian",
      "en_church_name": "Pefa church",
      "en_favorite_activity": "Athletics-she is in the school team\r\nDancing- can follow rhythms and movements\r\nlikes ball games and drama",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Gede Vocational Center",
      "en_out_reach_app_cas": "b0d8d2d1a68042b5b385bee13bf3929c",
      "en_disability_type": "Hearing Impairment",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "118",
      "en_cid": "KP4",
      "id": 47505,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Furaha\",\"en_second_name\":\"\",\"en_last_name_1\":\"Leonard\",\"en_last_name_2\":\"Mariga\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"01\\/01\\/1996\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Furaha is a young girl who is unable to hear, and has trouble speaking. Unfortunately, this means that she is unable to participate in normal classroom settings. Furaha and her three sisters are currently supported only by their father in a home that is 25 kilometers away from the Gede Special School. With sponsorship, Furaha will be able to be transported to and from school, and she will be enabled to pursue her passion for drama and dancing.\",\"en_private_comments\":\"February 14, 2023\\r\\nFuraha is a student at Gede Vocational Centre.  She has mastered most of the beauty therapy and hairdressings skills.  She is waiting to do her final examination in April of 2023.  Her favorite skill is facial work.\\r\\n\\r\\nFuraha is friendly, kind, and helpful to others.  She enjoys spending time with her many friends at home and at school.  She also enjoys watching television and plaiting hair.\\r\\n\\r\\nFuraha is married and pregnant.  She is more confident now that she has mastered skills to generate an income to help support her growing family.  \\r\\n\\r\\nFebruary 8, 2022\\r\\nFuraha is now 26 years old. She is attending Gede Vocational Center.  She is taking a course in beauty therapy.  she has mastered some skills like plaiting, shaping eyebrows, hair settings, and facial makeup.\\r\\n\\r\\nFuraha Has difficulty hearing sounds like people's voices or music.  She needs to look directly at the speaker and be close to the speaker to understand.  She has hearing aids but does not use them. She uses sign language for all her communication needs. She has been healthy this past year.  friendly, kind, and helpful to others.  She has many friends at home and at school.\\r\\nHer father is a hotel cook.  After giving birth Furaha's in-laws encouraged her return to school and are paying for her transportation and other needs.\\r\\n\\r\\n\\r\\nSeptember 1, 2020\\r\\nFuraha wanted to be an early childhood education teacher but while in college she got pregnant and was married to a fellow hearing impaired student who is volunteering as a teacher aid at Kakayuni Special School for the Deaf.  She has a baby but her mother in law is willing to nurse the baby and give her time to enroll at Gede Vocational Training Center for a beauty training course because she can no longer continue to pursue her teaching career due to the high entry requirements set by the ministry of education.  This made her change her mind and opt to join Gede Vocational center for Beauty Therapy training. \\r\\n\\r\\nHer new family has been counselled on the importance of helping Furaha to enroll at Gede Vocational Center so as to acquire skills that will make her independent.  They agreed and promised to provide transport and items that she will need to enroll at the vocational center when schools open.\\r\\nJuly 24, 2020\\r\\nFuraha is married to a fellow HI college student who is currently volunteering at Kakayuni Special School.  Furaha will be joining Gede Vocational Center when schools reopen.  Her family is receiving food support during the pandemic.\\r\\nJuly 18, 2018\\r\\n      Furaha is now 22 years old and a student at St. Angela Mumia Secondary Vocational School for the Deaf.  She is doing well academically partially because she has now mastered sign language.  She is very focused on her education and is striving to do well.  She would like to be a teacher when she completes her education.\\r\\n\\r\\n      Furaha has been healthy.  She makes friends easily as she really loves other people.  She enjoys watching television in her spare time.\\r\\n\\r\\n       Her family love their child and want what is best for them.  However, they rarely come to school to visit her.  They do support her desire to do well in school to become a teacher.  \\r\\n\\r\\n      Thank you for your support. Furaha is well on her way to achieve her dream of becoming a teacher and becoming self-reliant.\\r\\n\\r\\n3.22.2017\\r\\nKenya is in the midst of one of its worst droughts in recent history.  This makes it difficult for parents to provide even food for their families.    Many children are lucky to receive one meal a day.  Kupenda recently delivered food staples to some remote villages that were particularly hard hit but even this is a short term fix.  This makes sponsorship even more important because along with academic and medical services our boarding students get three meals a day.\\r\\n    Furaha is a 16 year old young woman attending Gede Special School.  She is currently in secondary school.  She is passing all of her subjects with English her best and Social Studies her most difficult.  She would like to be a teacher when she completes her education.\\r\\n      She has become a good actress especially in drama.  She shows talent in her performances.  She is also a good netball player.  Sophia cooperates well with others and loves to make new friends.\\r\\n      Sophia\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents have been participating in their child\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education by making sure she reports to school on time.  They also visit her while she is at school.  Unfortunately they have not yet learned sign language.\\r\\n       Thank you for your sponsorship which has given Sophia opportunities that she would not have had.\\r\\n\\r\\n10\\/28\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year.  Since Furaha has limited speech he may have benefitted from the speech therapist the Australian Red Cross was scheduled to send to us this year.  However the travel warnings resulted in postponement of this placement until things are deemed safe.  In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.  \\r\\nFuraha is now 18 years old and in the eighth grade at the Gede Special School.  She also plays soccer and volleyball.  According to her teachers, Furaha has excellent signing skills and has improved academically.  She is always friendly and willing to give a helping hand to anyone who needs it.  \\r\\nHer mother takes care of Furaha, her 3 sisters and her deaf brother (in grade six at the same school) on her own since the father left them and is uninvolved.  Therefore she is unable to contribute very much financially to Furaha\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education.  Therefore Furaha is very appreciative of your support.\\r\\nShe wants to be a teacher one day so your support may impact many others in the future!\\r\\n\\r\\nFuraha means \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093happy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d in Swahili.  Furaha was born a healthy child but became ill when she was only 18 months old.  This illness affected her ability to hear to the point where she cannot participate in normal \\r\\nclassrooms.  Her speech is also difficult to understand.  Despite her disability, she understands Swahili and sign language.  If she is not able to pay her primary boarding fees at the Gede Special School, she will not be able to attain an education.  Her father is a plot attendant and her mother is a small business woman.  However, her parents are divorced and she and her three sisters are supported by their father only.  Although he wants Furaha to attend school, he cannot pay for her transportation, as they live 25 kilometers from the school.  Furaha means \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093happy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d in Swahili.  Furaha was born a healthy child but became ill when she was only 18 months old.  This illness affected her ability to hear to the point where she cannot participate in  the mainstream classes.  Her speech is also difficult to understand.  Despite her disability, she understands Swahili and sign language. \\r\\n\\r\\nHer father is a caretaker for a private residence and her mother is a small business woman.  However, her parents are divorced and she and her three sisters are supported by their father only.  Although he wants Furaha to attend school, he cannot pay for her transportation, as they live 25 kilometers from the school.  \\r\\n\\r\\nShe is passionate about drama and dancing.  She likes to follow beats and rhythms and performs in plays.  Your sponsorship enables her to attend the Gede Special School where she is in class five.\\r\\n\\r\\nuploaded on (15th August 2013)\\r\\nFuraha is 17 years old and she is now in class 7. She continues to do well in school where she maintains an average grade of B in most of her subjects.  She is expected to join a secondary school when she completes her primary education. Her favourite subject is Kenyan sign language in which she scored an A. \\r\\n\\r\\nFuraha enjoys socializing with all of the students and teachers at the school and with the people in her community. She plays on the volleyball, football and netball teams and is a very good player. For this term she has even represented her school at the provisional level!  Furaha has gained very good sign language skills which have enabled her to flourish in her studies.  Going to school has enabled Furaha to be a happy and healthy girl in her school and community. She wants to be a teacher when she completes her studies. She is so grateful for your sponsorship and realizes the impact that it is having on her life. Her parents also send their thanks.  They are fully supportive of the school, attending school functions and meetings whenever it is possible and providing her with school items. Your sponsorship is greatly appreciated and is truly a blessing to this young woman\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life! (uploaded on 15th August,2013)\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Yes\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"can say some words\",\"en_lip_read\":\"No\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"With sympathy and fear\",\"en_family_communicat\":\"through gestures\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"class  7 H.I\",\"en_family_details\":\"parents divorced and only father caring for the child\",\"en_father_name\":\"Leonard Katana\",\"en_fathers_occupatio\":\"Peasant farmer\",\"en_mothers_name\":\"Faida Safari\",\"en_mothers_occupatio\":\"Peasant Farmer\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"3\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"The father struggles to meet the basic needs of his child as he does not have any form of employment\",\"en_house_location\":\"Malindi\",\"en_distance_away\":\"20km\",\"en_house_state\":\"brick\\/mabati\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12800\",\"en_other_needs\":\"none\",\"en_languages\":\"sign, Kiswahili and Giriama\",\"en_religion\":\"Christian\",\"en_church_name\":\"Pefa church\",\"en_favorite_activity\":\"Athletics-she is in the school team\\r\\nDancing- can follow rhythms and movements\\r\\nlikes ball games and drama\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Vocational Center\",\"en_out_reach_app_cas\":\"b0d8d2d1a68042b5b385bee13bf3929c\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"118\",\"en_cid\":\"KP4\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Furaha",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/210e6c0598047c433f9fb617b11f196a.jpg",
    "donations": [],
    "entity": {
      "id": 47505,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Furaha\",\"en_second_name\":\"\",\"en_last_name_1\":\"Leonard\",\"en_last_name_2\":\"Mariga\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"01\\/01\\/1996\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Furaha is a young girl who is unable to hear, and has trouble speaking. Unfortunately, this means that she is unable to participate in normal classroom settings. Furaha and her three sisters are currently supported only by their father in a home that is 25 kilometers away from the Gede Special School. With sponsorship, Furaha will be able to be transported to and from school, and she will be enabled to pursue her passion for drama and dancing.\",\"en_private_comments\":\"February 14, 2023\\r\\nFuraha is a student at Gede Vocational Centre.  She has mastered most of the beauty therapy and hairdressings skills.  She is waiting to do her final examination in April of 2023.  Her favorite skill is facial work.\\r\\n\\r\\nFuraha is friendly, kind, and helpful to others.  She enjoys spending time with her many friends at home and at school.  She also enjoys watching television and plaiting hair.\\r\\n\\r\\nFuraha is married and pregnant.  She is more confident now that she has mastered skills to generate an income to help support her growing family.  \\r\\n\\r\\nFebruary 8, 2022\\r\\nFuraha is now 26 years old. She is attending Gede Vocational Center.  She is taking a course in beauty therapy.  she has mastered some skills like plaiting, shaping eyebrows, hair settings, and facial makeup.\\r\\n\\r\\nFuraha Has difficulty hearing sounds like people's voices or music.  She needs to look directly at the speaker and be close to the speaker to understand.  She has hearing aids but does not use them. She uses sign language for all her communication needs. She has been healthy this past year.  friendly, kind, and helpful to others.  She has many friends at home and at school.\\r\\nHer father is a hotel cook.  After giving birth Furaha's in-laws encouraged her return to school and are paying for her transportation and other needs.\\r\\n\\r\\n\\r\\nSeptember 1, 2020\\r\\nFuraha wanted to be an early childhood education teacher but while in college she got pregnant and was married to a fellow hearing impaired student who is volunteering as a teacher aid at Kakayuni Special School for the Deaf.  She has a baby but her mother in law is willing to nurse the baby and give her time to enroll at Gede Vocational Training Center for a beauty training course because she can no longer continue to pursue her teaching career due to the high entry requirements set by the ministry of education.  This made her change her mind and opt to join Gede Vocational center for Beauty Therapy training. \\r\\n\\r\\nHer new family has been counselled on the importance of helping Furaha to enroll at Gede Vocational Center so as to acquire skills that will make her independent.  They agreed and promised to provide transport and items that she will need to enroll at the vocational center when schools open.\\r\\nJuly 24, 2020\\r\\nFuraha is married to a fellow HI college student who is currently volunteering at Kakayuni Special School.  Furaha will be joining Gede Vocational Center when schools reopen.  Her family is receiving food support during the pandemic.\\r\\nJuly 18, 2018\\r\\n      Furaha is now 22 years old and a student at St. Angela Mumia Secondary Vocational School for the Deaf.  She is doing well academically partially because she has now mastered sign language.  She is very focused on her education and is striving to do well.  She would like to be a teacher when she completes her education.\\r\\n\\r\\n      Furaha has been healthy.  She makes friends easily as she really loves other people.  She enjoys watching television in her spare time.\\r\\n\\r\\n       Her family love their child and want what is best for them.  However, they rarely come to school to visit her.  They do support her desire to do well in school to become a teacher.  \\r\\n\\r\\n      Thank you for your support. Furaha is well on her way to achieve her dream of becoming a teacher and becoming self-reliant.\\r\\n\\r\\n3.22.2017\\r\\nKenya is in the midst of one of its worst droughts in recent history.  This makes it difficult for parents to provide even food for their families.    Many children are lucky to receive one meal a day.  Kupenda recently delivered food staples to some remote villages that were particularly hard hit but even this is a short term fix.  This makes sponsorship even more important because along with academic and medical services our boarding students get three meals a day.\\r\\n    Furaha is a 16 year old young woman attending Gede Special School.  She is currently in secondary school.  She is passing all of her subjects with English her best and Social Studies her most difficult.  She would like to be a teacher when she completes her education.\\r\\n      She has become a good actress especially in drama.  She shows talent in her performances.  She is also a good netball player.  Sophia cooperates well with others and loves to make new friends.\\r\\n      Sophia\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents have been participating in their child\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education by making sure she reports to school on time.  They also visit her while she is at school.  Unfortunately they have not yet learned sign language.\\r\\n       Thank you for your sponsorship which has given Sophia opportunities that she would not have had.\\r\\n\\r\\n10\\/28\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year.  Since Furaha has limited speech he may have benefitted from the speech therapist the Australian Red Cross was scheduled to send to us this year.  However the travel warnings resulted in postponement of this placement until things are deemed safe.  In spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.  \\r\\nFuraha is now 18 years old and in the eighth grade at the Gede Special School.  She also plays soccer and volleyball.  According to her teachers, Furaha has excellent signing skills and has improved academically.  She is always friendly and willing to give a helping hand to anyone who needs it.  \\r\\nHer mother takes care of Furaha, her 3 sisters and her deaf brother (in grade six at the same school) on her own since the father left them and is uninvolved.  Therefore she is unable to contribute very much financially to Furaha\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s education.  Therefore Furaha is very appreciative of your support.\\r\\nShe wants to be a teacher one day so your support may impact many others in the future!\\r\\n\\r\\nFuraha means \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093happy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d in Swahili.  Furaha was born a healthy child but became ill when she was only 18 months old.  This illness affected her ability to hear to the point where she cannot participate in normal \\r\\nclassrooms.  Her speech is also difficult to understand.  Despite her disability, she understands Swahili and sign language.  If she is not able to pay her primary boarding fees at the Gede Special School, she will not be able to attain an education.  Her father is a plot attendant and her mother is a small business woman.  However, her parents are divorced and she and her three sisters are supported by their father only.  Although he wants Furaha to attend school, he cannot pay for her transportation, as they live 25 kilometers from the school.  Furaha means \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093happy\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d in Swahili.  Furaha was born a healthy child but became ill when she was only 18 months old.  This illness affected her ability to hear to the point where she cannot participate in  the mainstream classes.  Her speech is also difficult to understand.  Despite her disability, she understands Swahili and sign language. \\r\\n\\r\\nHer father is a caretaker for a private residence and her mother is a small business woman.  However, her parents are divorced and she and her three sisters are supported by their father only.  Although he wants Furaha to attend school, he cannot pay for her transportation, as they live 25 kilometers from the school.  \\r\\n\\r\\nShe is passionate about drama and dancing.  She likes to follow beats and rhythms and performs in plays.  Your sponsorship enables her to attend the Gede Special School where she is in class five.\\r\\n\\r\\nuploaded on (15th August 2013)\\r\\nFuraha is 17 years old and she is now in class 7. She continues to do well in school where she maintains an average grade of B in most of her subjects.  She is expected to join a secondary school when she completes her primary education. Her favourite subject is Kenyan sign language in which she scored an A. \\r\\n\\r\\nFuraha enjoys socializing with all of the students and teachers at the school and with the people in her community. She plays on the volleyball, football and netball teams and is a very good player. For this term she has even represented her school at the provisional level!  Furaha has gained very good sign language skills which have enabled her to flourish in her studies.  Going to school has enabled Furaha to be a happy and healthy girl in her school and community. She wants to be a teacher when she completes her studies. She is so grateful for your sponsorship and realizes the impact that it is having on her life. Her parents also send their thanks.  They are fully supportive of the school, attending school functions and meetings whenever it is possible and providing her with school items. Your sponsorship is greatly appreciated and is truly a blessing to this young woman\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life! (uploaded on 15th August,2013)\",\"en_level_hearing\":\"Normal\",\"en_hearing_test\":\"Yes\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"can say some words\",\"en_lip_read\":\"No\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"With sympathy and fear\",\"en_family_communicat\":\"through gestures\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"class  7 H.I\",\"en_family_details\":\"parents divorced and only father caring for the child\",\"en_father_name\":\"Leonard Katana\",\"en_fathers_occupatio\":\"Peasant farmer\",\"en_mothers_name\":\"Faida Safari\",\"en_mothers_occupatio\":\"Peasant Farmer\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"3\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"The father struggles to meet the basic needs of his child as he does not have any form of employment\",\"en_house_location\":\"Malindi\",\"en_distance_away\":\"20km\",\"en_house_state\":\"brick\\/mabati\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12800\",\"en_other_needs\":\"none\",\"en_languages\":\"sign, Kiswahili and Giriama\",\"en_religion\":\"Christian\",\"en_church_name\":\"Pefa church\",\"en_favorite_activity\":\"Athletics-she is in the school team\\r\\nDancing- can follow rhythms and movements\\r\\nlikes ball games and drama\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Vocational Center\",\"en_out_reach_app_cas\":\"b0d8d2d1a68042b5b385bee13bf3929c\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"118\",\"en_cid\":\"KP4\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/210e6c0598047c433f9fb617b11f196a_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Furaha ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47504,
    "profile": {
      "en_first_name": "Fatuma",
      "en_second_name": "",
      "en_last_name_1": "Mwalimu",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "10/01/2001",
      "en_mental_disability": "none",
      "en_public_comments": "Fatuma is a young girl who battled meningitis at a young age, and as a result, is completely deaf. Although she is very loved by her parents, their income is too inconsistent to provide for her boarding school fees. Fatuma currently communicates using sign language. She loves to play netball and other ball games. With sponsorship, she will be able to thrive in the supportive environment of the Gede Special School.",
      "en_private_comments": "January 13, 2023\r\nFatuma is now 21 years old and has recently completed her secondary education.  She is now waiting to join Gede Vocational Centre for a hairdressing and beauty course this year.\r\n\r\nFatuma is friendly, kind, and helpful to others.  She has been gaining many friends who have been visiting her at home and work together.  She enjoys doing household chores and spending time with her friends.\r\n\r\nOur staff in Kenya are counselling Fatuma and her family.  Fatuma is hoping that she can make it in life and that she can achieve anything she wants.  Her family now understands the importance of education.\r\n\r\nPoor soil and an insect infestation have made it difficult for the family to earn an income from their farm.  The area of the farm is experiencing a four year long drought.  It has recently rained in the region, but it will take three months before harvest.   Until then Kupenda is providing food for the family through local vendors.\r\n\r\nYour support is helping Fatuma to accomplish her dream and her family to have food to eat.  Thank you.\r\n\r\nNovember 8, 2021\r\n     Fatuma is now 20 years old and is a senior at Pwani Special Secondary School for the Deaf.  She is an  average student. She is strongest in Kenya Sign Language but struggles with other subjects.  She is organized and careful.  She does not lose her personal items.  Her teachers are working with her on study habits that may help to raise performance.\r\n     Fatuma can hear some sounds like a loud bang or a truck but can not distinguish voices.  She has hearing aids but does not use them because her hearing loss is so profound, they do not do much good.  She has no speech but at least one family member can communicate through sign language and gestures. Fatuma has had no other health issues this past year.\r\n      Fatuma is friendly, kind, and helpful to others. She has many friends who play volleyball and netball together during games time. She has competed at the National Games. She is a member of the drama and music club.  She enjoys watching television, talking with friends, and playing team sports.  \r\n       Counseling sessions with the parents on the rights of their child has empowered them with proper information on how to care and advocate for their child.  The father faced challenges in earning an income because his place of work was closed because of Covid-19.  The family farm also suffered from a prolonged drought.  Your support ensures that Fatuma will complete her education despite the family hardships.  Thank you.\r\n\r\nJune 13 2020\r\nFatuma is now 19 years old and a student at Pwani Secondary School for the Deaf.  She is currently in form 3 (Junior year).  Due to the Covid-19 pandemic all schools in Kenya were closed and Fatuma went home before taking final exams for the semester. She does well in Kenyan Sign Language but continues to be weak in other subjects.  Her teacher plans to engage her in remedial studies when the students return to school, hopefully in January 2021.\r\n\r\nFatuma is a responsible girl who enjoys watching television, trading stories with friends, and playing team sports.  She is a member of her school\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s Integrity Club where members of the club counsel other students who have exhibited bad behavior.  She competes in volleyball, netball, and running.  She has competed at  the regional, county and national level.\r\n\r\nCounselling by Kupenda staff have improved the child\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s support in accessing education.  Family member have been providing the child with toiletries and transport to school during half-term beaks and when school closes.  Her parents have also been applying for the ward bursary fund to raise part of the child\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s boarding fees.\r\n\r\nThings are improving for Fatuma.  Thank you for your support that is providing educational, social, and athletic opportunities for this young girl.\r\n\r\nApril 11, 2019\r\nFatuma is now 18 years old and in her 2nd year at Pwani Secondary School for the Deaf.  She has not yet done the end of year exam so there are no grades available.  Her teachers report that her work is improving and that she is well disciplined.\r\n\r\nFatuma is friendly and makes friends easily.  She participates in track events, netball, and volleyball.  She competed at the regional games this year and was awarded certificates for her efforts.  She likes to tell stories and participate in games during free time.\r\n\r\nHer father and brother are her main caretakers.  They love her and do not discriminate against her because of her disability.  They make sure she gets to school on time after holidays and visit her while she is at school.  They also provide her toiletries and uniforms.\r\n\r\nYour sponsorship is providing many opportunities for Fatuma.  She has been instructed in sign language and uses it for communication.  She has benefitted from counseling, guidance, and advocacy.  She has her boarding fees paid which give her opportunities to learn, develop athletically, and make friends.  Thank you for your generosity.\r\n\r\nMarch 22, 2018\r\nExciting things are happening for children with disabilities in Kenya.  A large plot of land was donated to build a new special school in a remote village.  Plans are being made to build a new dormitory at one of our existing schools.  More staff is being added in Kenya to be able to work  with these children.  Our Kenyan director and our USA director are conducting workshops for pastors, natural healers, parents and government leaders on responsibility towards children with disability.  Things are looking up for the children that Kupenda serves.\r\n\r\n       Fatuma is now 17 years old and a student at Gede Special School. She is doing well but her teacher thinks she could do better.  She has accepted her disability but needs counseling to direct her as she grows up.\r\n\r\n      Fatuma is a friendly young lady.  She is helpful and works well under supervision.  She participates in volleyball, handball, and netball.  She has competed at the national level and been awarded certificates for her efforts.  She also enjoys swimming and legball.\r\n\r\n       Her family is working hard to provide for their child.  They are co-operative, understanding, and committed to their daughter\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s well being.\r\n\r\n     Fatuma really appreciates your sponsorship.  She is grateful to have the opportunity to attend school where she is a successful student and athlete.\r\n\r\n10/27/14\r\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\r\nFatuma is now 18 years old and in the fifth grade at the Gede Special School.  Her teachers say she has excellent signing skills along with being very disciplined and very supportive of others.  She is also involved with the school\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s drama team.  \r\nHer parents always visit her while at school and contribute what they can to the school\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s development.  They also regular attend the Parent Teacher Association (PTA) meetings.  Fatuma\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s parents are learning sign language as part of the Kupenda funded workshops.  Most parents of deaf children do not have the ability to communicate with their children so this is a significant development.  They also take her to church with them.  \r\nFatuma would like to be a tailor when she finishes school.  Thank you for supporting her!\r\n\r\n(18TH JULY,2013)\r\nFatuma has progressed to grade 5 at Gede Special School. She is very active extra-curricular activities like netball, volley ball and acting. Last year she represented her school in netball and volleyball at the national level. She is above average in class work and her favorite subject is science. \r\nHer parents support her in her education by providing her basic items such as toiletries. At home Fatuma is doing house chores as any other Giriama girl of her age. She usually cooks, fetches water, digs, sweeps, does laundry, fetches firewood and helps her mother look after her younger siblings.  \r\nFatuma do appreciate your sponsorship and she always prays for you. She would like to be a nurse when she completes her studies so that she can serve her community especially those who have disabilities.\r\nThank you for your sponsorship and the love you have shown to Fatuma  as it has enabled her to have 3 meals per day as well as education.  (Uploaded on 24th July,2013)\r\n\r\n\r\n\r\n\r\n\r\n\r\nFatuma is a young girl who loves netball and other ball games.  When she was three years old, Fatuma grew ill with meningitis and became completely deaf.  Her mother is a peasant farmer and her father is a house cleaner.  Her father does not have a regular work schedule and the lack of consistent income to the family of seven makes it very difficult for them.  Fatuma is loved by her family but they cannot pay for her boarding fees.  She communicates using sign language because she has no ability so speak.  With sponsorship, Fatuma will enter primary class three and will live in the supportive environment that the Gede Special School provides.",
      "en_level_hearing": "none",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_needs_met": "Yes",
      "en_treated_before": "with pitty",
      "en_family_communicat": "Gestures",
      "en_school": "Gede Special School",
      "en_class_level": "class 5 HI",
      "en_family_details": "both parents",
      "en_father_name": "Mwalimu Charo Mangi",
      "en_fathers_occupatio": "house cleaner",
      "en_mothers_name": "Zawadi Katana",
      "en_mothers_occupatio": "pesant farmer",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "2",
      "en_number_of_sisters": "2",
      "en_willingness_of_pa": "willing few resources",
      "en_situation_explain": "The parents are not capable of paying boarding fees to Fatuma",
      "en_house_location": "Gongoni",
      "en_distance_away": "30 km",
      "en_house_state": "brick/mabati",
      "en_why_need_sponsors": "Boarding fees",
      "en_total_needed": "12800",
      "en_other_needs": "none",
      "en_languages": "sign",
      "en_religion": "Christian",
      "en_church_name": "not known",
      "en_favorite_activity": "Athletic, music, dancing, watching movies and acting drama",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Pwani Secondary School for the Deaf",
      "en_out_reach_app_cas": "d63ac309560341e3b0195b4ca325fbdb",
      "en_disability_type": "Hearing Impairment",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "117",
      "en_cid": "KP3",
      "id": 47504,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Fatuma\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mwalimu\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"10\\/01\\/2001\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Fatuma is a young girl who battled meningitis at a young age, and as a result, is completely deaf. Although she is very loved by her parents, their income is too inconsistent to provide for her boarding school fees. Fatuma currently communicates using sign language. She loves to play netball and other ball games. With sponsorship, she will be able to thrive in the supportive environment of the Gede Special School.\",\"en_private_comments\":\"January 13, 2023\\r\\nFatuma is now 21 years old and has recently completed her secondary education.  She is now waiting to join Gede Vocational Centre for a hairdressing and beauty course this year.\\r\\n\\r\\nFatuma is friendly, kind, and helpful to others.  She has been gaining many friends who have been visiting her at home and work together.  She enjoys doing household chores and spending time with her friends.\\r\\n\\r\\nOur staff in Kenya are counselling Fatuma and her family.  Fatuma is hoping that she can make it in life and that she can achieve anything she wants.  Her family now understands the importance of education.\\r\\n\\r\\nPoor soil and an insect infestation have made it difficult for the family to earn an income from their farm.  The area of the farm is experiencing a four year long drought.  It has recently rained in the region, but it will take three months before harvest.   Until then Kupenda is providing food for the family through local vendors.\\r\\n\\r\\nYour support is helping Fatuma to accomplish her dream and her family to have food to eat.  Thank you.\\r\\n\\r\\nNovember 8, 2021\\r\\n     Fatuma is now 20 years old and is a senior at Pwani Special Secondary School for the Deaf.  She is an  average student. She is strongest in Kenya Sign Language but struggles with other subjects.  She is organized and careful.  She does not lose her personal items.  Her teachers are working with her on study habits that may help to raise performance.\\r\\n     Fatuma can hear some sounds like a loud bang or a truck but can not distinguish voices.  She has hearing aids but does not use them because her hearing loss is so profound, they do not do much good.  She has no speech but at least one family member can communicate through sign language and gestures. Fatuma has had no other health issues this past year.\\r\\n      Fatuma is friendly, kind, and helpful to others. She has many friends who play volleyball and netball together during games time. She has competed at the National Games. She is a member of the drama and music club.  She enjoys watching television, talking with friends, and playing team sports.  \\r\\n       Counseling sessions with the parents on the rights of their child has empowered them with proper information on how to care and advocate for their child.  The father faced challenges in earning an income because his place of work was closed because of Covid-19.  The family farm also suffered from a prolonged drought.  Your support ensures that Fatuma will complete her education despite the family hardships.  Thank you.\\r\\n\\r\\nJune 13 2020\\r\\nFatuma is now 19 years old and a student at Pwani Secondary School for the Deaf.  She is currently in form 3 (Junior year).  Due to the Covid-19 pandemic all schools in Kenya were closed and Fatuma went home before taking final exams for the semester. She does well in Kenyan Sign Language but continues to be weak in other subjects.  Her teacher plans to engage her in remedial studies when the students return to school, hopefully in January 2021.\\r\\n\\r\\nFatuma is a responsible girl who enjoys watching television, trading stories with friends, and playing team sports.  She is a member of her school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Integrity Club where members of the club counsel other students who have exhibited bad behavior.  She competes in volleyball, netball, and running.  She has competed at  the regional, county and national level.\\r\\n\\r\\nCounselling by Kupenda staff have improved the child\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s support in accessing education.  Family member have been providing the child with toiletries and transport to school during half-term beaks and when school closes.  Her parents have also been applying for the ward bursary fund to raise part of the child\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s boarding fees.\\r\\n\\r\\nThings are improving for Fatuma.  Thank you for your support that is providing educational, social, and athletic opportunities for this young girl.\\r\\n\\r\\nApril 11, 2019\\r\\nFatuma is now 18 years old and in her 2nd year at Pwani Secondary School for the Deaf.  She has not yet done the end of year exam so there are no grades available.  Her teachers report that her work is improving and that she is well disciplined.\\r\\n\\r\\nFatuma is friendly and makes friends easily.  She participates in track events, netball, and volleyball.  She competed at the regional games this year and was awarded certificates for her efforts.  She likes to tell stories and participate in games during free time.\\r\\n\\r\\nHer father and brother are her main caretakers.  They love her and do not discriminate against her because of her disability.  They make sure she gets to school on time after holidays and visit her while she is at school.  They also provide her toiletries and uniforms.\\r\\n\\r\\nYour sponsorship is providing many opportunities for Fatuma.  She has been instructed in sign language and uses it for communication.  She has benefitted from counseling, guidance, and advocacy.  She has her boarding fees paid which give her opportunities to learn, develop athletically, and make friends.  Thank you for your generosity.\\r\\n\\r\\nMarch 22, 2018\\r\\nExciting things are happening for children with disabilities in Kenya.  A large plot of land was donated to build a new special school in a remote village.  Plans are being made to build a new dormitory at one of our existing schools.  More staff is being added in Kenya to be able to work  with these children.  Our Kenyan director and our USA director are conducting workshops for pastors, natural healers, parents and government leaders on responsibility towards children with disability.  Things are looking up for the children that Kupenda serves.\\r\\n\\r\\n       Fatuma is now 17 years old and a student at Gede Special School. She is doing well but her teacher thinks she could do better.  She has accepted her disability but needs counseling to direct her as she grows up.\\r\\n\\r\\n      Fatuma is a friendly young lady.  She is helpful and works well under supervision.  She participates in volleyball, handball, and netball.  She has competed at the national level and been awarded certificates for her efforts.  She also enjoys swimming and legball.\\r\\n\\r\\n       Her family is working hard to provide for their child.  They are co-operative, understanding, and committed to their daughter\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s well being.\\r\\n\\r\\n     Fatuma really appreciates your sponsorship.  She is grateful to have the opportunity to attend school where she is a successful student and athlete.\\r\\n\\r\\n10\\/27\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nFatuma is now 18 years old and in the fifth grade at the Gede Special School.  Her teachers say she has excellent signing skills along with being very disciplined and very supportive of others.  She is also involved with the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s drama team.  \\r\\nHer parents always visit her while at school and contribute what they can to the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s development.  They also regular attend the Parent Teacher Association (PTA) meetings.  Fatuma\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are learning sign language as part of the Kupenda funded workshops.  Most parents of deaf children do not have the ability to communicate with their children so this is a significant development.  They also take her to church with them.  \\r\\nFatuma would like to be a tailor when she finishes school.  Thank you for supporting her!\\r\\n\\r\\n(18TH JULY,2013)\\r\\nFatuma has progressed to grade 5 at Gede Special School. She is very active extra-curricular activities like netball, volley ball and acting. Last year she represented her school in netball and volleyball at the national level. She is above average in class work and her favorite subject is science. \\r\\nHer parents support her in her education by providing her basic items such as toiletries. At home Fatuma is doing house chores as any other Giriama girl of her age. She usually cooks, fetches water, digs, sweeps, does laundry, fetches firewood and helps her mother look after her younger siblings.  \\r\\nFatuma do appreciate your sponsorship and she always prays for you. She would like to be a nurse when she completes her studies so that she can serve her community especially those who have disabilities.\\r\\nThank you for your sponsorship and the love you have shown to Fatuma  as it has enabled her to have 3 meals per day as well as education.  (Uploaded on 24th July,2013)\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n\\r\\nFatuma is a young girl who loves netball and other ball games.  When she was three years old, Fatuma grew ill with meningitis and became completely deaf.  Her mother is a peasant farmer and her father is a house cleaner.  Her father does not have a regular work schedule and the lack of consistent income to the family of seven makes it very difficult for them.  Fatuma is loved by her family but they cannot pay for her boarding fees.  She communicates using sign language because she has no ability so speak.  With sponsorship, Fatuma will enter primary class three and will live in the supportive environment that the Gede Special School provides.\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"with pitty\",\"en_family_communicat\":\"Gestures\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"class 5 HI\",\"en_family_details\":\"both parents\",\"en_father_name\":\"Mwalimu Charo Mangi\",\"en_fathers_occupatio\":\"house cleaner\",\"en_mothers_name\":\"Zawadi Katana\",\"en_mothers_occupatio\":\"pesant farmer\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"2\",\"en_number_of_sisters\":\"2\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"The parents are not capable of paying boarding fees to Fatuma\",\"en_house_location\":\"Gongoni\",\"en_distance_away\":\"30 km\",\"en_house_state\":\"brick\\/mabati\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12800\",\"en_other_needs\":\"none\",\"en_languages\":\"sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"not known\",\"en_favorite_activity\":\"Athletic, music, dancing, watching movies and acting drama\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Pwani Secondary School for the Deaf\",\"en_out_reach_app_cas\":\"d63ac309560341e3b0195b4ca325fbdb\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"117\",\"en_cid\":\"KP3\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Fatuma",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/908a494417b08d854357cb292323d822.jpg",
    "donations": [],
    "entity": {
      "id": 47504,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Fatuma\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mwalimu\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"10\\/01\\/2001\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Fatuma is a young girl who battled meningitis at a young age, and as a result, is completely deaf. Although she is very loved by her parents, their income is too inconsistent to provide for her boarding school fees. Fatuma currently communicates using sign language. She loves to play netball and other ball games. With sponsorship, she will be able to thrive in the supportive environment of the Gede Special School.\",\"en_private_comments\":\"January 13, 2023\\r\\nFatuma is now 21 years old and has recently completed her secondary education.  She is now waiting to join Gede Vocational Centre for a hairdressing and beauty course this year.\\r\\n\\r\\nFatuma is friendly, kind, and helpful to others.  She has been gaining many friends who have been visiting her at home and work together.  She enjoys doing household chores and spending time with her friends.\\r\\n\\r\\nOur staff in Kenya are counselling Fatuma and her family.  Fatuma is hoping that she can make it in life and that she can achieve anything she wants.  Her family now understands the importance of education.\\r\\n\\r\\nPoor soil and an insect infestation have made it difficult for the family to earn an income from their farm.  The area of the farm is experiencing a four year long drought.  It has recently rained in the region, but it will take three months before harvest.   Until then Kupenda is providing food for the family through local vendors.\\r\\n\\r\\nYour support is helping Fatuma to accomplish her dream and her family to have food to eat.  Thank you.\\r\\n\\r\\nNovember 8, 2021\\r\\n     Fatuma is now 20 years old and is a senior at Pwani Special Secondary School for the Deaf.  She is an  average student. She is strongest in Kenya Sign Language but struggles with other subjects.  She is organized and careful.  She does not lose her personal items.  Her teachers are working with her on study habits that may help to raise performance.\\r\\n     Fatuma can hear some sounds like a loud bang or a truck but can not distinguish voices.  She has hearing aids but does not use them because her hearing loss is so profound, they do not do much good.  She has no speech but at least one family member can communicate through sign language and gestures. Fatuma has had no other health issues this past year.\\r\\n      Fatuma is friendly, kind, and helpful to others. She has many friends who play volleyball and netball together during games time. She has competed at the National Games. She is a member of the drama and music club.  She enjoys watching television, talking with friends, and playing team sports.  \\r\\n       Counseling sessions with the parents on the rights of their child has empowered them with proper information on how to care and advocate for their child.  The father faced challenges in earning an income because his place of work was closed because of Covid-19.  The family farm also suffered from a prolonged drought.  Your support ensures that Fatuma will complete her education despite the family hardships.  Thank you.\\r\\n\\r\\nJune 13 2020\\r\\nFatuma is now 19 years old and a student at Pwani Secondary School for the Deaf.  She is currently in form 3 (Junior year).  Due to the Covid-19 pandemic all schools in Kenya were closed and Fatuma went home before taking final exams for the semester. She does well in Kenyan Sign Language but continues to be weak in other subjects.  Her teacher plans to engage her in remedial studies when the students return to school, hopefully in January 2021.\\r\\n\\r\\nFatuma is a responsible girl who enjoys watching television, trading stories with friends, and playing team sports.  She is a member of her school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Integrity Club where members of the club counsel other students who have exhibited bad behavior.  She competes in volleyball, netball, and running.  She has competed at  the regional, county and national level.\\r\\n\\r\\nCounselling by Kupenda staff have improved the child\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s support in accessing education.  Family member have been providing the child with toiletries and transport to school during half-term beaks and when school closes.  Her parents have also been applying for the ward bursary fund to raise part of the child\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s boarding fees.\\r\\n\\r\\nThings are improving for Fatuma.  Thank you for your support that is providing educational, social, and athletic opportunities for this young girl.\\r\\n\\r\\nApril 11, 2019\\r\\nFatuma is now 18 years old and in her 2nd year at Pwani Secondary School for the Deaf.  She has not yet done the end of year exam so there are no grades available.  Her teachers report that her work is improving and that she is well disciplined.\\r\\n\\r\\nFatuma is friendly and makes friends easily.  She participates in track events, netball, and volleyball.  She competed at the regional games this year and was awarded certificates for her efforts.  She likes to tell stories and participate in games during free time.\\r\\n\\r\\nHer father and brother are her main caretakers.  They love her and do not discriminate against her because of her disability.  They make sure she gets to school on time after holidays and visit her while she is at school.  They also provide her toiletries and uniforms.\\r\\n\\r\\nYour sponsorship is providing many opportunities for Fatuma.  She has been instructed in sign language and uses it for communication.  She has benefitted from counseling, guidance, and advocacy.  She has her boarding fees paid which give her opportunities to learn, develop athletically, and make friends.  Thank you for your generosity.\\r\\n\\r\\nMarch 22, 2018\\r\\nExciting things are happening for children with disabilities in Kenya.  A large plot of land was donated to build a new special school in a remote village.  Plans are being made to build a new dormitory at one of our existing schools.  More staff is being added in Kenya to be able to work  with these children.  Our Kenyan director and our USA director are conducting workshops for pastors, natural healers, parents and government leaders on responsibility towards children with disability.  Things are looking up for the children that Kupenda serves.\\r\\n\\r\\n       Fatuma is now 17 years old and a student at Gede Special School. She is doing well but her teacher thinks she could do better.  She has accepted her disability but needs counseling to direct her as she grows up.\\r\\n\\r\\n      Fatuma is a friendly young lady.  She is helpful and works well under supervision.  She participates in volleyball, handball, and netball.  She has competed at the national level and been awarded certificates for her efforts.  She also enjoys swimming and legball.\\r\\n\\r\\n       Her family is working hard to provide for their child.  They are co-operative, understanding, and committed to their daughter\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s well being.\\r\\n\\r\\n     Fatuma really appreciates your sponsorship.  She is grateful to have the opportunity to attend school where she is a successful student and athlete.\\r\\n\\r\\n10\\/27\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nFatuma is now 18 years old and in the fifth grade at the Gede Special School.  Her teachers say she has excellent signing skills along with being very disciplined and very supportive of others.  She is also involved with the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s drama team.  \\r\\nHer parents always visit her while at school and contribute what they can to the school\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s development.  They also regular attend the Parent Teacher Association (PTA) meetings.  Fatuma\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s parents are learning sign language as part of the Kupenda funded workshops.  Most parents of deaf children do not have the ability to communicate with their children so this is a significant development.  They also take her to church with them.  \\r\\nFatuma would like to be a tailor when she finishes school.  Thank you for supporting her!\\r\\n\\r\\n(18TH JULY,2013)\\r\\nFatuma has progressed to grade 5 at Gede Special School. She is very active extra-curricular activities like netball, volley ball and acting. Last year she represented her school in netball and volleyball at the national level. She is above average in class work and her favorite subject is science. \\r\\nHer parents support her in her education by providing her basic items such as toiletries. At home Fatuma is doing house chores as any other Giriama girl of her age. She usually cooks, fetches water, digs, sweeps, does laundry, fetches firewood and helps her mother look after her younger siblings.  \\r\\nFatuma do appreciate your sponsorship and she always prays for you. She would like to be a nurse when she completes her studies so that she can serve her community especially those who have disabilities.\\r\\nThank you for your sponsorship and the love you have shown to Fatuma  as it has enabled her to have 3 meals per day as well as education.  (Uploaded on 24th July,2013)\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n\\r\\nFatuma is a young girl who loves netball and other ball games.  When she was three years old, Fatuma grew ill with meningitis and became completely deaf.  Her mother is a peasant farmer and her father is a house cleaner.  Her father does not have a regular work schedule and the lack of consistent income to the family of seven makes it very difficult for them.  Fatuma is loved by her family but they cannot pay for her boarding fees.  She communicates using sign language because she has no ability so speak.  With sponsorship, Fatuma will enter primary class three and will live in the supportive environment that the Gede Special School provides.\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"with pitty\",\"en_family_communicat\":\"Gestures\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"class 5 HI\",\"en_family_details\":\"both parents\",\"en_father_name\":\"Mwalimu Charo Mangi\",\"en_fathers_occupatio\":\"house cleaner\",\"en_mothers_name\":\"Zawadi Katana\",\"en_mothers_occupatio\":\"pesant farmer\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"2\",\"en_number_of_sisters\":\"2\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"The parents are not capable of paying boarding fees to Fatuma\",\"en_house_location\":\"Gongoni\",\"en_distance_away\":\"30 km\",\"en_house_state\":\"brick\\/mabati\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12800\",\"en_other_needs\":\"none\",\"en_languages\":\"sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"not known\",\"en_favorite_activity\":\"Athletic, music, dancing, watching movies and acting drama\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Pwani Secondary School for the Deaf\",\"en_out_reach_app_cas\":\"d63ac309560341e3b0195b4ca325fbdb\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"117\",\"en_cid\":\"KP3\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/908a494417b08d854357cb292323d822_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Fatuma ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47503,
    "profile": {
      "en_first_name": "Amani",
      "en_second_name": "",
      "en_last_name_1": "Mwagandi",
      "en_last_name_2": "",
      "en_gender": "Female",
      "en_date_of_birth": "01/08/1996",
      "en_mental_disability": "none",
      "en_public_comments": "Amani is a fifteen year old girl who is deaf and mute. Her mother is a widowed peasant farmer who is raising six children. Unfortunately, she is unable to provide Amani\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s boarding school fees. The community is supportive of Amani and believes she is very bright. Not only does Amani love to learn, but she loves to play volleyball as well. With sponsorship, Amani will be able to pursue further knowledge and skills at the Gede Special School.",
      "en_private_comments": "1/19/23\r\nAmani is now 26 years old and is a student at Karen Technical Institute.  Her mother and brother have been taking sign language classes organized by Kupenda to reduce the communication barrier between Amani and her family.\r\n\r\nAmani is friendly, kind, and helpful to others.  She is social, friendly, and enjoys being in the company of others.  She enjoys watching television and spending time with her friends.  She participates in netball, volleyball, and drama. She has even competed at the national games.\r\n\r\nAmani and her family have been counselled by a school staff member on the rights and laws of children with a disability.  They helped Amani make a new career choice after she was unable to become a teacher.  Her sister is grateful for the counselling as the family now knows where to get needed services.\r\n\r\nA four-year drought rendered the family farm unproductive.  Recently it began to rain in the region, but it will take 3 months for the crops to be harvested.  During that time, Kupenda is providing food for the family through local vendors.\r\n\r\nThank you for supporting Amani.\r\n\r\n1/12/22\r\nAmani is now 25 years old and will be attending Karen Institute of Technology for the Deaf to undertake a store-keeping course.  She had to leave Nesbony Teacher\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s College because of new policies that made it impossible for hearing impaired students.  She is a disciplined and hardworking young woman.\r\n\r\nAmani has no hearing at all.  Along with her hearing impairment Amani can not speak.  At least one of her family members can communicate with her regarding her personal needs.  She has had a healthy year and is up to date on immunizations, physicals, and hearing tests.\r\n\r\nAmani is friendly, kind, and helpful to others.  She is a social and responsible girl. She competes in track events as far as the county games. She enjoys spending time with her many friends and watching television.\r\n\r\nThe family relies on farming for their livelihood.  However, this year an insect infestation caused the farm to have a smaller yield.  Fortunately, Amani will have her tuition fees paid by your support.  Thank you.\r\n\r\n5/27/21\r\nAmani is now 24 years old.  At first, she was a student at Nesbony Teacher\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s College.  Nesbony started a requirement in which all students must take a sitting exam which discriminated against sign language users.  After counselling Amani has decided to enroll in Karen Technical School when school is in session.  The Pandemic has resulted in school closures for 10 months out of the last 14 months.\r\n\r\nAmani has not had any seizures for a year due to the medication she is taking.  She has not had any illnesses or need for medical help this last year.\r\n\r\nAmani is friendly, kind, and helpful.  She has many friends and enjoys being with her peers. She is talented in drama, sports, and games.\r\n\r\nThe family have been counselled on a regular basis about possible educational opportunities and precautions to prevent Covid-19.  This has resulted in Amani choosing to attend Karen Technical Institute.\r\n\r\nThank you for your support.  Amani is making great progress toward an independent future.\r\n\r\n9/16/2019\r\n      Amani is now 23 years old and a student at Nesbony Teacher\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s College where she is studying Early Childhood and Development Education.  It is a three-year course.  When she is finished, she will have acquired skills to enable her to work with hearing impaired students at the pre-primary grade level.\r\n\r\n          Amani co-operates and relates with others well.  She is ready to assist others with challenges.  She is a national level volleyball player.  Despite her epilepsy she is very social and has friends both with hearing impairment and without disability. She also has many friends that attend the same church, Emmanuel Church for the Deaf. She is a happy young woman with friends at home and at college.\r\n\r\n        In her family she is the only one with a disability, but all family members treat Amani with love.  Family members have learned sign language which makes communication at home easier for Amani.  Her mother and brother are good signers.\r\n\r\n        Your sponsorship is providing Amani with a post high school education.  Her educational opportunities have also provided Amani with friends as well as religious and athletic opportunities.  Thank you for your generosity.\r\n\r\n1/8/2019\r\n     Amani Is now 22 years old and recently graduated from Secondary School. Students in Kenya must take a national exam upon finishing form 4.  The results of that exam will be used for college entrance.  Amani has taken the exam but has not yet gotten the results.  She hopes to be enrolled in college next fall to study to be a pharmacist.  She is a very serious student.  She reports to school early, writes her assignments and hands them in on time, and is involved in study groups.\r\n     Amini is healthy with the exception of her epilepsy.  She is taking a medication that is helping to control the seizures.  The medication has worked and the seizure activity is under control.\r\n      Amani is a friendly and helpful young woman who is considered to be a leader in her class.  She participates in volleyball and has competed at the national games where she was awarded certificates for her efforts.  She also enjoys reading books and watching television.\r\n      Her family is supportive of Amani.  They provide for her toiletries, uniforms  and medication. The family continues to support Amani while she waits for college placement.\r\n      Your sponsorship has provided Amani an education all the way through high school.  Soon it will provide for her expense to attend college.  It has also ensured that she gets the proper medication.  Thank you for your generosity.\r\n\r\n7/14/2017\r\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \r\n        Amani will soon be 21 years old.  She is currently a student at Kuja Secondary School for the Deaf.  She is in form 3 and is maintaining her grades but improvement is expected for the next term. Her disability has a negative impact on her learning.  Sometimes there is a disconnect between the teacher and student when interpreting some concepts from English into Sign Language.  Amani is disciplined and determined to perform well..\r\n      Amani is physically fit and healthy.  She has no health problems.  She is helpful to other children and is the games prefect at her school.  She makes friends easily.  She plays volleyball and netball. She is a very active athlete that has competed nationally in sports for the deaf.\r\n      Amani\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s father passed away and it is only her elder brother who cares for her and her siblings.  The family is very supportive in providing Amani\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s needs while at school.\r\n       Thank you for giving Amani the chance to succeed and be successful.\r\n\r\n10/22/14\r\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\r\nAmani is now 18 years old and in the eighth grade at the Gede Special School unit for the deaf.  She continues to receive medication for her epileptic seizures but has had to visit the doctor several times due to their reoccurrences.  In spite of these frequenst attacks she has been able to do very well on her exams and in her classes. She is even the school \u00c3\u00a2\u00e2\u0082\u00ac\u00c5\u0093head girl\u00c3\u00a2\u00e2\u0082\u00ac\u00c2\u009d which means she is the main female responsible for the care of the other students after her teachers and housemothers.  \r\nHer family is very supportive of Amani.  Although her widowed mother earns very little farming the small plot of family land,, she provides what she can to the Parent Teacher Association and Amani\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s school materials.  Her mother is even learning sign language through the Kupenda funded sign language classes for parents.  Most families in the area are unable to communicate with their deaf family members which makes her learning that much more significant.  \r\nThanks to you Amani still hopes to be a nurse one day!\r\n\r\nAmani is now a 16 year old young woman in Class 7 at the Gede Special School. She continues to do well in her classwork and maintains an average B grade. In her favorite subject, Math, she even scored an A! Due to her progress, she is expected to join a national school when she completes her primary education. \r\n\r\nOverall, Amani continues to be social with all of the students, teachers, and the people in her community. This is even more possible now that she has progressed further in her sign language skills!\r\n\r\nIn her spare time, Amani enjoys music, movies, and athletics. She plays on the volleyball and netball teams and was able to represent her school at the provisional level!\r\n\r\nAt home, her family is supportive of the school in every way that they are able. They attend school functions and meetings whenever possible and provide her with school items. Unfortunately, they are still unable to provide for her school fees in addition to everything else. \r\n\r\nAmani herself also contributes to her family. She helps with cooking, fetching water, digging, sweeping, washing clothes, and looking after her younger siblings. She knows that your support is what will open up many possibilities for her in the future. In fact, Amani now dreams of becoming a nurse and treating other children with disabilities. She realizes the impact that your assistance is having in her life and is grateful for the opportunity to pursue her dreams. Thank you for being a blessing in this young woman\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s life!\r\n(Uploaded on 18th July 2013)",
      "en_level_hearing": "none",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "normal",
      "en_lip_read": "Does Not Apply",
      "en_needs_met": "Yes",
      "en_treated_before": "With sympathy",
      "en_family_communicat": "Gestures and speech",
      "en_school": "Gede Special School",
      "en_class_level": "Class 7 H.I",
      "en_family_details": "The father died and the mother cares for the child.",
      "en_father_name": "Mwagandi Chembe",
      "en_fathers_occupatio": "Deceased",
      "en_mothers_name": "Dama Mwagandi",
      "en_mothers_occupatio": "Peasant farmer",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "3",
      "en_number_of_sisters": "2",
      "en_willingness_of_pa": "willing few resources",
      "en_situation_explain": "The mother struggles to meet the needs of Amani.",
      "en_house_location": "Shomela",
      "en_distance_away": "20km",
      "en_house_state": "Mud/makuti",
      "en_why_need_sponsors": "Boarding fees",
      "en_total_needed": "12",
      "en_other_needs": "None",
      "en_languages": "Sign",
      "en_religion": "Christian",
      "en_church_name": "Pefa Church",
      "en_favorite_activity": "Athletics (playing football and netball)\r\nDancing\r\nWatching movies",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Karen Technical Institute",
      "en_out_reach_app_cas": "2dd168c8-4aeb-456f-94bd-8632cbee8eb0",
      "en_disability_type": "Hearing Impairment",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "116",
      "en_cid": "KP2",
      "id": 47503,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Amani\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mwagandi\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"01\\/08\\/1996\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Amani is a fifteen year old girl who is deaf and mute. Her mother is a widowed peasant farmer who is raising six children. Unfortunately, she is unable to provide Amani\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s boarding school fees. The community is supportive of Amani and believes she is very bright. Not only does Amani love to learn, but she loves to play volleyball as well. With sponsorship, Amani will be able to pursue further knowledge and skills at the Gede Special School.\",\"en_private_comments\":\"1\\/19\\/23\\r\\nAmani is now 26 years old and is a student at Karen Technical Institute.  Her mother and brother have been taking sign language classes organized by Kupenda to reduce the communication barrier between Amani and her family.\\r\\n\\r\\nAmani is friendly, kind, and helpful to others.  She is social, friendly, and enjoys being in the company of others.  She enjoys watching television and spending time with her friends.  She participates in netball, volleyball, and drama. She has even competed at the national games.\\r\\n\\r\\nAmani and her family have been counselled by a school staff member on the rights and laws of children with a disability.  They helped Amani make a new career choice after she was unable to become a teacher.  Her sister is grateful for the counselling as the family now knows where to get needed services.\\r\\n\\r\\nA four-year drought rendered the family farm unproductive.  Recently it began to rain in the region, but it will take 3 months for the crops to be harvested.  During that time, Kupenda is providing food for the family through local vendors.\\r\\n\\r\\nThank you for supporting Amani.\\r\\n\\r\\n1\\/12\\/22\\r\\nAmani is now 25 years old and will be attending Karen Institute of Technology for the Deaf to undertake a store-keeping course.  She had to leave Nesbony Teacher\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s College because of new policies that made it impossible for hearing impaired students.  She is a disciplined and hardworking young woman.\\r\\n\\r\\nAmani has no hearing at all.  Along with her hearing impairment Amani can not speak.  At least one of her family members can communicate with her regarding her personal needs.  She has had a healthy year and is up to date on immunizations, physicals, and hearing tests.\\r\\n\\r\\nAmani is friendly, kind, and helpful to others.  She is a social and responsible girl. She competes in track events as far as the county games. She enjoys spending time with her many friends and watching television.\\r\\n\\r\\nThe family relies on farming for their livelihood.  However, this year an insect infestation caused the farm to have a smaller yield.  Fortunately, Amani will have her tuition fees paid by your support.  Thank you.\\r\\n\\r\\n5\\/27\\/21\\r\\nAmani is now 24 years old.  At first, she was a student at Nesbony Teacher\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s College.  Nesbony started a requirement in which all students must take a sitting exam which discriminated against sign language users.  After counselling Amani has decided to enroll in Karen Technical School when school is in session.  The Pandemic has resulted in school closures for 10 months out of the last 14 months.\\r\\n\\r\\nAmani has not had any seizures for a year due to the medication she is taking.  She has not had any illnesses or need for medical help this last year.\\r\\n\\r\\nAmani is friendly, kind, and helpful.  She has many friends and enjoys being with her peers. She is talented in drama, sports, and games.\\r\\n\\r\\nThe family have been counselled on a regular basis about possible educational opportunities and precautions to prevent Covid-19.  This has resulted in Amani choosing to attend Karen Technical Institute.\\r\\n\\r\\nThank you for your support.  Amani is making great progress toward an independent future.\\r\\n\\r\\n9\\/16\\/2019\\r\\n      Amani is now 23 years old and a student at Nesbony Teacher\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s College where she is studying Early Childhood and Development Education.  It is a three-year course.  When she is finished, she will have acquired skills to enable her to work with hearing impaired students at the pre-primary grade level.\\r\\n\\r\\n          Amani co-operates and relates with others well.  She is ready to assist others with challenges.  She is a national level volleyball player.  Despite her epilepsy she is very social and has friends both with hearing impairment and without disability. She also has many friends that attend the same church, Emmanuel Church for the Deaf. She is a happy young woman with friends at home and at college.\\r\\n\\r\\n        In her family she is the only one with a disability, but all family members treat Amani with love.  Family members have learned sign language which makes communication at home easier for Amani.  Her mother and brother are good signers.\\r\\n\\r\\n        Your sponsorship is providing Amani with a post high school education.  Her educational opportunities have also provided Amani with friends as well as religious and athletic opportunities.  Thank you for your generosity.\\r\\n\\r\\n1\\/8\\/2019\\r\\n     Amani Is now 22 years old and recently graduated from Secondary School. Students in Kenya must take a national exam upon finishing form 4.  The results of that exam will be used for college entrance.  Amani has taken the exam but has not yet gotten the results.  She hopes to be enrolled in college next fall to study to be a pharmacist.  She is a very serious student.  She reports to school early, writes her assignments and hands them in on time, and is involved in study groups.\\r\\n     Amini is healthy with the exception of her epilepsy.  She is taking a medication that is helping to control the seizures.  The medication has worked and the seizure activity is under control.\\r\\n      Amani is a friendly and helpful young woman who is considered to be a leader in her class.  She participates in volleyball and has competed at the national games where she was awarded certificates for her efforts.  She also enjoys reading books and watching television.\\r\\n      Her family is supportive of Amani.  They provide for her toiletries, uniforms  and medication. The family continues to support Amani while she waits for college placement.\\r\\n      Your sponsorship has provided Amani an education all the way through high school.  Soon it will provide for her expense to attend college.  It has also ensured that she gets the proper medication.  Thank you for your generosity.\\r\\n\\r\\n7\\/14\\/2017\\r\\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \\r\\n        Amani will soon be 21 years old.  She is currently a student at Kuja Secondary School for the Deaf.  She is in form 3 and is maintaining her grades but improvement is expected for the next term. Her disability has a negative impact on her learning.  Sometimes there is a disconnect between the teacher and student when interpreting some concepts from English into Sign Language.  Amani is disciplined and determined to perform well..\\r\\n      Amani is physically fit and healthy.  She has no health problems.  She is helpful to other children and is the games prefect at her school.  She makes friends easily.  She plays volleyball and netball. She is a very active athlete that has competed nationally in sports for the deaf.\\r\\n      Amani\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s father passed away and it is only her elder brother who cares for her and her siblings.  The family is very supportive in providing Amani\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s needs while at school.\\r\\n       Thank you for giving Amani the chance to succeed and be successful.\\r\\n\\r\\n10\\/22\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nAmani is now 18 years old and in the eighth grade at the Gede Special School unit for the deaf.  She continues to receive medication for her epileptic seizures but has had to visit the doctor several times due to their reoccurrences.  In spite of these frequenst attacks she has been able to do very well on her exams and in her classes. She is even the school \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093head girl\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d which means she is the main female responsible for the care of the other students after her teachers and housemothers.  \\r\\nHer family is very supportive of Amani.  Although her widowed mother earns very little farming the small plot of family land,, she provides what she can to the Parent Teacher Association and Amani\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school materials.  Her mother is even learning sign language through the Kupenda funded sign language classes for parents.  Most families in the area are unable to communicate with their deaf family members which makes her learning that much more significant.  \\r\\nThanks to you Amani still hopes to be a nurse one day!\\r\\n\\r\\nAmani is now a 16 year old young woman in Class 7 at the Gede Special School. She continues to do well in her classwork and maintains an average B grade. In her favorite subject, Math, she even scored an A! Due to her progress, she is expected to join a national school when she completes her primary education. \\r\\n\\r\\nOverall, Amani continues to be social with all of the students, teachers, and the people in her community. This is even more possible now that she has progressed further in her sign language skills!\\r\\n\\r\\nIn her spare time, Amani enjoys music, movies, and athletics. She plays on the volleyball and netball teams and was able to represent her school at the provisional level!\\r\\n\\r\\nAt home, her family is supportive of the school in every way that they are able. They attend school functions and meetings whenever possible and provide her with school items. Unfortunately, they are still unable to provide for her school fees in addition to everything else. \\r\\n\\r\\nAmani herself also contributes to her family. She helps with cooking, fetching water, digging, sweeping, washing clothes, and looking after her younger siblings. She knows that your support is what will open up many possibilities for her in the future. In fact, Amani now dreams of becoming a nurse and treating other children with disabilities. She realizes the impact that your assistance is having in her life and is grateful for the opportunity to pursue her dreams. Thank you for being a blessing in this young woman\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life!\\r\\n(Uploaded on 18th July 2013)\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"With sympathy\",\"en_family_communicat\":\"Gestures and speech\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"Class 7 H.I\",\"en_family_details\":\"The father died and the mother cares for the child.\",\"en_father_name\":\"Mwagandi Chembe\",\"en_fathers_occupatio\":\"Deceased\",\"en_mothers_name\":\"Dama Mwagandi\",\"en_mothers_occupatio\":\"Peasant farmer\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"3\",\"en_number_of_sisters\":\"2\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"The mother struggles to meet the needs of Amani.\",\"en_house_location\":\"Shomela\",\"en_distance_away\":\"20km\",\"en_house_state\":\"Mud\\/makuti\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12\",\"en_other_needs\":\"None\",\"en_languages\":\"Sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"Pefa Church\",\"en_favorite_activity\":\"Athletics (playing football and netball)\\r\\nDancing\\r\\nWatching movies\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Karen Technical Institute\",\"en_out_reach_app_cas\":\"2dd168c8-4aeb-456f-94bd-8632cbee8eb0\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"116\",\"en_cid\":\"KP2\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Amani",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/b3212d1c8dd4cca4f949fe06409ff22a.jpg",
    "donations": [],
    "entity": {
      "id": 47503,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Amani\",\"en_second_name\":\"\",\"en_last_name_1\":\"Mwagandi\",\"en_last_name_2\":\"\",\"en_gender\":\"Female\",\"en_date_of_birth\":\"01\\/08\\/1996\",\"en_mental_disability\":\"none\",\"en_public_comments\":\"Amani is a fifteen year old girl who is deaf and mute. Her mother is a widowed peasant farmer who is raising six children. Unfortunately, she is unable to provide Amani\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s boarding school fees. The community is supportive of Amani and believes she is very bright. Not only does Amani love to learn, but she loves to play volleyball as well. With sponsorship, Amani will be able to pursue further knowledge and skills at the Gede Special School.\",\"en_private_comments\":\"1\\/19\\/23\\r\\nAmani is now 26 years old and is a student at Karen Technical Institute.  Her mother and brother have been taking sign language classes organized by Kupenda to reduce the communication barrier between Amani and her family.\\r\\n\\r\\nAmani is friendly, kind, and helpful to others.  She is social, friendly, and enjoys being in the company of others.  She enjoys watching television and spending time with her friends.  She participates in netball, volleyball, and drama. She has even competed at the national games.\\r\\n\\r\\nAmani and her family have been counselled by a school staff member on the rights and laws of children with a disability.  They helped Amani make a new career choice after she was unable to become a teacher.  Her sister is grateful for the counselling as the family now knows where to get needed services.\\r\\n\\r\\nA four-year drought rendered the family farm unproductive.  Recently it began to rain in the region, but it will take 3 months for the crops to be harvested.  During that time, Kupenda is providing food for the family through local vendors.\\r\\n\\r\\nThank you for supporting Amani.\\r\\n\\r\\n1\\/12\\/22\\r\\nAmani is now 25 years old and will be attending Karen Institute of Technology for the Deaf to undertake a store-keeping course.  She had to leave Nesbony Teacher\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s College because of new policies that made it impossible for hearing impaired students.  She is a disciplined and hardworking young woman.\\r\\n\\r\\nAmani has no hearing at all.  Along with her hearing impairment Amani can not speak.  At least one of her family members can communicate with her regarding her personal needs.  She has had a healthy year and is up to date on immunizations, physicals, and hearing tests.\\r\\n\\r\\nAmani is friendly, kind, and helpful to others.  She is a social and responsible girl. She competes in track events as far as the county games. She enjoys spending time with her many friends and watching television.\\r\\n\\r\\nThe family relies on farming for their livelihood.  However, this year an insect infestation caused the farm to have a smaller yield.  Fortunately, Amani will have her tuition fees paid by your support.  Thank you.\\r\\n\\r\\n5\\/27\\/21\\r\\nAmani is now 24 years old.  At first, she was a student at Nesbony Teacher\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s College.  Nesbony started a requirement in which all students must take a sitting exam which discriminated against sign language users.  After counselling Amani has decided to enroll in Karen Technical School when school is in session.  The Pandemic has resulted in school closures for 10 months out of the last 14 months.\\r\\n\\r\\nAmani has not had any seizures for a year due to the medication she is taking.  She has not had any illnesses or need for medical help this last year.\\r\\n\\r\\nAmani is friendly, kind, and helpful.  She has many friends and enjoys being with her peers. She is talented in drama, sports, and games.\\r\\n\\r\\nThe family have been counselled on a regular basis about possible educational opportunities and precautions to prevent Covid-19.  This has resulted in Amani choosing to attend Karen Technical Institute.\\r\\n\\r\\nThank you for your support.  Amani is making great progress toward an independent future.\\r\\n\\r\\n9\\/16\\/2019\\r\\n      Amani is now 23 years old and a student at Nesbony Teacher\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s College where she is studying Early Childhood and Development Education.  It is a three-year course.  When she is finished, she will have acquired skills to enable her to work with hearing impaired students at the pre-primary grade level.\\r\\n\\r\\n          Amani co-operates and relates with others well.  She is ready to assist others with challenges.  She is a national level volleyball player.  Despite her epilepsy she is very social and has friends both with hearing impairment and without disability. She also has many friends that attend the same church, Emmanuel Church for the Deaf. She is a happy young woman with friends at home and at college.\\r\\n\\r\\n        In her family she is the only one with a disability, but all family members treat Amani with love.  Family members have learned sign language which makes communication at home easier for Amani.  Her mother and brother are good signers.\\r\\n\\r\\n        Your sponsorship is providing Amani with a post high school education.  Her educational opportunities have also provided Amani with friends as well as religious and athletic opportunities.  Thank you for your generosity.\\r\\n\\r\\n1\\/8\\/2019\\r\\n     Amani Is now 22 years old and recently graduated from Secondary School. Students in Kenya must take a national exam upon finishing form 4.  The results of that exam will be used for college entrance.  Amani has taken the exam but has not yet gotten the results.  She hopes to be enrolled in college next fall to study to be a pharmacist.  She is a very serious student.  She reports to school early, writes her assignments and hands them in on time, and is involved in study groups.\\r\\n     Amini is healthy with the exception of her epilepsy.  She is taking a medication that is helping to control the seizures.  The medication has worked and the seizure activity is under control.\\r\\n      Amani is a friendly and helpful young woman who is considered to be a leader in her class.  She participates in volleyball and has competed at the national games where she was awarded certificates for her efforts.  She also enjoys reading books and watching television.\\r\\n      Her family is supportive of Amani.  They provide for her toiletries, uniforms  and medication. The family continues to support Amani while she waits for college placement.\\r\\n      Your sponsorship has provided Amani an education all the way through high school.  Soon it will provide for her expense to attend college.  It has also ensured that she gets the proper medication.  Thank you for your generosity.\\r\\n\\r\\n7\\/14\\/2017\\r\\nKenya is now experiencing one of the most severe droughts in recent history. This has impacted the food supply as well as the jobs of a people that primarily make a living as peasant farmers. Kupenda\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s Kenyan affiliate, Kuhenza, is trying to help by delivering food supplies to remote villages and starting new farms.  These are short term fixes but children attending Kupenda sponsored special schools are provided with two meals a day as well as high tea. \\r\\n        Amani will soon be 21 years old.  She is currently a student at Kuja Secondary School for the Deaf.  She is in form 3 and is maintaining her grades but improvement is expected for the next term. Her disability has a negative impact on her learning.  Sometimes there is a disconnect between the teacher and student when interpreting some concepts from English into Sign Language.  Amani is disciplined and determined to perform well..\\r\\n      Amani is physically fit and healthy.  She has no health problems.  She is helpful to other children and is the games prefect at her school.  She makes friends easily.  She plays volleyball and netball. She is a very active athlete that has competed nationally in sports for the deaf.\\r\\n      Amani\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s father passed away and it is only her elder brother who cares for her and her siblings.  The family is very supportive in providing Amani\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s needs while at school.\\r\\n       Thank you for giving Amani the chance to succeed and be successful.\\r\\n\\r\\n10\\/22\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nAmani is now 18 years old and in the eighth grade at the Gede Special School unit for the deaf.  She continues to receive medication for her epileptic seizures but has had to visit the doctor several times due to their reoccurrences.  In spite of these frequenst attacks she has been able to do very well on her exams and in her classes. She is even the school \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093head girl\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d which means she is the main female responsible for the care of the other students after her teachers and housemothers.  \\r\\nHer family is very supportive of Amani.  Although her widowed mother earns very little farming the small plot of family land,, she provides what she can to the Parent Teacher Association and Amani\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s school materials.  Her mother is even learning sign language through the Kupenda funded sign language classes for parents.  Most families in the area are unable to communicate with their deaf family members which makes her learning that much more significant.  \\r\\nThanks to you Amani still hopes to be a nurse one day!\\r\\n\\r\\nAmani is now a 16 year old young woman in Class 7 at the Gede Special School. She continues to do well in her classwork and maintains an average B grade. In her favorite subject, Math, she even scored an A! Due to her progress, she is expected to join a national school when she completes her primary education. \\r\\n\\r\\nOverall, Amani continues to be social with all of the students, teachers, and the people in her community. This is even more possible now that she has progressed further in her sign language skills!\\r\\n\\r\\nIn her spare time, Amani enjoys music, movies, and athletics. She plays on the volleyball and netball teams and was able to represent her school at the provisional level!\\r\\n\\r\\nAt home, her family is supportive of the school in every way that they are able. They attend school functions and meetings whenever possible and provide her with school items. Unfortunately, they are still unable to provide for her school fees in addition to everything else. \\r\\n\\r\\nAmani herself also contributes to her family. She helps with cooking, fetching water, digging, sweeping, washing clothes, and looking after her younger siblings. She knows that your support is what will open up many possibilities for her in the future. In fact, Amani now dreams of becoming a nurse and treating other children with disabilities. She realizes the impact that your assistance is having in her life and is grateful for the opportunity to pursue her dreams. Thank you for being a blessing in this young woman\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s life!\\r\\n(Uploaded on 18th July 2013)\",\"en_level_hearing\":\"none\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"normal\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"With sympathy\",\"en_family_communicat\":\"Gestures and speech\",\"en_school\":\"Gede Special School\",\"en_class_level\":\"Class 7 H.I\",\"en_family_details\":\"The father died and the mother cares for the child.\",\"en_father_name\":\"Mwagandi Chembe\",\"en_fathers_occupatio\":\"Deceased\",\"en_mothers_name\":\"Dama Mwagandi\",\"en_mothers_occupatio\":\"Peasant farmer\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"3\",\"en_number_of_sisters\":\"2\",\"en_willingness_of_pa\":\"willing few resources\",\"en_situation_explain\":\"The mother struggles to meet the needs of Amani.\",\"en_house_location\":\"Shomela\",\"en_distance_away\":\"20km\",\"en_house_state\":\"Mud\\/makuti\",\"en_why_need_sponsors\":\"Boarding fees\",\"en_total_needed\":\"12\",\"en_other_needs\":\"None\",\"en_languages\":\"Sign\",\"en_religion\":\"Christian\",\"en_church_name\":\"Pefa Church\",\"en_favorite_activity\":\"Athletics (playing football and netball)\\r\\nDancing\\r\\nWatching movies\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Karen Technical Institute\",\"en_out_reach_app_cas\":\"2dd168c8-4aeb-456f-94bd-8632cbee8eb0\",\"en_disability_type\":\"Hearing Impairment\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"116\",\"en_cid\":\"KP2\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/b3212d1c8dd4cca4f949fe06409ff22a_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Amani ",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 47502,
    "profile": {
      "en_first_name": "Said",
      "en_second_name": "Kitsao",
      "en_last_name_1": "Msaji",
      "en_last_name_2": "",
      "en_gender": "Male",
      "en_date_of_birth": "17/07/2002",
      "en_mental_disability": "Normal",
      "en_public_comments": "Said was born with cerebral palsy for unknown reasons. It has caused him to lack speech and need special services outside of the main stream school.",
      "en_private_comments": "March 8, 2023\r\nSaid is a freshman at Pwani School for the Deaf. The term has just started so there have been no exams.  \r\n\r\nSaid has accepted his disability and now interacts with people well.  He participates in many sports such as running and football.\r\n\r\nThe family is facing challenges earning a living as a drought in the area has resulted in fewer or no crops.  Hopefully, recent rains will change the economics of the area.\r\n\r\nOctober 28, 2021\r\nSaid is now 19 years old and is a freshman at Pwani Secondary School for the Deaf.  He just started school this month and has not yet taken any exams.  He is good at Kenyan Sign Language.\r\n\r\nSaid can walk independently, grasp any object, and write and draw.   He has been healthy and active this year.  He has had annual physicals and is up to date on immunizations.\r\n\r\nSaid is friendly and kind. He enjoys spending time with his friends, playing team sports, and watching television.\r\n\r\nHis family relies on farming for financial support.  The continued drought is causing the farm to be less productive. Since his father has died Said has remained with his mother who lacks a reliable source of income.\r\n \r\nOctober 9, 2020\r\nSaidi is now 18 years old and is  a student at Gede Special Primary School in grade 8.  He is improving in KSL (Kenyan Sign Language).\r\n\r\nSaidi is friendly and kind.  He plays with his peers, watches television, and plays team sports.  He competes in running and football, most recently at the national level.  He seems happy, hopeful, and content.\r\n\r\nKuhenza has counselled the family on the care, rights, and laws of their son.  This has resulted in better care of Saidi.  Kuhenza is providing food and hand soap monthly as well as boarding fees when schools are open.\r\nJuly 30, 2020 (Quick update)\r\nSaid is in class 8 at Gede Special School.  His family is receiving food support from Kuhenza during the pandemic.  He is also being contacted on a regular basis to make sure he is ok.  \r\nMay 31, 2019\r\nSaid is now 16 years old and a student at Gede Special School in grade 7.  In addition to his hearing impairment Said has mild cerebral palsy which makes him walk with a  gait.  He will be getting surgery to help correct this problem. In class he does average work.  He has mastered sign language and can now confidently communicate his needs.  \r\n\r\nWith the payment of his boarding fees, Said has an opportunity to stay in school where he is assured of nutritious meals, medical intervention when he is sick, socialization with other students, instruction through sign language and the ability to develop and nurture his talents and potentials.  At school he is also able to compete in junior races (100 meters and 50 meters).  He competed this year at the county level.  In his free time he enjoys dancing and telling stories.\r\n\r\nHis mother is his main caretaker.  She loves her son and treats him like any other child. She brings him to school on time, participates in parent groups, attends school activities, attends parent conferences, and advocates for her child.\r\n\r\nYour sponsorship is paying for Said\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s boarding fees, medical intervention, advocacy for children with disabilities,  and counseling for Said and his family.  Thank you for your generosity.\r\n\r\nMarch 29, 2018\r\nExciting things are happening for children with disabilities in Kenya.  A large plot of land was donated to build a new special school in a remote village.  Plans are set to build another dormitory at one of our existing schools.  More staff is being added in Kenya to be able to work with these children.  Our Kenyan director and USA director are conducting workshops for pastors, natural healers, parents and government leaders on responsibility towards children with disability.  Things are looking up for the children that Kupenda serves.\r\n      Said is now 15 years old and a student at Gede Special School.  He is in class six and his grades are improving.  He is having trouble with English as his disability makes writing difficult.  It takes him longer to do assignments and needs to be given more time.  He receives guidance and counselling at school to help him realize his dreams.  He is able to communicate fluently in sign language.  He aspires to be a pilot some day.\r\n     Said has been very healthy except for a boil on his cheek which requires surgery.  He is friendly with his peers but needs to be guided on how to improve these interactions.  He participates in track events and has made it to the county level competitions.   He also enjoys watching movies.\r\n       His parents love their son and want what is best for him.  They visit him at school, participate in teacher conferences, are active in parent groups and bring Said home for the weekends.  The family has a positive attitude toward their son  but could use some guidance on how to live with him when he is at  home.\r\n        Thank you for your sponsorship, it is giving Said the chance to develop his full potential.\r\n\r\n10/29/14\r\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\r\nSaid is now 12 years old and in the second grade at the Gede Special School.  He is in a specialized class because his cognitive development is slower than children in the mainstream class.  Said can now use sign language to communicate.  He can finger spell his name and those of the people around him.  His teachers say \u00c3\u00a2\u00e2\u0082\u00ac\u00c5\u0093he is a story teller who loves to chat with other children during his free time.\u00c3\u00a2\u00e2\u0082\u00ac\u00c2\u009d  He represents the school in the junior races and loves playing soccer.  \r\nHis parents are supportive of his education though they struggle top roved for their 8 children.  They are always visiting him at school and ensure he reports on time.  In spite of their low income level, they provide him with his school supplies and contribute to the Parent Teacher Association (PTA).  They also take him to church with them.  At home Said helps with some of the chores including washing clothes, tending animals, and looking after younger siblings.\r\n\r\nSaid is a ten year old boy who was born with cerebral palsy due to genetics.  He can walk without assistance because the cerebral palsy only affects the movement of his head and gives him a mild mental disability and no ability to speak.  Said\u00c3\u00a2\u00e2\u0082\u00ac\u00e2\u0084\u00a2s father is a hotelier and his mother is a peasant farmer.  The family of ten lives in a mud home that is located too far from Gede for Said to travel every day.  Said is in Primary class 1 and is has been doing very well.  He also likes to participate in the junior races.  With sponsorship, Said will continue to live in the safe environment that Gede provides and will continue his progress with his education.\r\nSaid was born with cerebral palsy that affects the movement of his head and gives him a slight mental disability.  His parents have seven other children to provide for and cannot pay for his boarding at Gede.  Said is in first grade and is doing quite well.  With sponsorship, he can continue his education at Gede.",
      "en_level_hearing": "",
      "en_hearing_test": "Does Not Apply",
      "en_walk": "Yes",
      "en_walk_assistance": "Does Not Apply",
      "en_cp_affected": "",
      "en_speech": "no speech",
      "en_lip_read": "Does Not Apply",
      "en_needs_met": "Yes",
      "en_treated_before": "",
      "en_family_communicat": "",
      "en_school": "",
      "en_class_level": "",
      "en_family_details": "",
      "en_father_name": "",
      "en_fathers_occupatio": "",
      "en_mothers_name": "",
      "en_mothers_occupatio": "",
      "en_guardians_name": "",
      "en_guardians_occupat": "",
      "en_guardians_relatio": "",
      "en_number_of_brother": "0",
      "en_number_of_sisters": "0",
      "en_willingness_of_pa": "Unwilling few resources",
      "en_situation_explain": "",
      "en_house_location": "",
      "en_distance_away": "",
      "en_house_state": "",
      "en_why_need_sponsors": "",
      "en_total_needed": "0",
      "en_other_needs": "",
      "en_languages": "",
      "en_religion": "",
      "en_church_name": "",
      "en_favorite_activity": "",
      "en_other_disabilitie": "No",
      "en_describe_disabili": "",
      "en_school_name": "Gede Special School",
      "en_out_reach_app_cas": "8f22726a-4dbc-4028-b34e-d4aad6a3c219",
      "en_disability_type": "Cerebral Palsy (CP)",
      "en_child_has_died": "FALSE",
      "en_not_available_for": "The child has not been contacted in over a year",
      "en_child_id": "115",
      "en_cid": "KP1",
      "id": 47502,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Said\",\"en_second_name\":\"Kitsao\",\"en_last_name_1\":\"Msaji\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"17\\/07\\/2002\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Said was born with cerebral palsy for unknown reasons. It has caused him to lack speech and need special services outside of the main stream school.\",\"en_private_comments\":\"March 8, 2023\\r\\nSaid is a freshman at Pwani School for the Deaf. The term has just started so there have been no exams.  \\r\\n\\r\\nSaid has accepted his disability and now interacts with people well.  He participates in many sports such as running and football.\\r\\n\\r\\nThe family is facing challenges earning a living as a drought in the area has resulted in fewer or no crops.  Hopefully, recent rains will change the economics of the area.\\r\\n\\r\\nOctober 28, 2021\\r\\nSaid is now 19 years old and is a freshman at Pwani Secondary School for the Deaf.  He just started school this month and has not yet taken any exams.  He is good at Kenyan Sign Language.\\r\\n\\r\\nSaid can walk independently, grasp any object, and write and draw.   He has been healthy and active this year.  He has had annual physicals and is up to date on immunizations.\\r\\n\\r\\nSaid is friendly and kind. He enjoys spending time with his friends, playing team sports, and watching television.\\r\\n\\r\\nHis family relies on farming for financial support.  The continued drought is causing the farm to be less productive. Since his father has died Said has remained with his mother who lacks a reliable source of income.\\r\\n \\r\\nOctober 9, 2020\\r\\nSaidi is now 18 years old and is  a student at Gede Special Primary School in grade 8.  He is improving in KSL (Kenyan Sign Language).\\r\\n\\r\\nSaidi is friendly and kind.  He plays with his peers, watches television, and plays team sports.  He competes in running and football, most recently at the national level.  He seems happy, hopeful, and content.\\r\\n\\r\\nKuhenza has counselled the family on the care, rights, and laws of their son.  This has resulted in better care of Saidi.  Kuhenza is providing food and hand soap monthly as well as boarding fees when schools are open.\\r\\nJuly 30, 2020 (Quick update)\\r\\nSaid is in class 8 at Gede Special School.  His family is receiving food support from Kuhenza during the pandemic.  He is also being contacted on a regular basis to make sure he is ok.  \\r\\nMay 31, 2019\\r\\nSaid is now 16 years old and a student at Gede Special School in grade 7.  In addition to his hearing impairment Said has mild cerebral palsy which makes him walk with a  gait.  He will be getting surgery to help correct this problem. In class he does average work.  He has mastered sign language and can now confidently communicate his needs.  \\r\\n\\r\\nWith the payment of his boarding fees, Said has an opportunity to stay in school where he is assured of nutritious meals, medical intervention when he is sick, socialization with other students, instruction through sign language and the ability to develop and nurture his talents and potentials.  At school he is also able to compete in junior races (100 meters and 50 meters).  He competed this year at the county level.  In his free time he enjoys dancing and telling stories.\\r\\n\\r\\nHis mother is his main caretaker.  She loves her son and treats him like any other child. She brings him to school on time, participates in parent groups, attends school activities, attends parent conferences, and advocates for her child.\\r\\n\\r\\nYour sponsorship is paying for Said\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s boarding fees, medical intervention, advocacy for children with disabilities,  and counseling for Said and his family.  Thank you for your generosity.\\r\\n\\r\\nMarch 29, 2018\\r\\nExciting things are happening for children with disabilities in Kenya.  A large plot of land was donated to build a new special school in a remote village.  Plans are set to build another dormitory at one of our existing schools.  More staff is being added in Kenya to be able to work with these children.  Our Kenyan director and USA director are conducting workshops for pastors, natural healers, parents and government leaders on responsibility towards children with disability.  Things are looking up for the children that Kupenda serves.\\r\\n      Said is now 15 years old and a student at Gede Special School.  He is in class six and his grades are improving.  He is having trouble with English as his disability makes writing difficult.  It takes him longer to do assignments and needs to be given more time.  He receives guidance and counselling at school to help him realize his dreams.  He is able to communicate fluently in sign language.  He aspires to be a pilot some day.\\r\\n     Said has been very healthy except for a boil on his cheek which requires surgery.  He is friendly with his peers but needs to be guided on how to improve these interactions.  He participates in track events and has made it to the county level competitions.   He also enjoys watching movies.\\r\\n       His parents love their son and want what is best for him.  They visit him at school, participate in teacher conferences, are active in parent groups and bring Said home for the weekends.  The family has a positive attitude toward their son  but could use some guidance on how to live with him when he is at  home.\\r\\n        Thank you for your sponsorship, it is giving Said the chance to develop his full potential.\\r\\n\\r\\n10\\/29\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nSaid is now 12 years old and in the second grade at the Gede Special School.  He is in a specialized class because his cognitive development is slower than children in the mainstream class.  Said can now use sign language to communicate.  He can finger spell his name and those of the people around him.  His teachers say \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093he is a story teller who loves to chat with other children during his free time.\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d  He represents the school in the junior races and loves playing soccer.  \\r\\nHis parents are supportive of his education though they struggle top roved for their 8 children.  They are always visiting him at school and ensure he reports on time.  In spite of their low income level, they provide him with his school supplies and contribute to the Parent Teacher Association (PTA).  They also take him to church with them.  At home Said helps with some of the chores including washing clothes, tending animals, and looking after younger siblings.\\r\\n\\r\\nSaid is a ten year old boy who was born with cerebral palsy due to genetics.  He can walk without assistance because the cerebral palsy only affects the movement of his head and gives him a mild mental disability and no ability to speak.  Said\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s father is a hotelier and his mother is a peasant farmer.  The family of ten lives in a mud home that is located too far from Gede for Said to travel every day.  Said is in Primary class 1 and is has been doing very well.  He also likes to participate in the junior races.  With sponsorship, Said will continue to live in the safe environment that Gede provides and will continue his progress with his education.\\r\\nSaid was born with cerebral palsy that affects the movement of his head and gives him a slight mental disability.  His parents have seven other children to provide for and cannot pay for his boarding at Gede.  Said is in first grade and is doing quite well.  With sponsorship, he can continue his education at Gede.\",\"en_level_hearing\":\"\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"no speech\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"\",\"en_distance_away\":\"\",\"en_house_state\":\"\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Special School\",\"en_out_reach_app_cas\":\"8f22726a-4dbc-4028-b34e-d4aad6a3c219\",\"en_disability_type\":\"Cerebral Palsy (CP)\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"115\",\"en_cid\":\"KP1\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Said",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Kitsao",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": null,
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/bc2e0c256681cf52b3401003dc0eb067.jpg",
    "donations": [],
    "entity": {
      "id": 47502,
      "client_id": 207,
      "program_id": 3506,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "2",
      "wait_time": "2023-05-12",
      "json_fields": "{\"en_first_name\":\"Said\",\"en_second_name\":\"Kitsao\",\"en_last_name_1\":\"Msaji\",\"en_last_name_2\":\"\",\"en_gender\":\"Male\",\"en_date_of_birth\":\"17\\/07\\/2002\",\"en_mental_disability\":\"Normal\",\"en_public_comments\":\"Said was born with cerebral palsy for unknown reasons. It has caused him to lack speech and need special services outside of the main stream school.\",\"en_private_comments\":\"March 8, 2023\\r\\nSaid is a freshman at Pwani School for the Deaf. The term has just started so there have been no exams.  \\r\\n\\r\\nSaid has accepted his disability and now interacts with people well.  He participates in many sports such as running and football.\\r\\n\\r\\nThe family is facing challenges earning a living as a drought in the area has resulted in fewer or no crops.  Hopefully, recent rains will change the economics of the area.\\r\\n\\r\\nOctober 28, 2021\\r\\nSaid is now 19 years old and is a freshman at Pwani Secondary School for the Deaf.  He just started school this month and has not yet taken any exams.  He is good at Kenyan Sign Language.\\r\\n\\r\\nSaid can walk independently, grasp any object, and write and draw.   He has been healthy and active this year.  He has had annual physicals and is up to date on immunizations.\\r\\n\\r\\nSaid is friendly and kind. He enjoys spending time with his friends, playing team sports, and watching television.\\r\\n\\r\\nHis family relies on farming for financial support.  The continued drought is causing the farm to be less productive. Since his father has died Said has remained with his mother who lacks a reliable source of income.\\r\\n \\r\\nOctober 9, 2020\\r\\nSaidi is now 18 years old and is  a student at Gede Special Primary School in grade 8.  He is improving in KSL (Kenyan Sign Language).\\r\\n\\r\\nSaidi is friendly and kind.  He plays with his peers, watches television, and plays team sports.  He competes in running and football, most recently at the national level.  He seems happy, hopeful, and content.\\r\\n\\r\\nKuhenza has counselled the family on the care, rights, and laws of their son.  This has resulted in better care of Saidi.  Kuhenza is providing food and hand soap monthly as well as boarding fees when schools are open.\\r\\nJuly 30, 2020 (Quick update)\\r\\nSaid is in class 8 at Gede Special School.  His family is receiving food support from Kuhenza during the pandemic.  He is also being contacted on a regular basis to make sure he is ok.  \\r\\nMay 31, 2019\\r\\nSaid is now 16 years old and a student at Gede Special School in grade 7.  In addition to his hearing impairment Said has mild cerebral palsy which makes him walk with a  gait.  He will be getting surgery to help correct this problem. In class he does average work.  He has mastered sign language and can now confidently communicate his needs.  \\r\\n\\r\\nWith the payment of his boarding fees, Said has an opportunity to stay in school where he is assured of nutritious meals, medical intervention when he is sick, socialization with other students, instruction through sign language and the ability to develop and nurture his talents and potentials.  At school he is also able to compete in junior races (100 meters and 50 meters).  He competed this year at the county level.  In his free time he enjoys dancing and telling stories.\\r\\n\\r\\nHis mother is his main caretaker.  She loves her son and treats him like any other child. She brings him to school on time, participates in parent groups, attends school activities, attends parent conferences, and advocates for her child.\\r\\n\\r\\nYour sponsorship is paying for Said\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s boarding fees, medical intervention, advocacy for children with disabilities,  and counseling for Said and his family.  Thank you for your generosity.\\r\\n\\r\\nMarch 29, 2018\\r\\nExciting things are happening for children with disabilities in Kenya.  A large plot of land was donated to build a new special school in a remote village.  Plans are set to build another dormitory at one of our existing schools.  More staff is being added in Kenya to be able to work with these children.  Our Kenyan director and USA director are conducting workshops for pastors, natural healers, parents and government leaders on responsibility towards children with disability.  Things are looking up for the children that Kupenda serves.\\r\\n      Said is now 15 years old and a student at Gede Special School.  He is in class six and his grades are improving.  He is having trouble with English as his disability makes writing difficult.  It takes him longer to do assignments and needs to be given more time.  He receives guidance and counselling at school to help him realize his dreams.  He is able to communicate fluently in sign language.  He aspires to be a pilot some day.\\r\\n     Said has been very healthy except for a boil on his cheek which requires surgery.  He is friendly with his peers but needs to be guided on how to improve these interactions.  He participates in track events and has made it to the county level competitions.   He also enjoys watching movies.\\r\\n       His parents love their son and want what is best for him.  They visit him at school, participate in teacher conferences, are active in parent groups and bring Said home for the weekends.  The family has a positive attitude toward their son  but could use some guidance on how to live with him when he is at  home.\\r\\n        Thank you for your sponsorship, it is giving Said the chance to develop his full potential.\\r\\n\\r\\n10\\/29\\/14\\r\\nThis year has been a tough one for the Kenya coast where terrorist activities have been focused.  Travel warnings due to terrorist attacks have limited the ability of Kupenda volunteers to travel to Kenya. This is something the children look forward to each year in spite of these difficult circumstances the children of Kupenda continue to receive much needed support and services.\\r\\nSaid is now 12 years old and in the second grade at the Gede Special School.  He is in a specialized class because his cognitive development is slower than children in the mainstream class.  Said can now use sign language to communicate.  He can finger spell his name and those of the people around him.  His teachers say \\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c5\\u0093he is a story teller who loves to chat with other children during his free time.\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00c2\\u009d  He represents the school in the junior races and loves playing soccer.  \\r\\nHis parents are supportive of his education though they struggle top roved for their 8 children.  They are always visiting him at school and ensure he reports on time.  In spite of their low income level, they provide him with his school supplies and contribute to the Parent Teacher Association (PTA).  They also take him to church with them.  At home Said helps with some of the chores including washing clothes, tending animals, and looking after younger siblings.\\r\\n\\r\\nSaid is a ten year old boy who was born with cerebral palsy due to genetics.  He can walk without assistance because the cerebral palsy only affects the movement of his head and gives him a mild mental disability and no ability to speak.  Said\\u00c3\\u00a2\\u00e2\\u0082\\u00ac\\u00e2\\u0084\\u00a2s father is a hotelier and his mother is a peasant farmer.  The family of ten lives in a mud home that is located too far from Gede for Said to travel every day.  Said is in Primary class 1 and is has been doing very well.  He also likes to participate in the junior races.  With sponsorship, Said will continue to live in the safe environment that Gede provides and will continue his progress with his education.\\r\\nSaid was born with cerebral palsy that affects the movement of his head and gives him a slight mental disability.  His parents have seven other children to provide for and cannot pay for his boarding at Gede.  Said is in first grade and is doing quite well.  With sponsorship, he can continue his education at Gede.\",\"en_level_hearing\":\"\",\"en_hearing_test\":\"Does Not Apply\",\"en_walk\":\"Yes\",\"en_walk_assistance\":\"Does Not Apply\",\"en_cp_affected\":\"\",\"en_speech\":\"no speech\",\"en_lip_read\":\"Does Not Apply\",\"en_needs_met\":\"Yes\",\"en_treated_before\":\"\",\"en_family_communicat\":\"\",\"en_school\":\"\",\"en_class_level\":\"\",\"en_family_details\":\"\",\"en_father_name\":\"\",\"en_fathers_occupatio\":\"\",\"en_mothers_name\":\"\",\"en_mothers_occupatio\":\"\",\"en_guardians_name\":\"\",\"en_guardians_occupat\":\"\",\"en_guardians_relatio\":\"\",\"en_number_of_brother\":\"0\",\"en_number_of_sisters\":\"0\",\"en_willingness_of_pa\":\"Unwilling few resources\",\"en_situation_explain\":\"\",\"en_house_location\":\"\",\"en_distance_away\":\"\",\"en_house_state\":\"\",\"en_why_need_sponsors\":\"\",\"en_total_needed\":\"0\",\"en_other_needs\":\"\",\"en_languages\":\"\",\"en_religion\":\"\",\"en_church_name\":\"\",\"en_favorite_activity\":\"\",\"en_other_disabilitie\":\"No\",\"en_describe_disabili\":\"\",\"en_school_name\":\"Gede Special School\",\"en_out_reach_app_cas\":\"8f22726a-4dbc-4028-b34e-d4aad6a3c219\",\"en_disability_type\":\"Cerebral Palsy (CP)\",\"en_child_has_died\":\"FALSE\",\"en_not_available_for\":\"The child has not been contacted in over a year\",\"en_child_id\":\"115\",\"en_cid\":\"KP1\"}",
      "deleted_at": null,
      "created_at": "2023-05-12T09:26:18.000000Z",
      "updated_at": "2023-05-12T09:26:18.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/bc2e0c256681cf52b3401003dc0eb067_t_.jpg",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3506,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 3030,
      "setting_id": 410,
      "emailset_id": 1557,
      "entity_submit": "3058",
      "donor_submit": "",
      "link_id": null,
      "name": "Kupenda",
      "prefix": "KP",
      "counter": 200,
      "lft": 12,
      "rgt": 13,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-04-29T15:08:37.000000Z",
      "updated_at": "2024-07-29T09:01:30.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Said Kitsao",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 48070,
    "profile": {
      "en_first_name": "Charity",
      "en_second_name": "Smart",
      "en_age": "2010-06-09",
      "id": 48070,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "sp_amount": "35",
      "sp_num": "2",
      "wait_time": "2024-08-06",
      "json_fields": "{\"en_first_name\":\"Charity\",\"en_second_name\":\"Smart\",\"en_age\":\"2010-06-09\"}",
      "deleted_at": null,
      "created_at": "2024-08-06T12:51:47.000000Z",
      "updated_at": "2024-08-06T12:51:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Charity",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Smart",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "2010-06-09",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48070,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "sp_amount": "35",
      "sp_num": "2",
      "wait_time": "2024-08-06",
      "json_fields": "{\"en_first_name\":\"Charity\",\"en_second_name\":\"Smart\",\"en_age\":\"2010-06-09\"}",
      "deleted_at": null,
      "created_at": "2024-08-06T12:51:47.000000Z",
      "updated_at": "2024-08-06T12:51:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3494,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 1542,
      "entity_submit": "3058",
      "donor_submit": null,
      "link_id": 929,
      "name": "Youth Mentorship Program",
      "prefix": "",
      "counter": 5,
      "lft": 21,
      "rgt": 22,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-03-25T09:14:29.000000Z",
      "updated_at": "2024-08-06T12:51:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Charity Smart",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 48069,
    "profile": {
      "en_first_name": "Fred",
      "en_second_name": "Johnson",
      "en_age": "2008-12-20",
      "id": 48069,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "sp_amount": "35",
      "sp_num": "2",
      "wait_time": "2024-08-06",
      "json_fields": "{\"en_first_name\":\"Fred\",\"en_second_name\":\"Johnson\",\"en_age\":\"2008-12-20\"}",
      "deleted_at": null,
      "created_at": "2024-08-06T12:47:32.000000Z",
      "updated_at": "2024-08-06T12:47:32.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Fred",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Johnson",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "2008-12-20",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48069,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "sp_amount": "35",
      "sp_num": "2",
      "wait_time": "2024-08-06",
      "json_fields": "{\"en_first_name\":\"Fred\",\"en_second_name\":\"Johnson\",\"en_age\":\"2008-12-20\"}",
      "deleted_at": null,
      "created_at": "2024-08-06T12:47:32.000000Z",
      "updated_at": "2024-08-06T12:47:32.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3494,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 1542,
      "entity_submit": "3058",
      "donor_submit": null,
      "link_id": 929,
      "name": "Youth Mentorship Program",
      "prefix": "",
      "counter": 5,
      "lft": 21,
      "rgt": 22,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-03-25T09:14:29.000000Z",
      "updated_at": "2024-08-06T12:51:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Fred Johnson",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 48068,
    "profile": {
      "en_first_name": "Mavis",
      "en_second_name": "Vader",
      "en_age": "2012-06-12",
      "id": 48068,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "sp_amount": "35",
      "sp_num": "2",
      "wait_time": "2024-08-06",
      "json_fields": "{\"en_first_name\":\"Mavis\",\"en_second_name\":\"Vader\",\"en_age\":\"2012-06-12\"}",
      "deleted_at": null,
      "created_at": "2024-08-06T12:44:15.000000Z",
      "updated_at": "2024-08-06T12:44:15.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Mavis",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Vader",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "2012-06-12",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48068,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "sp_amount": "35",
      "sp_num": "2",
      "wait_time": "2024-08-06",
      "json_fields": "{\"en_first_name\":\"Mavis\",\"en_second_name\":\"Vader\",\"en_age\":\"2012-06-12\"}",
      "deleted_at": null,
      "created_at": "2024-08-06T12:44:15.000000Z",
      "updated_at": "2024-08-06T12:44:15.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3494,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 1542,
      "entity_submit": "3058",
      "donor_submit": null,
      "link_id": 929,
      "name": "Youth Mentorship Program",
      "prefix": "",
      "counter": 5,
      "lft": 21,
      "rgt": 22,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-03-25T09:14:29.000000Z",
      "updated_at": "2024-08-06T12:51:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Mavis Vader",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 48067,
    "profile": {
      "en_first_name": "Matthew",
      "en_second_name": "Lakemans",
      "en_age": "2014-07-10",
      "id": 48067,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "sp_amount": "35",
      "sp_num": "2",
      "wait_time": "2024-08-06",
      "json_fields": "{\"en_first_name\":\"Matthew\",\"en_second_name\":\"Lakemans\",\"en_age\":\"2014-07-10\"}",
      "deleted_at": null,
      "created_at": "2024-08-06T12:43:25.000000Z",
      "updated_at": "2024-08-06T12:43:25.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Matthew",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Lakemans",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "2014-07-10",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48067,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "sp_amount": "35",
      "sp_num": "2",
      "wait_time": "2024-08-06",
      "json_fields": "{\"en_first_name\":\"Matthew\",\"en_second_name\":\"Lakemans\",\"en_age\":\"2014-07-10\"}",
      "deleted_at": null,
      "created_at": "2024-08-06T12:43:25.000000Z",
      "updated_at": "2024-08-06T12:43:25.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3494,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 1542,
      "entity_submit": "3058",
      "donor_submit": null,
      "link_id": 929,
      "name": "Youth Mentorship Program",
      "prefix": "",
      "counter": 5,
      "lft": 21,
      "rgt": 22,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-03-25T09:14:29.000000Z",
      "updated_at": "2024-08-06T12:51:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Matthew Lakemans",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 48046,
    "profile": {
      "en_first_name": "Dolly",
      "en_second_name": "Blackman",
      "en_age": "2016-02-03",
      "id": 48046,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "wait_time": "2024-07-09",
      "json_fields": "{\"en_first_name\":\"Dolly\",\"en_second_name\":\"Blackman\",\"en_age\":\"2016-02-03\",\"id\":\"48046\",\"client_id\":\"207\",\"program_id\":\"3494\",\"status\":\"0\",\"re_add\":\"\",\"wait_time\":\"2024-07-09\",\"json_fields\":\"{\\\"en_child_name\\\":\\\"David Sente\\\",\\\"en_gender\\\":\\\"Male\\\",\\\"en_test_checkbox_2\\\":\\\"\\\\\\\"later\\\\\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2024-07-09T13:35:33.000000Z\",\"updated_at\":\"2024-07-09T13:35:33.000000Z\",\"__hevo__database_name\":\"\",\"__hevo__ingested_at\":\"\",\"__hevo__marked_deleted\":\"\",\"__hevo__source_modified_at\":\"\",\"entity_id\":\"48046\"}",
      "deleted_at": null,
      "created_at": "2024-07-09T13:35:33.000000Z",
      "updated_at": "2024-08-06T12:40:55.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "entity_id": "48046",
      "sp_amount": "35",
      "sp_num": "2",
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Dolly",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Blackman",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "2016-02-03",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48046,
      "client_id": 207,
      "program_id": 3494,
      "status": "0",
      "re_add": null,
      "sp_amount": "35",
      "sp_num": "2",
      "wait_time": "2024-07-09",
      "json_fields": "{\"en_first_name\":\"Dolly\",\"en_second_name\":\"Blackman\",\"en_age\":\"2016-02-03\",\"id\":\"48046\",\"client_id\":\"207\",\"program_id\":\"3494\",\"status\":\"0\",\"re_add\":\"\",\"wait_time\":\"2024-07-09\",\"json_fields\":\"{\\\"en_child_name\\\":\\\"David Sente\\\",\\\"en_gender\\\":\\\"Male\\\",\\\"en_test_checkbox_2\\\":\\\"\\\\\\\"later\\\\\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2024-07-09T13:35:33.000000Z\",\"updated_at\":\"2024-07-09T13:35:33.000000Z\",\"__hevo__database_name\":\"\",\"__hevo__ingested_at\":\"\",\"__hevo__marked_deleted\":\"\",\"__hevo__source_modified_at\":\"\",\"entity_id\":\"48046\"}",
      "deleted_at": null,
      "created_at": "2024-07-09T13:35:33.000000Z",
      "updated_at": "2024-08-06T12:40:55.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [
      {
        "id": 26133,
        "hysform_id": 639,
        "name": "Test Sponsor",
        "email": "SponsorTest@gmail.com",
        "frequency": "Every Month",
        "amount": 35
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [
      {
        "id": 3058,
        "client_id": 207,
        "default_emailset_id": 0,
        "type": "submit",
        "name": "Child Reports",
        "prefix": "",
        "counter": 0,
        "box_folder_id": "",
        "can_donor_modify_amount": "",
        "mailchimp_list_id": "",
        "forgive_missed_payments": 0,
        "notify": null,
        "deleted_at": null,
        "created_at": "2024-07-24T07:22:56.000000Z",
        "updated_at": "2024-07-24T07:22:56.000000Z",
        "hide_payment": "",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "program": {
      "id": 3494,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 1542,
      "entity_submit": "3058",
      "donor_submit": null,
      "link_id": 929,
      "name": "Youth Mentorship Program",
      "prefix": "",
      "counter": 5,
      "lft": 21,
      "rgt": 22,
      "tree": 207,
      "box_folder_id": null,
      "deleted_at": null,
      "created_at": "2023-03-25T09:14:29.000000Z",
      "updated_at": "2024-08-06T12:51:47.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "children": []
    },
    "name": "Dolly Blackman",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "1 of 2": "Sponsors",
      "50%": "Complete"
    }
  },
  {
    "id": 48052,
    "profile": {
      "en_first_name": "Michelle",
      "en_second_name": "Olsson",
      "en_age": "2012-07-17",
      "id": 48052,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Michelle\",\"en_second_name\":\"Olsson\",\"en_age\":\"2012-07-17\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:44:36.000000Z",
      "updated_at": "2024-07-29T18:44:36.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Michelle",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Olsson",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "2012-07-17",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48052,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Michelle\",\"en_second_name\":\"Olsson\",\"en_age\":\"2012-07-17\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:44:36.000000Z",
      "updated_at": "2024-07-29T18:44:36.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "contribution",
      "sp_num": [
        {
          "symbol": "Yen",
          "amount": "100"
        }
      ],
      "sp_amount": [
        {
          "symbol": "Yen",
          "amount": "10"
        }
      ],
      "currency_symbol": "Yen"
    },
    "submit": [],
    "program": {
      "id": 3438,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 1641,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Marathon for the Disabled",
      "prefix": "C1",
      "counter": 5,
      "lft": 14,
      "rgt": 15,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-21T16:50:33.000000Z",
      "updated_at": "2024-08-06T12:02:58.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679910350683,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1679909849000,
      "children": []
    },
    "name": "Michelle Olsson",
    "settings": {
      "program_type": "contribution",
      "sp_num": "100",
      "labels": "Small",
      "number_spon": "",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "10",
      "transaction_amount": "",
      "currency_symbol": "Yen",
      "duration": "365",
      "stripe": "",
      "login_box": "",
      "checks": "",
      "designations": "",
      "sorting": "",
      "display_all": "",
      "wire_transfer": "",
      "cash": "",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "Yen0": "Monthly",
      "0%": "Complete"
    }
  },
  {
    "id": 48051,
    "profile": {
      "en_first_name": "Mathias",
      "en_second_name": "Wu",
      "en_age": "2000-08-24",
      "id": 48051,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Mathias\",\"en_second_name\":\"Wu\",\"en_age\":\"2000-08-24\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:44:03.000000Z",
      "updated_at": "2024-07-29T18:44:03.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Mathias",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Wu",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "2000-08-24",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48051,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Mathias\",\"en_second_name\":\"Wu\",\"en_age\":\"2000-08-24\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:44:03.000000Z",
      "updated_at": "2024-07-29T18:44:03.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "contribution",
      "sp_num": [
        {
          "symbol": "Yen",
          "amount": "100"
        }
      ],
      "sp_amount": [
        {
          "symbol": "Yen",
          "amount": "10"
        }
      ],
      "currency_symbol": "Yen"
    },
    "submit": [],
    "program": {
      "id": 3438,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 1641,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Marathon for the Disabled",
      "prefix": "C1",
      "counter": 5,
      "lft": 14,
      "rgt": 15,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-21T16:50:33.000000Z",
      "updated_at": "2024-08-06T12:02:58.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679910350683,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1679909849000,
      "children": []
    },
    "name": "Mathias Wu",
    "settings": {
      "program_type": "contribution",
      "sp_num": "100",
      "labels": "Small",
      "number_spon": "",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "10",
      "transaction_amount": "",
      "currency_symbol": "Yen",
      "duration": "365",
      "stripe": "",
      "login_box": "",
      "checks": "",
      "designations": "",
      "sorting": "",
      "display_all": "",
      "wire_transfer": "",
      "cash": "",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "Yen0": "Monthly",
      "0%": "Complete"
    }
  },
  {
    "id": 48050,
    "profile": {
      "en_first_name": "Kimberly",
      "en_second_name": "Parker",
      "en_age": "2006-07-13",
      "id": 48050,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Kimberly\",\"en_second_name\":\"Parker\",\"en_age\":\"2006-07-13\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:43:41.000000Z",
      "updated_at": "2024-07-29T18:43:41.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Kimberly",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Parker",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "2006-07-13",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48050,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Kimberly\",\"en_second_name\":\"Parker\",\"en_age\":\"2006-07-13\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:43:41.000000Z",
      "updated_at": "2024-07-29T18:43:41.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "contribution",
      "sp_num": [
        {
          "symbol": "Yen",
          "amount": "100"
        }
      ],
      "sp_amount": [
        {
          "symbol": "Yen",
          "amount": "10"
        }
      ],
      "currency_symbol": "Yen"
    },
    "submit": [],
    "program": {
      "id": 3438,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 1641,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Marathon for the Disabled",
      "prefix": "C1",
      "counter": 5,
      "lft": 14,
      "rgt": 15,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-21T16:50:33.000000Z",
      "updated_at": "2024-08-06T12:02:58.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679910350683,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1679909849000,
      "children": []
    },
    "name": "Kimberly Parker",
    "settings": {
      "program_type": "contribution",
      "sp_num": "100",
      "labels": "Small",
      "number_spon": "",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "10",
      "transaction_amount": "",
      "currency_symbol": "Yen",
      "duration": "365",
      "stripe": "",
      "login_box": "",
      "checks": "",
      "designations": "",
      "sorting": "",
      "display_all": "",
      "wire_transfer": "",
      "cash": "",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "Yen0": "Monthly",
      "0%": "Complete"
    }
  },
  {
    "id": 48049,
    "profile": {
      "en_first_name": "Morwenna",
      "en_second_name": "Barlow",
      "en_age": "1999-02-10",
      "id": 48049,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Morwenna\",\"en_second_name\":\"Barlow\",\"en_age\":\"1999-02-10\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:43:16.000000Z",
      "updated_at": "2024-07-29T18:43:16.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Morwenna",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Barlow",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "1999-02-10",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48049,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Morwenna\",\"en_second_name\":\"Barlow\",\"en_age\":\"1999-02-10\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:43:16.000000Z",
      "updated_at": "2024-07-29T18:43:16.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "contribution",
      "sp_num": [
        {
          "symbol": "Yen",
          "amount": "100"
        }
      ],
      "sp_amount": [
        {
          "symbol": "Yen",
          "amount": "10"
        }
      ],
      "currency_symbol": "Yen"
    },
    "submit": [],
    "program": {
      "id": 3438,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 1641,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Marathon for the Disabled",
      "prefix": "C1",
      "counter": 5,
      "lft": 14,
      "rgt": 15,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-21T16:50:33.000000Z",
      "updated_at": "2024-08-06T12:02:58.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679910350683,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1679909849000,
      "children": []
    },
    "name": "Morwenna Barlow",
    "settings": {
      "program_type": "contribution",
      "sp_num": "100",
      "labels": "Small",
      "number_spon": "",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "10",
      "transaction_amount": "",
      "currency_symbol": "Yen",
      "duration": "365",
      "stripe": "",
      "login_box": "",
      "checks": "",
      "designations": "",
      "sorting": "",
      "display_all": "",
      "wire_transfer": "",
      "cash": "",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "Yen0": "Monthly",
      "0%": "Complete"
    }
  },
  {
    "id": 48048,
    "profile": {
      "en_first_name": "Daniel",
      "en_second_name": "Cox",
      "en_age": "2010-02-26",
      "id": 48048,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Daniel\",\"en_second_name\":\"Cox\",\"en_age\":\"2010-02-26\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:41:59.000000Z",
      "updated_at": "2024-07-29T18:41:59.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": "Daniel",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": "Cox",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "2010-02-26",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 48048,
      "client_id": 207,
      "program_id": 3438,
      "status": "0",
      "re_add": null,
      "sp_amount": "10",
      "sp_num": "",
      "wait_time": "2024-07-29",
      "json_fields": "{\"en_first_name\":\"Daniel\",\"en_second_name\":\"Cox\",\"en_age\":\"2010-02-26\"}",
      "deleted_at": null,
      "created_at": "2024-07-29T18:41:59.000000Z",
      "updated_at": "2024-07-29T18:41:59.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "contribution",
      "sp_num": [
        {
          "symbol": "Yen",
          "amount": "100"
        }
      ],
      "sp_amount": [
        {
          "symbol": "Yen",
          "amount": "10"
        }
      ],
      "currency_symbol": "Yen"
    },
    "submit": [],
    "program": {
      "id": 3438,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 1641,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Marathon for the Disabled",
      "prefix": "C1",
      "counter": 5,
      "lft": 14,
      "rgt": 15,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-21T16:50:33.000000Z",
      "updated_at": "2024-08-06T12:02:58.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679910350683,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1679909849000,
      "children": []
    },
    "name": "Daniel Cox",
    "settings": {
      "program_type": "contribution",
      "sp_num": "100",
      "labels": "Small",
      "number_spon": "",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "10",
      "transaction_amount": "",
      "currency_symbol": "Yen",
      "duration": "365",
      "stripe": "",
      "login_box": "",
      "checks": "",
      "designations": "",
      "sorting": "",
      "display_all": "",
      "wire_transfer": "",
      "cash": "",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "",
      "display_percent": "",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "Yen0": "Monthly",
      "0%": "Complete"
    }
  },
  {
    "id": 46803,
    "profile": {
      "en_child_name": "Martha",
      "en_gender": "",
      "en_birthdate": "Yusufu",
      "id": 46803,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Martha\",\"en_gender\":\"\",\"en_birthdate\":\"Yusufu\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Martha",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 1,
        "filter": 1,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2024-07-11T09:50:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T14:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:53.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T17:27:08.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "Yusufu",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T04:11:48.000000Z",
        "updated_at": "2023-03-31T11:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:18.000000Z",
        "updated_at": "2023-01-12T13:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T11:11:19.000000Z",
        "updated_at": "2023-01-16T11:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T07:04:48.000000Z",
        "updated_at": "2023-03-17T07:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T09:42:48.000000Z",
        "updated_at": "2023-03-17T09:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T13:06:06.000000Z",
        "updated_at": "2023-03-31T13:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6735,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_id_field",
        "field_label": "Id fIELD",
        "field_data": null,
        "field_type": "hysCustomid",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2024-08-06T09:10:00.000000Z",
        "updated_at": "2024-08-06T09:10:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 46803,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Martha\",\"en_gender\":\"\",\"en_birthdate\":\"Yusufu\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3437,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 0,
      "setting_id": 410,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Medical",
      "prefix": "",
      "counter": 0,
      "lft": 16,
      "rgt": 17,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-14T20:13:03.000000Z",
      "updated_at": "2023-03-28T18:44:07.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248746,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003847000,
      "children": []
    },
    "name": "Martha",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 46802,
    "profile": {
      "en_child_name": "Grace",
      "en_gender": "Mahenzo",
      "en_birthdate": "Chengo",
      "id": 46802,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Grace\",\"en_gender\":\"Mahenzo\",\"en_birthdate\":\"Chengo\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Grace",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 1,
        "filter": 1,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2024-07-11T09:50:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Mahenzo",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T14:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:53.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T17:27:08.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "Chengo",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T04:11:48.000000Z",
        "updated_at": "2023-03-31T11:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:18.000000Z",
        "updated_at": "2023-01-12T13:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T11:11:19.000000Z",
        "updated_at": "2023-01-16T11:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T07:04:48.000000Z",
        "updated_at": "2023-03-17T07:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T09:42:48.000000Z",
        "updated_at": "2023-03-17T09:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T13:06:06.000000Z",
        "updated_at": "2023-03-31T13:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6735,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_id_field",
        "field_label": "Id fIELD",
        "field_data": null,
        "field_type": "hysCustomid",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2024-08-06T09:10:00.000000Z",
        "updated_at": "2024-08-06T09:10:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 46802,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Grace\",\"en_gender\":\"Mahenzo\",\"en_birthdate\":\"Chengo\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3437,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 0,
      "setting_id": 410,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Medical",
      "prefix": "",
      "counter": 0,
      "lft": 16,
      "rgt": 17,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-14T20:13:03.000000Z",
      "updated_at": "2023-03-28T18:44:07.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248746,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003847000,
      "children": []
    },
    "name": "Grace",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 46801,
    "profile": {
      "en_child_name": "Kennedy",
      "en_gender": "",
      "en_birthdate": "Kahindi",
      "id": 46801,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Kennedy\",\"en_gender\":\"\",\"en_birthdate\":\"Kahindi\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Kennedy",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 1,
        "filter": 1,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2024-07-11T09:50:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T14:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:53.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T17:27:08.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "Kahindi",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T04:11:48.000000Z",
        "updated_at": "2023-03-31T11:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:18.000000Z",
        "updated_at": "2023-01-12T13:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T11:11:19.000000Z",
        "updated_at": "2023-01-16T11:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T07:04:48.000000Z",
        "updated_at": "2023-03-17T07:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T09:42:48.000000Z",
        "updated_at": "2023-03-17T09:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T13:06:06.000000Z",
        "updated_at": "2023-03-31T13:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6735,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_id_field",
        "field_label": "Id fIELD",
        "field_data": null,
        "field_type": "hysCustomid",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2024-08-06T09:10:00.000000Z",
        "updated_at": "2024-08-06T09:10:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 46801,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Kennedy\",\"en_gender\":\"\",\"en_birthdate\":\"Kahindi\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3437,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 0,
      "setting_id": 410,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Medical",
      "prefix": "",
      "counter": 0,
      "lft": 16,
      "rgt": 17,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-14T20:13:03.000000Z",
      "updated_at": "2023-03-28T18:44:07.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248746,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003847000,
      "children": []
    },
    "name": "Kennedy",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 46800,
    "profile": {
      "en_child_name": "Baraka",
      "en_gender": "",
      "en_birthdate": "Kashuru",
      "id": 46800,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Baraka\",\"en_gender\":\"\",\"en_birthdate\":\"Kashuru\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Baraka",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 1,
        "filter": 1,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2024-07-11T09:50:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T14:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:53.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T17:27:08.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "Kashuru",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T04:11:48.000000Z",
        "updated_at": "2023-03-31T11:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:18.000000Z",
        "updated_at": "2023-01-12T13:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T11:11:19.000000Z",
        "updated_at": "2023-01-16T11:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T07:04:48.000000Z",
        "updated_at": "2023-03-17T07:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T09:42:48.000000Z",
        "updated_at": "2023-03-17T09:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T13:06:06.000000Z",
        "updated_at": "2023-03-31T13:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6735,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_id_field",
        "field_label": "Id fIELD",
        "field_data": null,
        "field_type": "hysCustomid",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2024-08-06T09:10:00.000000Z",
        "updated_at": "2024-08-06T09:10:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 46800,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Baraka\",\"en_gender\":\"\",\"en_birthdate\":\"Kashuru\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3437,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 0,
      "setting_id": 410,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Medical",
      "prefix": "",
      "counter": 0,
      "lft": 16,
      "rgt": 17,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-14T20:13:03.000000Z",
      "updated_at": "2023-03-28T18:44:07.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248746,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003847000,
      "children": []
    },
    "name": "Baraka",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 46799,
    "profile": {
      "en_child_name": "Amina",
      "en_gender": "Nyundo",
      "en_birthdate": "Chengo",
      "id": 46799,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Amina\",\"en_gender\":\"Nyundo\",\"en_birthdate\":\"Chengo\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Amina",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 1,
        "filter": 1,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2024-07-11T09:50:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Nyundo",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T14:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:53.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T17:27:08.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "Chengo",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T04:11:48.000000Z",
        "updated_at": "2023-03-31T11:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:18.000000Z",
        "updated_at": "2023-01-12T13:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T11:11:19.000000Z",
        "updated_at": "2023-01-16T11:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T07:04:48.000000Z",
        "updated_at": "2023-03-17T07:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T09:42:48.000000Z",
        "updated_at": "2023-03-17T09:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T13:06:06.000000Z",
        "updated_at": "2023-03-31T13:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6735,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_id_field",
        "field_label": "Id fIELD",
        "field_data": null,
        "field_type": "hysCustomid",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2024-08-06T09:10:00.000000Z",
        "updated_at": "2024-08-06T09:10:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 46799,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Amina\",\"en_gender\":\"Nyundo\",\"en_birthdate\":\"Chengo\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3437,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 0,
      "setting_id": 410,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Medical",
      "prefix": "",
      "counter": 0,
      "lft": 16,
      "rgt": 17,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-14T20:13:03.000000Z",
      "updated_at": "2023-03-28T18:44:07.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248746,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003847000,
      "children": []
    },
    "name": "Amina",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 46798,
    "profile": {
      "en_child_name": "Kashuru",
      "en_gender": "Msanzu",
      "en_birthdate": "Kin\uff83\uff62\u7ac4\uff6c\u9083\uff62gan\uff83\uff62\u7ac4\uff6c\u9083\uff62ga",
      "id": 46798,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Kashuru\",\"en_gender\":\"Msanzu\",\"en_birthdate\":\"Kin\\uff83\\uff62\\u7ac4\\uff6c\\u9083\\uff62gan\\uff83\\uff62\\u7ac4\\uff6c\\u9083\\uff62ga\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 2442,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_child_name",
        "field_label": "Child Name",
        "field_data": "Kashuru",
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 1,
        "filter": 1,
        "field_order": 0,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2024-07-11T09:50:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2444,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_gender",
        "field_label": "Gender",
        "field_data": "Msanzu",
        "field_type": "hysSelect",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 1,
        "deleted_at": null,
        "created_at": null,
        "updated_at": "2022-11-25T14:22:20.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2446,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_grade",
        "field_label": "Grade",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 2,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:53.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2907,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 3,
        "deleted_at": null,
        "created_at": "2018-09-29T17:27:08.000000Z",
        "updated_at": "2019-01-23T01:52:56.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2994,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_birthdate",
        "field_label": "Birthdate",
        "field_data": "Kin\uff83\uff62\u7ac4\uff6c\u9083\uff62gan\uff83\uff62\u7ac4\uff6c\u9083\uff62ga",
        "field_type": "hysDate",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 1,
        "field_order": 4,
        "deleted_at": null,
        "created_at": "2018-11-24T04:11:48.000000Z",
        "updated_at": "2023-03-31T11:17:50.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:18.000000Z",
        "updated_at": "2023-01-12T13:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6523,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_table",
        "field_label": "Test Table",
        "field_data": "age, gender",
        "field_type": "hysTable",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 12,
        "deleted_at": null,
        "created_at": "2023-01-16T11:11:19.000000Z",
        "updated_at": "2023-01-16T11:11:19.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6536,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_check_box",
        "field_label": "Test Check box",
        "field_data": "yes,no",
        "field_type": "hysCheckbox",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 13,
        "deleted_at": null,
        "created_at": "2023-03-17T07:04:48.000000Z",
        "updated_at": "2023-03-17T07:04:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6537,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_field_boolea",
        "field_label": "Test Field boolean",
        "field_data": "yes,no",
        "field_type": "hysSelect",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 14,
        "deleted_at": null,
        "created_at": "2023-03-17T09:42:48.000000Z",
        "updated_at": "2023-03-17T09:42:48.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6538,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_test_checkbox_2",
        "field_label": "Test Checkbox 2",
        "field_data": "maybe,later",
        "field_type": "hysCheckbox",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 15,
        "deleted_at": null,
        "created_at": "2023-03-31T13:06:06.000000Z",
        "updated_at": "2023-03-31T13:06:06.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6735,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_id_field",
        "field_label": "Id fIELD",
        "field_data": null,
        "field_type": "hysCustomid",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2024-08-06T09:10:00.000000Z",
        "updated_at": "2024-08-06T09:10:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 46798,
      "client_id": 207,
      "program_id": 3437,
      "status": "0",
      "re_add": null,
      "sp_amount": "40",
      "sp_num": "2",
      "wait_time": "2023-05-03",
      "json_fields": "{\"en_child_name\":\"Kashuru\",\"en_gender\":\"Msanzu\",\"en_birthdate\":\"Kin\\uff83\\uff62\\u7ac4\\uff6c\\u9083\\uff62gan\\uff83\\uff62\\u7ac4\\uff6c\\u9083\\uff62ga\"}",
      "deleted_at": null,
      "created_at": "2023-05-03T12:15:46.000000Z",
      "updated_at": "2023-05-03T12:15:46.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 3437,
      "client_id": 207,
      "hysform_id": 638,
      "donor_hysform_id": 0,
      "setting_id": 410,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Medical",
      "prefix": "",
      "counter": 0,
      "lft": 16,
      "rgt": 17,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2022-12-14T20:13:03.000000Z",
      "updated_at": "2023-03-28T18:44:07.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1680004248746,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1680003847000,
      "children": []
    },
    "name": "Kashuru",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 2": "Sponsors",
      "0%": "Complete"
    }
  },
  {
    "id": 36305,
    "profile": {
      "en_child_name": "Kelluckson Jack",
      "en_gender": "Male",
      "en_grade": "PS I",
      "en_age": "3",
      "en_birthdate": "12-17-2014",
      "en_favorite_subject": "",
      "id": 36305,
      "client_id": 207,
      "program_id": 1221,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Kelluckson Jack\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"3\",\"en_birthdate\":\"12-17-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T17:32:28.000000Z",
      "updated_at": "2024-07-09T13:55:58.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": null,
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": null,
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "3",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "https://s3-us-west-1.amazonaws.com/hys/c07e54b8f0c5686e2837e10950152f7dbc9b33fe1.png",
    "donations": [],
    "entity": {
      "id": 36305,
      "client_id": 207,
      "program_id": 1221,
      "status": "1",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "0000-00-00",
      "json_fields": "{\"en_child_name\":\"Kelluckson Jack\",\"en_gender\":\"Male\",\"en_grade\":\"PS I\",\"en_age\":\"3\",\"en_birthdate\":\"12-17-2014\",\"en_favorite_subject\":\"\"}",
      "deleted_at": null,
      "created_at": "2018-09-29T17:32:28.000000Z",
      "updated_at": "2024-07-09T13:55:58.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "https://s3-us-west-1.amazonaws.com/hys/c07e54b8f0c5686e2837e10950152f7dbc9b33fe1_t_.png",
    "sponsors": [
      {
        "id": 26134,
        "hysform_id": 639,
        "name": "Test Mulimwa",
        "email": "TestMulimwa@gmail.com",
        "frequency": "Every Month",
        "amount": 32
      }
    ],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 1221,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Sponsored",
      "prefix": "",
      "counter": 54,
      "lft": 18,
      "rgt": 19,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2019-01-22T01:50:21.000000Z",
      "updated_at": "2024-07-26T09:58:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679910350681,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1679909849000,
      "children": []
    },
    "name": "",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$13": "To Date",
      "1 of 1": "Sponsors",
      "100%": "Complete"
    }
  },
  {
    "id": 45642,
    "profile": {
      "en_child_name": "Emma Watson",
      "en_gender": "Male",
      "en_grade": "P1",
      "en_age": "6",
      "en_birthdate": "2000-05-12",
      "en_favorite_subject": "English",
      "id": 45642,
      "client_id": 207,
      "program_id": 1221,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "2022-11-18",
      "json_fields": "{\"en_child_name\":\"Emma Watson\",\"en_gender\":\"Male\",\"en_grade\":\"P1\",\"en_age\":\"6\",\"en_birthdate\":\"2000-05-12\",\"en_favorite_subject\":\"English\"}",
      "deleted_at": null,
      "created_at": "2022-11-18T14:45:34.000000Z",
      "updated_at": "2022-11-18T14:45:34.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "fields": [
      {
        "id": 6717,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_first_name",
        "field_label": "First Name",
        "field_data": null,
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6718,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_second_name",
        "field_label": "Second Name",
        "field_data": null,
        "field_type": "hysText",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 1,
        "sortable": 0,
        "filter": 0,
        "field_order": 9,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      },
      {
        "id": 6719,
        "client_id": 207,
        "hysform_id": 3019,
        "field_key": "en_age",
        "field_label": "Age",
        "field_data": "6",
        "field_type": "hysAge",
        "required": 1,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 10,
        "deleted_at": null,
        "created_at": "2024-07-29T08:35:13.000000Z",
        "updated_at": "2024-07-29T08:35:13.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
      }
    ],
    "profilePic": "",
    "donations": [],
    "entity": {
      "id": 45642,
      "client_id": 207,
      "program_id": 1221,
      "status": "0",
      "re_add": null,
      "sp_amount": "32",
      "sp_num": "1",
      "wait_time": "2022-11-18",
      "json_fields": "{\"en_child_name\":\"Emma Watson\",\"en_gender\":\"Male\",\"en_grade\":\"P1\",\"en_age\":\"6\",\"en_birthdate\":\"2000-05-12\",\"en_favorite_subject\":\"English\"}",
      "deleted_at": null,
      "created_at": "2022-11-18T14:45:34.000000Z",
      "updated_at": "2022-11-18T14:45:34.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725261350,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null,
      "tags": null
    },
    "profileThumb": "",
    "sponsors": [],
    "programData": {
      "type": "number",
      "number_sponsors": [
        "2"
      ],
      "sp_amount": [
        {
          "symbol": "$",
          "amount": "35"
        },
        {
          "symbol": "$",
          "amount": "40"
        },
        {
          "symbol": "$",
          "amount": "50"
        }
      ],
      "currency_symbol": "$"
    },
    "submit": [],
    "program": {
      "id": 1221,
      "client_id": 207,
      "hysform_id": 3019,
      "donor_hysform_id": 639,
      "setting_id": 410,
      "emailset_id": 0,
      "entity_submit": "",
      "donor_submit": "",
      "link_id": 0,
      "name": "Sponsored",
      "prefix": "",
      "counter": 54,
      "lft": 18,
      "rgt": 19,
      "tree": 207,
      "box_folder_id": "",
      "deleted_at": null,
      "created_at": "2019-01-22T01:50:21.000000Z",
      "updated_at": "2024-07-26T09:58:46.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679910350681,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": 1679909849000,
      "children": []
    },
    "name": "",
    "settings": {
      "program_type": "number",
      "sp_num": "",
      "labels": "",
      "number_spon": "2",
      "descending_order": "",
      "hide_noimage_recipients": "",
      "donation_target": "",
      "sponsorship_amount": "35,40,50",
      "transaction_amount": "",
      "currency_symbol": "$",
      "duration": "366",
      "stripe": "1",
      "login_box": "1",
      "checks": "1",
      "designations": "1",
      "sorting": "1",
      "display_all": "1",
      "wire_transfer": "1",
      "cash": "1",
      "hide_payment_method": "",
      "hide_frequency": "",
      "placeholder": "",
      "display_info": "1",
      "display_percent": "1",
      "processing_fee": "",
      "processing_percentage": ""
    },
    "details": {
      "$0": "To Date",
      "0 of 1": "Sponsors",
      "0%": "Complete"
    }
  }
]

export const fields = [
  {
    "id": 2442,
    "client_id": 207,
    "hysform_id": 638,
    "field_key": "en_child_name",
    "field_label": "Child Name",
    "field_data": "Enter Name",
    "field_type": "hysText",
    "required": 1,
    "permissions": "public",
    "admingroup_id": 0,
    "is_title": 1,
    "sortable": 1,
    "filter": 1,
    "field_order": 0,
    "deleted_at": null,
    "created_at": null,
    "updated_at": "2024-07-11T09:50:19.000000Z",
    "__hevo__database_name": "apphys_new",
    "__hevo__ingested_at": 1679725257287,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null
  },
  {
      "id": 2444,
      "client_id": 207,
      "hysform_id": 638,
      "field_key": "en_gender",
      "field_label": "Gender",
      "field_data": ",Male,Female",
      "field_type": "hysSelect",
      "required": 1,
      "permissions": "public",
      "admingroup_id": 0,
      "is_title": 0,
      "sortable": 0,
      "filter": 0,
      "field_order": 1,
      "deleted_at": null,
      "created_at": null,
      "updated_at": "2022-11-25T14:22:20.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725257287,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
  },
  {
      "id": 2446,
      "client_id": 207,
      "hysform_id": 638,
      "field_key": "en_grade",
      "field_label": "Grade",
      "field_data": "",
      "field_type": "hysText",
      "required": 0,
      "permissions": "public",
      "admingroup_id": 0,
      "is_title": 0,
      "sortable": 0,
      "filter": 0,
      "field_order": 2,
      "deleted_at": null,
      "created_at": "2017-02-22T18:57:53.000000Z",
      "updated_at": "2019-01-23T01:52:56.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725257287,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
  },
  {
      "id": 2907,
      "client_id": 207,
      "hysform_id": 638,
      "field_key": "en_age",
      "field_label": "Age",
      "field_data": "",
      "field_type": "hysText",
      "required": 0,
      "permissions": "public",
      "admingroup_id": 0,
      "is_title": 0,
      "sortable": 0,
      "filter": 0,
      "field_order": 3,
      "deleted_at": null,
      "created_at": "2018-09-29T17:27:08.000000Z",
      "updated_at": "2019-01-23T01:52:56.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725257287,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
  },
  {
      "id": 2994,
      "client_id": 207,
      "hysform_id": 638,
      "field_key": "en_birthdate",
      "field_label": "Birthdate",
      "field_data": "",
      "field_type": "hysDate",
      "required": 0,
      "permissions": "public",
      "admingroup_id": 0,
      "is_title": 0,
      "sortable": 0,
      "filter": 1,
      "field_order": 4,
      "deleted_at": null,
      "created_at": "2018-11-24T04:11:48.000000Z",
      "updated_at": "2023-03-31T11:17:50.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725257287,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
    },
    {
        "id": 2445,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_favorite_subject",
        "field_label": "Favorite Subject",
        "field_data": "",
        "field_type": "hysText",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 8,
        "deleted_at": null,
        "created_at": "2017-02-22T18:57:18.000000Z",
        "updated_at": "2023-01-12T13:58:21.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725257287,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null
    },
    {
        "id": 6735,
        "client_id": 207,
        "hysform_id": 638,
        "field_key": "en_id_field",
        "field_label": "Id fIELD",
        "field_data": null,
        "field_type": "hysCustomid",
        "required": 0,
        "permissions": "public",
        "admingroup_id": 0,
        "is_title": 0,
        "sortable": 0,
        "filter": 0,
        "field_order": 17,
        "deleted_at": null,
        "created_at": "2024-08-06T09:10:00.000000Z",
        "updated_at": "2024-08-06T09:10:00.000000Z",
        "__hevo__database_name": null,
        "__hevo__ingested_at": null,
        "__hevo__marked_deleted": null,
        "__hevo__source_modified_at": null
    },
    {
      "id": 1436,
      "client_id": 207,
      "hysform_id": 639,
      "field_key": "dn_donor_name",
      "field_label": "Donor Name",
      "field_data": "Enter Name",
      "field_type": "hysText",
      "required": 1,
      "permissions": "public",
      "admingroup_id": 0,
      "is_title": 1,
      "field_order": 0,
      "deleted_at": null,
      "created_at": "2017-02-22T17:40:22.000000Z",
      "updated_at": "2022-12-12T15:27:35.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725249741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
  },
  {
      "id": 1817,
      "client_id": 207,
      "hysform_id": 639,
      "field_key": "dn_payment_type",
      "field_label": "Payment Type",
      "field_data": "",
      "field_type": "hysText",
      "required": 0,
      "permissions": "admin",
      "admingroup_id": 0,
      "is_title": 1,
      "field_order": 1,
      "deleted_at": null,
      "created_at": "2019-01-23T01:58:32.000000Z",
      "updated_at": "2022-12-12T15:27:35.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725249741,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null
  },
  {
      "id": 5166,
      "client_id": 207,
      "hysform_id": 639,
      "field_key": "dn_address",
      "field_label": "Address",
      "field_data": null,
      "field_type": "hysText",
      "required": 0,
      "permissions": "public",
      "admingroup_id": 0,
      "is_title": 0,
      "field_order": 7,
      "deleted_at": null,
      "created_at": "2024-08-02T21:47:21.000000Z",
      "updated_at": "2024-08-02T21:47:21.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null
  },
  {
      "id": 5170,
      "client_id": 207,
      "hysform_id": 639,
      "field_key": "dn_id_field",
      "field_label": "Id fIELD",
      "field_data": null,
      "field_type": "hysCustomid",
      "required": 0,
      "permissions": "public",
      "admingroup_id": 0,
      "is_title": 0,
      "field_order": 8,
      "deleted_at": null,
      "created_at": "2024-08-06T09:47:24.000000Z",
      "updated_at": "2024-08-06T09:47:24.000000Z",
      "__hevo__database_name": null,
      "__hevo__ingested_at": null,
      "__hevo__marked_deleted": null,
      "__hevo__source_modified_at": null
  },
  {
    "id": 6717,
    "client_id": 207,
    "hysform_id": 3019,
    "field_key": "en_first_name",
    "field_label": "First Name",
    "field_data": null,
    "field_type": "hysText",
    "required": 1,
    "permissions": "public",
    "admingroup_id": 0,
    "is_title": 1,
    "sortable": 0,
    "filter": 0,
    "field_order": 8,
    "deleted_at": null,
    "created_at": "2024-07-29T08:35:13.000000Z",
    "updated_at": "2024-07-29T08:35:13.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null
  },
  {
    "id": 6718,
    "client_id": 207,
    "hysform_id": 3019,
    "field_key": "en_second_name",
    "field_label": "Second Name",
    "field_data": null,
    "field_type": "hysText",
    "required": 1,
    "permissions": "public",
    "admingroup_id": 0,
    "is_title": 1,
    "sortable": 0,
    "filter": 0,
    "field_order": 9,
    "deleted_at": null,
    "created_at": "2024-07-29T08:35:13.000000Z",
    "updated_at": "2024-07-29T08:35:13.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null
  },
  {
    "id": 6719,
    "client_id": 207,
    "hysform_id": 3019,
    "field_key": "en_age",
    "field_label": "Age",
    "field_data": null,
    "field_type": "hysAge",
    "required": 1,
    "permissions": "public",
    "admingroup_id": 0,
    "is_title": 0,
    "sortable": 0,
    "filter": 0,
    "field_order": 10,
    "deleted_at": null,
    "created_at": "2024-07-29T08:35:13.000000Z",
    "updated_at": "2024-07-29T08:35:13.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null
  },
  {
    "id": 5124,
    "client_id": 207,
    "hysform_id": 3030,
    "field_key": "dn_first_name",
    "field_label": "First Name",
    "field_data": null,
    "field_type": "hysText",
    "required": 0,
    "permissions": "public",
    "admingroup_id": 0,
    "is_title": 0,
    "field_order": 1,
    "deleted_at": null,
    "created_at": "2023-05-06T18:51:09.000000Z",
    "updated_at": "2023-05-06T18:51:09.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null
  },
  {
    "id": 6701,
    "client_id": 207,
    "hysform_id": 3051,
    "field_key": "en_name",
    "field_label": "Name",
    "field_data": null,
    "field_type": "hysText",
    "required": 1,
    "permissions": "public",
    "admingroup_id": 0,
    "is_title": 1,
    "sortable": 0,
    "filter": 0,
    "field_order": 1,
    "deleted_at": null,
    "created_at": "2024-06-13T08:38:33.000000Z",
    "updated_at": "2024-06-13T08:38:33.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null
  },
  {
    "id": 6643,
    "client_id": 207,
    "hysform_id": 3048,
    "field_key": "en_name",
    "field_label": "Name",
    "field_data": null,
    "field_type": "hysText",
    "required": 0,
    "permissions": "public",
    "admingroup_id": 0,
    "is_title": 1,
    "sortable": 0,
    "filter": 0,
    "field_order": 1,
    "deleted_at": null,
    "created_at": "2023-10-17T06:27:32.000000Z",
    "updated_at": "2023-10-17T06:27:32.000000Z",
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null
  }
]
